
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6577"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6577"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iwYKF", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $d7da5726a9ca36a2$export$ffb0004e005737fa, (v) => $d7da5726a9ca36a2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d7da5726a9ca36a2$export$34b9dba7ce09269b, (v) => $d7da5726a9ca36a2$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d7da5726a9ca36a2$export$25062201e9e25d76, (v) => $d7da5726a9ca36a2$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7da5726a9ca36a2$export$ffb0004e005737fa;
var $d7da5726a9ca36a2$export$34b9dba7ce09269b;
var $d7da5726a9ca36a2$export$25062201e9e25d76;
"use strict";

var $lx97N = parcelRequire("lx97N");
var $d7da5726a9ca36a2$var$k = Symbol.for("react.element"), $d7da5726a9ca36a2$var$l = Symbol.for("react.fragment"), $d7da5726a9ca36a2$var$m = Object.prototype.hasOwnProperty, $d7da5726a9ca36a2$var$n = $lx97N.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $d7da5726a9ca36a2$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $d7da5726a9ca36a2$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$d7da5726a9ca36a2$var$m.call(a, b) && !$d7da5726a9ca36a2$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $d7da5726a9ca36a2$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $d7da5726a9ca36a2$var$n.current
    };
}
$d7da5726a9ca36a2$export$ffb0004e005737fa = $d7da5726a9ca36a2$var$l;
$d7da5726a9ca36a2$export$34b9dba7ce09269b = $d7da5726a9ca36a2$var$q;
$d7da5726a9ca36a2$export$25062201e9e25d76 = $d7da5726a9ca36a2$var$q;

});
parcelRegister("lx97N", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8E8IG"));

});
parcelRegister("8E8IG", function(module, exports) {

$parcel$export(module.exports, "Children", () => $64b8d2b03b5764eb$export$dca3b0875bd9a954, (v) => $64b8d2b03b5764eb$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $64b8d2b03b5764eb$export$16fa2f45be04daa8, (v) => $64b8d2b03b5764eb$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $64b8d2b03b5764eb$export$ffb0004e005737fa, (v) => $64b8d2b03b5764eb$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $64b8d2b03b5764eb$export$e2c29f18771995cb, (v) => $64b8d2b03b5764eb$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $64b8d2b03b5764eb$export$221d75b3f55bb0bd, (v) => $64b8d2b03b5764eb$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $64b8d2b03b5764eb$export$5f8d39834fd61797, (v) => $64b8d2b03b5764eb$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $64b8d2b03b5764eb$export$74bf444e3cd11ea5, (v) => $64b8d2b03b5764eb$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $64b8d2b03b5764eb$export$ae55be85d98224ed, (v) => $64b8d2b03b5764eb$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $64b8d2b03b5764eb$export$e530037191fcd5d7, (v) => $64b8d2b03b5764eb$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $64b8d2b03b5764eb$export$fd42f52fd3ae1109, (v) => $64b8d2b03b5764eb$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $64b8d2b03b5764eb$export$c8a8987d4410bf2d, (v) => $64b8d2b03b5764eb$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $64b8d2b03b5764eb$export$d38cd72104c1f0e9, (v) => $64b8d2b03b5764eb$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $64b8d2b03b5764eb$export$7d1e3a5e95ceca43, (v) => $64b8d2b03b5764eb$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $64b8d2b03b5764eb$export$257a8862b851cb5b, (v) => $64b8d2b03b5764eb$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $64b8d2b03b5764eb$export$a8257692ac88316c, (v) => $64b8d2b03b5764eb$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $64b8d2b03b5764eb$export$488013bae63b21da, (v) => $64b8d2b03b5764eb$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $64b8d2b03b5764eb$export$7c73462e0d25e514, (v) => $64b8d2b03b5764eb$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $64b8d2b03b5764eb$export$7568632d0d33d16d, (v) => $64b8d2b03b5764eb$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $64b8d2b03b5764eb$export$88948ce120ea2619, (v) => $64b8d2b03b5764eb$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $64b8d2b03b5764eb$export$35808ee640e87ca7, (v) => $64b8d2b03b5764eb$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $64b8d2b03b5764eb$export$fae74005e78b1a27, (v) => $64b8d2b03b5764eb$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $64b8d2b03b5764eb$export$dc8fbce3eb94dc1e, (v) => $64b8d2b03b5764eb$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $64b8d2b03b5764eb$export$6a7bc4e911dc01cf, (v) => $64b8d2b03b5764eb$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $64b8d2b03b5764eb$export$6d9c69b0de29b591, (v) => $64b8d2b03b5764eb$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $64b8d2b03b5764eb$export$f680877a34711e37, (v) => $64b8d2b03b5764eb$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $64b8d2b03b5764eb$export$d5a552a76deda3c2, (v) => $64b8d2b03b5764eb$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $64b8d2b03b5764eb$export$aaabe4eda9ed9969, (v) => $64b8d2b03b5764eb$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $64b8d2b03b5764eb$export$e5c5a5f917a5871c, (v) => $64b8d2b03b5764eb$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $64b8d2b03b5764eb$export$1538c33de8887b59, (v) => $64b8d2b03b5764eb$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $64b8d2b03b5764eb$export$13e3392192263954, (v) => $64b8d2b03b5764eb$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $64b8d2b03b5764eb$export$b8f5890fc79d6aca, (v) => $64b8d2b03b5764eb$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $64b8d2b03b5764eb$export$60241385465d0a34, (v) => $64b8d2b03b5764eb$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $64b8d2b03b5764eb$export$306c0aa65ff9ec16, (v) => $64b8d2b03b5764eb$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $64b8d2b03b5764eb$export$7b286972b8d8ccbf, (v) => $64b8d2b03b5764eb$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $64b8d2b03b5764eb$export$83d89fbfd8236492, (v) => $64b8d2b03b5764eb$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $64b8d2b03b5764eb$export$dca3b0875bd9a954;
var $64b8d2b03b5764eb$export$16fa2f45be04daa8;
var $64b8d2b03b5764eb$export$ffb0004e005737fa;
var $64b8d2b03b5764eb$export$e2c29f18771995cb;
var $64b8d2b03b5764eb$export$221d75b3f55bb0bd;
var $64b8d2b03b5764eb$export$5f8d39834fd61797;
var $64b8d2b03b5764eb$export$74bf444e3cd11ea5;
var $64b8d2b03b5764eb$export$ae55be85d98224ed;
var $64b8d2b03b5764eb$export$e530037191fcd5d7;
var $64b8d2b03b5764eb$export$fd42f52fd3ae1109;
var $64b8d2b03b5764eb$export$c8a8987d4410bf2d;
var $64b8d2b03b5764eb$export$d38cd72104c1f0e9;
var $64b8d2b03b5764eb$export$7d1e3a5e95ceca43;
var $64b8d2b03b5764eb$export$257a8862b851cb5b;
var $64b8d2b03b5764eb$export$a8257692ac88316c;
var $64b8d2b03b5764eb$export$488013bae63b21da;
var $64b8d2b03b5764eb$export$7c73462e0d25e514;
var $64b8d2b03b5764eb$export$7568632d0d33d16d;
var $64b8d2b03b5764eb$export$88948ce120ea2619;
var $64b8d2b03b5764eb$export$35808ee640e87ca7;
var $64b8d2b03b5764eb$export$fae74005e78b1a27;
var $64b8d2b03b5764eb$export$dc8fbce3eb94dc1e;
var $64b8d2b03b5764eb$export$6a7bc4e911dc01cf;
var $64b8d2b03b5764eb$export$6d9c69b0de29b591;
var $64b8d2b03b5764eb$export$f680877a34711e37;
var $64b8d2b03b5764eb$export$d5a552a76deda3c2;
var $64b8d2b03b5764eb$export$aaabe4eda9ed9969;
var $64b8d2b03b5764eb$export$e5c5a5f917a5871c;
var $64b8d2b03b5764eb$export$1538c33de8887b59;
var $64b8d2b03b5764eb$export$13e3392192263954;
var $64b8d2b03b5764eb$export$b8f5890fc79d6aca;
var $64b8d2b03b5764eb$export$60241385465d0a34;
var $64b8d2b03b5764eb$export$306c0aa65ff9ec16;
var $64b8d2b03b5764eb$export$7b286972b8d8ccbf;
var $64b8d2b03b5764eb$export$83d89fbfd8236492;
"use strict";
var $64b8d2b03b5764eb$var$l = Symbol.for("react.element"), $64b8d2b03b5764eb$var$n = Symbol.for("react.portal"), $64b8d2b03b5764eb$var$p = Symbol.for("react.fragment"), $64b8d2b03b5764eb$var$q = Symbol.for("react.strict_mode"), $64b8d2b03b5764eb$var$r = Symbol.for("react.profiler"), $64b8d2b03b5764eb$var$t = Symbol.for("react.provider"), $64b8d2b03b5764eb$var$u = Symbol.for("react.context"), $64b8d2b03b5764eb$var$v = Symbol.for("react.forward_ref"), $64b8d2b03b5764eb$var$w = Symbol.for("react.suspense"), $64b8d2b03b5764eb$var$x = Symbol.for("react.memo"), $64b8d2b03b5764eb$var$y = Symbol.for("react.lazy"), $64b8d2b03b5764eb$var$z = Symbol.iterator;
function $64b8d2b03b5764eb$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $64b8d2b03b5764eb$var$z && a[$64b8d2b03b5764eb$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $64b8d2b03b5764eb$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $64b8d2b03b5764eb$var$C = Object.assign, $64b8d2b03b5764eb$var$D = {};
function $64b8d2b03b5764eb$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $64b8d2b03b5764eb$var$D;
    this.updater = e || $64b8d2b03b5764eb$var$B;
}
$64b8d2b03b5764eb$var$E.prototype.isReactComponent = {};
$64b8d2b03b5764eb$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$64b8d2b03b5764eb$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $64b8d2b03b5764eb$var$F() {}
$64b8d2b03b5764eb$var$F.prototype = $64b8d2b03b5764eb$var$E.prototype;
function $64b8d2b03b5764eb$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $64b8d2b03b5764eb$var$D;
    this.updater = e || $64b8d2b03b5764eb$var$B;
}
var $64b8d2b03b5764eb$var$H = $64b8d2b03b5764eb$var$G.prototype = new $64b8d2b03b5764eb$var$F;
$64b8d2b03b5764eb$var$H.constructor = $64b8d2b03b5764eb$var$G;
$64b8d2b03b5764eb$var$C($64b8d2b03b5764eb$var$H, $64b8d2b03b5764eb$var$E.prototype);
$64b8d2b03b5764eb$var$H.isPureReactComponent = !0;
var $64b8d2b03b5764eb$var$I = Array.isArray, $64b8d2b03b5764eb$var$J = Object.prototype.hasOwnProperty, $64b8d2b03b5764eb$var$K = {
    current: null
}, $64b8d2b03b5764eb$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $64b8d2b03b5764eb$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$64b8d2b03b5764eb$var$J.call(b, d) && !$64b8d2b03b5764eb$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $64b8d2b03b5764eb$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $64b8d2b03b5764eb$var$K.current
    };
}
function $64b8d2b03b5764eb$var$N(a, b) {
    return {
        $$typeof: $64b8d2b03b5764eb$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $64b8d2b03b5764eb$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $64b8d2b03b5764eb$var$l;
}
function $64b8d2b03b5764eb$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $64b8d2b03b5764eb$var$P = /\/+/g;
function $64b8d2b03b5764eb$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $64b8d2b03b5764eb$var$escape("" + a.key) : b.toString(36);
}
function $64b8d2b03b5764eb$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $64b8d2b03b5764eb$var$l:
                case $64b8d2b03b5764eb$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $64b8d2b03b5764eb$var$Q(h, 0) : d, $64b8d2b03b5764eb$var$I(c) ? (e = "", null != a && (e = a.replace($64b8d2b03b5764eb$var$P, "$&/") + "/"), $64b8d2b03b5764eb$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($64b8d2b03b5764eb$var$O(c) && (c = $64b8d2b03b5764eb$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($64b8d2b03b5764eb$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($64b8d2b03b5764eb$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $64b8d2b03b5764eb$var$Q(k, g);
        h += $64b8d2b03b5764eb$var$R(k, b, e, f, c);
    }
    else if (f = $64b8d2b03b5764eb$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $64b8d2b03b5764eb$var$Q(k, g++), h += $64b8d2b03b5764eb$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $64b8d2b03b5764eb$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $64b8d2b03b5764eb$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $64b8d2b03b5764eb$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $64b8d2b03b5764eb$var$U = {
    current: null
}, $64b8d2b03b5764eb$var$V = {
    transition: null
}, $64b8d2b03b5764eb$var$W = {
    ReactCurrentDispatcher: $64b8d2b03b5764eb$var$U,
    ReactCurrentBatchConfig: $64b8d2b03b5764eb$var$V,
    ReactCurrentOwner: $64b8d2b03b5764eb$var$K
};
$64b8d2b03b5764eb$export$dca3b0875bd9a954 = {
    map: $64b8d2b03b5764eb$var$S,
    forEach: function(a, b, e) {
        $64b8d2b03b5764eb$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $64b8d2b03b5764eb$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $64b8d2b03b5764eb$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$64b8d2b03b5764eb$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$64b8d2b03b5764eb$export$16fa2f45be04daa8 = $64b8d2b03b5764eb$var$E;
$64b8d2b03b5764eb$export$ffb0004e005737fa = $64b8d2b03b5764eb$var$p;
$64b8d2b03b5764eb$export$e2c29f18771995cb = $64b8d2b03b5764eb$var$r;
$64b8d2b03b5764eb$export$221d75b3f55bb0bd = $64b8d2b03b5764eb$var$G;
$64b8d2b03b5764eb$export$5f8d39834fd61797 = $64b8d2b03b5764eb$var$q;
$64b8d2b03b5764eb$export$74bf444e3cd11ea5 = $64b8d2b03b5764eb$var$w;
$64b8d2b03b5764eb$export$ae55be85d98224ed = $64b8d2b03b5764eb$var$W;
$64b8d2b03b5764eb$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $64b8d2b03b5764eb$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $64b8d2b03b5764eb$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$64b8d2b03b5764eb$var$J.call(b, f) && !$64b8d2b03b5764eb$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $64b8d2b03b5764eb$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$64b8d2b03b5764eb$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $64b8d2b03b5764eb$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $64b8d2b03b5764eb$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$64b8d2b03b5764eb$export$c8a8987d4410bf2d = $64b8d2b03b5764eb$var$M;
$64b8d2b03b5764eb$export$d38cd72104c1f0e9 = function(a) {
    var b = $64b8d2b03b5764eb$var$M.bind(null, a);
    b.type = a;
    return b;
};
$64b8d2b03b5764eb$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$64b8d2b03b5764eb$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $64b8d2b03b5764eb$var$v,
        render: a
    };
};
$64b8d2b03b5764eb$export$a8257692ac88316c = $64b8d2b03b5764eb$var$O;
$64b8d2b03b5764eb$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $64b8d2b03b5764eb$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $64b8d2b03b5764eb$var$T
    };
};
$64b8d2b03b5764eb$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $64b8d2b03b5764eb$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$64b8d2b03b5764eb$export$7568632d0d33d16d = function(a) {
    var b = $64b8d2b03b5764eb$var$V.transition;
    $64b8d2b03b5764eb$var$V.transition = {};
    try {
        a();
    } finally{
        $64b8d2b03b5764eb$var$V.transition = b;
    }
};
$64b8d2b03b5764eb$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$64b8d2b03b5764eb$export$35808ee640e87ca7 = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useCallback(a, b);
};
$64b8d2b03b5764eb$export$fae74005e78b1a27 = function(a) {
    return $64b8d2b03b5764eb$var$U.current.useContext(a);
};
$64b8d2b03b5764eb$export$dc8fbce3eb94dc1e = function() {};
$64b8d2b03b5764eb$export$6a7bc4e911dc01cf = function(a) {
    return $64b8d2b03b5764eb$var$U.current.useDeferredValue(a);
};
$64b8d2b03b5764eb$export$6d9c69b0de29b591 = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useEffect(a, b);
};
$64b8d2b03b5764eb$export$f680877a34711e37 = function() {
    return $64b8d2b03b5764eb$var$U.current.useId();
};
$64b8d2b03b5764eb$export$d5a552a76deda3c2 = function(a, b, e) {
    return $64b8d2b03b5764eb$var$U.current.useImperativeHandle(a, b, e);
};
$64b8d2b03b5764eb$export$aaabe4eda9ed9969 = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useInsertionEffect(a, b);
};
$64b8d2b03b5764eb$export$e5c5a5f917a5871c = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useLayoutEffect(a, b);
};
$64b8d2b03b5764eb$export$1538c33de8887b59 = function(a, b) {
    return $64b8d2b03b5764eb$var$U.current.useMemo(a, b);
};
$64b8d2b03b5764eb$export$13e3392192263954 = function(a, b, e) {
    return $64b8d2b03b5764eb$var$U.current.useReducer(a, b, e);
};
$64b8d2b03b5764eb$export$b8f5890fc79d6aca = function(a) {
    return $64b8d2b03b5764eb$var$U.current.useRef(a);
};
$64b8d2b03b5764eb$export$60241385465d0a34 = function(a) {
    return $64b8d2b03b5764eb$var$U.current.useState(a);
};
$64b8d2b03b5764eb$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $64b8d2b03b5764eb$var$U.current.useSyncExternalStore(a, b, e);
};
$64b8d2b03b5764eb$export$7b286972b8d8ccbf = function() {
    return $64b8d2b03b5764eb$var$U.current.useTransition();
};
$64b8d2b03b5764eb$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("f2Jil", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $af3a2d87ccb15d29$export$ae55be85d98224ed, (v) => $af3a2d87ccb15d29$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $af3a2d87ccb15d29$export$d39a5bbd09211389, (v) => $af3a2d87ccb15d29$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $af3a2d87ccb15d29$export$882461b6382ed46c, (v) => $af3a2d87ccb15d29$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $af3a2d87ccb15d29$export$466bfc07425424d5, (v) => $af3a2d87ccb15d29$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $af3a2d87ccb15d29$export$cd75ccfd720a3cd4, (v) => $af3a2d87ccb15d29$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $af3a2d87ccb15d29$export$fa8d919ba61d84db, (v) => $af3a2d87ccb15d29$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $af3a2d87ccb15d29$export$757ceba2d55c277e, (v) => $af3a2d87ccb15d29$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $af3a2d87ccb15d29$export$b3890eb0ae9dca99, (v) => $af3a2d87ccb15d29$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $af3a2d87ccb15d29$export$502457920280e6be, (v) => $af3a2d87ccb15d29$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $af3a2d87ccb15d29$export$c78a37762a8d58e1, (v) => $af3a2d87ccb15d29$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $af3a2d87ccb15d29$export$dc54d992c10e8a18, (v) => $af3a2d87ccb15d29$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $af3a2d87ccb15d29$export$83d89fbfd8236492, (v) => $af3a2d87ccb15d29$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $af3a2d87ccb15d29$export$ae55be85d98224ed;
var $af3a2d87ccb15d29$export$d39a5bbd09211389;
var $af3a2d87ccb15d29$export$882461b6382ed46c;
var $af3a2d87ccb15d29$export$466bfc07425424d5;
var $af3a2d87ccb15d29$export$cd75ccfd720a3cd4;
var $af3a2d87ccb15d29$export$fa8d919ba61d84db;
var $af3a2d87ccb15d29$export$757ceba2d55c277e;
var $af3a2d87ccb15d29$export$b3890eb0ae9dca99;
var $af3a2d87ccb15d29$export$502457920280e6be;
var $af3a2d87ccb15d29$export$c78a37762a8d58e1;
var $af3a2d87ccb15d29$export$dc54d992c10e8a18;
var $af3a2d87ccb15d29$export$83d89fbfd8236492;
"use strict";

var $lx97N = parcelRequire("lx97N");

var $7DCHO = parcelRequire("7DCHO");
function $af3a2d87ccb15d29$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $af3a2d87ccb15d29$var$da = new Set, $af3a2d87ccb15d29$var$ea = {};
function $af3a2d87ccb15d29$var$fa(a, b) {
    $af3a2d87ccb15d29$var$ha(a, b);
    $af3a2d87ccb15d29$var$ha(a + "Capture", b);
}
function $af3a2d87ccb15d29$var$ha(a, b) {
    $af3a2d87ccb15d29$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$af3a2d87ccb15d29$var$da.add(b[a]);
}
var $af3a2d87ccb15d29$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $af3a2d87ccb15d29$var$ja = Object.prototype.hasOwnProperty, $af3a2d87ccb15d29$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $af3a2d87ccb15d29$var$la = {}, $af3a2d87ccb15d29$var$ma = {};
function $af3a2d87ccb15d29$var$oa(a) {
    if ($af3a2d87ccb15d29$var$ja.call($af3a2d87ccb15d29$var$ma, a)) return !0;
    if ($af3a2d87ccb15d29$var$ja.call($af3a2d87ccb15d29$var$la, a)) return !1;
    if ($af3a2d87ccb15d29$var$ka.test(a)) return $af3a2d87ccb15d29$var$ma[a] = !0;
    $af3a2d87ccb15d29$var$la[a] = !0;
    return !1;
}
function $af3a2d87ccb15d29$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $af3a2d87ccb15d29$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $af3a2d87ccb15d29$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $af3a2d87ccb15d29$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $af3a2d87ccb15d29$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $af3a2d87ccb15d29$var$z[b] = new $af3a2d87ccb15d29$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $af3a2d87ccb15d29$var$ra = /[\-:]([a-z])/g;
function $af3a2d87ccb15d29$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($af3a2d87ccb15d29$var$ra, $af3a2d87ccb15d29$var$sa);
    $af3a2d87ccb15d29$var$z[b] = new $af3a2d87ccb15d29$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($af3a2d87ccb15d29$var$ra, $af3a2d87ccb15d29$var$sa);
    $af3a2d87ccb15d29$var$z[b] = new $af3a2d87ccb15d29$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($af3a2d87ccb15d29$var$ra, $af3a2d87ccb15d29$var$sa);
    $af3a2d87ccb15d29$var$z[b] = new $af3a2d87ccb15d29$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$af3a2d87ccb15d29$var$z.xlinkHref = new $af3a2d87ccb15d29$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $af3a2d87ccb15d29$var$z[a] = new $af3a2d87ccb15d29$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $af3a2d87ccb15d29$var$ta(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$z.hasOwnProperty(b) ? $af3a2d87ccb15d29$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $af3a2d87ccb15d29$var$qa(b, c, e, d) && (c = null), d || null === e ? $af3a2d87ccb15d29$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $af3a2d87ccb15d29$var$ua = $lx97N.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $af3a2d87ccb15d29$var$va = Symbol.for("react.element"), $af3a2d87ccb15d29$var$wa = Symbol.for("react.portal"), $af3a2d87ccb15d29$var$ya = Symbol.for("react.fragment"), $af3a2d87ccb15d29$var$za = Symbol.for("react.strict_mode"), $af3a2d87ccb15d29$var$Aa = Symbol.for("react.profiler"), $af3a2d87ccb15d29$var$Ba = Symbol.for("react.provider"), $af3a2d87ccb15d29$var$Ca = Symbol.for("react.context"), $af3a2d87ccb15d29$var$Da = Symbol.for("react.forward_ref"), $af3a2d87ccb15d29$var$Ea = Symbol.for("react.suspense"), $af3a2d87ccb15d29$var$Fa = Symbol.for("react.suspense_list"), $af3a2d87ccb15d29$var$Ga = Symbol.for("react.memo"), $af3a2d87ccb15d29$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $af3a2d87ccb15d29$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $af3a2d87ccb15d29$var$Ja = Symbol.iterator;
function $af3a2d87ccb15d29$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $af3a2d87ccb15d29$var$Ja && a[$af3a2d87ccb15d29$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $af3a2d87ccb15d29$var$A = Object.assign, $af3a2d87ccb15d29$var$La;
function $af3a2d87ccb15d29$var$Ma(a) {
    if (void 0 === $af3a2d87ccb15d29$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $af3a2d87ccb15d29$var$La = b && b[1] || "";
    }
    return "\n" + $af3a2d87ccb15d29$var$La + a;
}
var $af3a2d87ccb15d29$var$Na = !1;
function $af3a2d87ccb15d29$var$Oa(a, b) {
    if (!a || $af3a2d87ccb15d29$var$Na) return "";
    $af3a2d87ccb15d29$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $af3a2d87ccb15d29$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $af3a2d87ccb15d29$var$Ma(a) : "";
}
function $af3a2d87ccb15d29$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $af3a2d87ccb15d29$var$Ma(a.type);
        case 16:
            return $af3a2d87ccb15d29$var$Ma("Lazy");
        case 13:
            return $af3a2d87ccb15d29$var$Ma("Suspense");
        case 19:
            return $af3a2d87ccb15d29$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $af3a2d87ccb15d29$var$Oa(a.type, !1), a;
        case 11:
            return a = $af3a2d87ccb15d29$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $af3a2d87ccb15d29$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $af3a2d87ccb15d29$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $af3a2d87ccb15d29$var$ya:
            return "Fragment";
        case $af3a2d87ccb15d29$var$wa:
            return "Portal";
        case $af3a2d87ccb15d29$var$Aa:
            return "Profiler";
        case $af3a2d87ccb15d29$var$za:
            return "StrictMode";
        case $af3a2d87ccb15d29$var$Ea:
            return "Suspense";
        case $af3a2d87ccb15d29$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $af3a2d87ccb15d29$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $af3a2d87ccb15d29$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $af3a2d87ccb15d29$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $af3a2d87ccb15d29$var$Ga:
            return b = a.displayName || null, null !== b ? b : $af3a2d87ccb15d29$var$Qa(a.type) || "Memo";
        case $af3a2d87ccb15d29$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $af3a2d87ccb15d29$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $af3a2d87ccb15d29$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $af3a2d87ccb15d29$var$Qa(b);
        case 8:
            return b === $af3a2d87ccb15d29$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $af3a2d87ccb15d29$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $af3a2d87ccb15d29$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $af3a2d87ccb15d29$var$Ua(a) {
    var b = $af3a2d87ccb15d29$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $af3a2d87ccb15d29$var$Va(a) {
    a._valueTracker || (a._valueTracker = $af3a2d87ccb15d29$var$Ua(a));
}
function $af3a2d87ccb15d29$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $af3a2d87ccb15d29$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $af3a2d87ccb15d29$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $af3a2d87ccb15d29$var$Ya(a, b) {
    var c = b.checked;
    return $af3a2d87ccb15d29$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $af3a2d87ccb15d29$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $af3a2d87ccb15d29$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $af3a2d87ccb15d29$var$ab(a, b) {
    b = b.checked;
    null != b && $af3a2d87ccb15d29$var$ta(a, "checked", b, !1);
}
function $af3a2d87ccb15d29$var$bb(a, b) {
    $af3a2d87ccb15d29$var$ab(a, b);
    var c = $af3a2d87ccb15d29$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $af3a2d87ccb15d29$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $af3a2d87ccb15d29$var$cb(a, b.type, $af3a2d87ccb15d29$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $af3a2d87ccb15d29$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $af3a2d87ccb15d29$var$cb(a, b, c) {
    if ("number" !== b || $af3a2d87ccb15d29$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $af3a2d87ccb15d29$var$eb = Array.isArray;
function $af3a2d87ccb15d29$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $af3a2d87ccb15d29$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $af3a2d87ccb15d29$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($af3a2d87ccb15d29$var$p(91));
    return $af3a2d87ccb15d29$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $af3a2d87ccb15d29$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($af3a2d87ccb15d29$var$p(92));
            if ($af3a2d87ccb15d29$var$eb(c)) {
                if (1 < c.length) throw Error($af3a2d87ccb15d29$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $af3a2d87ccb15d29$var$Sa(c)
    };
}
function $af3a2d87ccb15d29$var$ib(a, b) {
    var c = $af3a2d87ccb15d29$var$Sa(b.value), d = $af3a2d87ccb15d29$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $af3a2d87ccb15d29$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $af3a2d87ccb15d29$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $af3a2d87ccb15d29$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $af3a2d87ccb15d29$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $af3a2d87ccb15d29$var$mb, $af3a2d87ccb15d29$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $af3a2d87ccb15d29$var$mb = $af3a2d87ccb15d29$var$mb || document.createElement("div");
        $af3a2d87ccb15d29$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $af3a2d87ccb15d29$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $af3a2d87ccb15d29$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $af3a2d87ccb15d29$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $af3a2d87ccb15d29$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($af3a2d87ccb15d29$var$pb).forEach(function(a) {
    $af3a2d87ccb15d29$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $af3a2d87ccb15d29$var$pb[b] = $af3a2d87ccb15d29$var$pb[a];
    });
});
function $af3a2d87ccb15d29$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $af3a2d87ccb15d29$var$pb.hasOwnProperty(a) && $af3a2d87ccb15d29$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $af3a2d87ccb15d29$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $af3a2d87ccb15d29$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $af3a2d87ccb15d29$var$tb = $af3a2d87ccb15d29$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $af3a2d87ccb15d29$var$ub(a, b) {
    if (b) {
        if ($af3a2d87ccb15d29$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($af3a2d87ccb15d29$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($af3a2d87ccb15d29$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($af3a2d87ccb15d29$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($af3a2d87ccb15d29$var$p(62));
    }
}
function $af3a2d87ccb15d29$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $af3a2d87ccb15d29$var$wb = null;
function $af3a2d87ccb15d29$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $af3a2d87ccb15d29$var$yb = null, $af3a2d87ccb15d29$var$zb = null, $af3a2d87ccb15d29$var$Ab = null;
function $af3a2d87ccb15d29$var$Bb(a) {
    if (a = $af3a2d87ccb15d29$var$Cb(a)) {
        if ("function" !== typeof $af3a2d87ccb15d29$var$yb) throw Error($af3a2d87ccb15d29$var$p(280));
        var b = a.stateNode;
        b && (b = $af3a2d87ccb15d29$var$Db(b), $af3a2d87ccb15d29$var$yb(a.stateNode, a.type, b));
    }
}
function $af3a2d87ccb15d29$var$Eb(a) {
    $af3a2d87ccb15d29$var$zb ? $af3a2d87ccb15d29$var$Ab ? $af3a2d87ccb15d29$var$Ab.push(a) : $af3a2d87ccb15d29$var$Ab = [
        a
    ] : $af3a2d87ccb15d29$var$zb = a;
}
function $af3a2d87ccb15d29$var$Fb() {
    if ($af3a2d87ccb15d29$var$zb) {
        var a = $af3a2d87ccb15d29$var$zb, b = $af3a2d87ccb15d29$var$Ab;
        $af3a2d87ccb15d29$var$Ab = $af3a2d87ccb15d29$var$zb = null;
        $af3a2d87ccb15d29$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$af3a2d87ccb15d29$var$Bb(b[a]);
    }
}
function $af3a2d87ccb15d29$var$Gb(a, b) {
    return a(b);
}
function $af3a2d87ccb15d29$var$Hb() {}
var $af3a2d87ccb15d29$var$Ib = !1;
function $af3a2d87ccb15d29$var$Jb(a, b, c) {
    if ($af3a2d87ccb15d29$var$Ib) return a(b, c);
    $af3a2d87ccb15d29$var$Ib = !0;
    try {
        return $af3a2d87ccb15d29$var$Gb(a, b, c);
    } finally{
        if ($af3a2d87ccb15d29$var$Ib = !1, null !== $af3a2d87ccb15d29$var$zb || null !== $af3a2d87ccb15d29$var$Ab) $af3a2d87ccb15d29$var$Hb(), $af3a2d87ccb15d29$var$Fb();
    }
}
function $af3a2d87ccb15d29$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $af3a2d87ccb15d29$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($af3a2d87ccb15d29$var$p(231, b, typeof c));
    return c;
}
var $af3a2d87ccb15d29$var$Lb = !1;
if ($af3a2d87ccb15d29$var$ia) try {
    var $af3a2d87ccb15d29$var$Mb = {};
    Object.defineProperty($af3a2d87ccb15d29$var$Mb, "passive", {
        get: function() {
            $af3a2d87ccb15d29$var$Lb = !0;
        }
    });
    window.addEventListener("test", $af3a2d87ccb15d29$var$Mb, $af3a2d87ccb15d29$var$Mb);
    window.removeEventListener("test", $af3a2d87ccb15d29$var$Mb, $af3a2d87ccb15d29$var$Mb);
} catch (a) {
    $af3a2d87ccb15d29$var$Lb = !1;
}
function $af3a2d87ccb15d29$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $af3a2d87ccb15d29$var$Ob = !1, $af3a2d87ccb15d29$var$Pb = null, $af3a2d87ccb15d29$var$Qb = !1, $af3a2d87ccb15d29$var$Rb = null, $af3a2d87ccb15d29$var$Sb = {
    onError: function(a) {
        $af3a2d87ccb15d29$var$Ob = !0;
        $af3a2d87ccb15d29$var$Pb = a;
    }
};
function $af3a2d87ccb15d29$var$Tb(a, b, c, d, e, f, g, h, k) {
    $af3a2d87ccb15d29$var$Ob = !1;
    $af3a2d87ccb15d29$var$Pb = null;
    $af3a2d87ccb15d29$var$Nb.apply($af3a2d87ccb15d29$var$Sb, arguments);
}
function $af3a2d87ccb15d29$var$Ub(a, b, c, d, e, f, g, h, k) {
    $af3a2d87ccb15d29$var$Tb.apply(this, arguments);
    if ($af3a2d87ccb15d29$var$Ob) {
        if ($af3a2d87ccb15d29$var$Ob) {
            var l = $af3a2d87ccb15d29$var$Pb;
            $af3a2d87ccb15d29$var$Ob = !1;
            $af3a2d87ccb15d29$var$Pb = null;
        } else throw Error($af3a2d87ccb15d29$var$p(198));
        $af3a2d87ccb15d29$var$Qb || ($af3a2d87ccb15d29$var$Qb = !0, $af3a2d87ccb15d29$var$Rb = l);
    }
}
function $af3a2d87ccb15d29$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $af3a2d87ccb15d29$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $af3a2d87ccb15d29$var$Xb(a) {
    if ($af3a2d87ccb15d29$var$Vb(a) !== a) throw Error($af3a2d87ccb15d29$var$p(188));
}
function $af3a2d87ccb15d29$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $af3a2d87ccb15d29$var$Vb(a);
        if (null === b) throw Error($af3a2d87ccb15d29$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $af3a2d87ccb15d29$var$Xb(e), a;
                if (f === d) return $af3a2d87ccb15d29$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($af3a2d87ccb15d29$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($af3a2d87ccb15d29$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($af3a2d87ccb15d29$var$p(190));
    }
    if (3 !== c.tag) throw Error($af3a2d87ccb15d29$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $af3a2d87ccb15d29$var$Zb(a) {
    a = $af3a2d87ccb15d29$var$Yb(a);
    return null !== a ? $af3a2d87ccb15d29$var$$b(a) : null;
}
function $af3a2d87ccb15d29$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $af3a2d87ccb15d29$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $af3a2d87ccb15d29$var$ac = $7DCHO.unstable_scheduleCallback, $af3a2d87ccb15d29$var$bc = $7DCHO.unstable_cancelCallback, $af3a2d87ccb15d29$var$cc = $7DCHO.unstable_shouldYield, $af3a2d87ccb15d29$var$dc = $7DCHO.unstable_requestPaint, $af3a2d87ccb15d29$var$B = $7DCHO.unstable_now, $af3a2d87ccb15d29$var$ec = $7DCHO.unstable_getCurrentPriorityLevel, $af3a2d87ccb15d29$var$fc = $7DCHO.unstable_ImmediatePriority, $af3a2d87ccb15d29$var$gc = $7DCHO.unstable_UserBlockingPriority, $af3a2d87ccb15d29$var$hc = $7DCHO.unstable_NormalPriority, $af3a2d87ccb15d29$var$ic = $7DCHO.unstable_LowPriority, $af3a2d87ccb15d29$var$jc = $7DCHO.unstable_IdlePriority, $af3a2d87ccb15d29$var$kc = null, $af3a2d87ccb15d29$var$lc = null;
function $af3a2d87ccb15d29$var$mc(a) {
    if ($af3a2d87ccb15d29$var$lc && "function" === typeof $af3a2d87ccb15d29$var$lc.onCommitFiberRoot) try {
        $af3a2d87ccb15d29$var$lc.onCommitFiberRoot($af3a2d87ccb15d29$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $af3a2d87ccb15d29$var$oc = Math.clz32 ? Math.clz32 : $af3a2d87ccb15d29$var$nc, $af3a2d87ccb15d29$var$pc = Math.log, $af3a2d87ccb15d29$var$qc = Math.LN2;
function $af3a2d87ccb15d29$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($af3a2d87ccb15d29$var$pc(a) / $af3a2d87ccb15d29$var$qc | 0) | 0;
}
var $af3a2d87ccb15d29$var$rc = 64, $af3a2d87ccb15d29$var$sc = 4194304;
function $af3a2d87ccb15d29$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $af3a2d87ccb15d29$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $af3a2d87ccb15d29$var$tc(h) : (f &= g, 0 !== f && (d = $af3a2d87ccb15d29$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $af3a2d87ccb15d29$var$tc(g) : 0 !== f && (d = $af3a2d87ccb15d29$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $af3a2d87ccb15d29$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $af3a2d87ccb15d29$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $af3a2d87ccb15d29$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $af3a2d87ccb15d29$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $af3a2d87ccb15d29$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $af3a2d87ccb15d29$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $af3a2d87ccb15d29$var$yc() {
    var a = $af3a2d87ccb15d29$var$rc;
    $af3a2d87ccb15d29$var$rc <<= 1;
    0 === ($af3a2d87ccb15d29$var$rc & 4194240) && ($af3a2d87ccb15d29$var$rc = 64);
    return a;
}
function $af3a2d87ccb15d29$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $af3a2d87ccb15d29$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $af3a2d87ccb15d29$var$oc(b);
    a[b] = c;
}
function $af3a2d87ccb15d29$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $af3a2d87ccb15d29$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $af3a2d87ccb15d29$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $af3a2d87ccb15d29$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $af3a2d87ccb15d29$var$C = 0;
function $af3a2d87ccb15d29$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $af3a2d87ccb15d29$var$Ec, $af3a2d87ccb15d29$var$Fc, $af3a2d87ccb15d29$var$Gc, $af3a2d87ccb15d29$var$Hc, $af3a2d87ccb15d29$var$Ic, $af3a2d87ccb15d29$var$Jc = !1, $af3a2d87ccb15d29$var$Kc = [], $af3a2d87ccb15d29$var$Lc = null, $af3a2d87ccb15d29$var$Mc = null, $af3a2d87ccb15d29$var$Nc = null, $af3a2d87ccb15d29$var$Oc = new Map, $af3a2d87ccb15d29$var$Pc = new Map, $af3a2d87ccb15d29$var$Qc = [], $af3a2d87ccb15d29$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $af3a2d87ccb15d29$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $af3a2d87ccb15d29$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $af3a2d87ccb15d29$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $af3a2d87ccb15d29$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $af3a2d87ccb15d29$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $af3a2d87ccb15d29$var$Pc.delete(b.pointerId);
    }
}
function $af3a2d87ccb15d29$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $af3a2d87ccb15d29$var$Cb(b), null !== b && $af3a2d87ccb15d29$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $af3a2d87ccb15d29$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $af3a2d87ccb15d29$var$Lc = $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $af3a2d87ccb15d29$var$Mc = $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $af3a2d87ccb15d29$var$Nc = $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $af3a2d87ccb15d29$var$Oc.set(f, $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $af3a2d87ccb15d29$var$Pc.set(f, $af3a2d87ccb15d29$var$Tc($af3a2d87ccb15d29$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $af3a2d87ccb15d29$var$Vc(a) {
    var b = $af3a2d87ccb15d29$var$Wc(a.target);
    if (null !== b) {
        var c = $af3a2d87ccb15d29$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $af3a2d87ccb15d29$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $af3a2d87ccb15d29$var$Ic(a.priority, function() {
                        $af3a2d87ccb15d29$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $af3a2d87ccb15d29$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $af3a2d87ccb15d29$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $af3a2d87ccb15d29$var$wb = d;
            c.target.dispatchEvent(d);
            $af3a2d87ccb15d29$var$wb = null;
        } else return b = $af3a2d87ccb15d29$var$Cb(c), null !== b && $af3a2d87ccb15d29$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $af3a2d87ccb15d29$var$Zc(a, b, c) {
    $af3a2d87ccb15d29$var$Xc(a) && c.delete(b);
}
function $af3a2d87ccb15d29$var$$c() {
    $af3a2d87ccb15d29$var$Jc = !1;
    null !== $af3a2d87ccb15d29$var$Lc && $af3a2d87ccb15d29$var$Xc($af3a2d87ccb15d29$var$Lc) && ($af3a2d87ccb15d29$var$Lc = null);
    null !== $af3a2d87ccb15d29$var$Mc && $af3a2d87ccb15d29$var$Xc($af3a2d87ccb15d29$var$Mc) && ($af3a2d87ccb15d29$var$Mc = null);
    null !== $af3a2d87ccb15d29$var$Nc && $af3a2d87ccb15d29$var$Xc($af3a2d87ccb15d29$var$Nc) && ($af3a2d87ccb15d29$var$Nc = null);
    $af3a2d87ccb15d29$var$Oc.forEach($af3a2d87ccb15d29$var$Zc);
    $af3a2d87ccb15d29$var$Pc.forEach($af3a2d87ccb15d29$var$Zc);
}
function $af3a2d87ccb15d29$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $af3a2d87ccb15d29$var$Jc || ($af3a2d87ccb15d29$var$Jc = !0, $7DCHO.unstable_scheduleCallback($7DCHO.unstable_NormalPriority, $af3a2d87ccb15d29$var$$c)));
}
function $af3a2d87ccb15d29$var$bd(a) {
    function b(b) {
        return $af3a2d87ccb15d29$var$ad(b, a);
    }
    if (0 < $af3a2d87ccb15d29$var$Kc.length) {
        $af3a2d87ccb15d29$var$ad($af3a2d87ccb15d29$var$Kc[0], a);
        for(var c = 1; c < $af3a2d87ccb15d29$var$Kc.length; c++){
            var d = $af3a2d87ccb15d29$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $af3a2d87ccb15d29$var$Lc && $af3a2d87ccb15d29$var$ad($af3a2d87ccb15d29$var$Lc, a);
    null !== $af3a2d87ccb15d29$var$Mc && $af3a2d87ccb15d29$var$ad($af3a2d87ccb15d29$var$Mc, a);
    null !== $af3a2d87ccb15d29$var$Nc && $af3a2d87ccb15d29$var$ad($af3a2d87ccb15d29$var$Nc, a);
    $af3a2d87ccb15d29$var$Oc.forEach(b);
    $af3a2d87ccb15d29$var$Pc.forEach(b);
    for(c = 0; c < $af3a2d87ccb15d29$var$Qc.length; c++)d = $af3a2d87ccb15d29$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $af3a2d87ccb15d29$var$Qc.length && (c = $af3a2d87ccb15d29$var$Qc[0], null === c.blockedOn);)$af3a2d87ccb15d29$var$Vc(c), null === c.blockedOn && $af3a2d87ccb15d29$var$Qc.shift();
}
var $af3a2d87ccb15d29$var$cd = $af3a2d87ccb15d29$var$ua.ReactCurrentBatchConfig, $af3a2d87ccb15d29$var$dd = !0;
function $af3a2d87ccb15d29$var$ed(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$C, f = $af3a2d87ccb15d29$var$cd.transition;
    $af3a2d87ccb15d29$var$cd.transition = null;
    try {
        $af3a2d87ccb15d29$var$C = 1, $af3a2d87ccb15d29$var$fd(a, b, c, d);
    } finally{
        $af3a2d87ccb15d29$var$C = e, $af3a2d87ccb15d29$var$cd.transition = f;
    }
}
function $af3a2d87ccb15d29$var$gd(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$C, f = $af3a2d87ccb15d29$var$cd.transition;
    $af3a2d87ccb15d29$var$cd.transition = null;
    try {
        $af3a2d87ccb15d29$var$C = 4, $af3a2d87ccb15d29$var$fd(a, b, c, d);
    } finally{
        $af3a2d87ccb15d29$var$C = e, $af3a2d87ccb15d29$var$cd.transition = f;
    }
}
function $af3a2d87ccb15d29$var$fd(a, b, c, d) {
    if ($af3a2d87ccb15d29$var$dd) {
        var e = $af3a2d87ccb15d29$var$Yc(a, b, c, d);
        if (null === e) $af3a2d87ccb15d29$var$hd(a, b, d, $af3a2d87ccb15d29$var$id, c), $af3a2d87ccb15d29$var$Sc(a, d);
        else if ($af3a2d87ccb15d29$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($af3a2d87ccb15d29$var$Sc(a, d), b & 4 && -1 < $af3a2d87ccb15d29$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $af3a2d87ccb15d29$var$Cb(e);
                null !== f && $af3a2d87ccb15d29$var$Ec(f);
                f = $af3a2d87ccb15d29$var$Yc(a, b, c, d);
                null === f && $af3a2d87ccb15d29$var$hd(a, b, d, $af3a2d87ccb15d29$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $af3a2d87ccb15d29$var$hd(a, b, d, null, c);
    }
}
var $af3a2d87ccb15d29$var$id = null;
function $af3a2d87ccb15d29$var$Yc(a, b, c, d) {
    $af3a2d87ccb15d29$var$id = null;
    a = $af3a2d87ccb15d29$var$xb(d);
    a = $af3a2d87ccb15d29$var$Wc(a);
    if (null !== a) {
        if (b = $af3a2d87ccb15d29$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $af3a2d87ccb15d29$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $af3a2d87ccb15d29$var$id = a;
    return null;
}
function $af3a2d87ccb15d29$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($af3a2d87ccb15d29$var$ec()){
                case $af3a2d87ccb15d29$var$fc:
                    return 1;
                case $af3a2d87ccb15d29$var$gc:
                    return 4;
                case $af3a2d87ccb15d29$var$hc:
                case $af3a2d87ccb15d29$var$ic:
                    return 16;
                case $af3a2d87ccb15d29$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $af3a2d87ccb15d29$var$kd = null, $af3a2d87ccb15d29$var$ld = null, $af3a2d87ccb15d29$var$md = null;
function $af3a2d87ccb15d29$var$nd() {
    if ($af3a2d87ccb15d29$var$md) return $af3a2d87ccb15d29$var$md;
    var a, b = $af3a2d87ccb15d29$var$ld, c = b.length, d, e = "value" in $af3a2d87ccb15d29$var$kd ? $af3a2d87ccb15d29$var$kd.value : $af3a2d87ccb15d29$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $af3a2d87ccb15d29$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $af3a2d87ccb15d29$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $af3a2d87ccb15d29$var$pd() {
    return !0;
}
function $af3a2d87ccb15d29$var$qd() {
    return !1;
}
function $af3a2d87ccb15d29$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $af3a2d87ccb15d29$var$pd : $af3a2d87ccb15d29$var$qd;
        this.isPropagationStopped = $af3a2d87ccb15d29$var$qd;
        return this;
    }
    $af3a2d87ccb15d29$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $af3a2d87ccb15d29$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $af3a2d87ccb15d29$var$pd);
        },
        persist: function() {},
        isPersistent: $af3a2d87ccb15d29$var$pd
    });
    return b;
}
var $af3a2d87ccb15d29$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $af3a2d87ccb15d29$var$td = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$sd), $af3a2d87ccb15d29$var$ud = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    view: 0,
    detail: 0
}), $af3a2d87ccb15d29$var$vd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$ud), $af3a2d87ccb15d29$var$wd, $af3a2d87ccb15d29$var$xd, $af3a2d87ccb15d29$var$yd, $af3a2d87ccb15d29$var$Ad = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $af3a2d87ccb15d29$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $af3a2d87ccb15d29$var$yd && ($af3a2d87ccb15d29$var$yd && "mousemove" === a.type ? ($af3a2d87ccb15d29$var$wd = a.screenX - $af3a2d87ccb15d29$var$yd.screenX, $af3a2d87ccb15d29$var$xd = a.screenY - $af3a2d87ccb15d29$var$yd.screenY) : $af3a2d87ccb15d29$var$xd = $af3a2d87ccb15d29$var$wd = 0, $af3a2d87ccb15d29$var$yd = a);
        return $af3a2d87ccb15d29$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $af3a2d87ccb15d29$var$xd;
    }
}), $af3a2d87ccb15d29$var$Bd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Ad), $af3a2d87ccb15d29$var$Cd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$Ad, {
    dataTransfer: 0
}), $af3a2d87ccb15d29$var$Dd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Cd), $af3a2d87ccb15d29$var$Ed = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$ud, {
    relatedTarget: 0
}), $af3a2d87ccb15d29$var$Fd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Ed), $af3a2d87ccb15d29$var$Gd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $af3a2d87ccb15d29$var$Hd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Gd), $af3a2d87ccb15d29$var$Id = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $af3a2d87ccb15d29$var$Jd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Id), $af3a2d87ccb15d29$var$Kd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    data: 0
}), $af3a2d87ccb15d29$var$Ld = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Kd), $af3a2d87ccb15d29$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $af3a2d87ccb15d29$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $af3a2d87ccb15d29$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $af3a2d87ccb15d29$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $af3a2d87ccb15d29$var$Od[a]) ? !!b[a] : !1;
}
function $af3a2d87ccb15d29$var$zd() {
    return $af3a2d87ccb15d29$var$Pd;
}
var $af3a2d87ccb15d29$var$Qd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $af3a2d87ccb15d29$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $af3a2d87ccb15d29$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $af3a2d87ccb15d29$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $af3a2d87ccb15d29$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $af3a2d87ccb15d29$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $af3a2d87ccb15d29$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $af3a2d87ccb15d29$var$Rd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Qd), $af3a2d87ccb15d29$var$Sd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $af3a2d87ccb15d29$var$Td = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Sd), $af3a2d87ccb15d29$var$Ud = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $af3a2d87ccb15d29$var$zd
}), $af3a2d87ccb15d29$var$Vd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Ud), $af3a2d87ccb15d29$var$Wd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $af3a2d87ccb15d29$var$Xd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Wd), $af3a2d87ccb15d29$var$Yd = $af3a2d87ccb15d29$var$A({}, $af3a2d87ccb15d29$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $af3a2d87ccb15d29$var$Zd = $af3a2d87ccb15d29$var$rd($af3a2d87ccb15d29$var$Yd), $af3a2d87ccb15d29$var$$d = [
    9,
    13,
    27,
    32
], $af3a2d87ccb15d29$var$ae = $af3a2d87ccb15d29$var$ia && "CompositionEvent" in window, $af3a2d87ccb15d29$var$be = null;
$af3a2d87ccb15d29$var$ia && "documentMode" in document && ($af3a2d87ccb15d29$var$be = document.documentMode);
var $af3a2d87ccb15d29$var$ce = $af3a2d87ccb15d29$var$ia && "TextEvent" in window && !$af3a2d87ccb15d29$var$be, $af3a2d87ccb15d29$var$de = $af3a2d87ccb15d29$var$ia && (!$af3a2d87ccb15d29$var$ae || $af3a2d87ccb15d29$var$be && 8 < $af3a2d87ccb15d29$var$be && 11 >= $af3a2d87ccb15d29$var$be), $af3a2d87ccb15d29$var$ee = String.fromCharCode(32), $af3a2d87ccb15d29$var$fe = !1;
function $af3a2d87ccb15d29$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $af3a2d87ccb15d29$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $af3a2d87ccb15d29$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $af3a2d87ccb15d29$var$ie = !1;
function $af3a2d87ccb15d29$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $af3a2d87ccb15d29$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $af3a2d87ccb15d29$var$fe = !0;
            return $af3a2d87ccb15d29$var$ee;
        case "textInput":
            return a = b.data, a === $af3a2d87ccb15d29$var$ee && $af3a2d87ccb15d29$var$fe ? null : a;
        default:
            return null;
    }
}
function $af3a2d87ccb15d29$var$ke(a, b) {
    if ($af3a2d87ccb15d29$var$ie) return "compositionend" === a || !$af3a2d87ccb15d29$var$ae && $af3a2d87ccb15d29$var$ge(a, b) ? (a = $af3a2d87ccb15d29$var$nd(), $af3a2d87ccb15d29$var$md = $af3a2d87ccb15d29$var$ld = $af3a2d87ccb15d29$var$kd = null, $af3a2d87ccb15d29$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $af3a2d87ccb15d29$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $af3a2d87ccb15d29$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $af3a2d87ccb15d29$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$af3a2d87ccb15d29$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $af3a2d87ccb15d29$var$ne(a, b, c, d) {
    $af3a2d87ccb15d29$var$Eb(d);
    b = $af3a2d87ccb15d29$var$oe(b, "onChange");
    0 < b.length && (c = new $af3a2d87ccb15d29$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $af3a2d87ccb15d29$var$pe = null, $af3a2d87ccb15d29$var$qe = null;
function $af3a2d87ccb15d29$var$re(a) {
    $af3a2d87ccb15d29$var$se(a, 0);
}
function $af3a2d87ccb15d29$var$te(a) {
    var b = $af3a2d87ccb15d29$var$ue(a);
    if ($af3a2d87ccb15d29$var$Wa(b)) return a;
}
function $af3a2d87ccb15d29$var$ve(a, b) {
    if ("change" === a) return b;
}
var $af3a2d87ccb15d29$var$we = !1;
if ($af3a2d87ccb15d29$var$ia) {
    var $af3a2d87ccb15d29$var$xe;
    if ($af3a2d87ccb15d29$var$ia) {
        var $af3a2d87ccb15d29$var$ye = "oninput" in document;
        if (!$af3a2d87ccb15d29$var$ye) {
            var $af3a2d87ccb15d29$var$ze = document.createElement("div");
            $af3a2d87ccb15d29$var$ze.setAttribute("oninput", "return;");
            $af3a2d87ccb15d29$var$ye = "function" === typeof $af3a2d87ccb15d29$var$ze.oninput;
        }
        $af3a2d87ccb15d29$var$xe = $af3a2d87ccb15d29$var$ye;
    } else $af3a2d87ccb15d29$var$xe = !1;
    $af3a2d87ccb15d29$var$we = $af3a2d87ccb15d29$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $af3a2d87ccb15d29$var$Ae() {
    $af3a2d87ccb15d29$var$pe && ($af3a2d87ccb15d29$var$pe.detachEvent("onpropertychange", $af3a2d87ccb15d29$var$Be), $af3a2d87ccb15d29$var$qe = $af3a2d87ccb15d29$var$pe = null);
}
function $af3a2d87ccb15d29$var$Be(a) {
    if ("value" === a.propertyName && $af3a2d87ccb15d29$var$te($af3a2d87ccb15d29$var$qe)) {
        var b = [];
        $af3a2d87ccb15d29$var$ne(b, $af3a2d87ccb15d29$var$qe, a, $af3a2d87ccb15d29$var$xb(a));
        $af3a2d87ccb15d29$var$Jb($af3a2d87ccb15d29$var$re, b);
    }
}
function $af3a2d87ccb15d29$var$Ce(a, b, c) {
    "focusin" === a ? ($af3a2d87ccb15d29$var$Ae(), $af3a2d87ccb15d29$var$pe = b, $af3a2d87ccb15d29$var$qe = c, $af3a2d87ccb15d29$var$pe.attachEvent("onpropertychange", $af3a2d87ccb15d29$var$Be)) : "focusout" === a && $af3a2d87ccb15d29$var$Ae();
}
function $af3a2d87ccb15d29$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $af3a2d87ccb15d29$var$te($af3a2d87ccb15d29$var$qe);
}
function $af3a2d87ccb15d29$var$Ee(a, b) {
    if ("click" === a) return $af3a2d87ccb15d29$var$te(b);
}
function $af3a2d87ccb15d29$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $af3a2d87ccb15d29$var$te(b);
}
function $af3a2d87ccb15d29$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $af3a2d87ccb15d29$var$He = "function" === typeof Object.is ? Object.is : $af3a2d87ccb15d29$var$Ge;
function $af3a2d87ccb15d29$var$Ie(a, b) {
    if ($af3a2d87ccb15d29$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$af3a2d87ccb15d29$var$ja.call(b, e) || !$af3a2d87ccb15d29$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $af3a2d87ccb15d29$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $af3a2d87ccb15d29$var$Ke(a, b) {
    var c = $af3a2d87ccb15d29$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $af3a2d87ccb15d29$var$Je(c);
    }
}
function $af3a2d87ccb15d29$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $af3a2d87ccb15d29$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $af3a2d87ccb15d29$var$Me() {
    for(var a = window, b = $af3a2d87ccb15d29$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $af3a2d87ccb15d29$var$Xa(a.document);
    }
    return b;
}
function $af3a2d87ccb15d29$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $af3a2d87ccb15d29$var$Oe(a) {
    var b = $af3a2d87ccb15d29$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $af3a2d87ccb15d29$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $af3a2d87ccb15d29$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $af3a2d87ccb15d29$var$Ke(c, f);
                var g = $af3a2d87ccb15d29$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $af3a2d87ccb15d29$var$Pe = $af3a2d87ccb15d29$var$ia && "documentMode" in document && 11 >= document.documentMode, $af3a2d87ccb15d29$var$Qe = null, $af3a2d87ccb15d29$var$Re = null, $af3a2d87ccb15d29$var$Se = null, $af3a2d87ccb15d29$var$Te = !1;
function $af3a2d87ccb15d29$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $af3a2d87ccb15d29$var$Te || null == $af3a2d87ccb15d29$var$Qe || $af3a2d87ccb15d29$var$Qe !== $af3a2d87ccb15d29$var$Xa(d) || (d = $af3a2d87ccb15d29$var$Qe, "selectionStart" in d && $af3a2d87ccb15d29$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $af3a2d87ccb15d29$var$Se && $af3a2d87ccb15d29$var$Ie($af3a2d87ccb15d29$var$Se, d) || ($af3a2d87ccb15d29$var$Se = d, d = $af3a2d87ccb15d29$var$oe($af3a2d87ccb15d29$var$Re, "onSelect"), 0 < d.length && (b = new $af3a2d87ccb15d29$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $af3a2d87ccb15d29$var$Qe)));
}
function $af3a2d87ccb15d29$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $af3a2d87ccb15d29$var$We = {
    animationend: $af3a2d87ccb15d29$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $af3a2d87ccb15d29$var$Ve("Animation", "AnimationIteration"),
    animationstart: $af3a2d87ccb15d29$var$Ve("Animation", "AnimationStart"),
    transitionend: $af3a2d87ccb15d29$var$Ve("Transition", "TransitionEnd")
}, $af3a2d87ccb15d29$var$Xe = {}, $af3a2d87ccb15d29$var$Ye = {};
$af3a2d87ccb15d29$var$ia && ($af3a2d87ccb15d29$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $af3a2d87ccb15d29$var$We.animationend.animation, delete $af3a2d87ccb15d29$var$We.animationiteration.animation, delete $af3a2d87ccb15d29$var$We.animationstart.animation), "TransitionEvent" in window || delete $af3a2d87ccb15d29$var$We.transitionend.transition);
function $af3a2d87ccb15d29$var$Ze(a) {
    if ($af3a2d87ccb15d29$var$Xe[a]) return $af3a2d87ccb15d29$var$Xe[a];
    if (!$af3a2d87ccb15d29$var$We[a]) return a;
    var b = $af3a2d87ccb15d29$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $af3a2d87ccb15d29$var$Ye) return $af3a2d87ccb15d29$var$Xe[a] = b[c];
    return a;
}
var $af3a2d87ccb15d29$var$$e = $af3a2d87ccb15d29$var$Ze("animationend"), $af3a2d87ccb15d29$var$af = $af3a2d87ccb15d29$var$Ze("animationiteration"), $af3a2d87ccb15d29$var$bf = $af3a2d87ccb15d29$var$Ze("animationstart"), $af3a2d87ccb15d29$var$cf = $af3a2d87ccb15d29$var$Ze("transitionend"), $af3a2d87ccb15d29$var$df = new Map, $af3a2d87ccb15d29$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $af3a2d87ccb15d29$var$ff(a, b) {
    $af3a2d87ccb15d29$var$df.set(a, b);
    $af3a2d87ccb15d29$var$fa(b, [
        a
    ]);
}
for(var $af3a2d87ccb15d29$var$gf = 0; $af3a2d87ccb15d29$var$gf < $af3a2d87ccb15d29$var$ef.length; $af3a2d87ccb15d29$var$gf++){
    var $af3a2d87ccb15d29$var$hf = $af3a2d87ccb15d29$var$ef[$af3a2d87ccb15d29$var$gf], $af3a2d87ccb15d29$var$jf = $af3a2d87ccb15d29$var$hf.toLowerCase(), $af3a2d87ccb15d29$var$kf = $af3a2d87ccb15d29$var$hf[0].toUpperCase() + $af3a2d87ccb15d29$var$hf.slice(1);
    $af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$jf, "on" + $af3a2d87ccb15d29$var$kf);
}
$af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$$e, "onAnimationEnd");
$af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$af, "onAnimationIteration");
$af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$bf, "onAnimationStart");
$af3a2d87ccb15d29$var$ff("dblclick", "onDoubleClick");
$af3a2d87ccb15d29$var$ff("focusin", "onFocus");
$af3a2d87ccb15d29$var$ff("focusout", "onBlur");
$af3a2d87ccb15d29$var$ff($af3a2d87ccb15d29$var$cf, "onTransitionEnd");
$af3a2d87ccb15d29$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$af3a2d87ccb15d29$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$af3a2d87ccb15d29$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$af3a2d87ccb15d29$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$af3a2d87ccb15d29$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$af3a2d87ccb15d29$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$af3a2d87ccb15d29$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$af3a2d87ccb15d29$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$af3a2d87ccb15d29$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$af3a2d87ccb15d29$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $af3a2d87ccb15d29$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $af3a2d87ccb15d29$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($af3a2d87ccb15d29$var$lf));
function $af3a2d87ccb15d29$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $af3a2d87ccb15d29$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $af3a2d87ccb15d29$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $af3a2d87ccb15d29$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $af3a2d87ccb15d29$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($af3a2d87ccb15d29$var$Qb) throw a = $af3a2d87ccb15d29$var$Rb, $af3a2d87ccb15d29$var$Qb = !1, $af3a2d87ccb15d29$var$Rb = null, a;
}
function $af3a2d87ccb15d29$var$D(a, b) {
    var c = b[$af3a2d87ccb15d29$var$of];
    void 0 === c && (c = b[$af3a2d87ccb15d29$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($af3a2d87ccb15d29$var$pf(b, a, 2, !1), c.add(d));
}
function $af3a2d87ccb15d29$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $af3a2d87ccb15d29$var$pf(c, a, d, b);
}
var $af3a2d87ccb15d29$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $af3a2d87ccb15d29$var$sf(a) {
    if (!a[$af3a2d87ccb15d29$var$rf]) {
        a[$af3a2d87ccb15d29$var$rf] = !0;
        $af3a2d87ccb15d29$var$da.forEach(function(b) {
            "selectionchange" !== b && ($af3a2d87ccb15d29$var$mf.has(b) || $af3a2d87ccb15d29$var$qf(b, !1, a), $af3a2d87ccb15d29$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$af3a2d87ccb15d29$var$rf] || (b[$af3a2d87ccb15d29$var$rf] = !0, $af3a2d87ccb15d29$var$qf("selectionchange", !1, b));
    }
}
function $af3a2d87ccb15d29$var$pf(a, b, c, d) {
    switch($af3a2d87ccb15d29$var$jd(b)){
        case 1:
            var e = $af3a2d87ccb15d29$var$ed;
            break;
        case 4:
            e = $af3a2d87ccb15d29$var$gd;
            break;
        default:
            e = $af3a2d87ccb15d29$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$af3a2d87ccb15d29$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $af3a2d87ccb15d29$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $af3a2d87ccb15d29$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $af3a2d87ccb15d29$var$Jb(function() {
        var d = f, e = $af3a2d87ccb15d29$var$xb(c), g = [];
        a: {
            var h = $af3a2d87ccb15d29$var$df.get(a);
            if (void 0 !== h) {
                var k = $af3a2d87ccb15d29$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $af3a2d87ccb15d29$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $af3a2d87ccb15d29$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $af3a2d87ccb15d29$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $af3a2d87ccb15d29$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $af3a2d87ccb15d29$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $af3a2d87ccb15d29$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $af3a2d87ccb15d29$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $af3a2d87ccb15d29$var$Vd;
                        break;
                    case $af3a2d87ccb15d29$var$$e:
                    case $af3a2d87ccb15d29$var$af:
                    case $af3a2d87ccb15d29$var$bf:
                        k = $af3a2d87ccb15d29$var$Hd;
                        break;
                    case $af3a2d87ccb15d29$var$cf:
                        k = $af3a2d87ccb15d29$var$Xd;
                        break;
                    case "scroll":
                        k = $af3a2d87ccb15d29$var$vd;
                        break;
                    case "wheel":
                        k = $af3a2d87ccb15d29$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $af3a2d87ccb15d29$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $af3a2d87ccb15d29$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $af3a2d87ccb15d29$var$Kb(w, x), null != F && t.push($af3a2d87ccb15d29$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $af3a2d87ccb15d29$var$wb && (n = c.relatedTarget || c.fromElement) && ($af3a2d87ccb15d29$var$Wc(n) || n[$af3a2d87ccb15d29$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $af3a2d87ccb15d29$var$Wc(n) : null, null !== n && (J = $af3a2d87ccb15d29$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $af3a2d87ccb15d29$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $af3a2d87ccb15d29$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $af3a2d87ccb15d29$var$ue(k);
                        u = null == n ? h : $af3a2d87ccb15d29$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $af3a2d87ccb15d29$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $af3a2d87ccb15d29$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $af3a2d87ccb15d29$var$vf(F))u++;
                            for(; 0 < w - u;)t = $af3a2d87ccb15d29$var$vf(t), w--;
                            for(; 0 < u - w;)x = $af3a2d87ccb15d29$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $af3a2d87ccb15d29$var$vf(t);
                                x = $af3a2d87ccb15d29$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $af3a2d87ccb15d29$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $af3a2d87ccb15d29$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $af3a2d87ccb15d29$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $af3a2d87ccb15d29$var$ve;
                else if ($af3a2d87ccb15d29$var$me(h)) {
                    if ($af3a2d87ccb15d29$var$we) na = $af3a2d87ccb15d29$var$Fe;
                    else {
                        na = $af3a2d87ccb15d29$var$De;
                        var xa = $af3a2d87ccb15d29$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $af3a2d87ccb15d29$var$Ee);
                if (na && (na = na(a, d))) {
                    $af3a2d87ccb15d29$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $af3a2d87ccb15d29$var$cb(h, "number", h.value);
            }
            xa = d ? $af3a2d87ccb15d29$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($af3a2d87ccb15d29$var$me(xa) || "true" === xa.contentEditable) $af3a2d87ccb15d29$var$Qe = xa, $af3a2d87ccb15d29$var$Re = d, $af3a2d87ccb15d29$var$Se = null;
                    break;
                case "focusout":
                    $af3a2d87ccb15d29$var$Se = $af3a2d87ccb15d29$var$Re = $af3a2d87ccb15d29$var$Qe = null;
                    break;
                case "mousedown":
                    $af3a2d87ccb15d29$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $af3a2d87ccb15d29$var$Te = !1;
                    $af3a2d87ccb15d29$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($af3a2d87ccb15d29$var$Pe) break;
                case "keydown":
                case "keyup":
                    $af3a2d87ccb15d29$var$Ue(g, c, e);
            }
            var $a;
            if ($af3a2d87ccb15d29$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $af3a2d87ccb15d29$var$ie ? $af3a2d87ccb15d29$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($af3a2d87ccb15d29$var$de && "ko" !== c.locale && ($af3a2d87ccb15d29$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $af3a2d87ccb15d29$var$ie && ($a = $af3a2d87ccb15d29$var$nd()) : ($af3a2d87ccb15d29$var$kd = e, $af3a2d87ccb15d29$var$ld = "value" in $af3a2d87ccb15d29$var$kd ? $af3a2d87ccb15d29$var$kd.value : $af3a2d87ccb15d29$var$kd.textContent, $af3a2d87ccb15d29$var$ie = !0)), xa = $af3a2d87ccb15d29$var$oe(d, ba), 0 < xa.length && (ba = new $af3a2d87ccb15d29$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $af3a2d87ccb15d29$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $af3a2d87ccb15d29$var$ce ? $af3a2d87ccb15d29$var$je(a, c) : $af3a2d87ccb15d29$var$ke(a, c)) d = $af3a2d87ccb15d29$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $af3a2d87ccb15d29$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $af3a2d87ccb15d29$var$se(g, b);
    });
}
function $af3a2d87ccb15d29$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $af3a2d87ccb15d29$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $af3a2d87ccb15d29$var$Kb(a, c), null != f && d.unshift($af3a2d87ccb15d29$var$tf(a, f, e)), f = $af3a2d87ccb15d29$var$Kb(a, b), null != f && d.push($af3a2d87ccb15d29$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $af3a2d87ccb15d29$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $af3a2d87ccb15d29$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $af3a2d87ccb15d29$var$Kb(c, f), null != k && g.unshift($af3a2d87ccb15d29$var$tf(c, k, h))) : e || (k = $af3a2d87ccb15d29$var$Kb(c, f), null != k && g.push($af3a2d87ccb15d29$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $af3a2d87ccb15d29$var$xf = /\r\n?/g, $af3a2d87ccb15d29$var$yf = /\u0000|\uFFFD/g;
function $af3a2d87ccb15d29$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($af3a2d87ccb15d29$var$xf, "\n").replace($af3a2d87ccb15d29$var$yf, "");
}
function $af3a2d87ccb15d29$var$Af(a, b, c) {
    b = $af3a2d87ccb15d29$var$zf(b);
    if ($af3a2d87ccb15d29$var$zf(a) !== b && c) throw Error($af3a2d87ccb15d29$var$p(425));
}
function $af3a2d87ccb15d29$var$Bf() {}
var $af3a2d87ccb15d29$var$Cf = null, $af3a2d87ccb15d29$var$Df = null;
function $af3a2d87ccb15d29$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $af3a2d87ccb15d29$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $af3a2d87ccb15d29$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $af3a2d87ccb15d29$var$Hf = "function" === typeof Promise ? Promise : void 0, $af3a2d87ccb15d29$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $af3a2d87ccb15d29$var$Hf ? function(a) {
    return $af3a2d87ccb15d29$var$Hf.resolve(null).then(a).catch($af3a2d87ccb15d29$var$If);
} : $af3a2d87ccb15d29$var$Ff;
function $af3a2d87ccb15d29$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $af3a2d87ccb15d29$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $af3a2d87ccb15d29$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $af3a2d87ccb15d29$var$bd(b);
}
function $af3a2d87ccb15d29$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $af3a2d87ccb15d29$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $af3a2d87ccb15d29$var$Nf = Math.random().toString(36).slice(2), $af3a2d87ccb15d29$var$Of = "__reactFiber$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$Pf = "__reactProps$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$uf = "__reactContainer$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$of = "__reactEvents$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$Qf = "__reactListeners$" + $af3a2d87ccb15d29$var$Nf, $af3a2d87ccb15d29$var$Rf = "__reactHandles$" + $af3a2d87ccb15d29$var$Nf;
function $af3a2d87ccb15d29$var$Wc(a) {
    var b = a[$af3a2d87ccb15d29$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$af3a2d87ccb15d29$var$uf] || c[$af3a2d87ccb15d29$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $af3a2d87ccb15d29$var$Mf(a); null !== a;){
                if (c = a[$af3a2d87ccb15d29$var$Of]) return c;
                a = $af3a2d87ccb15d29$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $af3a2d87ccb15d29$var$Cb(a) {
    a = a[$af3a2d87ccb15d29$var$Of] || a[$af3a2d87ccb15d29$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $af3a2d87ccb15d29$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($af3a2d87ccb15d29$var$p(33));
}
function $af3a2d87ccb15d29$var$Db(a) {
    return a[$af3a2d87ccb15d29$var$Pf] || null;
}
var $af3a2d87ccb15d29$var$Sf = [], $af3a2d87ccb15d29$var$Tf = -1;
function $af3a2d87ccb15d29$var$Uf(a) {
    return {
        current: a
    };
}
function $af3a2d87ccb15d29$var$E(a) {
    0 > $af3a2d87ccb15d29$var$Tf || (a.current = $af3a2d87ccb15d29$var$Sf[$af3a2d87ccb15d29$var$Tf], $af3a2d87ccb15d29$var$Sf[$af3a2d87ccb15d29$var$Tf] = null, $af3a2d87ccb15d29$var$Tf--);
}
function $af3a2d87ccb15d29$var$G(a, b) {
    $af3a2d87ccb15d29$var$Tf++;
    $af3a2d87ccb15d29$var$Sf[$af3a2d87ccb15d29$var$Tf] = a.current;
    a.current = b;
}
var $af3a2d87ccb15d29$var$Vf = {}, $af3a2d87ccb15d29$var$H = $af3a2d87ccb15d29$var$Uf($af3a2d87ccb15d29$var$Vf), $af3a2d87ccb15d29$var$Wf = $af3a2d87ccb15d29$var$Uf(!1), $af3a2d87ccb15d29$var$Xf = $af3a2d87ccb15d29$var$Vf;
function $af3a2d87ccb15d29$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $af3a2d87ccb15d29$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $af3a2d87ccb15d29$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $af3a2d87ccb15d29$var$$f() {
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf);
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H);
}
function $af3a2d87ccb15d29$var$ag(a, b, c) {
    if ($af3a2d87ccb15d29$var$H.current !== $af3a2d87ccb15d29$var$Vf) throw Error($af3a2d87ccb15d29$var$p(168));
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$H, b);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Wf, c);
}
function $af3a2d87ccb15d29$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($af3a2d87ccb15d29$var$p(108, $af3a2d87ccb15d29$var$Ra(a) || "Unknown", e));
    return $af3a2d87ccb15d29$var$A({}, c, d);
}
function $af3a2d87ccb15d29$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $af3a2d87ccb15d29$var$Vf;
    $af3a2d87ccb15d29$var$Xf = $af3a2d87ccb15d29$var$H.current;
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$H, a);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Wf, $af3a2d87ccb15d29$var$Wf.current);
    return !0;
}
function $af3a2d87ccb15d29$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($af3a2d87ccb15d29$var$p(169));
    c ? (a = $af3a2d87ccb15d29$var$bg(a, b, $af3a2d87ccb15d29$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf), $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H), $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$H, a)) : $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Wf, c);
}
var $af3a2d87ccb15d29$var$eg = null, $af3a2d87ccb15d29$var$fg = !1, $af3a2d87ccb15d29$var$gg = !1;
function $af3a2d87ccb15d29$var$hg(a) {
    null === $af3a2d87ccb15d29$var$eg ? $af3a2d87ccb15d29$var$eg = [
        a
    ] : $af3a2d87ccb15d29$var$eg.push(a);
}
function $af3a2d87ccb15d29$var$ig(a) {
    $af3a2d87ccb15d29$var$fg = !0;
    $af3a2d87ccb15d29$var$hg(a);
}
function $af3a2d87ccb15d29$var$jg() {
    if (!$af3a2d87ccb15d29$var$gg && null !== $af3a2d87ccb15d29$var$eg) {
        $af3a2d87ccb15d29$var$gg = !0;
        var a = 0, b = $af3a2d87ccb15d29$var$C;
        try {
            var c = $af3a2d87ccb15d29$var$eg;
            for($af3a2d87ccb15d29$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $af3a2d87ccb15d29$var$eg = null;
            $af3a2d87ccb15d29$var$fg = !1;
        } catch (e) {
            throw null !== $af3a2d87ccb15d29$var$eg && ($af3a2d87ccb15d29$var$eg = $af3a2d87ccb15d29$var$eg.slice(a + 1)), $af3a2d87ccb15d29$var$ac($af3a2d87ccb15d29$var$fc, $af3a2d87ccb15d29$var$jg), e;
        } finally{
            $af3a2d87ccb15d29$var$C = b, $af3a2d87ccb15d29$var$gg = !1;
        }
    }
    return null;
}
var $af3a2d87ccb15d29$var$kg = [], $af3a2d87ccb15d29$var$lg = 0, $af3a2d87ccb15d29$var$mg = null, $af3a2d87ccb15d29$var$ng = 0, $af3a2d87ccb15d29$var$og = [], $af3a2d87ccb15d29$var$pg = 0, $af3a2d87ccb15d29$var$qg = null, $af3a2d87ccb15d29$var$rg = 1, $af3a2d87ccb15d29$var$sg = "";
function $af3a2d87ccb15d29$var$tg(a, b) {
    $af3a2d87ccb15d29$var$kg[$af3a2d87ccb15d29$var$lg++] = $af3a2d87ccb15d29$var$ng;
    $af3a2d87ccb15d29$var$kg[$af3a2d87ccb15d29$var$lg++] = $af3a2d87ccb15d29$var$mg;
    $af3a2d87ccb15d29$var$mg = a;
    $af3a2d87ccb15d29$var$ng = b;
}
function $af3a2d87ccb15d29$var$ug(a, b, c) {
    $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$rg;
    $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$sg;
    $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$qg;
    $af3a2d87ccb15d29$var$qg = a;
    var d = $af3a2d87ccb15d29$var$rg;
    a = $af3a2d87ccb15d29$var$sg;
    var e = 32 - $af3a2d87ccb15d29$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $af3a2d87ccb15d29$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $af3a2d87ccb15d29$var$rg = 1 << 32 - $af3a2d87ccb15d29$var$oc(b) + e | c << e | d;
        $af3a2d87ccb15d29$var$sg = f + a;
    } else $af3a2d87ccb15d29$var$rg = 1 << f | c << e | d, $af3a2d87ccb15d29$var$sg = a;
}
function $af3a2d87ccb15d29$var$vg(a) {
    null !== a.return && ($af3a2d87ccb15d29$var$tg(a, 1), $af3a2d87ccb15d29$var$ug(a, 1, 0));
}
function $af3a2d87ccb15d29$var$wg(a) {
    for(; a === $af3a2d87ccb15d29$var$mg;)$af3a2d87ccb15d29$var$mg = $af3a2d87ccb15d29$var$kg[--$af3a2d87ccb15d29$var$lg], $af3a2d87ccb15d29$var$kg[$af3a2d87ccb15d29$var$lg] = null, $af3a2d87ccb15d29$var$ng = $af3a2d87ccb15d29$var$kg[--$af3a2d87ccb15d29$var$lg], $af3a2d87ccb15d29$var$kg[$af3a2d87ccb15d29$var$lg] = null;
    for(; a === $af3a2d87ccb15d29$var$qg;)$af3a2d87ccb15d29$var$qg = $af3a2d87ccb15d29$var$og[--$af3a2d87ccb15d29$var$pg], $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg] = null, $af3a2d87ccb15d29$var$sg = $af3a2d87ccb15d29$var$og[--$af3a2d87ccb15d29$var$pg], $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg] = null, $af3a2d87ccb15d29$var$rg = $af3a2d87ccb15d29$var$og[--$af3a2d87ccb15d29$var$pg], $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg] = null;
}
var $af3a2d87ccb15d29$var$xg = null, $af3a2d87ccb15d29$var$yg = null, $af3a2d87ccb15d29$var$I = !1, $af3a2d87ccb15d29$var$zg = null;
function $af3a2d87ccb15d29$var$Ag(a, b) {
    var c = $af3a2d87ccb15d29$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $af3a2d87ccb15d29$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $af3a2d87ccb15d29$var$xg = a, $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $af3a2d87ccb15d29$var$xg = a, $af3a2d87ccb15d29$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $af3a2d87ccb15d29$var$qg ? {
                id: $af3a2d87ccb15d29$var$rg,
                overflow: $af3a2d87ccb15d29$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $af3a2d87ccb15d29$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $af3a2d87ccb15d29$var$xg = a, $af3a2d87ccb15d29$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $af3a2d87ccb15d29$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $af3a2d87ccb15d29$var$Eg(a) {
    if ($af3a2d87ccb15d29$var$I) {
        var b = $af3a2d87ccb15d29$var$yg;
        if (b) {
            var c = b;
            if (!$af3a2d87ccb15d29$var$Cg(a, b)) {
                if ($af3a2d87ccb15d29$var$Dg(a)) throw Error($af3a2d87ccb15d29$var$p(418));
                b = $af3a2d87ccb15d29$var$Lf(c.nextSibling);
                var d = $af3a2d87ccb15d29$var$xg;
                b && $af3a2d87ccb15d29$var$Cg(a, b) ? $af3a2d87ccb15d29$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $af3a2d87ccb15d29$var$I = !1, $af3a2d87ccb15d29$var$xg = a);
            }
        } else {
            if ($af3a2d87ccb15d29$var$Dg(a)) throw Error($af3a2d87ccb15d29$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $af3a2d87ccb15d29$var$I = !1;
            $af3a2d87ccb15d29$var$xg = a;
        }
    }
}
function $af3a2d87ccb15d29$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $af3a2d87ccb15d29$var$xg = a;
}
function $af3a2d87ccb15d29$var$Gg(a) {
    if (a !== $af3a2d87ccb15d29$var$xg) return !1;
    if (!$af3a2d87ccb15d29$var$I) return $af3a2d87ccb15d29$var$Fg(a), $af3a2d87ccb15d29$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$af3a2d87ccb15d29$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $af3a2d87ccb15d29$var$yg)) {
        if ($af3a2d87ccb15d29$var$Dg(a)) throw $af3a2d87ccb15d29$var$Hg(), Error($af3a2d87ccb15d29$var$p(418));
        for(; b;)$af3a2d87ccb15d29$var$Ag(a, b), b = $af3a2d87ccb15d29$var$Lf(b.nextSibling);
    }
    $af3a2d87ccb15d29$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($af3a2d87ccb15d29$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $af3a2d87ccb15d29$var$yg = null;
        }
    } else $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$xg ? $af3a2d87ccb15d29$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $af3a2d87ccb15d29$var$Hg() {
    for(var a = $af3a2d87ccb15d29$var$yg; a;)a = $af3a2d87ccb15d29$var$Lf(a.nextSibling);
}
function $af3a2d87ccb15d29$var$Ig() {
    $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$xg = null;
    $af3a2d87ccb15d29$var$I = !1;
}
function $af3a2d87ccb15d29$var$Jg(a) {
    null === $af3a2d87ccb15d29$var$zg ? $af3a2d87ccb15d29$var$zg = [
        a
    ] : $af3a2d87ccb15d29$var$zg.push(a);
}
var $af3a2d87ccb15d29$var$Kg = $af3a2d87ccb15d29$var$ua.ReactCurrentBatchConfig;
function $af3a2d87ccb15d29$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $af3a2d87ccb15d29$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $af3a2d87ccb15d29$var$Mg = $af3a2d87ccb15d29$var$Uf(null), $af3a2d87ccb15d29$var$Ng = null, $af3a2d87ccb15d29$var$Og = null, $af3a2d87ccb15d29$var$Pg = null;
function $af3a2d87ccb15d29$var$Qg() {
    $af3a2d87ccb15d29$var$Pg = $af3a2d87ccb15d29$var$Og = $af3a2d87ccb15d29$var$Ng = null;
}
function $af3a2d87ccb15d29$var$Rg(a) {
    var b = $af3a2d87ccb15d29$var$Mg.current;
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Mg);
    a._currentValue = b;
}
function $af3a2d87ccb15d29$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $af3a2d87ccb15d29$var$Tg(a, b) {
    $af3a2d87ccb15d29$var$Ng = a;
    $af3a2d87ccb15d29$var$Pg = $af3a2d87ccb15d29$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($af3a2d87ccb15d29$var$Ug = !0), a.firstContext = null);
}
function $af3a2d87ccb15d29$var$Vg(a) {
    var b = a._currentValue;
    if ($af3a2d87ccb15d29$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $af3a2d87ccb15d29$var$Og) {
            if (null === $af3a2d87ccb15d29$var$Ng) throw Error($af3a2d87ccb15d29$var$p(308));
            $af3a2d87ccb15d29$var$Og = a;
            $af3a2d87ccb15d29$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $af3a2d87ccb15d29$var$Og = $af3a2d87ccb15d29$var$Og.next = a;
    }
    return b;
}
var $af3a2d87ccb15d29$var$Wg = null;
function $af3a2d87ccb15d29$var$Xg(a) {
    null === $af3a2d87ccb15d29$var$Wg ? $af3a2d87ccb15d29$var$Wg = [
        a
    ] : $af3a2d87ccb15d29$var$Wg.push(a);
}
function $af3a2d87ccb15d29$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $af3a2d87ccb15d29$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $af3a2d87ccb15d29$var$Zg(a, d);
}
function $af3a2d87ccb15d29$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $af3a2d87ccb15d29$var$$g = !1;
function $af3a2d87ccb15d29$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $af3a2d87ccb15d29$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $af3a2d87ccb15d29$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $af3a2d87ccb15d29$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($af3a2d87ccb15d29$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $af3a2d87ccb15d29$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $af3a2d87ccb15d29$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $af3a2d87ccb15d29$var$Zg(a, c);
}
function $af3a2d87ccb15d29$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $af3a2d87ccb15d29$var$Cc(a, c);
    }
}
function $af3a2d87ccb15d29$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $af3a2d87ccb15d29$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $af3a2d87ccb15d29$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $af3a2d87ccb15d29$var$A({}, q, r);
                            break a;
                        case 2:
                            $af3a2d87ccb15d29$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $af3a2d87ccb15d29$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $af3a2d87ccb15d29$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($af3a2d87ccb15d29$var$p(191, e));
            e.call(d);
        }
    }
}
var $af3a2d87ccb15d29$var$jh = (new $lx97N.Component).refs;
function $af3a2d87ccb15d29$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $af3a2d87ccb15d29$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $af3a2d87ccb15d29$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $af3a2d87ccb15d29$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $af3a2d87ccb15d29$var$L(), e = $af3a2d87ccb15d29$var$lh(a), f = $af3a2d87ccb15d29$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $af3a2d87ccb15d29$var$dh(a, f, e);
        null !== b && ($af3a2d87ccb15d29$var$mh(b, a, e, d), $af3a2d87ccb15d29$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $af3a2d87ccb15d29$var$L(), e = $af3a2d87ccb15d29$var$lh(a), f = $af3a2d87ccb15d29$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $af3a2d87ccb15d29$var$dh(a, f, e);
        null !== b && ($af3a2d87ccb15d29$var$mh(b, a, e, d), $af3a2d87ccb15d29$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $af3a2d87ccb15d29$var$L(), d = $af3a2d87ccb15d29$var$lh(a), e = $af3a2d87ccb15d29$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $af3a2d87ccb15d29$var$dh(a, e, d);
        null !== b && ($af3a2d87ccb15d29$var$mh(b, a, d, c), $af3a2d87ccb15d29$var$eh(b, a, d));
    }
};
function $af3a2d87ccb15d29$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$af3a2d87ccb15d29$var$Ie(c, d) || !$af3a2d87ccb15d29$var$Ie(e, f) : !0;
}
function $af3a2d87ccb15d29$var$ph(a, b, c) {
    var d = !1, e = $af3a2d87ccb15d29$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $af3a2d87ccb15d29$var$Vg(f) : (e = $af3a2d87ccb15d29$var$Zf(b) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $af3a2d87ccb15d29$var$Yf(a, e) : $af3a2d87ccb15d29$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $af3a2d87ccb15d29$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $af3a2d87ccb15d29$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $af3a2d87ccb15d29$var$nh.enqueueReplaceState(b, b.state, null);
}
function $af3a2d87ccb15d29$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $af3a2d87ccb15d29$var$jh;
    $af3a2d87ccb15d29$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $af3a2d87ccb15d29$var$Vg(f) : (f = $af3a2d87ccb15d29$var$Zf(b) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current, e.context = $af3a2d87ccb15d29$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($af3a2d87ccb15d29$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $af3a2d87ccb15d29$var$nh.enqueueReplaceState(e, e.state, null), $af3a2d87ccb15d29$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $af3a2d87ccb15d29$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($af3a2d87ccb15d29$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($af3a2d87ccb15d29$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $af3a2d87ccb15d29$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($af3a2d87ccb15d29$var$p(284));
        if (!c._owner) throw Error($af3a2d87ccb15d29$var$p(290, a));
    }
    return a;
}
function $af3a2d87ccb15d29$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($af3a2d87ccb15d29$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $af3a2d87ccb15d29$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $af3a2d87ccb15d29$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $af3a2d87ccb15d29$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $af3a2d87ccb15d29$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $af3a2d87ccb15d29$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $af3a2d87ccb15d29$var$Ha && $af3a2d87ccb15d29$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $af3a2d87ccb15d29$var$sh(a, b, c), d.return = a, d;
        d = $af3a2d87ccb15d29$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $af3a2d87ccb15d29$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $af3a2d87ccb15d29$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $af3a2d87ccb15d29$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $af3a2d87ccb15d29$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $af3a2d87ccb15d29$var$va:
                    return c = $af3a2d87ccb15d29$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $af3a2d87ccb15d29$var$sh(a, null, b), c.return = a, c;
                case $af3a2d87ccb15d29$var$wa:
                    return b = $af3a2d87ccb15d29$var$zh(b, a.mode, c), b.return = a, b;
                case $af3a2d87ccb15d29$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($af3a2d87ccb15d29$var$eb(b) || $af3a2d87ccb15d29$var$Ka(b)) return b = $af3a2d87ccb15d29$var$Ah(b, a.mode, c, null), b.return = a, b;
            $af3a2d87ccb15d29$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $af3a2d87ccb15d29$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $af3a2d87ccb15d29$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $af3a2d87ccb15d29$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($af3a2d87ccb15d29$var$eb(c) || $af3a2d87ccb15d29$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $af3a2d87ccb15d29$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $af3a2d87ccb15d29$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $af3a2d87ccb15d29$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $af3a2d87ccb15d29$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($af3a2d87ccb15d29$var$eb(d) || $af3a2d87ccb15d29$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $af3a2d87ccb15d29$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $af3a2d87ccb15d29$var$Ka(h);
        if ("function" !== typeof l) throw Error($af3a2d87ccb15d29$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($af3a2d87ccb15d29$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $af3a2d87ccb15d29$var$I && $af3a2d87ccb15d29$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $af3a2d87ccb15d29$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $af3a2d87ccb15d29$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $af3a2d87ccb15d29$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $af3a2d87ccb15d29$var$Ha && $af3a2d87ccb15d29$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $af3a2d87ccb15d29$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $af3a2d87ccb15d29$var$ya ? (d = $af3a2d87ccb15d29$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $af3a2d87ccb15d29$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $af3a2d87ccb15d29$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $af3a2d87ccb15d29$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $af3a2d87ccb15d29$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $af3a2d87ccb15d29$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($af3a2d87ccb15d29$var$eb(f)) return n(a, d, f, h);
            if ($af3a2d87ccb15d29$var$Ka(f)) return t(a, d, f, h);
            $af3a2d87ccb15d29$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $af3a2d87ccb15d29$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $af3a2d87ccb15d29$var$Bh = $af3a2d87ccb15d29$var$vh(!0), $af3a2d87ccb15d29$var$Ch = $af3a2d87ccb15d29$var$vh(!1), $af3a2d87ccb15d29$var$Dh = {}, $af3a2d87ccb15d29$var$Eh = $af3a2d87ccb15d29$var$Uf($af3a2d87ccb15d29$var$Dh), $af3a2d87ccb15d29$var$Fh = $af3a2d87ccb15d29$var$Uf($af3a2d87ccb15d29$var$Dh), $af3a2d87ccb15d29$var$Gh = $af3a2d87ccb15d29$var$Uf($af3a2d87ccb15d29$var$Dh);
function $af3a2d87ccb15d29$var$Hh(a) {
    if (a === $af3a2d87ccb15d29$var$Dh) throw Error($af3a2d87ccb15d29$var$p(174));
    return a;
}
function $af3a2d87ccb15d29$var$Ih(a, b) {
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Gh, b);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Fh, a);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Eh, $af3a2d87ccb15d29$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $af3a2d87ccb15d29$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $af3a2d87ccb15d29$var$lb(b, a);
    }
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Eh);
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Eh, b);
}
function $af3a2d87ccb15d29$var$Jh() {
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Eh);
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Fh);
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Gh);
}
function $af3a2d87ccb15d29$var$Kh(a) {
    $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Gh.current);
    var b = $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Eh.current);
    var c = $af3a2d87ccb15d29$var$lb(b, a.type);
    b !== c && ($af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Fh, a), $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Eh, c));
}
function $af3a2d87ccb15d29$var$Lh(a) {
    $af3a2d87ccb15d29$var$Fh.current === a && ($af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Eh), $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Fh));
}
var $af3a2d87ccb15d29$var$M = $af3a2d87ccb15d29$var$Uf(0);
function $af3a2d87ccb15d29$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $af3a2d87ccb15d29$var$Nh = [];
function $af3a2d87ccb15d29$var$Oh() {
    for(var a = 0; a < $af3a2d87ccb15d29$var$Nh.length; a++)$af3a2d87ccb15d29$var$Nh[a]._workInProgressVersionPrimary = null;
    $af3a2d87ccb15d29$var$Nh.length = 0;
}
var $af3a2d87ccb15d29$var$Ph = $af3a2d87ccb15d29$var$ua.ReactCurrentDispatcher, $af3a2d87ccb15d29$var$Qh = $af3a2d87ccb15d29$var$ua.ReactCurrentBatchConfig, $af3a2d87ccb15d29$var$Rh = 0, $af3a2d87ccb15d29$var$N = null, $af3a2d87ccb15d29$var$O = null, $af3a2d87ccb15d29$var$P = null, $af3a2d87ccb15d29$var$Sh = !1, $af3a2d87ccb15d29$var$Th = !1, $af3a2d87ccb15d29$var$Uh = 0, $af3a2d87ccb15d29$var$Vh = 0;
function $af3a2d87ccb15d29$var$Q() {
    throw Error($af3a2d87ccb15d29$var$p(321));
}
function $af3a2d87ccb15d29$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$af3a2d87ccb15d29$var$He(a[c], b[c])) return !1;
    return !0;
}
function $af3a2d87ccb15d29$var$Xh(a, b, c, d, e, f) {
    $af3a2d87ccb15d29$var$Rh = f;
    $af3a2d87ccb15d29$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $af3a2d87ccb15d29$var$Ph.current = null === a || null === a.memoizedState ? $af3a2d87ccb15d29$var$Yh : $af3a2d87ccb15d29$var$Zh;
    a = c(d, e);
    if ($af3a2d87ccb15d29$var$Th) {
        f = 0;
        do {
            $af3a2d87ccb15d29$var$Th = !1;
            $af3a2d87ccb15d29$var$Uh = 0;
            if (25 <= f) throw Error($af3a2d87ccb15d29$var$p(301));
            f += 1;
            $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$O = null;
            b.updateQueue = null;
            $af3a2d87ccb15d29$var$Ph.current = $af3a2d87ccb15d29$var$$h;
            a = c(d, e);
        }while ($af3a2d87ccb15d29$var$Th);
    }
    $af3a2d87ccb15d29$var$Ph.current = $af3a2d87ccb15d29$var$ai;
    b = null !== $af3a2d87ccb15d29$var$O && null !== $af3a2d87ccb15d29$var$O.next;
    $af3a2d87ccb15d29$var$Rh = 0;
    $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$O = $af3a2d87ccb15d29$var$N = null;
    $af3a2d87ccb15d29$var$Sh = !1;
    if (b) throw Error($af3a2d87ccb15d29$var$p(300));
    return a;
}
function $af3a2d87ccb15d29$var$bi() {
    var a = 0 !== $af3a2d87ccb15d29$var$Uh;
    $af3a2d87ccb15d29$var$Uh = 0;
    return a;
}
function $af3a2d87ccb15d29$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $af3a2d87ccb15d29$var$P ? $af3a2d87ccb15d29$var$N.memoizedState = $af3a2d87ccb15d29$var$P = a : $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$P.next = a;
    return $af3a2d87ccb15d29$var$P;
}
function $af3a2d87ccb15d29$var$di() {
    if (null === $af3a2d87ccb15d29$var$O) {
        var a = $af3a2d87ccb15d29$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $af3a2d87ccb15d29$var$O.next;
    var b = null === $af3a2d87ccb15d29$var$P ? $af3a2d87ccb15d29$var$N.memoizedState : $af3a2d87ccb15d29$var$P.next;
    if (null !== b) $af3a2d87ccb15d29$var$P = b, $af3a2d87ccb15d29$var$O = a;
    else {
        if (null === a) throw Error($af3a2d87ccb15d29$var$p(310));
        $af3a2d87ccb15d29$var$O = a;
        a = {
            memoizedState: $af3a2d87ccb15d29$var$O.memoizedState,
            baseState: $af3a2d87ccb15d29$var$O.baseState,
            baseQueue: $af3a2d87ccb15d29$var$O.baseQueue,
            queue: $af3a2d87ccb15d29$var$O.queue,
            next: null
        };
        null === $af3a2d87ccb15d29$var$P ? $af3a2d87ccb15d29$var$N.memoizedState = $af3a2d87ccb15d29$var$P = a : $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$P.next = a;
    }
    return $af3a2d87ccb15d29$var$P;
}
function $af3a2d87ccb15d29$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $af3a2d87ccb15d29$var$fi(a) {
    var b = $af3a2d87ccb15d29$var$di(), c = b.queue;
    if (null === c) throw Error($af3a2d87ccb15d29$var$p(311));
    c.lastRenderedReducer = a;
    var d = $af3a2d87ccb15d29$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($af3a2d87ccb15d29$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $af3a2d87ccb15d29$var$N.lanes |= m;
                $af3a2d87ccb15d29$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $af3a2d87ccb15d29$var$He(d, b.memoizedState) || ($af3a2d87ccb15d29$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $af3a2d87ccb15d29$var$N.lanes |= f, $af3a2d87ccb15d29$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $af3a2d87ccb15d29$var$gi(a) {
    var b = $af3a2d87ccb15d29$var$di(), c = b.queue;
    if (null === c) throw Error($af3a2d87ccb15d29$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $af3a2d87ccb15d29$var$He(f, b.memoizedState) || ($af3a2d87ccb15d29$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $af3a2d87ccb15d29$var$hi() {}
function $af3a2d87ccb15d29$var$ii(a, b) {
    var c = $af3a2d87ccb15d29$var$N, d = $af3a2d87ccb15d29$var$di(), e = b(), f = !$af3a2d87ccb15d29$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $af3a2d87ccb15d29$var$Ug = !0);
    d = d.queue;
    $af3a2d87ccb15d29$var$ji($af3a2d87ccb15d29$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $af3a2d87ccb15d29$var$P && $af3a2d87ccb15d29$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $af3a2d87ccb15d29$var$li(9, $af3a2d87ccb15d29$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $af3a2d87ccb15d29$var$R) throw Error($af3a2d87ccb15d29$var$p(349));
        0 !== ($af3a2d87ccb15d29$var$Rh & 30) || $af3a2d87ccb15d29$var$ni(c, b, e);
    }
    return e;
}
function $af3a2d87ccb15d29$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $af3a2d87ccb15d29$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $af3a2d87ccb15d29$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $af3a2d87ccb15d29$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $af3a2d87ccb15d29$var$oi(b) && $af3a2d87ccb15d29$var$pi(a);
}
function $af3a2d87ccb15d29$var$ki(a, b, c) {
    return c(function() {
        $af3a2d87ccb15d29$var$oi(b) && $af3a2d87ccb15d29$var$pi(a);
    });
}
function $af3a2d87ccb15d29$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$af3a2d87ccb15d29$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $af3a2d87ccb15d29$var$pi(a) {
    var b = $af3a2d87ccb15d29$var$Zg(a, 1);
    null !== b && $af3a2d87ccb15d29$var$mh(b, a, 1, -1);
}
function $af3a2d87ccb15d29$var$qi(a) {
    var b = $af3a2d87ccb15d29$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $af3a2d87ccb15d29$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $af3a2d87ccb15d29$var$ri.bind(null, $af3a2d87ccb15d29$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $af3a2d87ccb15d29$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $af3a2d87ccb15d29$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $af3a2d87ccb15d29$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $af3a2d87ccb15d29$var$si() {
    return $af3a2d87ccb15d29$var$di().memoizedState;
}
function $af3a2d87ccb15d29$var$ti(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$ci();
    $af3a2d87ccb15d29$var$N.flags |= a;
    e.memoizedState = $af3a2d87ccb15d29$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $af3a2d87ccb15d29$var$ui(a, b, c, d) {
    var e = $af3a2d87ccb15d29$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $af3a2d87ccb15d29$var$O) {
        var g = $af3a2d87ccb15d29$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $af3a2d87ccb15d29$var$Wh(d, g.deps)) {
            e.memoizedState = $af3a2d87ccb15d29$var$li(b, c, f, d);
            return;
        }
    }
    $af3a2d87ccb15d29$var$N.flags |= a;
    e.memoizedState = $af3a2d87ccb15d29$var$li(1 | b, c, f, d);
}
function $af3a2d87ccb15d29$var$vi(a, b) {
    return $af3a2d87ccb15d29$var$ti(8390656, 8, a, b);
}
function $af3a2d87ccb15d29$var$ji(a, b) {
    return $af3a2d87ccb15d29$var$ui(2048, 8, a, b);
}
function $af3a2d87ccb15d29$var$wi(a, b) {
    return $af3a2d87ccb15d29$var$ui(4, 2, a, b);
}
function $af3a2d87ccb15d29$var$xi(a, b) {
    return $af3a2d87ccb15d29$var$ui(4, 4, a, b);
}
function $af3a2d87ccb15d29$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $af3a2d87ccb15d29$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $af3a2d87ccb15d29$var$ui(4, 4, $af3a2d87ccb15d29$var$yi.bind(null, b, a), c);
}
function $af3a2d87ccb15d29$var$Ai() {}
function $af3a2d87ccb15d29$var$Bi(a, b) {
    var c = $af3a2d87ccb15d29$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $af3a2d87ccb15d29$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $af3a2d87ccb15d29$var$Ci(a, b) {
    var c = $af3a2d87ccb15d29$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $af3a2d87ccb15d29$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $af3a2d87ccb15d29$var$Di(a, b, c) {
    if (0 === ($af3a2d87ccb15d29$var$Rh & 21)) return a.baseState && (a.baseState = !1, $af3a2d87ccb15d29$var$Ug = !0), a.memoizedState = c;
    $af3a2d87ccb15d29$var$He(c, b) || (c = $af3a2d87ccb15d29$var$yc(), $af3a2d87ccb15d29$var$N.lanes |= c, $af3a2d87ccb15d29$var$hh |= c, a.baseState = !0);
    return b;
}
function $af3a2d87ccb15d29$var$Ei(a, b) {
    var c = $af3a2d87ccb15d29$var$C;
    $af3a2d87ccb15d29$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $af3a2d87ccb15d29$var$Qh.transition;
    $af3a2d87ccb15d29$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $af3a2d87ccb15d29$var$C = c, $af3a2d87ccb15d29$var$Qh.transition = d;
    }
}
function $af3a2d87ccb15d29$var$Fi() {
    return $af3a2d87ccb15d29$var$di().memoizedState;
}
function $af3a2d87ccb15d29$var$Gi(a, b, c) {
    var d = $af3a2d87ccb15d29$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($af3a2d87ccb15d29$var$Hi(a)) $af3a2d87ccb15d29$var$Ii(b, c);
    else if (c = $af3a2d87ccb15d29$var$Yg(a, b, c, d), null !== c) {
        var e = $af3a2d87ccb15d29$var$L();
        $af3a2d87ccb15d29$var$mh(c, a, d, e);
        $af3a2d87ccb15d29$var$Ji(c, b, d);
    }
}
function $af3a2d87ccb15d29$var$ri(a, b, c) {
    var d = $af3a2d87ccb15d29$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($af3a2d87ccb15d29$var$Hi(a)) $af3a2d87ccb15d29$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($af3a2d87ccb15d29$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $af3a2d87ccb15d29$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $af3a2d87ccb15d29$var$Yg(a, b, e, d);
        null !== c && (e = $af3a2d87ccb15d29$var$L(), $af3a2d87ccb15d29$var$mh(c, a, d, e), $af3a2d87ccb15d29$var$Ji(c, b, d));
    }
}
function $af3a2d87ccb15d29$var$Hi(a) {
    var b = a.alternate;
    return a === $af3a2d87ccb15d29$var$N || null !== b && b === $af3a2d87ccb15d29$var$N;
}
function $af3a2d87ccb15d29$var$Ii(a, b) {
    $af3a2d87ccb15d29$var$Th = $af3a2d87ccb15d29$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $af3a2d87ccb15d29$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $af3a2d87ccb15d29$var$Cc(a, c);
    }
}
var $af3a2d87ccb15d29$var$ai = {
    readContext: $af3a2d87ccb15d29$var$Vg,
    useCallback: $af3a2d87ccb15d29$var$Q,
    useContext: $af3a2d87ccb15d29$var$Q,
    useEffect: $af3a2d87ccb15d29$var$Q,
    useImperativeHandle: $af3a2d87ccb15d29$var$Q,
    useInsertionEffect: $af3a2d87ccb15d29$var$Q,
    useLayoutEffect: $af3a2d87ccb15d29$var$Q,
    useMemo: $af3a2d87ccb15d29$var$Q,
    useReducer: $af3a2d87ccb15d29$var$Q,
    useRef: $af3a2d87ccb15d29$var$Q,
    useState: $af3a2d87ccb15d29$var$Q,
    useDebugValue: $af3a2d87ccb15d29$var$Q,
    useDeferredValue: $af3a2d87ccb15d29$var$Q,
    useTransition: $af3a2d87ccb15d29$var$Q,
    useMutableSource: $af3a2d87ccb15d29$var$Q,
    useSyncExternalStore: $af3a2d87ccb15d29$var$Q,
    useId: $af3a2d87ccb15d29$var$Q,
    unstable_isNewReconciler: !1
}, $af3a2d87ccb15d29$var$Yh = {
    readContext: $af3a2d87ccb15d29$var$Vg,
    useCallback: function(a, b) {
        $af3a2d87ccb15d29$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $af3a2d87ccb15d29$var$Vg,
    useEffect: $af3a2d87ccb15d29$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $af3a2d87ccb15d29$var$ti(4194308, 4, $af3a2d87ccb15d29$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $af3a2d87ccb15d29$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $af3a2d87ccb15d29$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $af3a2d87ccb15d29$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $af3a2d87ccb15d29$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $af3a2d87ccb15d29$var$Gi.bind(null, $af3a2d87ccb15d29$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $af3a2d87ccb15d29$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $af3a2d87ccb15d29$var$qi,
    useDebugValue: $af3a2d87ccb15d29$var$Ai,
    useDeferredValue: function(a) {
        return $af3a2d87ccb15d29$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $af3a2d87ccb15d29$var$qi(!1), b = a[0];
        a = $af3a2d87ccb15d29$var$Ei.bind(null, a[1]);
        $af3a2d87ccb15d29$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $af3a2d87ccb15d29$var$N, e = $af3a2d87ccb15d29$var$ci();
        if ($af3a2d87ccb15d29$var$I) {
            if (void 0 === c) throw Error($af3a2d87ccb15d29$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $af3a2d87ccb15d29$var$R) throw Error($af3a2d87ccb15d29$var$p(349));
            0 !== ($af3a2d87ccb15d29$var$Rh & 30) || $af3a2d87ccb15d29$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $af3a2d87ccb15d29$var$vi($af3a2d87ccb15d29$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $af3a2d87ccb15d29$var$li(9, $af3a2d87ccb15d29$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $af3a2d87ccb15d29$var$ci(), b = $af3a2d87ccb15d29$var$R.identifierPrefix;
        if ($af3a2d87ccb15d29$var$I) {
            var c = $af3a2d87ccb15d29$var$sg;
            var d = $af3a2d87ccb15d29$var$rg;
            c = (d & ~(1 << 32 - $af3a2d87ccb15d29$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $af3a2d87ccb15d29$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $af3a2d87ccb15d29$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $af3a2d87ccb15d29$var$Zh = {
    readContext: $af3a2d87ccb15d29$var$Vg,
    useCallback: $af3a2d87ccb15d29$var$Bi,
    useContext: $af3a2d87ccb15d29$var$Vg,
    useEffect: $af3a2d87ccb15d29$var$ji,
    useImperativeHandle: $af3a2d87ccb15d29$var$zi,
    useInsertionEffect: $af3a2d87ccb15d29$var$wi,
    useLayoutEffect: $af3a2d87ccb15d29$var$xi,
    useMemo: $af3a2d87ccb15d29$var$Ci,
    useReducer: $af3a2d87ccb15d29$var$fi,
    useRef: $af3a2d87ccb15d29$var$si,
    useState: function() {
        return $af3a2d87ccb15d29$var$fi($af3a2d87ccb15d29$var$ei);
    },
    useDebugValue: $af3a2d87ccb15d29$var$Ai,
    useDeferredValue: function(a) {
        var b = $af3a2d87ccb15d29$var$di();
        return $af3a2d87ccb15d29$var$Di(b, $af3a2d87ccb15d29$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $af3a2d87ccb15d29$var$fi($af3a2d87ccb15d29$var$ei)[0], b = $af3a2d87ccb15d29$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $af3a2d87ccb15d29$var$hi,
    useSyncExternalStore: $af3a2d87ccb15d29$var$ii,
    useId: $af3a2d87ccb15d29$var$Fi,
    unstable_isNewReconciler: !1
}, $af3a2d87ccb15d29$var$$h = {
    readContext: $af3a2d87ccb15d29$var$Vg,
    useCallback: $af3a2d87ccb15d29$var$Bi,
    useContext: $af3a2d87ccb15d29$var$Vg,
    useEffect: $af3a2d87ccb15d29$var$ji,
    useImperativeHandle: $af3a2d87ccb15d29$var$zi,
    useInsertionEffect: $af3a2d87ccb15d29$var$wi,
    useLayoutEffect: $af3a2d87ccb15d29$var$xi,
    useMemo: $af3a2d87ccb15d29$var$Ci,
    useReducer: $af3a2d87ccb15d29$var$gi,
    useRef: $af3a2d87ccb15d29$var$si,
    useState: function() {
        return $af3a2d87ccb15d29$var$gi($af3a2d87ccb15d29$var$ei);
    },
    useDebugValue: $af3a2d87ccb15d29$var$Ai,
    useDeferredValue: function(a) {
        var b = $af3a2d87ccb15d29$var$di();
        return null === $af3a2d87ccb15d29$var$O ? b.memoizedState = a : $af3a2d87ccb15d29$var$Di(b, $af3a2d87ccb15d29$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $af3a2d87ccb15d29$var$gi($af3a2d87ccb15d29$var$ei)[0], b = $af3a2d87ccb15d29$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $af3a2d87ccb15d29$var$hi,
    useSyncExternalStore: $af3a2d87ccb15d29$var$ii,
    useId: $af3a2d87ccb15d29$var$Fi,
    unstable_isNewReconciler: !1
};
function $af3a2d87ccb15d29$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $af3a2d87ccb15d29$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $af3a2d87ccb15d29$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $af3a2d87ccb15d29$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $af3a2d87ccb15d29$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $af3a2d87ccb15d29$var$Oi(a, b, c) {
    c = $af3a2d87ccb15d29$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $af3a2d87ccb15d29$var$Pi || ($af3a2d87ccb15d29$var$Pi = !0, $af3a2d87ccb15d29$var$Qi = d);
        $af3a2d87ccb15d29$var$Mi(a, b);
    };
    return c;
}
function $af3a2d87ccb15d29$var$Ri(a, b, c) {
    c = $af3a2d87ccb15d29$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $af3a2d87ccb15d29$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $af3a2d87ccb15d29$var$Mi(a, b);
        "function" !== typeof d && (null === $af3a2d87ccb15d29$var$Si ? $af3a2d87ccb15d29$var$Si = new Set([
            this
        ]) : $af3a2d87ccb15d29$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $af3a2d87ccb15d29$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $af3a2d87ccb15d29$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $af3a2d87ccb15d29$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $af3a2d87ccb15d29$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $af3a2d87ccb15d29$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $af3a2d87ccb15d29$var$ch(-1, 1), b.tag = 2, $af3a2d87ccb15d29$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $af3a2d87ccb15d29$var$Xi = $af3a2d87ccb15d29$var$ua.ReactCurrentOwner, $af3a2d87ccb15d29$var$Ug = !1;
function $af3a2d87ccb15d29$var$Yi(a, b, c, d) {
    b.child = null === a ? $af3a2d87ccb15d29$var$Ch(b, null, c, d) : $af3a2d87ccb15d29$var$Bh(b, a.child, c, d);
}
function $af3a2d87ccb15d29$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $af3a2d87ccb15d29$var$Tg(b, e);
    d = $af3a2d87ccb15d29$var$Xh(a, b, c, d, f, e);
    c = $af3a2d87ccb15d29$var$bi();
    if (null !== a && !$af3a2d87ccb15d29$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $af3a2d87ccb15d29$var$$i(a, b, e);
    $af3a2d87ccb15d29$var$I && c && $af3a2d87ccb15d29$var$vg(b);
    b.flags |= 1;
    $af3a2d87ccb15d29$var$Yi(a, b, d, e);
    return b.child;
}
function $af3a2d87ccb15d29$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$af3a2d87ccb15d29$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $af3a2d87ccb15d29$var$cj(a, b, f, d, e);
        a = $af3a2d87ccb15d29$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $af3a2d87ccb15d29$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $af3a2d87ccb15d29$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $af3a2d87ccb15d29$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $af3a2d87ccb15d29$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($af3a2d87ccb15d29$var$Ie(f, d) && a.ref === b.ref) {
            if ($af3a2d87ccb15d29$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($af3a2d87ccb15d29$var$Ug = !0);
            else return b.lanes = a.lanes, $af3a2d87ccb15d29$var$$i(a, b, e);
        }
    }
    return $af3a2d87ccb15d29$var$dj(a, b, c, d, e);
}
function $af3a2d87ccb15d29$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$fj, $af3a2d87ccb15d29$var$gj), $af3a2d87ccb15d29$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$fj, $af3a2d87ccb15d29$var$gj), $af3a2d87ccb15d29$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$fj, $af3a2d87ccb15d29$var$gj);
            $af3a2d87ccb15d29$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$fj, $af3a2d87ccb15d29$var$gj), $af3a2d87ccb15d29$var$gj |= d;
    $af3a2d87ccb15d29$var$Yi(a, b, e, c);
    return b.child;
}
function $af3a2d87ccb15d29$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $af3a2d87ccb15d29$var$dj(a, b, c, d, e) {
    var f = $af3a2d87ccb15d29$var$Zf(c) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current;
    f = $af3a2d87ccb15d29$var$Yf(b, f);
    $af3a2d87ccb15d29$var$Tg(b, e);
    c = $af3a2d87ccb15d29$var$Xh(a, b, c, d, f, e);
    d = $af3a2d87ccb15d29$var$bi();
    if (null !== a && !$af3a2d87ccb15d29$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $af3a2d87ccb15d29$var$$i(a, b, e);
    $af3a2d87ccb15d29$var$I && d && $af3a2d87ccb15d29$var$vg(b);
    b.flags |= 1;
    $af3a2d87ccb15d29$var$Yi(a, b, c, e);
    return b.child;
}
function $af3a2d87ccb15d29$var$ij(a, b, c, d, e) {
    if ($af3a2d87ccb15d29$var$Zf(c)) {
        var f = !0;
        $af3a2d87ccb15d29$var$cg(b);
    } else f = !1;
    $af3a2d87ccb15d29$var$Tg(b, e);
    if (null === b.stateNode) $af3a2d87ccb15d29$var$jj(a, b), $af3a2d87ccb15d29$var$ph(b, c, d), $af3a2d87ccb15d29$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $af3a2d87ccb15d29$var$Vg(l) : (l = $af3a2d87ccb15d29$var$Zf(c) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current, l = $af3a2d87ccb15d29$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $af3a2d87ccb15d29$var$qh(b, g, d, l);
        $af3a2d87ccb15d29$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $af3a2d87ccb15d29$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $af3a2d87ccb15d29$var$Wf.current || $af3a2d87ccb15d29$var$$g ? ("function" === typeof m && ($af3a2d87ccb15d29$var$kh(b, c, m, d), k = b.memoizedState), (h = $af3a2d87ccb15d29$var$$g || $af3a2d87ccb15d29$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $af3a2d87ccb15d29$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $af3a2d87ccb15d29$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $af3a2d87ccb15d29$var$Vg(k) : (k = $af3a2d87ccb15d29$var$Zf(c) ? $af3a2d87ccb15d29$var$Xf : $af3a2d87ccb15d29$var$H.current, k = $af3a2d87ccb15d29$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $af3a2d87ccb15d29$var$qh(b, g, d, k);
        $af3a2d87ccb15d29$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $af3a2d87ccb15d29$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $af3a2d87ccb15d29$var$Wf.current || $af3a2d87ccb15d29$var$$g ? ("function" === typeof y && ($af3a2d87ccb15d29$var$kh(b, c, y, d), n = b.memoizedState), (l = $af3a2d87ccb15d29$var$$g || $af3a2d87ccb15d29$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $af3a2d87ccb15d29$var$kj(a, b, c, d, f, e);
}
function $af3a2d87ccb15d29$var$kj(a, b, c, d, e, f) {
    $af3a2d87ccb15d29$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $af3a2d87ccb15d29$var$dg(b, c, !1), $af3a2d87ccb15d29$var$$i(a, b, f);
    d = b.stateNode;
    $af3a2d87ccb15d29$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $af3a2d87ccb15d29$var$Bh(b, a.child, null, f), b.child = $af3a2d87ccb15d29$var$Bh(b, null, h, f)) : $af3a2d87ccb15d29$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $af3a2d87ccb15d29$var$dg(b, c, !0);
    return b.child;
}
function $af3a2d87ccb15d29$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $af3a2d87ccb15d29$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $af3a2d87ccb15d29$var$ag(a, b.context, !1);
    $af3a2d87ccb15d29$var$Ih(a, b.containerInfo);
}
function $af3a2d87ccb15d29$var$mj(a, b, c, d, e) {
    $af3a2d87ccb15d29$var$Ig();
    $af3a2d87ccb15d29$var$Jg(e);
    b.flags |= 256;
    $af3a2d87ccb15d29$var$Yi(a, b, c, d);
    return b.child;
}
var $af3a2d87ccb15d29$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $af3a2d87ccb15d29$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $af3a2d87ccb15d29$var$pj(a, b, c) {
    var d = b.pendingProps, e = $af3a2d87ccb15d29$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, e & 1);
    if (null === a) {
        $af3a2d87ccb15d29$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $af3a2d87ccb15d29$var$qj(g, d, 0, null), a = $af3a2d87ccb15d29$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $af3a2d87ccb15d29$var$oj(c), b.memoizedState = $af3a2d87ccb15d29$var$nj, a) : $af3a2d87ccb15d29$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $af3a2d87ccb15d29$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $af3a2d87ccb15d29$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $af3a2d87ccb15d29$var$wh(h, f) : (f = $af3a2d87ccb15d29$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $af3a2d87ccb15d29$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $af3a2d87ccb15d29$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $af3a2d87ccb15d29$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $af3a2d87ccb15d29$var$rj(a, b) {
    b = $af3a2d87ccb15d29$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $af3a2d87ccb15d29$var$tj(a, b, c, d) {
    null !== d && $af3a2d87ccb15d29$var$Jg(d);
    $af3a2d87ccb15d29$var$Bh(b, a.child, null, c);
    a = $af3a2d87ccb15d29$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $af3a2d87ccb15d29$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $af3a2d87ccb15d29$var$Li(Error($af3a2d87ccb15d29$var$p(422))), $af3a2d87ccb15d29$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $af3a2d87ccb15d29$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $af3a2d87ccb15d29$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $af3a2d87ccb15d29$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $af3a2d87ccb15d29$var$oj(g);
        b.memoizedState = $af3a2d87ccb15d29$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $af3a2d87ccb15d29$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($af3a2d87ccb15d29$var$p(419));
        d = $af3a2d87ccb15d29$var$Li(f, d, void 0);
        return $af3a2d87ccb15d29$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($af3a2d87ccb15d29$var$Ug || h) {
        d = $af3a2d87ccb15d29$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $af3a2d87ccb15d29$var$Zg(a, e), $af3a2d87ccb15d29$var$mh(d, a, e, -1));
        }
        $af3a2d87ccb15d29$var$uj();
        d = $af3a2d87ccb15d29$var$Li(Error($af3a2d87ccb15d29$var$p(421)));
        return $af3a2d87ccb15d29$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $af3a2d87ccb15d29$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$Lf(e.nextSibling);
    $af3a2d87ccb15d29$var$xg = b;
    $af3a2d87ccb15d29$var$I = !0;
    $af3a2d87ccb15d29$var$zg = null;
    null !== a && ($af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$rg, $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$sg, $af3a2d87ccb15d29$var$og[$af3a2d87ccb15d29$var$pg++] = $af3a2d87ccb15d29$var$qg, $af3a2d87ccb15d29$var$rg = a.id, $af3a2d87ccb15d29$var$sg = a.overflow, $af3a2d87ccb15d29$var$qg = b);
    b = $af3a2d87ccb15d29$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $af3a2d87ccb15d29$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $af3a2d87ccb15d29$var$Sg(a.return, b, c);
}
function $af3a2d87ccb15d29$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $af3a2d87ccb15d29$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $af3a2d87ccb15d29$var$Yi(a, b, d.children, c);
    d = $af3a2d87ccb15d29$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $af3a2d87ccb15d29$var$wj(a, c, b);
            else if (19 === a.tag) $af3a2d87ccb15d29$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $af3a2d87ccb15d29$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $af3a2d87ccb15d29$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $af3a2d87ccb15d29$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $af3a2d87ccb15d29$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $af3a2d87ccb15d29$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $af3a2d87ccb15d29$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $af3a2d87ccb15d29$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $af3a2d87ccb15d29$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($af3a2d87ccb15d29$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $af3a2d87ccb15d29$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $af3a2d87ccb15d29$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $af3a2d87ccb15d29$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $af3a2d87ccb15d29$var$lj(b);
            $af3a2d87ccb15d29$var$Ig();
            break;
        case 5:
            $af3a2d87ccb15d29$var$Kh(b);
            break;
        case 1:
            $af3a2d87ccb15d29$var$Zf(b.type) && $af3a2d87ccb15d29$var$cg(b);
            break;
        case 4:
            $af3a2d87ccb15d29$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $af3a2d87ccb15d29$var$pj(a, b, c);
                $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current & 1);
                a = $af3a2d87ccb15d29$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $af3a2d87ccb15d29$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $af3a2d87ccb15d29$var$ej(a, b, c);
    }
    return $af3a2d87ccb15d29$var$$i(a, b, c);
}
var $af3a2d87ccb15d29$var$Aj, $af3a2d87ccb15d29$var$Bj, $af3a2d87ccb15d29$var$Cj, $af3a2d87ccb15d29$var$Dj;
$af3a2d87ccb15d29$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$af3a2d87ccb15d29$var$Bj = function() {};
$af3a2d87ccb15d29$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $af3a2d87ccb15d29$var$Ya(a, e);
                d = $af3a2d87ccb15d29$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $af3a2d87ccb15d29$var$A({}, e, {
                    value: void 0
                });
                d = $af3a2d87ccb15d29$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $af3a2d87ccb15d29$var$gb(a, e);
                d = $af3a2d87ccb15d29$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $af3a2d87ccb15d29$var$Bf);
        }
        $af3a2d87ccb15d29$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($af3a2d87ccb15d29$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($af3a2d87ccb15d29$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $af3a2d87ccb15d29$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$af3a2d87ccb15d29$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $af3a2d87ccb15d29$var$Ej(a, b) {
    if (!$af3a2d87ccb15d29$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $af3a2d87ccb15d29$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $af3a2d87ccb15d29$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $af3a2d87ccb15d29$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $af3a2d87ccb15d29$var$S(b), null;
        case 1:
            return $af3a2d87ccb15d29$var$Zf(b.type) && $af3a2d87ccb15d29$var$$f(), $af3a2d87ccb15d29$var$S(b), null;
        case 3:
            d = b.stateNode;
            $af3a2d87ccb15d29$var$Jh();
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf);
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H);
            $af3a2d87ccb15d29$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $af3a2d87ccb15d29$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $af3a2d87ccb15d29$var$zg && ($af3a2d87ccb15d29$var$Gj($af3a2d87ccb15d29$var$zg), $af3a2d87ccb15d29$var$zg = null));
            $af3a2d87ccb15d29$var$Bj(a, b);
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 5:
            $af3a2d87ccb15d29$var$Lh(b);
            var e = $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $af3a2d87ccb15d29$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($af3a2d87ccb15d29$var$p(166));
                    $af3a2d87ccb15d29$var$S(b);
                    return null;
                }
                a = $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Eh.current);
                if ($af3a2d87ccb15d29$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$af3a2d87ccb15d29$var$Of] = b;
                    d[$af3a2d87ccb15d29$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $af3a2d87ccb15d29$var$D("cancel", d);
                            $af3a2d87ccb15d29$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $af3a2d87ccb15d29$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $af3a2d87ccb15d29$var$lf.length; e++)$af3a2d87ccb15d29$var$D($af3a2d87ccb15d29$var$lf[e], d);
                            break;
                        case "source":
                            $af3a2d87ccb15d29$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $af3a2d87ccb15d29$var$D("error", d);
                            $af3a2d87ccb15d29$var$D("load", d);
                            break;
                        case "details":
                            $af3a2d87ccb15d29$var$D("toggle", d);
                            break;
                        case "input":
                            $af3a2d87ccb15d29$var$Za(d, f);
                            $af3a2d87ccb15d29$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $af3a2d87ccb15d29$var$D("invalid", d);
                            break;
                        case "textarea":
                            $af3a2d87ccb15d29$var$hb(d, f), $af3a2d87ccb15d29$var$D("invalid", d);
                    }
                    $af3a2d87ccb15d29$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $af3a2d87ccb15d29$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $af3a2d87ccb15d29$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $af3a2d87ccb15d29$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $af3a2d87ccb15d29$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $af3a2d87ccb15d29$var$Va(d);
                            $af3a2d87ccb15d29$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $af3a2d87ccb15d29$var$Va(d);
                            $af3a2d87ccb15d29$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $af3a2d87ccb15d29$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $af3a2d87ccb15d29$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$af3a2d87ccb15d29$var$Of] = b;
                    a[$af3a2d87ccb15d29$var$Pf] = d;
                    $af3a2d87ccb15d29$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $af3a2d87ccb15d29$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $af3a2d87ccb15d29$var$D("cancel", a);
                                $af3a2d87ccb15d29$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $af3a2d87ccb15d29$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $af3a2d87ccb15d29$var$lf.length; e++)$af3a2d87ccb15d29$var$D($af3a2d87ccb15d29$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $af3a2d87ccb15d29$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $af3a2d87ccb15d29$var$D("error", a);
                                $af3a2d87ccb15d29$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $af3a2d87ccb15d29$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $af3a2d87ccb15d29$var$Za(a, d);
                                e = $af3a2d87ccb15d29$var$Ya(a, d);
                                $af3a2d87ccb15d29$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $af3a2d87ccb15d29$var$A({}, d, {
                                    value: void 0
                                });
                                $af3a2d87ccb15d29$var$D("invalid", a);
                                break;
                            case "textarea":
                                $af3a2d87ccb15d29$var$hb(a, d);
                                e = $af3a2d87ccb15d29$var$gb(a, d);
                                $af3a2d87ccb15d29$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $af3a2d87ccb15d29$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $af3a2d87ccb15d29$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $af3a2d87ccb15d29$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $af3a2d87ccb15d29$var$ob(a, k) : "number" === typeof k && $af3a2d87ccb15d29$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($af3a2d87ccb15d29$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $af3a2d87ccb15d29$var$D("scroll", a) : null != k && $af3a2d87ccb15d29$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $af3a2d87ccb15d29$var$Va(a);
                                $af3a2d87ccb15d29$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $af3a2d87ccb15d29$var$Va(a);
                                $af3a2d87ccb15d29$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $af3a2d87ccb15d29$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $af3a2d87ccb15d29$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $af3a2d87ccb15d29$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $af3a2d87ccb15d29$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $af3a2d87ccb15d29$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($af3a2d87ccb15d29$var$p(166));
                c = $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Gh.current);
                $af3a2d87ccb15d29$var$Hh($af3a2d87ccb15d29$var$Eh.current);
                if ($af3a2d87ccb15d29$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$af3a2d87ccb15d29$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $af3a2d87ccb15d29$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $af3a2d87ccb15d29$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $af3a2d87ccb15d29$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$af3a2d87ccb15d29$var$Of] = b, b.stateNode = d;
            }
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 13:
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($af3a2d87ccb15d29$var$I && null !== $af3a2d87ccb15d29$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $af3a2d87ccb15d29$var$Hg(), $af3a2d87ccb15d29$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $af3a2d87ccb15d29$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($af3a2d87ccb15d29$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($af3a2d87ccb15d29$var$p(317));
                        f[$af3a2d87ccb15d29$var$Of] = b;
                    } else $af3a2d87ccb15d29$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $af3a2d87ccb15d29$var$S(b);
                    f = !1;
                } else null !== $af3a2d87ccb15d29$var$zg && ($af3a2d87ccb15d29$var$Gj($af3a2d87ccb15d29$var$zg), $af3a2d87ccb15d29$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($af3a2d87ccb15d29$var$M.current & 1) ? 0 === $af3a2d87ccb15d29$var$T && ($af3a2d87ccb15d29$var$T = 3) : $af3a2d87ccb15d29$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 4:
            return $af3a2d87ccb15d29$var$Jh(), $af3a2d87ccb15d29$var$Bj(a, b), null === a && $af3a2d87ccb15d29$var$sf(b.stateNode.containerInfo), $af3a2d87ccb15d29$var$S(b), null;
        case 10:
            return $af3a2d87ccb15d29$var$Rg(b.type._context), $af3a2d87ccb15d29$var$S(b), null;
        case 17:
            return $af3a2d87ccb15d29$var$Zf(b.type) && $af3a2d87ccb15d29$var$$f(), $af3a2d87ccb15d29$var$S(b), null;
        case 19:
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
            f = b.memoizedState;
            if (null === f) return $af3a2d87ccb15d29$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $af3a2d87ccb15d29$var$Ej(f, !1);
                else {
                    if (0 !== $af3a2d87ccb15d29$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $af3a2d87ccb15d29$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $af3a2d87ccb15d29$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, $af3a2d87ccb15d29$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $af3a2d87ccb15d29$var$B() > $af3a2d87ccb15d29$var$Hj && (b.flags |= 128, d = !0, $af3a2d87ccb15d29$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $af3a2d87ccb15d29$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $af3a2d87ccb15d29$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$af3a2d87ccb15d29$var$I) return $af3a2d87ccb15d29$var$S(b), null;
                    } else 2 * $af3a2d87ccb15d29$var$B() - f.renderingStartTime > $af3a2d87ccb15d29$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $af3a2d87ccb15d29$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $af3a2d87ccb15d29$var$B(), b.sibling = null, c = $af3a2d87ccb15d29$var$M.current, $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$M, d ? c & 1 | 2 : c & 1), b;
            $af3a2d87ccb15d29$var$S(b);
            return null;
        case 22:
        case 23:
            return $af3a2d87ccb15d29$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($af3a2d87ccb15d29$var$gj & 1073741824) && ($af3a2d87ccb15d29$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $af3a2d87ccb15d29$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($af3a2d87ccb15d29$var$p(156, b.tag));
}
function $af3a2d87ccb15d29$var$Jj(a, b) {
    $af3a2d87ccb15d29$var$wg(b);
    switch(b.tag){
        case 1:
            return $af3a2d87ccb15d29$var$Zf(b.type) && $af3a2d87ccb15d29$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $af3a2d87ccb15d29$var$Jh(), $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf), $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H), $af3a2d87ccb15d29$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $af3a2d87ccb15d29$var$Lh(b), null;
        case 13:
            $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($af3a2d87ccb15d29$var$p(340));
                $af3a2d87ccb15d29$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M), null;
        case 4:
            return $af3a2d87ccb15d29$var$Jh(), null;
        case 10:
            return $af3a2d87ccb15d29$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $af3a2d87ccb15d29$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $af3a2d87ccb15d29$var$Kj = !1, $af3a2d87ccb15d29$var$U = !1, $af3a2d87ccb15d29$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $af3a2d87ccb15d29$var$V = null;
function $af3a2d87ccb15d29$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $af3a2d87ccb15d29$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $af3a2d87ccb15d29$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $af3a2d87ccb15d29$var$W(a, b, d);
    }
}
var $af3a2d87ccb15d29$var$Oj = !1;
function $af3a2d87ccb15d29$var$Pj(a, b) {
    $af3a2d87ccb15d29$var$Cf = $af3a2d87ccb15d29$var$dd;
    a = $af3a2d87ccb15d29$var$Me();
    if ($af3a2d87ccb15d29$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $af3a2d87ccb15d29$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $af3a2d87ccb15d29$var$dd = !1;
    for($af3a2d87ccb15d29$var$V = b; null !== $af3a2d87ccb15d29$var$V;)if (b = $af3a2d87ccb15d29$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $af3a2d87ccb15d29$var$V = a;
    else for(; null !== $af3a2d87ccb15d29$var$V;){
        b = $af3a2d87ccb15d29$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $af3a2d87ccb15d29$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($af3a2d87ccb15d29$var$p(163));
            }
        } catch (F) {
            $af3a2d87ccb15d29$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $af3a2d87ccb15d29$var$V = a;
            break;
        }
        $af3a2d87ccb15d29$var$V = b.return;
    }
    n = $af3a2d87ccb15d29$var$Oj;
    $af3a2d87ccb15d29$var$Oj = !1;
    return n;
}
function $af3a2d87ccb15d29$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $af3a2d87ccb15d29$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $af3a2d87ccb15d29$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $af3a2d87ccb15d29$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $af3a2d87ccb15d29$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $af3a2d87ccb15d29$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$af3a2d87ccb15d29$var$Of], delete b[$af3a2d87ccb15d29$var$Pf], delete b[$af3a2d87ccb15d29$var$of], delete b[$af3a2d87ccb15d29$var$Qf], delete b[$af3a2d87ccb15d29$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $af3a2d87ccb15d29$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $af3a2d87ccb15d29$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $af3a2d87ccb15d29$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $af3a2d87ccb15d29$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $af3a2d87ccb15d29$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($af3a2d87ccb15d29$var$Wj(a, b, c), a = a.sibling; null !== a;)$af3a2d87ccb15d29$var$Wj(a, b, c), a = a.sibling;
}
function $af3a2d87ccb15d29$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($af3a2d87ccb15d29$var$Xj(a, b, c), a = a.sibling; null !== a;)$af3a2d87ccb15d29$var$Xj(a, b, c), a = a.sibling;
}
var $af3a2d87ccb15d29$var$X = null, $af3a2d87ccb15d29$var$Yj = !1;
function $af3a2d87ccb15d29$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$af3a2d87ccb15d29$var$ak(a, b, c), c = c.sibling;
}
function $af3a2d87ccb15d29$var$ak(a, b, c) {
    if ($af3a2d87ccb15d29$var$lc && "function" === typeof $af3a2d87ccb15d29$var$lc.onCommitFiberUnmount) try {
        $af3a2d87ccb15d29$var$lc.onCommitFiberUnmount($af3a2d87ccb15d29$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $af3a2d87ccb15d29$var$U || $af3a2d87ccb15d29$var$Mj(c, b);
        case 6:
            var d = $af3a2d87ccb15d29$var$X, e = $af3a2d87ccb15d29$var$Yj;
            $af3a2d87ccb15d29$var$X = null;
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            $af3a2d87ccb15d29$var$X = d;
            $af3a2d87ccb15d29$var$Yj = e;
            null !== $af3a2d87ccb15d29$var$X && ($af3a2d87ccb15d29$var$Yj ? (a = $af3a2d87ccb15d29$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $af3a2d87ccb15d29$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $af3a2d87ccb15d29$var$X && ($af3a2d87ccb15d29$var$Yj ? (a = $af3a2d87ccb15d29$var$X, c = c.stateNode, 8 === a.nodeType ? $af3a2d87ccb15d29$var$Kf(a.parentNode, c) : 1 === a.nodeType && $af3a2d87ccb15d29$var$Kf(a, c), $af3a2d87ccb15d29$var$bd(a)) : $af3a2d87ccb15d29$var$Kf($af3a2d87ccb15d29$var$X, c.stateNode));
            break;
        case 4:
            d = $af3a2d87ccb15d29$var$X;
            e = $af3a2d87ccb15d29$var$Yj;
            $af3a2d87ccb15d29$var$X = c.stateNode.containerInfo;
            $af3a2d87ccb15d29$var$Yj = !0;
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            $af3a2d87ccb15d29$var$X = d;
            $af3a2d87ccb15d29$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$af3a2d87ccb15d29$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $af3a2d87ccb15d29$var$Nj(c, b, g) : 0 !== (f & 4) && $af3a2d87ccb15d29$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            break;
        case 1:
            if (!$af3a2d87ccb15d29$var$U && ($af3a2d87ccb15d29$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $af3a2d87ccb15d29$var$W(c, b, h);
            }
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            break;
        case 21:
            $af3a2d87ccb15d29$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($af3a2d87ccb15d29$var$U = (d = $af3a2d87ccb15d29$var$U) || null !== c.memoizedState, $af3a2d87ccb15d29$var$Zj(a, b, c), $af3a2d87ccb15d29$var$U = d) : $af3a2d87ccb15d29$var$Zj(a, b, c);
            break;
        default:
            $af3a2d87ccb15d29$var$Zj(a, b, c);
    }
}
function $af3a2d87ccb15d29$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $af3a2d87ccb15d29$var$Lj);
        b.forEach(function(b) {
            var d = $af3a2d87ccb15d29$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $af3a2d87ccb15d29$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $af3a2d87ccb15d29$var$X = h.stateNode;
                        $af3a2d87ccb15d29$var$Yj = !1;
                        break a;
                    case 3:
                        $af3a2d87ccb15d29$var$X = h.stateNode.containerInfo;
                        $af3a2d87ccb15d29$var$Yj = !0;
                        break a;
                    case 4:
                        $af3a2d87ccb15d29$var$X = h.stateNode.containerInfo;
                        $af3a2d87ccb15d29$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $af3a2d87ccb15d29$var$X) throw Error($af3a2d87ccb15d29$var$p(160));
            $af3a2d87ccb15d29$var$ak(f, g, e);
            $af3a2d87ccb15d29$var$X = null;
            $af3a2d87ccb15d29$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $af3a2d87ccb15d29$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$af3a2d87ccb15d29$var$ek(b, a), b = b.sibling;
}
function $af3a2d87ccb15d29$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            if (d & 4) {
                try {
                    $af3a2d87ccb15d29$var$Qj(3, a, a.return), $af3a2d87ccb15d29$var$Rj(3, a);
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
                try {
                    $af3a2d87ccb15d29$var$Qj(5, a, a.return);
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            d & 512 && null !== c && $af3a2d87ccb15d29$var$Mj(c, c.return);
            break;
        case 5:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            d & 512 && null !== c && $af3a2d87ccb15d29$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $af3a2d87ccb15d29$var$ob(e, "");
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $af3a2d87ccb15d29$var$ab(e, f);
                    $af3a2d87ccb15d29$var$vb(h, g);
                    var l = $af3a2d87ccb15d29$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $af3a2d87ccb15d29$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $af3a2d87ccb15d29$var$nb(e, q) : "children" === m ? $af3a2d87ccb15d29$var$ob(e, q) : $af3a2d87ccb15d29$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $af3a2d87ccb15d29$var$bb(e, f);
                            break;
                        case "textarea":
                            $af3a2d87ccb15d29$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $af3a2d87ccb15d29$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $af3a2d87ccb15d29$var$fb(e, !!f.multiple, f.defaultValue, !0) : $af3a2d87ccb15d29$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$af3a2d87ccb15d29$var$Pf] = f;
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($af3a2d87ccb15d29$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $af3a2d87ccb15d29$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $af3a2d87ccb15d29$var$bd(b.containerInfo);
            } catch (t) {
                $af3a2d87ccb15d29$var$W(a, a.return, t);
            }
            break;
        case 4:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            break;
        case 13:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($af3a2d87ccb15d29$var$gk = $af3a2d87ccb15d29$var$B()));
            d & 4 && $af3a2d87ccb15d29$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($af3a2d87ccb15d29$var$U = (l = $af3a2d87ccb15d29$var$U) || m, $af3a2d87ccb15d29$var$dk(b, a), $af3a2d87ccb15d29$var$U = l) : $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($af3a2d87ccb15d29$var$V = a, m = a.child; null !== m;){
                    for(q = $af3a2d87ccb15d29$var$V = m; null !== $af3a2d87ccb15d29$var$V;){
                        r = $af3a2d87ccb15d29$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $af3a2d87ccb15d29$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $af3a2d87ccb15d29$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $af3a2d87ccb15d29$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $af3a2d87ccb15d29$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $af3a2d87ccb15d29$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $af3a2d87ccb15d29$var$V = y) : $af3a2d87ccb15d29$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $af3a2d87ccb15d29$var$rb("display", g));
                            } catch (t) {
                                $af3a2d87ccb15d29$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $af3a2d87ccb15d29$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $af3a2d87ccb15d29$var$dk(b, a);
            $af3a2d87ccb15d29$var$fk(a);
            d & 4 && $af3a2d87ccb15d29$var$bk(a);
            break;
        case 21:
            break;
        default:
            $af3a2d87ccb15d29$var$dk(b, a), $af3a2d87ccb15d29$var$fk(a);
    }
}
function $af3a2d87ccb15d29$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($af3a2d87ccb15d29$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($af3a2d87ccb15d29$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($af3a2d87ccb15d29$var$ob(e, ""), d.flags &= -33);
                    var f = $af3a2d87ccb15d29$var$Vj(a);
                    $af3a2d87ccb15d29$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $af3a2d87ccb15d29$var$Vj(a);
                    $af3a2d87ccb15d29$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($af3a2d87ccb15d29$var$p(161));
            }
        } catch (k) {
            $af3a2d87ccb15d29$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $af3a2d87ccb15d29$var$ik(a, b, c) {
    $af3a2d87ccb15d29$var$V = a;
    $af3a2d87ccb15d29$var$jk(a, b, c);
}
function $af3a2d87ccb15d29$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $af3a2d87ccb15d29$var$V;){
        var e = $af3a2d87ccb15d29$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $af3a2d87ccb15d29$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $af3a2d87ccb15d29$var$U;
                h = $af3a2d87ccb15d29$var$Kj;
                var l = $af3a2d87ccb15d29$var$U;
                $af3a2d87ccb15d29$var$Kj = g;
                if (($af3a2d87ccb15d29$var$U = k) && !l) for($af3a2d87ccb15d29$var$V = e; null !== $af3a2d87ccb15d29$var$V;)g = $af3a2d87ccb15d29$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $af3a2d87ccb15d29$var$kk(e) : null !== k ? (k.return = g, $af3a2d87ccb15d29$var$V = k) : $af3a2d87ccb15d29$var$kk(e);
                for(; null !== f;)$af3a2d87ccb15d29$var$V = f, $af3a2d87ccb15d29$var$jk(f, b, c), f = f.sibling;
                $af3a2d87ccb15d29$var$V = e;
                $af3a2d87ccb15d29$var$Kj = h;
                $af3a2d87ccb15d29$var$U = l;
            }
            $af3a2d87ccb15d29$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $af3a2d87ccb15d29$var$V = f) : $af3a2d87ccb15d29$var$lk(a, b, c);
    }
}
function $af3a2d87ccb15d29$var$lk(a) {
    for(; null !== $af3a2d87ccb15d29$var$V;){
        var b = $af3a2d87ccb15d29$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $af3a2d87ccb15d29$var$U || $af3a2d87ccb15d29$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$af3a2d87ccb15d29$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $af3a2d87ccb15d29$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $af3a2d87ccb15d29$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $af3a2d87ccb15d29$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $af3a2d87ccb15d29$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($af3a2d87ccb15d29$var$p(163));
                }
                $af3a2d87ccb15d29$var$U || b.flags & 512 && $af3a2d87ccb15d29$var$Sj(b);
            } catch (r) {
                $af3a2d87ccb15d29$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $af3a2d87ccb15d29$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $af3a2d87ccb15d29$var$V = c;
            break;
        }
        $af3a2d87ccb15d29$var$V = b.return;
    }
}
function $af3a2d87ccb15d29$var$hk(a) {
    for(; null !== $af3a2d87ccb15d29$var$V;){
        var b = $af3a2d87ccb15d29$var$V;
        if (b === a) {
            $af3a2d87ccb15d29$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $af3a2d87ccb15d29$var$V = c;
            break;
        }
        $af3a2d87ccb15d29$var$V = b.return;
    }
}
function $af3a2d87ccb15d29$var$kk(a) {
    for(; null !== $af3a2d87ccb15d29$var$V;){
        var b = $af3a2d87ccb15d29$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $af3a2d87ccb15d29$var$Rj(4, b);
                    } catch (k) {
                        $af3a2d87ccb15d29$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $af3a2d87ccb15d29$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $af3a2d87ccb15d29$var$Sj(b);
                    } catch (k) {
                        $af3a2d87ccb15d29$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $af3a2d87ccb15d29$var$Sj(b);
                    } catch (k) {
                        $af3a2d87ccb15d29$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $af3a2d87ccb15d29$var$W(b, b.return, k);
        }
        if (b === a) {
            $af3a2d87ccb15d29$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $af3a2d87ccb15d29$var$V = h;
            break;
        }
        $af3a2d87ccb15d29$var$V = b.return;
    }
}
var $af3a2d87ccb15d29$var$mk = Math.ceil, $af3a2d87ccb15d29$var$nk = $af3a2d87ccb15d29$var$ua.ReactCurrentDispatcher, $af3a2d87ccb15d29$var$ok = $af3a2d87ccb15d29$var$ua.ReactCurrentOwner, $af3a2d87ccb15d29$var$pk = $af3a2d87ccb15d29$var$ua.ReactCurrentBatchConfig, $af3a2d87ccb15d29$var$K = 0, $af3a2d87ccb15d29$var$R = null, $af3a2d87ccb15d29$var$Y = null, $af3a2d87ccb15d29$var$Z = 0, $af3a2d87ccb15d29$var$gj = 0, $af3a2d87ccb15d29$var$fj = $af3a2d87ccb15d29$var$Uf(0), $af3a2d87ccb15d29$var$T = 0, $af3a2d87ccb15d29$var$qk = null, $af3a2d87ccb15d29$var$hh = 0, $af3a2d87ccb15d29$var$rk = 0, $af3a2d87ccb15d29$var$sk = 0, $af3a2d87ccb15d29$var$tk = null, $af3a2d87ccb15d29$var$uk = null, $af3a2d87ccb15d29$var$gk = 0, $af3a2d87ccb15d29$var$Hj = Infinity, $af3a2d87ccb15d29$var$vk = null, $af3a2d87ccb15d29$var$Pi = !1, $af3a2d87ccb15d29$var$Qi = null, $af3a2d87ccb15d29$var$Si = null, $af3a2d87ccb15d29$var$wk = !1, $af3a2d87ccb15d29$var$xk = null, $af3a2d87ccb15d29$var$yk = 0, $af3a2d87ccb15d29$var$zk = 0, $af3a2d87ccb15d29$var$Ak = null, $af3a2d87ccb15d29$var$Bk = -1, $af3a2d87ccb15d29$var$Ck = 0;
function $af3a2d87ccb15d29$var$L() {
    return 0 !== ($af3a2d87ccb15d29$var$K & 6) ? $af3a2d87ccb15d29$var$B() : -1 !== $af3a2d87ccb15d29$var$Bk ? $af3a2d87ccb15d29$var$Bk : $af3a2d87ccb15d29$var$Bk = $af3a2d87ccb15d29$var$B();
}
function $af3a2d87ccb15d29$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($af3a2d87ccb15d29$var$K & 2) && 0 !== $af3a2d87ccb15d29$var$Z) return $af3a2d87ccb15d29$var$Z & -$af3a2d87ccb15d29$var$Z;
    if (null !== $af3a2d87ccb15d29$var$Kg.transition) return 0 === $af3a2d87ccb15d29$var$Ck && ($af3a2d87ccb15d29$var$Ck = $af3a2d87ccb15d29$var$yc()), $af3a2d87ccb15d29$var$Ck;
    a = $af3a2d87ccb15d29$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $af3a2d87ccb15d29$var$jd(a.type);
    return a;
}
function $af3a2d87ccb15d29$var$mh(a, b, c, d) {
    if (50 < $af3a2d87ccb15d29$var$zk) throw $af3a2d87ccb15d29$var$zk = 0, $af3a2d87ccb15d29$var$Ak = null, Error($af3a2d87ccb15d29$var$p(185));
    $af3a2d87ccb15d29$var$Ac(a, c, d);
    if (0 === ($af3a2d87ccb15d29$var$K & 2) || a !== $af3a2d87ccb15d29$var$R) a === $af3a2d87ccb15d29$var$R && (0 === ($af3a2d87ccb15d29$var$K & 2) && ($af3a2d87ccb15d29$var$rk |= c), 4 === $af3a2d87ccb15d29$var$T && $af3a2d87ccb15d29$var$Dk(a, $af3a2d87ccb15d29$var$Z)), $af3a2d87ccb15d29$var$Ek(a, d), 1 === c && 0 === $af3a2d87ccb15d29$var$K && 0 === (b.mode & 1) && ($af3a2d87ccb15d29$var$Hj = $af3a2d87ccb15d29$var$B() + 500, $af3a2d87ccb15d29$var$fg && $af3a2d87ccb15d29$var$jg());
}
function $af3a2d87ccb15d29$var$Ek(a, b) {
    var c = a.callbackNode;
    $af3a2d87ccb15d29$var$wc(a, b);
    var d = $af3a2d87ccb15d29$var$uc(a, a === $af3a2d87ccb15d29$var$R ? $af3a2d87ccb15d29$var$Z : 0);
    if (0 === d) null !== c && $af3a2d87ccb15d29$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $af3a2d87ccb15d29$var$bc(c);
        if (1 === b) 0 === a.tag ? $af3a2d87ccb15d29$var$ig($af3a2d87ccb15d29$var$Fk.bind(null, a)) : $af3a2d87ccb15d29$var$hg($af3a2d87ccb15d29$var$Fk.bind(null, a)), $af3a2d87ccb15d29$var$Jf(function() {
            0 === ($af3a2d87ccb15d29$var$K & 6) && $af3a2d87ccb15d29$var$jg();
        }), c = null;
        else {
            switch($af3a2d87ccb15d29$var$Dc(d)){
                case 1:
                    c = $af3a2d87ccb15d29$var$fc;
                    break;
                case 4:
                    c = $af3a2d87ccb15d29$var$gc;
                    break;
                case 16:
                    c = $af3a2d87ccb15d29$var$hc;
                    break;
                case 536870912:
                    c = $af3a2d87ccb15d29$var$jc;
                    break;
                default:
                    c = $af3a2d87ccb15d29$var$hc;
            }
            c = $af3a2d87ccb15d29$var$Gk(c, $af3a2d87ccb15d29$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $af3a2d87ccb15d29$var$Hk(a, b) {
    $af3a2d87ccb15d29$var$Bk = -1;
    $af3a2d87ccb15d29$var$Ck = 0;
    if (0 !== ($af3a2d87ccb15d29$var$K & 6)) throw Error($af3a2d87ccb15d29$var$p(327));
    var c = a.callbackNode;
    if ($af3a2d87ccb15d29$var$Ik() && a.callbackNode !== c) return null;
    var d = $af3a2d87ccb15d29$var$uc(a, a === $af3a2d87ccb15d29$var$R ? $af3a2d87ccb15d29$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $af3a2d87ccb15d29$var$Jk(a, d);
    else {
        b = d;
        var e = $af3a2d87ccb15d29$var$K;
        $af3a2d87ccb15d29$var$K |= 2;
        var f = $af3a2d87ccb15d29$var$Kk();
        if ($af3a2d87ccb15d29$var$R !== a || $af3a2d87ccb15d29$var$Z !== b) $af3a2d87ccb15d29$var$vk = null, $af3a2d87ccb15d29$var$Hj = $af3a2d87ccb15d29$var$B() + 500, $af3a2d87ccb15d29$var$Lk(a, b);
        for(;;)try {
            $af3a2d87ccb15d29$var$Mk();
            break;
        } catch (h) {
            $af3a2d87ccb15d29$var$Nk(a, h);
        }
        $af3a2d87ccb15d29$var$Qg();
        $af3a2d87ccb15d29$var$nk.current = f;
        $af3a2d87ccb15d29$var$K = e;
        null !== $af3a2d87ccb15d29$var$Y ? b = 0 : ($af3a2d87ccb15d29$var$R = null, $af3a2d87ccb15d29$var$Z = 0, b = $af3a2d87ccb15d29$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $af3a2d87ccb15d29$var$xc(a), 0 !== e && (d = e, b = $af3a2d87ccb15d29$var$Ok(a, e)));
        if (1 === b) throw c = $af3a2d87ccb15d29$var$qk, $af3a2d87ccb15d29$var$Lk(a, 0), $af3a2d87ccb15d29$var$Dk(a, d), $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B()), c;
        if (6 === b) $af3a2d87ccb15d29$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$af3a2d87ccb15d29$var$Pk(e) && (b = $af3a2d87ccb15d29$var$Jk(a, d), 2 === b && (f = $af3a2d87ccb15d29$var$xc(a), 0 !== f && (d = f, b = $af3a2d87ccb15d29$var$Ok(a, f))), 1 === b)) throw c = $af3a2d87ccb15d29$var$qk, $af3a2d87ccb15d29$var$Lk(a, 0), $af3a2d87ccb15d29$var$Dk(a, d), $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($af3a2d87ccb15d29$var$p(345));
                case 2:
                    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
                    break;
                case 3:
                    $af3a2d87ccb15d29$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $af3a2d87ccb15d29$var$gk + 500 - $af3a2d87ccb15d29$var$B(), 10 < b)) {
                        if (0 !== $af3a2d87ccb15d29$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $af3a2d87ccb15d29$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $af3a2d87ccb15d29$var$Ff($af3a2d87ccb15d29$var$Qk.bind(null, a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk), b);
                        break;
                    }
                    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
                    break;
                case 4:
                    $af3a2d87ccb15d29$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $af3a2d87ccb15d29$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $af3a2d87ccb15d29$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $af3a2d87ccb15d29$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $af3a2d87ccb15d29$var$Ff($af3a2d87ccb15d29$var$Qk.bind(null, a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk), d);
                        break;
                    }
                    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
                    break;
                case 5:
                    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
                    break;
                default:
                    throw Error($af3a2d87ccb15d29$var$p(329));
            }
        }
    }
    $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B());
    return a.callbackNode === c ? $af3a2d87ccb15d29$var$Hk.bind(null, a) : null;
}
function $af3a2d87ccb15d29$var$Ok(a, b) {
    var c = $af3a2d87ccb15d29$var$tk;
    a.current.memoizedState.isDehydrated && ($af3a2d87ccb15d29$var$Lk(a, b).flags |= 256);
    a = $af3a2d87ccb15d29$var$Jk(a, b);
    2 !== a && (b = $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$uk = c, null !== b && $af3a2d87ccb15d29$var$Gj(b));
    return a;
}
function $af3a2d87ccb15d29$var$Gj(a) {
    null === $af3a2d87ccb15d29$var$uk ? $af3a2d87ccb15d29$var$uk = a : $af3a2d87ccb15d29$var$uk.push.apply($af3a2d87ccb15d29$var$uk, a);
}
function $af3a2d87ccb15d29$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$af3a2d87ccb15d29$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $af3a2d87ccb15d29$var$Dk(a, b) {
    b &= ~$af3a2d87ccb15d29$var$sk;
    b &= ~$af3a2d87ccb15d29$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $af3a2d87ccb15d29$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $af3a2d87ccb15d29$var$Fk(a) {
    if (0 !== ($af3a2d87ccb15d29$var$K & 6)) throw Error($af3a2d87ccb15d29$var$p(327));
    $af3a2d87ccb15d29$var$Ik();
    var b = $af3a2d87ccb15d29$var$uc(a, 0);
    if (0 === (b & 1)) return $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B()), null;
    var c = $af3a2d87ccb15d29$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $af3a2d87ccb15d29$var$xc(a);
        0 !== d && (b = d, c = $af3a2d87ccb15d29$var$Ok(a, d));
    }
    if (1 === c) throw c = $af3a2d87ccb15d29$var$qk, $af3a2d87ccb15d29$var$Lk(a, 0), $af3a2d87ccb15d29$var$Dk(a, b), $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B()), c;
    if (6 === c) throw Error($af3a2d87ccb15d29$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $af3a2d87ccb15d29$var$Qk(a, $af3a2d87ccb15d29$var$uk, $af3a2d87ccb15d29$var$vk);
    $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B());
    return null;
}
function $af3a2d87ccb15d29$var$Rk(a, b) {
    var c = $af3a2d87ccb15d29$var$K;
    $af3a2d87ccb15d29$var$K |= 1;
    try {
        return a(b);
    } finally{
        $af3a2d87ccb15d29$var$K = c, 0 === $af3a2d87ccb15d29$var$K && ($af3a2d87ccb15d29$var$Hj = $af3a2d87ccb15d29$var$B() + 500, $af3a2d87ccb15d29$var$fg && $af3a2d87ccb15d29$var$jg());
    }
}
function $af3a2d87ccb15d29$var$Sk(a) {
    null !== $af3a2d87ccb15d29$var$xk && 0 === $af3a2d87ccb15d29$var$xk.tag && 0 === ($af3a2d87ccb15d29$var$K & 6) && $af3a2d87ccb15d29$var$Ik();
    var b = $af3a2d87ccb15d29$var$K;
    $af3a2d87ccb15d29$var$K |= 1;
    var c = $af3a2d87ccb15d29$var$pk.transition, d = $af3a2d87ccb15d29$var$C;
    try {
        if ($af3a2d87ccb15d29$var$pk.transition = null, $af3a2d87ccb15d29$var$C = 1, a) return a();
    } finally{
        $af3a2d87ccb15d29$var$C = d, $af3a2d87ccb15d29$var$pk.transition = c, $af3a2d87ccb15d29$var$K = b, 0 === ($af3a2d87ccb15d29$var$K & 6) && $af3a2d87ccb15d29$var$jg();
    }
}
function $af3a2d87ccb15d29$var$Ij() {
    $af3a2d87ccb15d29$var$gj = $af3a2d87ccb15d29$var$fj.current;
    $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$fj);
}
function $af3a2d87ccb15d29$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $af3a2d87ccb15d29$var$Gf(c));
    if (null !== $af3a2d87ccb15d29$var$Y) for(c = $af3a2d87ccb15d29$var$Y.return; null !== c;){
        var d = c;
        $af3a2d87ccb15d29$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $af3a2d87ccb15d29$var$$f();
                break;
            case 3:
                $af3a2d87ccb15d29$var$Jh();
                $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$Wf);
                $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$H);
                $af3a2d87ccb15d29$var$Oh();
                break;
            case 5:
                $af3a2d87ccb15d29$var$Lh(d);
                break;
            case 4:
                $af3a2d87ccb15d29$var$Jh();
                break;
            case 13:
                $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
                break;
            case 19:
                $af3a2d87ccb15d29$var$E($af3a2d87ccb15d29$var$M);
                break;
            case 10:
                $af3a2d87ccb15d29$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $af3a2d87ccb15d29$var$Ij();
        }
        c = c.return;
    }
    $af3a2d87ccb15d29$var$R = a;
    $af3a2d87ccb15d29$var$Y = a = $af3a2d87ccb15d29$var$wh(a.current, null);
    $af3a2d87ccb15d29$var$Z = $af3a2d87ccb15d29$var$gj = b;
    $af3a2d87ccb15d29$var$T = 0;
    $af3a2d87ccb15d29$var$qk = null;
    $af3a2d87ccb15d29$var$sk = $af3a2d87ccb15d29$var$rk = $af3a2d87ccb15d29$var$hh = 0;
    $af3a2d87ccb15d29$var$uk = $af3a2d87ccb15d29$var$tk = null;
    if (null !== $af3a2d87ccb15d29$var$Wg) {
        for(b = 0; b < $af3a2d87ccb15d29$var$Wg.length; b++)if (c = $af3a2d87ccb15d29$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $af3a2d87ccb15d29$var$Wg = null;
    }
    return a;
}
function $af3a2d87ccb15d29$var$Nk(a, b) {
    do {
        var c = $af3a2d87ccb15d29$var$Y;
        try {
            $af3a2d87ccb15d29$var$Qg();
            $af3a2d87ccb15d29$var$Ph.current = $af3a2d87ccb15d29$var$ai;
            if ($af3a2d87ccb15d29$var$Sh) {
                for(var d = $af3a2d87ccb15d29$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $af3a2d87ccb15d29$var$Sh = !1;
            }
            $af3a2d87ccb15d29$var$Rh = 0;
            $af3a2d87ccb15d29$var$P = $af3a2d87ccb15d29$var$O = $af3a2d87ccb15d29$var$N = null;
            $af3a2d87ccb15d29$var$Th = !1;
            $af3a2d87ccb15d29$var$Uh = 0;
            $af3a2d87ccb15d29$var$ok.current = null;
            if (null === c || null === c.return) {
                $af3a2d87ccb15d29$var$T = 1;
                $af3a2d87ccb15d29$var$qk = b;
                $af3a2d87ccb15d29$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $af3a2d87ccb15d29$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $af3a2d87ccb15d29$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $af3a2d87ccb15d29$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $af3a2d87ccb15d29$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $af3a2d87ccb15d29$var$Ti(f, l, b);
                            $af3a2d87ccb15d29$var$uj();
                            break a;
                        }
                        k = Error($af3a2d87ccb15d29$var$p(426));
                    }
                } else if ($af3a2d87ccb15d29$var$I && h.mode & 1) {
                    var J = $af3a2d87ccb15d29$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $af3a2d87ccb15d29$var$Wi(J, g, h, f, b);
                        $af3a2d87ccb15d29$var$Jg($af3a2d87ccb15d29$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $af3a2d87ccb15d29$var$Ki(k, h);
                4 !== $af3a2d87ccb15d29$var$T && ($af3a2d87ccb15d29$var$T = 2);
                null === $af3a2d87ccb15d29$var$tk ? $af3a2d87ccb15d29$var$tk = [
                    f
                ] : $af3a2d87ccb15d29$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $af3a2d87ccb15d29$var$Oi(f, k, b);
                            $af3a2d87ccb15d29$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $af3a2d87ccb15d29$var$Si || !$af3a2d87ccb15d29$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $af3a2d87ccb15d29$var$Ri(f, h, b);
                                $af3a2d87ccb15d29$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $af3a2d87ccb15d29$var$Tk(c);
        } catch (na) {
            b = na;
            $af3a2d87ccb15d29$var$Y === c && null !== c && ($af3a2d87ccb15d29$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $af3a2d87ccb15d29$var$Kk() {
    var a = $af3a2d87ccb15d29$var$nk.current;
    $af3a2d87ccb15d29$var$nk.current = $af3a2d87ccb15d29$var$ai;
    return null === a ? $af3a2d87ccb15d29$var$ai : a;
}
function $af3a2d87ccb15d29$var$uj() {
    if (0 === $af3a2d87ccb15d29$var$T || 3 === $af3a2d87ccb15d29$var$T || 2 === $af3a2d87ccb15d29$var$T) $af3a2d87ccb15d29$var$T = 4;
    null === $af3a2d87ccb15d29$var$R || 0 === ($af3a2d87ccb15d29$var$hh & 268435455) && 0 === ($af3a2d87ccb15d29$var$rk & 268435455) || $af3a2d87ccb15d29$var$Dk($af3a2d87ccb15d29$var$R, $af3a2d87ccb15d29$var$Z);
}
function $af3a2d87ccb15d29$var$Jk(a, b) {
    var c = $af3a2d87ccb15d29$var$K;
    $af3a2d87ccb15d29$var$K |= 2;
    var d = $af3a2d87ccb15d29$var$Kk();
    if ($af3a2d87ccb15d29$var$R !== a || $af3a2d87ccb15d29$var$Z !== b) $af3a2d87ccb15d29$var$vk = null, $af3a2d87ccb15d29$var$Lk(a, b);
    for(;;)try {
        $af3a2d87ccb15d29$var$Uk();
        break;
    } catch (e) {
        $af3a2d87ccb15d29$var$Nk(a, e);
    }
    $af3a2d87ccb15d29$var$Qg();
    $af3a2d87ccb15d29$var$K = c;
    $af3a2d87ccb15d29$var$nk.current = d;
    if (null !== $af3a2d87ccb15d29$var$Y) throw Error($af3a2d87ccb15d29$var$p(261));
    $af3a2d87ccb15d29$var$R = null;
    $af3a2d87ccb15d29$var$Z = 0;
    return $af3a2d87ccb15d29$var$T;
}
function $af3a2d87ccb15d29$var$Uk() {
    for(; null !== $af3a2d87ccb15d29$var$Y;)$af3a2d87ccb15d29$var$Vk($af3a2d87ccb15d29$var$Y);
}
function $af3a2d87ccb15d29$var$Mk() {
    for(; null !== $af3a2d87ccb15d29$var$Y && !$af3a2d87ccb15d29$var$cc();)$af3a2d87ccb15d29$var$Vk($af3a2d87ccb15d29$var$Y);
}
function $af3a2d87ccb15d29$var$Vk(a) {
    var b = $af3a2d87ccb15d29$var$Wk(a.alternate, a, $af3a2d87ccb15d29$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $af3a2d87ccb15d29$var$Tk(a) : $af3a2d87ccb15d29$var$Y = b;
    $af3a2d87ccb15d29$var$ok.current = null;
}
function $af3a2d87ccb15d29$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $af3a2d87ccb15d29$var$Fj(c, b, $af3a2d87ccb15d29$var$gj), null !== c) {
                $af3a2d87ccb15d29$var$Y = c;
                return;
            }
        } else {
            c = $af3a2d87ccb15d29$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $af3a2d87ccb15d29$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $af3a2d87ccb15d29$var$T = 6;
                $af3a2d87ccb15d29$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $af3a2d87ccb15d29$var$Y = b;
            return;
        }
        $af3a2d87ccb15d29$var$Y = b = a;
    }while (null !== b);
    0 === $af3a2d87ccb15d29$var$T && ($af3a2d87ccb15d29$var$T = 5);
}
function $af3a2d87ccb15d29$var$Qk(a, b, c) {
    var d = $af3a2d87ccb15d29$var$C, e = $af3a2d87ccb15d29$var$pk.transition;
    try {
        $af3a2d87ccb15d29$var$pk.transition = null, $af3a2d87ccb15d29$var$C = 1, $af3a2d87ccb15d29$var$Xk(a, b, c, d);
    } finally{
        $af3a2d87ccb15d29$var$pk.transition = e, $af3a2d87ccb15d29$var$C = d;
    }
    return null;
}
function $af3a2d87ccb15d29$var$Xk(a, b, c, d) {
    do $af3a2d87ccb15d29$var$Ik();
    while (null !== $af3a2d87ccb15d29$var$xk);
    if (0 !== ($af3a2d87ccb15d29$var$K & 6)) throw Error($af3a2d87ccb15d29$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($af3a2d87ccb15d29$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $af3a2d87ccb15d29$var$Bc(a, f);
    a === $af3a2d87ccb15d29$var$R && ($af3a2d87ccb15d29$var$Y = $af3a2d87ccb15d29$var$R = null, $af3a2d87ccb15d29$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $af3a2d87ccb15d29$var$wk || ($af3a2d87ccb15d29$var$wk = !0, $af3a2d87ccb15d29$var$Gk($af3a2d87ccb15d29$var$hc, function() {
        $af3a2d87ccb15d29$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $af3a2d87ccb15d29$var$pk.transition;
        $af3a2d87ccb15d29$var$pk.transition = null;
        var g = $af3a2d87ccb15d29$var$C;
        $af3a2d87ccb15d29$var$C = 1;
        var h = $af3a2d87ccb15d29$var$K;
        $af3a2d87ccb15d29$var$K |= 4;
        $af3a2d87ccb15d29$var$ok.current = null;
        $af3a2d87ccb15d29$var$Pj(a, c);
        $af3a2d87ccb15d29$var$ek(c, a);
        $af3a2d87ccb15d29$var$Oe($af3a2d87ccb15d29$var$Df);
        $af3a2d87ccb15d29$var$dd = !!$af3a2d87ccb15d29$var$Cf;
        $af3a2d87ccb15d29$var$Df = $af3a2d87ccb15d29$var$Cf = null;
        a.current = c;
        $af3a2d87ccb15d29$var$ik(c, a, e);
        $af3a2d87ccb15d29$var$dc();
        $af3a2d87ccb15d29$var$K = h;
        $af3a2d87ccb15d29$var$C = g;
        $af3a2d87ccb15d29$var$pk.transition = f;
    } else a.current = c;
    $af3a2d87ccb15d29$var$wk && ($af3a2d87ccb15d29$var$wk = !1, $af3a2d87ccb15d29$var$xk = a, $af3a2d87ccb15d29$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($af3a2d87ccb15d29$var$Si = null);
    $af3a2d87ccb15d29$var$mc(c.stateNode, d);
    $af3a2d87ccb15d29$var$Ek(a, $af3a2d87ccb15d29$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($af3a2d87ccb15d29$var$Pi) throw $af3a2d87ccb15d29$var$Pi = !1, a = $af3a2d87ccb15d29$var$Qi, $af3a2d87ccb15d29$var$Qi = null, a;
    0 !== ($af3a2d87ccb15d29$var$yk & 1) && 0 !== a.tag && $af3a2d87ccb15d29$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $af3a2d87ccb15d29$var$Ak ? $af3a2d87ccb15d29$var$zk++ : ($af3a2d87ccb15d29$var$zk = 0, $af3a2d87ccb15d29$var$Ak = a) : $af3a2d87ccb15d29$var$zk = 0;
    $af3a2d87ccb15d29$var$jg();
    return null;
}
function $af3a2d87ccb15d29$var$Ik() {
    if (null !== $af3a2d87ccb15d29$var$xk) {
        var a = $af3a2d87ccb15d29$var$Dc($af3a2d87ccb15d29$var$yk), b = $af3a2d87ccb15d29$var$pk.transition, c = $af3a2d87ccb15d29$var$C;
        try {
            $af3a2d87ccb15d29$var$pk.transition = null;
            $af3a2d87ccb15d29$var$C = 16 > a ? 16 : a;
            if (null === $af3a2d87ccb15d29$var$xk) var d = !1;
            else {
                a = $af3a2d87ccb15d29$var$xk;
                $af3a2d87ccb15d29$var$xk = null;
                $af3a2d87ccb15d29$var$yk = 0;
                if (0 !== ($af3a2d87ccb15d29$var$K & 6)) throw Error($af3a2d87ccb15d29$var$p(331));
                var e = $af3a2d87ccb15d29$var$K;
                $af3a2d87ccb15d29$var$K |= 4;
                for($af3a2d87ccb15d29$var$V = a.current; null !== $af3a2d87ccb15d29$var$V;){
                    var f = $af3a2d87ccb15d29$var$V, g = f.child;
                    if (0 !== ($af3a2d87ccb15d29$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($af3a2d87ccb15d29$var$V = l; null !== $af3a2d87ccb15d29$var$V;){
                                    var m = $af3a2d87ccb15d29$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $af3a2d87ccb15d29$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $af3a2d87ccb15d29$var$V = q;
                                    else for(; null !== $af3a2d87ccb15d29$var$V;){
                                        m = $af3a2d87ccb15d29$var$V;
                                        var r = m.sibling, y = m.return;
                                        $af3a2d87ccb15d29$var$Tj(m);
                                        if (m === l) {
                                            $af3a2d87ccb15d29$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $af3a2d87ccb15d29$var$V = r;
                                            break;
                                        }
                                        $af3a2d87ccb15d29$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $af3a2d87ccb15d29$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $af3a2d87ccb15d29$var$V = g;
                    else b: for(; null !== $af3a2d87ccb15d29$var$V;){
                        f = $af3a2d87ccb15d29$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $af3a2d87ccb15d29$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $af3a2d87ccb15d29$var$V = x;
                            break b;
                        }
                        $af3a2d87ccb15d29$var$V = f.return;
                    }
                }
                var w = a.current;
                for($af3a2d87ccb15d29$var$V = w; null !== $af3a2d87ccb15d29$var$V;){
                    g = $af3a2d87ccb15d29$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $af3a2d87ccb15d29$var$V = u;
                    else b: for(g = w; null !== $af3a2d87ccb15d29$var$V;){
                        h = $af3a2d87ccb15d29$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $af3a2d87ccb15d29$var$Rj(9, h);
                            }
                        } catch (na) {
                            $af3a2d87ccb15d29$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $af3a2d87ccb15d29$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $af3a2d87ccb15d29$var$V = F;
                            break b;
                        }
                        $af3a2d87ccb15d29$var$V = h.return;
                    }
                }
                $af3a2d87ccb15d29$var$K = e;
                $af3a2d87ccb15d29$var$jg();
                if ($af3a2d87ccb15d29$var$lc && "function" === typeof $af3a2d87ccb15d29$var$lc.onPostCommitFiberRoot) try {
                    $af3a2d87ccb15d29$var$lc.onPostCommitFiberRoot($af3a2d87ccb15d29$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $af3a2d87ccb15d29$var$C = c, $af3a2d87ccb15d29$var$pk.transition = b;
        }
    }
    return !1;
}
function $af3a2d87ccb15d29$var$Yk(a, b, c) {
    b = $af3a2d87ccb15d29$var$Ki(c, b);
    b = $af3a2d87ccb15d29$var$Oi(a, b, 1);
    a = $af3a2d87ccb15d29$var$dh(a, b, 1);
    b = $af3a2d87ccb15d29$var$L();
    null !== a && ($af3a2d87ccb15d29$var$Ac(a, 1, b), $af3a2d87ccb15d29$var$Ek(a, b));
}
function $af3a2d87ccb15d29$var$W(a, b, c) {
    if (3 === a.tag) $af3a2d87ccb15d29$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $af3a2d87ccb15d29$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $af3a2d87ccb15d29$var$Si || !$af3a2d87ccb15d29$var$Si.has(d))) {
                a = $af3a2d87ccb15d29$var$Ki(c, a);
                a = $af3a2d87ccb15d29$var$Ri(b, a, 1);
                b = $af3a2d87ccb15d29$var$dh(b, a, 1);
                a = $af3a2d87ccb15d29$var$L();
                null !== b && ($af3a2d87ccb15d29$var$Ac(b, 1, a), $af3a2d87ccb15d29$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $af3a2d87ccb15d29$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $af3a2d87ccb15d29$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $af3a2d87ccb15d29$var$R === a && ($af3a2d87ccb15d29$var$Z & c) === c && (4 === $af3a2d87ccb15d29$var$T || 3 === $af3a2d87ccb15d29$var$T && ($af3a2d87ccb15d29$var$Z & 130023424) === $af3a2d87ccb15d29$var$Z && 500 > $af3a2d87ccb15d29$var$B() - $af3a2d87ccb15d29$var$gk ? $af3a2d87ccb15d29$var$Lk(a, 0) : $af3a2d87ccb15d29$var$sk |= c);
    $af3a2d87ccb15d29$var$Ek(a, b);
}
function $af3a2d87ccb15d29$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $af3a2d87ccb15d29$var$sc, $af3a2d87ccb15d29$var$sc <<= 1, 0 === ($af3a2d87ccb15d29$var$sc & 130023424) && ($af3a2d87ccb15d29$var$sc = 4194304)));
    var c = $af3a2d87ccb15d29$var$L();
    a = $af3a2d87ccb15d29$var$Zg(a, b);
    null !== a && ($af3a2d87ccb15d29$var$Ac(a, b, c), $af3a2d87ccb15d29$var$Ek(a, c));
}
function $af3a2d87ccb15d29$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $af3a2d87ccb15d29$var$Zk(a, c);
}
function $af3a2d87ccb15d29$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($af3a2d87ccb15d29$var$p(314));
    }
    null !== d && d.delete(b);
    $af3a2d87ccb15d29$var$Zk(a, c);
}
var $af3a2d87ccb15d29$var$Wk;
$af3a2d87ccb15d29$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $af3a2d87ccb15d29$var$Wf.current) $af3a2d87ccb15d29$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $af3a2d87ccb15d29$var$Ug = !1, $af3a2d87ccb15d29$var$zj(a, b, c);
            $af3a2d87ccb15d29$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $af3a2d87ccb15d29$var$Ug = !1, $af3a2d87ccb15d29$var$I && 0 !== (b.flags & 1048576) && $af3a2d87ccb15d29$var$ug(b, $af3a2d87ccb15d29$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $af3a2d87ccb15d29$var$jj(a, b);
            a = b.pendingProps;
            var e = $af3a2d87ccb15d29$var$Yf(b, $af3a2d87ccb15d29$var$H.current);
            $af3a2d87ccb15d29$var$Tg(b, c);
            e = $af3a2d87ccb15d29$var$Xh(null, b, d, a, e, c);
            var f = $af3a2d87ccb15d29$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $af3a2d87ccb15d29$var$Zf(d) ? (f = !0, $af3a2d87ccb15d29$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $af3a2d87ccb15d29$var$ah(b), e.updater = $af3a2d87ccb15d29$var$nh, b.stateNode = e, e._reactInternals = b, $af3a2d87ccb15d29$var$rh(b, d, a, c), b = $af3a2d87ccb15d29$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $af3a2d87ccb15d29$var$I && f && $af3a2d87ccb15d29$var$vg(b), $af3a2d87ccb15d29$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $af3a2d87ccb15d29$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $af3a2d87ccb15d29$var$$k(d);
                a = $af3a2d87ccb15d29$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $af3a2d87ccb15d29$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $af3a2d87ccb15d29$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $af3a2d87ccb15d29$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $af3a2d87ccb15d29$var$aj(null, b, d, $af3a2d87ccb15d29$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($af3a2d87ccb15d29$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af3a2d87ccb15d29$var$Lg(d, e), $af3a2d87ccb15d29$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af3a2d87ccb15d29$var$Lg(d, e), $af3a2d87ccb15d29$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $af3a2d87ccb15d29$var$lj(b);
                if (null === a) throw Error($af3a2d87ccb15d29$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $af3a2d87ccb15d29$var$bh(a, b);
                $af3a2d87ccb15d29$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $af3a2d87ccb15d29$var$Ki(Error($af3a2d87ccb15d29$var$p(423)), b);
                        b = $af3a2d87ccb15d29$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $af3a2d87ccb15d29$var$Ki(Error($af3a2d87ccb15d29$var$p(424)), b);
                        b = $af3a2d87ccb15d29$var$mj(a, b, d, c, e);
                        break a;
                    } else for($af3a2d87ccb15d29$var$yg = $af3a2d87ccb15d29$var$Lf(b.stateNode.containerInfo.firstChild), $af3a2d87ccb15d29$var$xg = b, $af3a2d87ccb15d29$var$I = !0, $af3a2d87ccb15d29$var$zg = null, c = $af3a2d87ccb15d29$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $af3a2d87ccb15d29$var$Ig();
                    if (d === e) {
                        b = $af3a2d87ccb15d29$var$$i(a, b, c);
                        break a;
                    }
                    $af3a2d87ccb15d29$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $af3a2d87ccb15d29$var$Kh(b), null === a && $af3a2d87ccb15d29$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $af3a2d87ccb15d29$var$Ef(d, e) ? g = null : null !== f && $af3a2d87ccb15d29$var$Ef(d, f) && (b.flags |= 32), $af3a2d87ccb15d29$var$hj(a, b), $af3a2d87ccb15d29$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $af3a2d87ccb15d29$var$Eg(b), null;
        case 13:
            return $af3a2d87ccb15d29$var$pj(a, b, c);
        case 4:
            return $af3a2d87ccb15d29$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $af3a2d87ccb15d29$var$Bh(b, null, d, c) : $af3a2d87ccb15d29$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af3a2d87ccb15d29$var$Lg(d, e), $af3a2d87ccb15d29$var$Zi(a, b, d, e, c);
        case 7:
            return $af3a2d87ccb15d29$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $af3a2d87ccb15d29$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $af3a2d87ccb15d29$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $af3a2d87ccb15d29$var$G($af3a2d87ccb15d29$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($af3a2d87ccb15d29$var$He(f.value, g)) {
                        if (f.children === e.children && !$af3a2d87ccb15d29$var$Wf.current) {
                            b = $af3a2d87ccb15d29$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $af3a2d87ccb15d29$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $af3a2d87ccb15d29$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($af3a2d87ccb15d29$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $af3a2d87ccb15d29$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $af3a2d87ccb15d29$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $af3a2d87ccb15d29$var$Tg(b, c), e = $af3a2d87ccb15d29$var$Vg(e), d = d(e), b.flags |= 1, $af3a2d87ccb15d29$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $af3a2d87ccb15d29$var$Lg(d, b.pendingProps), e = $af3a2d87ccb15d29$var$Lg(d.type, e), $af3a2d87ccb15d29$var$aj(a, b, d, e, c);
        case 15:
            return $af3a2d87ccb15d29$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $af3a2d87ccb15d29$var$Lg(d, e), $af3a2d87ccb15d29$var$jj(a, b), b.tag = 1, $af3a2d87ccb15d29$var$Zf(d) ? (a = !0, $af3a2d87ccb15d29$var$cg(b)) : a = !1, $af3a2d87ccb15d29$var$Tg(b, c), $af3a2d87ccb15d29$var$ph(b, d, e), $af3a2d87ccb15d29$var$rh(b, d, e, c), $af3a2d87ccb15d29$var$kj(null, b, d, !0, a, c);
        case 19:
            return $af3a2d87ccb15d29$var$yj(a, b, c);
        case 22:
            return $af3a2d87ccb15d29$var$ej(a, b, c);
    }
    throw Error($af3a2d87ccb15d29$var$p(156, b.tag));
};
function $af3a2d87ccb15d29$var$Gk(a, b) {
    return $af3a2d87ccb15d29$var$ac(a, b);
}
function $af3a2d87ccb15d29$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $af3a2d87ccb15d29$var$Bg(a, b, c, d) {
    return new $af3a2d87ccb15d29$var$al(a, b, c, d);
}
function $af3a2d87ccb15d29$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $af3a2d87ccb15d29$var$$k(a) {
    if ("function" === typeof a) return $af3a2d87ccb15d29$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $af3a2d87ccb15d29$var$Da) return 11;
        if (a === $af3a2d87ccb15d29$var$Ga) return 14;
    }
    return 2;
}
function $af3a2d87ccb15d29$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $af3a2d87ccb15d29$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $af3a2d87ccb15d29$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $af3a2d87ccb15d29$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $af3a2d87ccb15d29$var$ya:
            return $af3a2d87ccb15d29$var$Ah(c.children, e, f, b);
        case $af3a2d87ccb15d29$var$za:
            g = 8;
            e |= 8;
            break;
        case $af3a2d87ccb15d29$var$Aa:
            return a = $af3a2d87ccb15d29$var$Bg(12, c, b, e | 2), a.elementType = $af3a2d87ccb15d29$var$Aa, a.lanes = f, a;
        case $af3a2d87ccb15d29$var$Ea:
            return a = $af3a2d87ccb15d29$var$Bg(13, c, b, e), a.elementType = $af3a2d87ccb15d29$var$Ea, a.lanes = f, a;
        case $af3a2d87ccb15d29$var$Fa:
            return a = $af3a2d87ccb15d29$var$Bg(19, c, b, e), a.elementType = $af3a2d87ccb15d29$var$Fa, a.lanes = f, a;
        case $af3a2d87ccb15d29$var$Ia:
            return $af3a2d87ccb15d29$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $af3a2d87ccb15d29$var$Ba:
                    g = 10;
                    break a;
                case $af3a2d87ccb15d29$var$Ca:
                    g = 9;
                    break a;
                case $af3a2d87ccb15d29$var$Da:
                    g = 11;
                    break a;
                case $af3a2d87ccb15d29$var$Ga:
                    g = 14;
                    break a;
                case $af3a2d87ccb15d29$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($af3a2d87ccb15d29$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $af3a2d87ccb15d29$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $af3a2d87ccb15d29$var$Ah(a, b, c, d) {
    a = $af3a2d87ccb15d29$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $af3a2d87ccb15d29$var$qj(a, b, c, d) {
    a = $af3a2d87ccb15d29$var$Bg(22, a, d, b);
    a.elementType = $af3a2d87ccb15d29$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $af3a2d87ccb15d29$var$xh(a, b, c) {
    a = $af3a2d87ccb15d29$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $af3a2d87ccb15d29$var$zh(a, b, c) {
    b = $af3a2d87ccb15d29$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $af3a2d87ccb15d29$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $af3a2d87ccb15d29$var$zc(0);
    this.expirationTimes = $af3a2d87ccb15d29$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $af3a2d87ccb15d29$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $af3a2d87ccb15d29$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $af3a2d87ccb15d29$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $af3a2d87ccb15d29$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $af3a2d87ccb15d29$var$ah(f);
    return a;
}
function $af3a2d87ccb15d29$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $af3a2d87ccb15d29$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $af3a2d87ccb15d29$var$el(a) {
    if (!a) return $af3a2d87ccb15d29$var$Vf;
    a = a._reactInternals;
    a: {
        if ($af3a2d87ccb15d29$var$Vb(a) !== a || 1 !== a.tag) throw Error($af3a2d87ccb15d29$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($af3a2d87ccb15d29$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($af3a2d87ccb15d29$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($af3a2d87ccb15d29$var$Zf(c)) return $af3a2d87ccb15d29$var$bg(a, c, b);
    }
    return b;
}
function $af3a2d87ccb15d29$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $af3a2d87ccb15d29$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $af3a2d87ccb15d29$var$el(null);
    c = a.current;
    d = $af3a2d87ccb15d29$var$L();
    e = $af3a2d87ccb15d29$var$lh(c);
    f = $af3a2d87ccb15d29$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $af3a2d87ccb15d29$var$dh(c, f, e);
    a.current.lanes = e;
    $af3a2d87ccb15d29$var$Ac(a, e, d);
    $af3a2d87ccb15d29$var$Ek(a, d);
    return a;
}
function $af3a2d87ccb15d29$var$gl(a, b, c, d) {
    var e = b.current, f = $af3a2d87ccb15d29$var$L(), g = $af3a2d87ccb15d29$var$lh(e);
    c = $af3a2d87ccb15d29$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $af3a2d87ccb15d29$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $af3a2d87ccb15d29$var$dh(e, b, g);
    null !== a && ($af3a2d87ccb15d29$var$mh(a, e, g, f), $af3a2d87ccb15d29$var$eh(a, e, g));
    return g;
}
function $af3a2d87ccb15d29$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $af3a2d87ccb15d29$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $af3a2d87ccb15d29$var$jl(a, b) {
    $af3a2d87ccb15d29$var$il(a, b);
    (a = a.alternate) && $af3a2d87ccb15d29$var$il(a, b);
}
function $af3a2d87ccb15d29$var$kl() {
    return null;
}
var $af3a2d87ccb15d29$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $af3a2d87ccb15d29$var$ml(a) {
    this._internalRoot = a;
}
$af3a2d87ccb15d29$var$nl.prototype.render = $af3a2d87ccb15d29$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($af3a2d87ccb15d29$var$p(409));
    $af3a2d87ccb15d29$var$gl(a, b, null, null);
};
$af3a2d87ccb15d29$var$nl.prototype.unmount = $af3a2d87ccb15d29$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $af3a2d87ccb15d29$var$Sk(function() {
            $af3a2d87ccb15d29$var$gl(null, a, null, null);
        });
        b[$af3a2d87ccb15d29$var$uf] = null;
    }
};
function $af3a2d87ccb15d29$var$nl(a) {
    this._internalRoot = a;
}
$af3a2d87ccb15d29$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $af3a2d87ccb15d29$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $af3a2d87ccb15d29$var$Qc.length && 0 !== b && b < $af3a2d87ccb15d29$var$Qc[c].priority; c++);
        $af3a2d87ccb15d29$var$Qc.splice(c, 0, a);
        0 === c && $af3a2d87ccb15d29$var$Vc(a);
    }
};
function $af3a2d87ccb15d29$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $af3a2d87ccb15d29$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $af3a2d87ccb15d29$var$ql() {}
function $af3a2d87ccb15d29$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $af3a2d87ccb15d29$var$hl(g);
                f.call(a);
            };
        }
        var g = $af3a2d87ccb15d29$var$fl(b, d, a, 0, null, !1, !1, "", $af3a2d87ccb15d29$var$ql);
        a._reactRootContainer = g;
        a[$af3a2d87ccb15d29$var$uf] = g.current;
        $af3a2d87ccb15d29$var$sf(8 === a.nodeType ? a.parentNode : a);
        $af3a2d87ccb15d29$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $af3a2d87ccb15d29$var$hl(k);
            h.call(a);
        };
    }
    var k = $af3a2d87ccb15d29$var$cl(a, 0, !1, null, null, !1, !1, "", $af3a2d87ccb15d29$var$ql);
    a._reactRootContainer = k;
    a[$af3a2d87ccb15d29$var$uf] = k.current;
    $af3a2d87ccb15d29$var$sf(8 === a.nodeType ? a.parentNode : a);
    $af3a2d87ccb15d29$var$Sk(function() {
        $af3a2d87ccb15d29$var$gl(b, k, c, d);
    });
    return k;
}
function $af3a2d87ccb15d29$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $af3a2d87ccb15d29$var$hl(g);
                h.call(a);
            };
        }
        $af3a2d87ccb15d29$var$gl(b, g, a, e);
    } else g = $af3a2d87ccb15d29$var$rl(c, b, a, e, d);
    return $af3a2d87ccb15d29$var$hl(g);
}
$af3a2d87ccb15d29$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $af3a2d87ccb15d29$var$tc(b.pendingLanes);
                0 !== c && ($af3a2d87ccb15d29$var$Cc(b, c | 1), $af3a2d87ccb15d29$var$Ek(b, $af3a2d87ccb15d29$var$B()), 0 === ($af3a2d87ccb15d29$var$K & 6) && ($af3a2d87ccb15d29$var$Hj = $af3a2d87ccb15d29$var$B() + 500, $af3a2d87ccb15d29$var$jg()));
            }
            break;
        case 13:
            $af3a2d87ccb15d29$var$Sk(function() {
                var b = $af3a2d87ccb15d29$var$Zg(a, 1);
                if (null !== b) {
                    var c = $af3a2d87ccb15d29$var$L();
                    $af3a2d87ccb15d29$var$mh(b, a, 1, c);
                }
            }), $af3a2d87ccb15d29$var$jl(a, 1);
    }
};
$af3a2d87ccb15d29$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $af3a2d87ccb15d29$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $af3a2d87ccb15d29$var$L();
            $af3a2d87ccb15d29$var$mh(b, a, 134217728, c);
        }
        $af3a2d87ccb15d29$var$jl(a, 134217728);
    }
};
$af3a2d87ccb15d29$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $af3a2d87ccb15d29$var$lh(a), c = $af3a2d87ccb15d29$var$Zg(a, b);
        if (null !== c) {
            var d = $af3a2d87ccb15d29$var$L();
            $af3a2d87ccb15d29$var$mh(c, a, b, d);
        }
        $af3a2d87ccb15d29$var$jl(a, b);
    }
};
$af3a2d87ccb15d29$var$Hc = function() {
    return $af3a2d87ccb15d29$var$C;
};
$af3a2d87ccb15d29$var$Ic = function(a, b) {
    var c = $af3a2d87ccb15d29$var$C;
    try {
        return $af3a2d87ccb15d29$var$C = a, b();
    } finally{
        $af3a2d87ccb15d29$var$C = c;
    }
};
$af3a2d87ccb15d29$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $af3a2d87ccb15d29$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $af3a2d87ccb15d29$var$Db(d);
                        if (!e) throw Error($af3a2d87ccb15d29$var$p(90));
                        $af3a2d87ccb15d29$var$Wa(d);
                        $af3a2d87ccb15d29$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $af3a2d87ccb15d29$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $af3a2d87ccb15d29$var$fb(a, !!c.multiple, b, !1);
    }
};
$af3a2d87ccb15d29$var$Gb = $af3a2d87ccb15d29$var$Rk;
$af3a2d87ccb15d29$var$Hb = $af3a2d87ccb15d29$var$Sk;
var $af3a2d87ccb15d29$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $af3a2d87ccb15d29$var$Cb,
        $af3a2d87ccb15d29$var$ue,
        $af3a2d87ccb15d29$var$Db,
        $af3a2d87ccb15d29$var$Eb,
        $af3a2d87ccb15d29$var$Fb,
        $af3a2d87ccb15d29$var$Rk
    ]
}, $af3a2d87ccb15d29$var$ul = {
    findFiberByHostInstance: $af3a2d87ccb15d29$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $af3a2d87ccb15d29$var$vl = {
    bundleType: $af3a2d87ccb15d29$var$ul.bundleType,
    version: $af3a2d87ccb15d29$var$ul.version,
    rendererPackageName: $af3a2d87ccb15d29$var$ul.rendererPackageName,
    rendererConfig: $af3a2d87ccb15d29$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $af3a2d87ccb15d29$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $af3a2d87ccb15d29$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $af3a2d87ccb15d29$var$ul.findFiberByHostInstance || $af3a2d87ccb15d29$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $af3a2d87ccb15d29$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$af3a2d87ccb15d29$var$wl.isDisabled && $af3a2d87ccb15d29$var$wl.supportsFiber) try {
        $af3a2d87ccb15d29$var$kc = $af3a2d87ccb15d29$var$wl.inject($af3a2d87ccb15d29$var$vl), $af3a2d87ccb15d29$var$lc = $af3a2d87ccb15d29$var$wl;
    } catch (a) {}
}
$af3a2d87ccb15d29$export$ae55be85d98224ed = $af3a2d87ccb15d29$var$tl;
$af3a2d87ccb15d29$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$af3a2d87ccb15d29$var$ol(b)) throw Error($af3a2d87ccb15d29$var$p(200));
    return $af3a2d87ccb15d29$var$dl(a, b, null, c);
};
$af3a2d87ccb15d29$export$882461b6382ed46c = function(a, b) {
    if (!$af3a2d87ccb15d29$var$ol(a)) throw Error($af3a2d87ccb15d29$var$p(299));
    var c = !1, d = "", e = $af3a2d87ccb15d29$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $af3a2d87ccb15d29$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$af3a2d87ccb15d29$var$uf] = b.current;
    $af3a2d87ccb15d29$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $af3a2d87ccb15d29$var$ml(b);
};
$af3a2d87ccb15d29$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($af3a2d87ccb15d29$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($af3a2d87ccb15d29$var$p(268, a));
    }
    a = $af3a2d87ccb15d29$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$af3a2d87ccb15d29$export$cd75ccfd720a3cd4 = function(a) {
    return $af3a2d87ccb15d29$var$Sk(a);
};
$af3a2d87ccb15d29$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$af3a2d87ccb15d29$var$pl(b)) throw Error($af3a2d87ccb15d29$var$p(200));
    return $af3a2d87ccb15d29$var$sl(null, a, b, !0, c);
};
$af3a2d87ccb15d29$export$757ceba2d55c277e = function(a, b, c) {
    if (!$af3a2d87ccb15d29$var$ol(a)) throw Error($af3a2d87ccb15d29$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $af3a2d87ccb15d29$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $af3a2d87ccb15d29$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$af3a2d87ccb15d29$var$uf] = b.current;
    $af3a2d87ccb15d29$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $af3a2d87ccb15d29$var$nl(b);
};
$af3a2d87ccb15d29$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$af3a2d87ccb15d29$var$pl(b)) throw Error($af3a2d87ccb15d29$var$p(200));
    return $af3a2d87ccb15d29$var$sl(null, a, b, !1, c);
};
$af3a2d87ccb15d29$export$502457920280e6be = function(a) {
    if (!$af3a2d87ccb15d29$var$pl(a)) throw Error($af3a2d87ccb15d29$var$p(40));
    return a._reactRootContainer ? ($af3a2d87ccb15d29$var$Sk(function() {
        $af3a2d87ccb15d29$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$af3a2d87ccb15d29$var$uf] = null;
        });
    }), !0) : !1;
};
$af3a2d87ccb15d29$export$c78a37762a8d58e1 = $af3a2d87ccb15d29$var$Rk;
$af3a2d87ccb15d29$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$af3a2d87ccb15d29$var$pl(c)) throw Error($af3a2d87ccb15d29$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($af3a2d87ccb15d29$var$p(38));
    return $af3a2d87ccb15d29$var$sl(a, b, c, !1, d);
};
$af3a2d87ccb15d29$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("7DCHO", function(module, exports) {
"use strict";

module.exports = (parcelRequire("59RiQ"));

});
parcelRegister("59RiQ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $3c1723e4455f0262$export$c4744153514ff05d, (v) => $3c1723e4455f0262$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $3c1723e4455f0262$export$3e506c1ccc9cc1a7, (v) => $3c1723e4455f0262$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $3c1723e4455f0262$export$e26fe2ed2fa76875, (v) => $3c1723e4455f0262$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $3c1723e4455f0262$export$502329bbf4b505b1, (v) => $3c1723e4455f0262$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $3c1723e4455f0262$export$6e3807111c4874c4, (v) => $3c1723e4455f0262$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $3c1723e4455f0262$export$c27134553091fb3a, (v) => $3c1723e4455f0262$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $3c1723e4455f0262$export$33ee1acdc04fd2a2, (v) => $3c1723e4455f0262$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $3c1723e4455f0262$export$b00a404bbd5edef2, (v) => $3c1723e4455f0262$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $3c1723e4455f0262$export$8352ce38b91d0c62, (v) => $3c1723e4455f0262$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $3c1723e4455f0262$export$d66a1c1c77bd778b, (v) => $3c1723e4455f0262$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $3c1723e4455f0262$export$d3dfb8e4810cb555, (v) => $3c1723e4455f0262$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $3c1723e4455f0262$export$839f9183b0465a69, (v) => $3c1723e4455f0262$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $3c1723e4455f0262$export$72fdf0e06517287b, (v) => $3c1723e4455f0262$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $3c1723e4455f0262$export$4b844e58a3e414b4, (v) => $3c1723e4455f0262$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $3c1723e4455f0262$export$816d2913ae6b83b1, (v) => $3c1723e4455f0262$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $3c1723e4455f0262$export$61bcfe829111a1d0, (v) => $3c1723e4455f0262$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $3c1723e4455f0262$export$7ee8c9beb337bc3f, (v) => $3c1723e4455f0262$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $3c1723e4455f0262$export$b5836b71941fa3ed, (v) => $3c1723e4455f0262$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $3c1723e4455f0262$export$cf845f2c119da08a, (v) => $3c1723e4455f0262$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3c1723e4455f0262$export$c4744153514ff05d;
var $3c1723e4455f0262$export$3e506c1ccc9cc1a7;
var $3c1723e4455f0262$export$e26fe2ed2fa76875;
var $3c1723e4455f0262$export$502329bbf4b505b1;
var $3c1723e4455f0262$export$6e3807111c4874c4;
var $3c1723e4455f0262$export$c27134553091fb3a;
var $3c1723e4455f0262$export$33ee1acdc04fd2a2;
var $3c1723e4455f0262$export$b00a404bbd5edef2;
var $3c1723e4455f0262$export$8352ce38b91d0c62;
var $3c1723e4455f0262$export$d66a1c1c77bd778b;
var $3c1723e4455f0262$export$d3dfb8e4810cb555;
var $3c1723e4455f0262$export$839f9183b0465a69;
var $3c1723e4455f0262$export$72fdf0e06517287b;
var $3c1723e4455f0262$export$4b844e58a3e414b4;
var $3c1723e4455f0262$export$816d2913ae6b83b1;
var $3c1723e4455f0262$export$61bcfe829111a1d0;
var $3c1723e4455f0262$export$7ee8c9beb337bc3f;
var $3c1723e4455f0262$export$b5836b71941fa3ed;
var $3c1723e4455f0262$export$cf845f2c119da08a;
"use strict";
function $3c1723e4455f0262$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $3c1723e4455f0262$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $3c1723e4455f0262$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $3c1723e4455f0262$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $3c1723e4455f0262$var$g(C, c)) n < e && 0 > $3c1723e4455f0262$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $3c1723e4455f0262$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $3c1723e4455f0262$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3c1723e4455f0262$var$l = performance;
    $3c1723e4455f0262$export$c4744153514ff05d = function() {
        return $3c1723e4455f0262$var$l.now();
    };
} else {
    var $3c1723e4455f0262$var$p = Date, $3c1723e4455f0262$var$q = $3c1723e4455f0262$var$p.now();
    $3c1723e4455f0262$export$c4744153514ff05d = function() {
        return $3c1723e4455f0262$var$p.now() - $3c1723e4455f0262$var$q;
    };
}
var $3c1723e4455f0262$var$r = [], $3c1723e4455f0262$var$t = [], $3c1723e4455f0262$var$u = 1, $3c1723e4455f0262$var$v = null, $3c1723e4455f0262$var$y = 3, $3c1723e4455f0262$var$z = !1, $3c1723e4455f0262$var$A = !1, $3c1723e4455f0262$var$B = !1, $3c1723e4455f0262$var$D = "function" === typeof setTimeout ? setTimeout : null, $3c1723e4455f0262$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $3c1723e4455f0262$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $3c1723e4455f0262$var$G(a) {
    for(var b = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$t); null !== b;){
        if (null === b.callback) $3c1723e4455f0262$var$k($3c1723e4455f0262$var$t);
        else if (b.startTime <= a) $3c1723e4455f0262$var$k($3c1723e4455f0262$var$t), b.sortIndex = b.expirationTime, $3c1723e4455f0262$var$f($3c1723e4455f0262$var$r, b);
        else break;
        b = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$t);
    }
}
function $3c1723e4455f0262$var$H(a) {
    $3c1723e4455f0262$var$B = !1;
    $3c1723e4455f0262$var$G(a);
    if (!$3c1723e4455f0262$var$A) {
        if (null !== $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r)) $3c1723e4455f0262$var$A = !0, $3c1723e4455f0262$var$I($3c1723e4455f0262$var$J);
        else {
            var b = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$t);
            null !== b && $3c1723e4455f0262$var$K($3c1723e4455f0262$var$H, b.startTime - a);
        }
    }
}
function $3c1723e4455f0262$var$J(a, b) {
    $3c1723e4455f0262$var$A = !1;
    $3c1723e4455f0262$var$B && ($3c1723e4455f0262$var$B = !1, $3c1723e4455f0262$var$E($3c1723e4455f0262$var$L), $3c1723e4455f0262$var$L = -1);
    $3c1723e4455f0262$var$z = !0;
    var c = $3c1723e4455f0262$var$y;
    try {
        $3c1723e4455f0262$var$G(b);
        for($3c1723e4455f0262$var$v = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r); null !== $3c1723e4455f0262$var$v && (!($3c1723e4455f0262$var$v.expirationTime > b) || a && !$3c1723e4455f0262$var$M());){
            var d = $3c1723e4455f0262$var$v.callback;
            if ("function" === typeof d) {
                $3c1723e4455f0262$var$v.callback = null;
                $3c1723e4455f0262$var$y = $3c1723e4455f0262$var$v.priorityLevel;
                var e = d($3c1723e4455f0262$var$v.expirationTime <= b);
                b = $3c1723e4455f0262$export$c4744153514ff05d();
                "function" === typeof e ? $3c1723e4455f0262$var$v.callback = e : $3c1723e4455f0262$var$v === $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r) && $3c1723e4455f0262$var$k($3c1723e4455f0262$var$r);
                $3c1723e4455f0262$var$G(b);
            } else $3c1723e4455f0262$var$k($3c1723e4455f0262$var$r);
            $3c1723e4455f0262$var$v = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r);
        }
        if (null !== $3c1723e4455f0262$var$v) var w = !0;
        else {
            var m = $3c1723e4455f0262$var$h($3c1723e4455f0262$var$t);
            null !== m && $3c1723e4455f0262$var$K($3c1723e4455f0262$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $3c1723e4455f0262$var$v = null, $3c1723e4455f0262$var$y = c, $3c1723e4455f0262$var$z = !1;
    }
}
var $3c1723e4455f0262$var$N = !1, $3c1723e4455f0262$var$O = null, $3c1723e4455f0262$var$L = -1, $3c1723e4455f0262$var$P = 5, $3c1723e4455f0262$var$Q = -1;
function $3c1723e4455f0262$var$M() {
    return $3c1723e4455f0262$export$c4744153514ff05d() - $3c1723e4455f0262$var$Q < $3c1723e4455f0262$var$P ? !1 : !0;
}
function $3c1723e4455f0262$var$R() {
    if (null !== $3c1723e4455f0262$var$O) {
        var a = $3c1723e4455f0262$export$c4744153514ff05d();
        $3c1723e4455f0262$var$Q = a;
        var b = !0;
        try {
            b = $3c1723e4455f0262$var$O(!0, a);
        } finally{
            b ? $3c1723e4455f0262$var$S() : ($3c1723e4455f0262$var$N = !1, $3c1723e4455f0262$var$O = null);
        }
    } else $3c1723e4455f0262$var$N = !1;
}
var $3c1723e4455f0262$var$S;
if ("function" === typeof $3c1723e4455f0262$var$F) $3c1723e4455f0262$var$S = function() {
    $3c1723e4455f0262$var$F($3c1723e4455f0262$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3c1723e4455f0262$var$T = new MessageChannel, $3c1723e4455f0262$var$U = $3c1723e4455f0262$var$T.port2;
    $3c1723e4455f0262$var$T.port1.onmessage = $3c1723e4455f0262$var$R;
    $3c1723e4455f0262$var$S = function() {
        $3c1723e4455f0262$var$U.postMessage(null);
    };
} else $3c1723e4455f0262$var$S = function() {
    $3c1723e4455f0262$var$D($3c1723e4455f0262$var$R, 0);
};
function $3c1723e4455f0262$var$I(a) {
    $3c1723e4455f0262$var$O = a;
    $3c1723e4455f0262$var$N || ($3c1723e4455f0262$var$N = !0, $3c1723e4455f0262$var$S());
}
function $3c1723e4455f0262$var$K(a, b) {
    $3c1723e4455f0262$var$L = $3c1723e4455f0262$var$D(function() {
        a($3c1723e4455f0262$export$c4744153514ff05d());
    }, b);
}
$3c1723e4455f0262$export$3e506c1ccc9cc1a7 = 5;
$3c1723e4455f0262$export$e26fe2ed2fa76875 = 1;
$3c1723e4455f0262$export$502329bbf4b505b1 = 4;
$3c1723e4455f0262$export$6e3807111c4874c4 = 3;
$3c1723e4455f0262$export$c27134553091fb3a = null;
$3c1723e4455f0262$export$33ee1acdc04fd2a2 = 2;
$3c1723e4455f0262$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$3c1723e4455f0262$export$8352ce38b91d0c62 = function() {
    $3c1723e4455f0262$var$A || $3c1723e4455f0262$var$z || ($3c1723e4455f0262$var$A = !0, $3c1723e4455f0262$var$I($3c1723e4455f0262$var$J));
};
$3c1723e4455f0262$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3c1723e4455f0262$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$3c1723e4455f0262$export$d3dfb8e4810cb555 = function() {
    return $3c1723e4455f0262$var$y;
};
$3c1723e4455f0262$export$839f9183b0465a69 = function() {
    return $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r);
};
$3c1723e4455f0262$export$72fdf0e06517287b = function(a) {
    switch($3c1723e4455f0262$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $3c1723e4455f0262$var$y;
    }
    var c = $3c1723e4455f0262$var$y;
    $3c1723e4455f0262$var$y = b;
    try {
        return a();
    } finally{
        $3c1723e4455f0262$var$y = c;
    }
};
$3c1723e4455f0262$export$4b844e58a3e414b4 = function() {};
$3c1723e4455f0262$export$816d2913ae6b83b1 = function() {};
$3c1723e4455f0262$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $3c1723e4455f0262$var$y;
    $3c1723e4455f0262$var$y = a;
    try {
        return b();
    } finally{
        $3c1723e4455f0262$var$y = c;
    }
};
$3c1723e4455f0262$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $3c1723e4455f0262$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $3c1723e4455f0262$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $3c1723e4455f0262$var$f($3c1723e4455f0262$var$t, a), null === $3c1723e4455f0262$var$h($3c1723e4455f0262$var$r) && a === $3c1723e4455f0262$var$h($3c1723e4455f0262$var$t) && ($3c1723e4455f0262$var$B ? ($3c1723e4455f0262$var$E($3c1723e4455f0262$var$L), $3c1723e4455f0262$var$L = -1) : $3c1723e4455f0262$var$B = !0, $3c1723e4455f0262$var$K($3c1723e4455f0262$var$H, c - d))) : (a.sortIndex = e, $3c1723e4455f0262$var$f($3c1723e4455f0262$var$r, a), $3c1723e4455f0262$var$A || $3c1723e4455f0262$var$z || ($3c1723e4455f0262$var$A = !0, $3c1723e4455f0262$var$I($3c1723e4455f0262$var$J)));
    return a;
};
$3c1723e4455f0262$export$b5836b71941fa3ed = $3c1723e4455f0262$var$M;
$3c1723e4455f0262$export$cf845f2c119da08a = function(a) {
    var b = $3c1723e4455f0262$var$y;
    return function() {
        var c = $3c1723e4455f0262$var$y;
        $3c1723e4455f0262$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $3c1723e4455f0262$var$y = c;
        }
    };
};

});



var $b8c53ef43392f031$exports = {};
"use strict";

$b8c53ef43392f031$exports = (parcelRequire("iwYKF"));


var $e08bedd2d92855da$export$882461b6382ed46c;
var $e08bedd2d92855da$export$757ceba2d55c277e;
"use strict";
var $0d985e384f32d040$exports = {};
"use strict";
function $0d985e384f32d040$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($0d985e384f32d040$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$0d985e384f32d040$var$checkDCE();

$0d985e384f32d040$exports = (parcelRequire("f2Jil"));


var $e08bedd2d92855da$var$i;
$e08bedd2d92855da$export$882461b6382ed46c = $0d985e384f32d040$exports.createRoot;
$e08bedd2d92855da$export$757ceba2d55c277e = $0d985e384f32d040$exports.hydrateRoot;



/* eslint-disable max-lines */ /* istanbul ignore file */ var $02744a89fa0d46f3$exports = {};
"use strict";
var $a0a93ab95ef303e4$exports = {};
"use strict";
const $a0a93ab95ef303e4$var$isObject = (value)=>typeof value === "object" && value !== null;
const $a0a93ab95ef303e4$var$mapObjectSkip = Symbol("skip");
// Customized for this use-case
const $a0a93ab95ef303e4$var$isObjectCustom = (value)=>$a0a93ab95ef303e4$var$isObject(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const $a0a93ab95ef303e4$var$mapObject = (object, mapper, options, isSeen = new WeakMap())=>{
    options = {
        deep: false,
        target: {},
        ...options
    };
    if (isSeen.has(object)) return isSeen.get(object);
    isSeen.set(object, options.target);
    const { target: target } = options;
    delete options.target;
    const mapArray = (array)=>array.map((element)=>$a0a93ab95ef303e4$var$isObjectCustom(element) ? $a0a93ab95ef303e4$var$mapObject(element, mapper, options, isSeen) : element);
    if (Array.isArray(object)) return mapArray(object);
    for (const [key, value] of Object.entries(object)){
        const mapResult = mapper(key, value, object);
        if (mapResult === $a0a93ab95ef303e4$var$mapObjectSkip) continue;
        let [newKey, newValue, { shouldRecurse: shouldRecurse = true } = {}] = mapResult;
        // Drop `__proto__` keys.
        if (newKey === "__proto__") continue;
        if (options.deep && shouldRecurse && $a0a93ab95ef303e4$var$isObjectCustom(newValue)) newValue = Array.isArray(newValue) ? mapArray(newValue) : $a0a93ab95ef303e4$var$mapObject(newValue, mapper, options, isSeen);
        target[newKey] = newValue;
    }
    return target;
};
$a0a93ab95ef303e4$exports = (object, mapper, options)=>{
    if (!$a0a93ab95ef303e4$var$isObject(object)) throw new TypeError(`Expected an object, got \`${object}\` (${typeof object})`);
    return $a0a93ab95ef303e4$var$mapObject(object, mapper, options);
};
$a0a93ab95ef303e4$exports.mapObjectSkip = $a0a93ab95ef303e4$var$mapObjectSkip;


var $60a70e2f81b43d9e$exports = {};
"use strict";
const $60a70e2f81b43d9e$var$UPPERCASE = /[\p{Lu}]/u;
const $60a70e2f81b43d9e$var$LOWERCASE = /[\p{Ll}]/u;
const $60a70e2f81b43d9e$var$LEADING_CAPITAL = /^[\p{Lu}](?![\p{Lu}])/gu;
const $60a70e2f81b43d9e$var$IDENTIFIER = /([\p{Alpha}\p{N}_]|$)/u;
const $60a70e2f81b43d9e$var$SEPARATORS = /[_.\- ]+/;
const $60a70e2f81b43d9e$var$LEADING_SEPARATORS = new RegExp("^" + $60a70e2f81b43d9e$var$SEPARATORS.source);
const $60a70e2f81b43d9e$var$SEPARATORS_AND_IDENTIFIER = new RegExp($60a70e2f81b43d9e$var$SEPARATORS.source + $60a70e2f81b43d9e$var$IDENTIFIER.source, "gu");
const $60a70e2f81b43d9e$var$NUMBERS_AND_IDENTIFIER = new RegExp("\\d+" + $60a70e2f81b43d9e$var$IDENTIFIER.source, "gu");
const $60a70e2f81b43d9e$var$preserveCamelCase = (string, toLowerCase, toUpperCase)=>{
    let isLastCharLower = false;
    let isLastCharUpper = false;
    let isLastLastCharUpper = false;
    for(let i = 0; i < string.length; i++){
        const character = string[i];
        if (isLastCharLower && $60a70e2f81b43d9e$var$UPPERCASE.test(character)) {
            string = string.slice(0, i) + "-" + string.slice(i);
            isLastCharLower = false;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = true;
            i++;
        } else if (isLastCharUpper && isLastLastCharUpper && $60a70e2f81b43d9e$var$LOWERCASE.test(character)) {
            string = string.slice(0, i - 1) + "-" + string.slice(i - 1);
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = false;
            isLastCharLower = true;
        } else {
            isLastCharLower = toLowerCase(character) === character && toUpperCase(character) !== character;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = toUpperCase(character) === character && toLowerCase(character) !== character;
        }
    }
    return string;
};
const $60a70e2f81b43d9e$var$preserveConsecutiveUppercase = (input, toLowerCase)=>{
    $60a70e2f81b43d9e$var$LEADING_CAPITAL.lastIndex = 0;
    return input.replace($60a70e2f81b43d9e$var$LEADING_CAPITAL, (m1)=>toLowerCase(m1));
};
const $60a70e2f81b43d9e$var$postProcess = (input, toUpperCase)=>{
    $60a70e2f81b43d9e$var$SEPARATORS_AND_IDENTIFIER.lastIndex = 0;
    $60a70e2f81b43d9e$var$NUMBERS_AND_IDENTIFIER.lastIndex = 0;
    return input.replace($60a70e2f81b43d9e$var$SEPARATORS_AND_IDENTIFIER, (_, identifier)=>toUpperCase(identifier)).replace($60a70e2f81b43d9e$var$NUMBERS_AND_IDENTIFIER, (m)=>toUpperCase(m));
};
const $60a70e2f81b43d9e$var$camelCase = (input, options)=>{
    if (!(typeof input === "string" || Array.isArray(input))) throw new TypeError("Expected the input to be `string | string[]`");
    options = {
        pascalCase: false,
        preserveConsecutiveUppercase: false,
        ...options
    };
    if (Array.isArray(input)) input = input.map((x)=>x.trim()).filter((x)=>x.length).join("-");
    else input = input.trim();
    if (input.length === 0) return "";
    const toLowerCase = options.locale === false ? (string)=>string.toLowerCase() : (string)=>string.toLocaleLowerCase(options.locale);
    const toUpperCase = options.locale === false ? (string)=>string.toUpperCase() : (string)=>string.toLocaleUpperCase(options.locale);
    if (input.length === 1) return options.pascalCase ? toUpperCase(input) : toLowerCase(input);
    const hasUpperCase = input !== toLowerCase(input);
    if (hasUpperCase) input = $60a70e2f81b43d9e$var$preserveCamelCase(input, toLowerCase, toUpperCase);
    input = input.replace($60a70e2f81b43d9e$var$LEADING_SEPARATORS, "");
    if (options.preserveConsecutiveUppercase) input = $60a70e2f81b43d9e$var$preserveConsecutiveUppercase(input, toLowerCase);
    else input = toLowerCase(input);
    if (options.pascalCase) input = toUpperCase(input.charAt(0)) + input.slice(1);
    return $60a70e2f81b43d9e$var$postProcess(input, toUpperCase);
};
$60a70e2f81b43d9e$exports = $60a70e2f81b43d9e$var$camelCase;
// TODO: Remove this for the next major release
$60a70e2f81b43d9e$exports.default = $60a70e2f81b43d9e$var$camelCase;


var $ed535625cf51def1$exports = {};
"use strict";
class $ed535625cf51def1$var$QuickLRU {
    constructor(options = {}){
        if (!(options.maxSize && options.maxSize > 0)) throw new TypeError("`maxSize` must be a number greater than 0");
        this.maxSize = options.maxSize;
        this.onEviction = options.onEviction;
        this.cache = new Map();
        this.oldCache = new Map();
        this._size = 0;
    }
    _set(key, value) {
        this.cache.set(key, value);
        this._size++;
        if (this._size >= this.maxSize) {
            this._size = 0;
            if (typeof this.onEviction === "function") for (const [key, value] of this.oldCache.entries())this.onEviction(key, value);
            this.oldCache = this.cache;
            this.cache = new Map();
        }
    }
    get(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        if (this.oldCache.has(key)) {
            const value = this.oldCache.get(key);
            this.oldCache.delete(key);
            this._set(key, value);
            return value;
        }
    }
    set(key, value) {
        if (this.cache.has(key)) this.cache.set(key, value);
        else this._set(key, value);
        return this;
    }
    has(key) {
        return this.cache.has(key) || this.oldCache.has(key);
    }
    peek(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        if (this.oldCache.has(key)) return this.oldCache.get(key);
    }
    delete(key) {
        const deleted = this.cache.delete(key);
        if (deleted) this._size--;
        return this.oldCache.delete(key) || deleted;
    }
    clear() {
        this.cache.clear();
        this.oldCache.clear();
        this._size = 0;
    }
    *keys() {
        for (const [key] of this)yield key;
    }
    *values() {
        for (const [, value] of this)yield value;
    }
    *[Symbol.iterator]() {
        for (const item of this.cache)yield item;
        for (const item of this.oldCache){
            const [key] = item;
            if (!this.cache.has(key)) yield item;
        }
    }
    get size() {
        let oldCacheSize = 0;
        for (const key of this.oldCache.keys())if (!this.cache.has(key)) oldCacheSize++;
        return Math.min(this._size + oldCacheSize, this.maxSize);
    }
}
$ed535625cf51def1$exports = $ed535625cf51def1$var$QuickLRU;


const $02744a89fa0d46f3$var$has = (array, key)=>array.some((x)=>{
        if (typeof x === "string") return x === key;
        x.lastIndex = 0;
        return x.test(key);
    });
const $02744a89fa0d46f3$var$cache = new $ed535625cf51def1$exports({
    maxSize: 100000
});
// Reproduces behavior from `map-obj`
const $02744a89fa0d46f3$var$isObject = (value)=>typeof value === "object" && value !== null && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const $02744a89fa0d46f3$var$camelCaseConvert = (input, options)=>{
    if (!$02744a89fa0d46f3$var$isObject(input)) return input;
    options = {
        deep: false,
        pascalCase: false,
        ...options
    };
    const { exclude: exclude, pascalCase: pascalCase, stopPaths: stopPaths, deep: deep } = options;
    const stopPathsSet = new Set(stopPaths);
    const makeMapper = (parentPath)=>(key, value)=>{
            if (deep && $02744a89fa0d46f3$var$isObject(value)) {
                const path = parentPath === undefined ? key : `${parentPath}.${key}`;
                if (!stopPathsSet.has(path)) value = $a0a93ab95ef303e4$exports(value, makeMapper(path));
            }
            if (!(exclude && $02744a89fa0d46f3$var$has(exclude, key))) {
                const cacheKey = pascalCase ? `${key}_` : key;
                if ($02744a89fa0d46f3$var$cache.has(cacheKey)) key = $02744a89fa0d46f3$var$cache.get(cacheKey);
                else {
                    const returnValue = $60a70e2f81b43d9e$exports(key, {
                        pascalCase: pascalCase,
                        locale: false
                    });
                    if (key.length < 100) $02744a89fa0d46f3$var$cache.set(cacheKey, returnValue);
                    key = returnValue;
                }
            }
            return [
                key,
                value
            ];
        };
    return $a0a93ab95ef303e4$exports(input, makeMapper(undefined));
};
$02744a89fa0d46f3$exports = (input, options)=>{
    if (Array.isArray(input)) return Object.keys(input).map((key)=>$02744a89fa0d46f3$var$camelCaseConvert(input[key], options));
    return $02744a89fa0d46f3$var$camelCaseConvert(input, options);
};


/**
 * @overview Constants for Logto. Synchronized with `@logto/core-kit` package at hash `081094d`.
 */ /** Scopes that reserved by Logto, which will be added to the auth request automatically. */ var $42336f286a2da162$export$1d2e82cebfd4b08;
(function(ReservedScope) {
    ReservedScope["OpenId"] = "openid";
    ReservedScope["OfflineAccess"] = "offline_access";
})($42336f286a2da162$export$1d2e82cebfd4b08 || ($42336f286a2da162$export$1d2e82cebfd4b08 = {}));
var $42336f286a2da162$export$36ba08a8e14b2df6;
(function(ReservedResource) {
    /**
   * The resource for organization template per RFC 0001.
   *
   * @see {@link https://github.com/logto-io/rfcs | RFC 0001} for more details.
   */ ReservedResource["Organization"] = "urn:logto:resource:organizations";
})($42336f286a2da162$export$36ba08a8e14b2df6 || ($42336f286a2da162$export$36ba08a8e14b2df6 = {}));
var $42336f286a2da162$export$4b02c5b431f6eb78;
(function(UserScope) {
    /**
   * Scope for basic user info.
   *
   * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
   */ UserScope["Profile"] = "profile";
    /**
   * Scope for user email address.
   *
   * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
   */ UserScope["Email"] = "email";
    /**
   * Scope for user phone number.
   *
   * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
   */ UserScope["Phone"] = "phone";
    /**
   * Scope for user's custom data.
   *
   * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
   */ UserScope["CustomData"] = "custom_data";
    /**
   * Scope for user's social identity details.
   *
   * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
   */ UserScope["Identities"] = "identities";
    /**
   * Scope for user's roles.
   *
   * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
   */ UserScope["Roles"] = "roles";
    /**
   * Scope for user's organization IDs and perform organization token grant per [RFC 0001](https://github.com/logto-io/rfcs).
   *
   * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
   */ UserScope["Organizations"] = "urn:logto:scope:organizations";
    /**
   * Scope for user's organization roles per [RFC 0001](https://github.com/logto-io/rfcs).
   *
   * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
   */ UserScope["OrganizationRoles"] = "urn:logto:scope:organization_roles";
})($42336f286a2da162$export$4b02c5b431f6eb78 || ($42336f286a2da162$export$4b02c5b431f6eb78 = {}));
const $42336f286a2da162$export$f57bb8dda2a18319 = Object.freeze({
    ["profile"]: [
        "name",
        "picture",
        "username"
    ],
    ["email"]: [
        "email",
        "email_verified"
    ],
    ["phone"]: [
        "phone_number",
        "phone_number_verified"
    ],
    ["roles"]: [
        "roles"
    ],
    ["urn:logto:scope:organizations"]: [
        "organizations"
    ],
    ["urn:logto:scope:organization_roles"]: [
        "organization_roles"
    ],
    ["custom_data"]: [],
    ["identities"]: []
});
const $42336f286a2da162$export$c11d5a3385aa71dd = Object.freeze({
    ["profile"]: [],
    ["email"]: [],
    ["phone"]: [],
    ["roles"]: [],
    ["urn:logto:scope:organizations"]: [],
    ["urn:logto:scope:organization_roles"]: [],
    ["custom_data"]: [
        "custom_data"
    ],
    ["identities"]: [
        "identities"
    ]
});
const $42336f286a2da162$export$6c46daeabb0176f9 = Object.freeze(// Hard to infer type directly, use `as` for a workaround.
// eslint-disable-next-line no-restricted-syntax
Object.fromEntries(Object.values($42336f286a2da162$export$4b02c5b431f6eb78).map((current)=>[
        current,
        [
            ...$42336f286a2da162$export$f57bb8dda2a18319[current],
            ...$42336f286a2da162$export$c11d5a3385aa71dd[current]
        ]
    ])));
const $42336f286a2da162$export$fc38cc6da79faa5c = "urn:logto:organization:";
const $42336f286a2da162$export$22667c0b6b2d7fac = (organizationId)=>`${$42336f286a2da162$export$fc38cc6da79faa5c}${organizationId}`;
const $42336f286a2da162$export$a237ae1b02e4e718 = (urn)=>{
    if (!urn.startsWith($42336f286a2da162$export$fc38cc6da79faa5c)) throw new TypeError("Invalid organization URN.");
    return urn.slice($42336f286a2da162$export$fc38cc6da79faa5c.length);
};


const $238718982990e066$export$e2e108cbe2e4f865 = {
    formUrlEncoded: {
        "Content-Type": "application/x-www-form-urlencoded"
    }
};
var $238718982990e066$export$3f2aafdd1ccae76c;
(function(TokenGrantType) {
    TokenGrantType["AuthorizationCode"] = "authorization_code";
    TokenGrantType["RefreshToken"] = "refresh_token";
})($238718982990e066$export$3f2aafdd1ccae76c || ($238718982990e066$export$3f2aafdd1ccae76c = {}));
var $238718982990e066$export$65f63a8bc3cba53d;
(function(QueryKey) {
    QueryKey["ClientId"] = "client_id";
    QueryKey["Code"] = "code";
    QueryKey["CodeChallenge"] = "code_challenge";
    QueryKey["CodeChallengeMethod"] = "code_challenge_method";
    QueryKey["CodeVerifier"] = "code_verifier";
    QueryKey["Error"] = "error";
    QueryKey["ErrorDescription"] = "error_description";
    QueryKey["GrantType"] = "grant_type";
    QueryKey["IdToken"] = "id_token";
    QueryKey["IdTokenHint"] = "id_token_hint";
    QueryKey["PostLogoutRedirectUri"] = "post_logout_redirect_uri";
    QueryKey["Prompt"] = "prompt";
    QueryKey["RedirectUri"] = "redirect_uri";
    QueryKey["RefreshToken"] = "refresh_token";
    QueryKey["Resource"] = "resource";
    QueryKey["ResponseType"] = "response_type";
    QueryKey["Scope"] = "scope";
    QueryKey["State"] = "state";
    QueryKey["Token"] = "token";
    // Need to align with the OIDC extraParams settings in core
    QueryKey["InteractionMode"] = "interaction_mode";
    /** The query key for specifying the organization ID. */ QueryKey["OrganizationId"] = "organization_id";
})($238718982990e066$export$65f63a8bc3cba53d || ($238718982990e066$export$65f63a8bc3cba53d = {}));
var $238718982990e066$export$83716a4aa1642908;
(function(Prompt) {
    /**
   * The Authorization Server MUST prompt the End-User for consent
   * before returning information to the Client.
   */ Prompt["Consent"] = "consent";
    /**
   * The Authorization Server MUST prompt the End-User for re-authentication,
   * forcing the user to log in again. Note the there'll be no Refresh Token
   * returned in this case.
   */ Prompt["Login"] = "login";
})($238718982990e066$export$83716a4aa1642908 || ($238718982990e066$export$83716a4aa1642908 = {}));


const $a915d9bd754b9637$export$684f740cd70532d4 = async ({ clientId: clientId, tokenEndpoint: tokenEndpoint, redirectUri: redirectUri, codeVerifier: codeVerifier, code: code, resource: resource }, requester)=>{
    const parameters = new URLSearchParams();
    parameters.append((0, $238718982990e066$export$65f63a8bc3cba53d).ClientId, clientId);
    parameters.append((0, $238718982990e066$export$65f63a8bc3cba53d).Code, code);
    parameters.append((0, $238718982990e066$export$65f63a8bc3cba53d).CodeVerifier, codeVerifier);
    parameters.append((0, $238718982990e066$export$65f63a8bc3cba53d).RedirectUri, redirectUri);
    parameters.append((0, $238718982990e066$export$65f63a8bc3cba53d).GrantType, (0, $238718982990e066$export$3f2aafdd1ccae76c).AuthorizationCode);
    if (resource) parameters.append((0, $238718982990e066$export$65f63a8bc3cba53d).Resource, resource);
    const snakeCaseCodeTokenResponse = await requester(tokenEndpoint, {
        method: "POST",
        headers: (0, $238718982990e066$export$e2e108cbe2e4f865).formUrlEncoded,
        body: parameters
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($02744a89fa0d46f3$exports)))(snakeCaseCodeTokenResponse);
};
const $a915d9bd754b9637$export$9909137b467efb8b = async (params, requester)=>{
    const { clientId: clientId, tokenEndpoint: tokenEndpoint, refreshToken: refreshToken, resource: resource, organizationId: organizationId, scopes: scopes } = params;
    const parameters = new URLSearchParams();
    parameters.append((0, $238718982990e066$export$65f63a8bc3cba53d).ClientId, clientId);
    parameters.append((0, $238718982990e066$export$65f63a8bc3cba53d).RefreshToken, refreshToken);
    parameters.append((0, $238718982990e066$export$65f63a8bc3cba53d).GrantType, (0, $238718982990e066$export$3f2aafdd1ccae76c).RefreshToken);
    if (resource) parameters.append((0, $238718982990e066$export$65f63a8bc3cba53d).Resource, resource);
    if (organizationId) parameters.append((0, $238718982990e066$export$65f63a8bc3cba53d).OrganizationId, organizationId);
    if (scopes?.length) parameters.append((0, $238718982990e066$export$65f63a8bc3cba53d).Scope, scopes.join(" "));
    const snakeCaseRefreshTokenTokenResponse = await requester(tokenEndpoint, {
        method: "POST",
        headers: (0, $238718982990e066$export$e2e108cbe2e4f865).formUrlEncoded,
        body: parameters
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($02744a89fa0d46f3$exports)))(snakeCaseRefreshTokenTokenResponse);
};



const $ca3b2e038507e68c$export$815bda5ead26b243 = "/oidc/.well-known/openid-configuration";
const $ca3b2e038507e68c$export$98242d8e822ad11f = async (endpoint, requester)=>(0, (/*@__PURE__*/$parcel$interopDefault($02744a89fa0d46f3$exports)))(await requester(endpoint));



const $1e317dee172ec983$export$573f8dbbf6fbef75 = async (revocationEndpoint, clientId, token, requester)=>requester(revocationEndpoint, {
        method: "POST",
        headers: (0, $238718982990e066$export$e2e108cbe2e4f865).formUrlEncoded,
        body: new URLSearchParams({
            [(0, $238718982990e066$export$65f63a8bc3cba53d).ClientId]: clientId,
            [(0, $238718982990e066$export$65f63a8bc3cba53d).Token]: token
        })
    });



const $f90f919a5030a3f9$export$670d48958e84d448 = (value)=>{
    if (value) return Array.isArray(value) ? value : [
        value
    ];
    return [];
};
// Disable FP rules here to use the performant approach while keep the function itself "FP"
/* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ const $f90f919a5030a3f9$export$76d90c956114f2c2 = (times, initial, iterate)=>{
    let result = initial;
    while(times--)result = iterate(result);
    return result;
};
/* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ const $f90f919a5030a3f9$export$6b75200e58bc97d0 = (array)=>[
        ...new Set(array)
    ];


// https://github.com/facebook/jest/issues/7547
const $7e1433e6b31310f4$export$a7a9523472993e97 = (value, error)=>{
    if (!value) // https://github.com/typescript-eslint/typescript-eslint/issues/3814
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw error;
};


// eslint-disable-next-line id-length
const $9e33c937422a19bc$var$compareFunction = (a, b)=>{
    if (typeof a === "string" && typeof b === "string") return a.localeCompare(b);
    if (typeof a === "number" && typeof b === "number") return a - b;
    if (typeof a === "boolean" && typeof b === "boolean") return Number(a) - Number(b);
    throw new Error("Unsupported compare type");
};
const $9e33c937422a19bc$export$12dc7a11e2f7584e = (array1, array2)=>{
    if (array1.length !== array2.length) return false;
    const sortedA = array1.slice().sort($9e33c937422a19bc$var$compareFunction);
    const sortedB = array2.slice().sort($9e33c937422a19bc$var$compareFunction);
    return sortedA.every((value, index)=>value === sortedB[index]);
};
// eslint-disable-next-line unicorn/prefer-native-coercion-functions
const $9e33c937422a19bc$export$ccb441c9c5feb3fc = (value)=>Boolean(value);
const $9e33c937422a19bc$export$b29ea735dcfba3c1 = (value)=>value !== null && value !== undefined;
const $9e33c937422a19bc$export$a4f4bb6b1453fff5 = (data, property)=>Object.prototype.hasOwnProperty.call(data, property);
const $9e33c937422a19bc$export$fb789885f1f64dd7 = (string)=>Boolean(/[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/.test(string));



const $6feb4dcbcbb1bc92$export$133fc36489ac9add = (exp)=>(0, $9e33c937422a19bc$export$ccb441c9c5feb3fc)(exp) ? exp : null;
/**
 * Conditional return the expression result when it's not {@link Falsy};
 * otherwise return `undefined`.
 *
 * @example
 * ```ts
 * conditional(1 && '2') // '2'
 * conditional(false && '1') // undefined
 * ```
 */ const $6feb4dcbcbb1bc92$export$c327da55a124987a = (exp)=>(0, $9e33c937422a19bc$export$ccb441c9c5feb3fc)(exp) ? exp : undefined;
/** Alias for {@link conditional}. */ const $6feb4dcbcbb1bc92$export$7ffafceb12143143 = $6feb4dcbcbb1bc92$export$c327da55a124987a;
/**
 * Conditional return the stringified expression result (using `String`) when it's not {@link Falsy};
 * otherwise return an empty string.
 *
 * @example
 * ```ts
 * conditionalString(1 && 2) // '2'
 * conditionalString(false && '1') // ''
 * ```
 */ const $6feb4dcbcbb1bc92$export$78aa88a01782ee9d = (exp)=>(0, $9e33c937422a19bc$export$ccb441c9c5feb3fc)(exp) ? String(exp) : "";
/** Alias for {@link conditionalString}. */ const $6feb4dcbcbb1bc92$export$723fe479c809eebc = $6feb4dcbcbb1bc92$export$78aa88a01782ee9d;
/**
 * Conditional concat multiple expression results into a array by filtering all {@link Falsy} results
 * and flatten 1 level deep if the expression result is an array.
 *
 * @example
 * ```ts
 * conditionalArray(1, [2, 3]) // [1, 2, 3]
 * ```
 */ const $6feb4dcbcbb1bc92$export$c96eff0e57d59a5e = (...exps)=>exps.filter((value)=>(0, $9e33c937422a19bc$export$ccb441c9c5feb3fc)(value)).flat();
/** Alias for {@link conditionalArray}. */ const $6feb4dcbcbb1bc92$export$68c43792fed28aa6 = $6feb4dcbcbb1bc92$export$c96eff0e57d59a5e;
/**
 * Return a new object with all {@link Falsy} values removed.
 * This function only performs a shallow removal, i.e. it does not remove
 * {@link Falsy} values nested in objects.
 *
 * @example
 * ```ts
 * conditionalObject({
 *   foo: 'foo',
 *   bar: undefined,
 *   baz: false,
 * }) // { foo: 'foo' }
 * ```
 */ const $6feb4dcbcbb1bc92$export$6d93be478c042166 = (object)=>// eslint-disable-next-line no-restricted-syntax
    Object.fromEntries(Object.entries(object).filter(([, value])=>(0, $9e33c937422a19bc$export$ccb441c9c5feb3fc)(value)));
/** Alias for {@link conditionalObject}. */ const $6feb4dcbcbb1bc92$export$48ab0026c89e64fa = $6feb4dcbcbb1bc92$export$6d93be478c042166;



var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


// Browsers don't have `process`
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const $633f040a7339798f$export$4bd44a2aa29d3d6e = (key, fallback = "")=>$cfae44f0dfdf62c0$exports?.env[key] ?? fallback;
const $633f040a7339798f$export$912b126b3b8a9cf1 = (envKey, fallback = [])=>{
    const rawValue = $633f040a7339798f$export$4bd44a2aa29d3d6e(envKey);
    if (!rawValue) return fallback;
    return rawValue.split(",").map((value)=>value.trim()).filter(Boolean);
};
const $633f040a7339798f$export$9f11f28d727ba39d = (key)=>{
    // Browsers don't have `process`
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const value = $cfae44f0dfdf62c0$exports?.env[key];
    (0, $7e1433e6b31310f4$export$a7a9523472993e97)(value, new Error(`env variable ${key} not found`));
    return value;
};
const $633f040a7339798f$export$8ee0fc9ee280b4ee = ()=>typeof window === "undefined";


// Intended
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $bded8ec22c6c6d73$export$8793edee2d425525 = ()=>{};
const $bded8ec22c6c6d73$export$4369c812aac99591 = (value)=>value !== null && (typeof value === "object" || typeof value === "function") && "then" in value && typeof value.then === "function";
const $bded8ec22c6c6d73$export$2cb2cb98cc670b59 = (exec, onError)=>{
    const handleError = (error)=>{
        if (onError instanceof Error) throw onError;
        return onError(error);
    };
    try {
        const unwrapped = typeof exec === "function" ? exec() : exec;
        return $bded8ec22c6c6d73$export$4369c812aac99591(unwrapped) ? unwrapped.catch(handleError) : unwrapped;
    } catch (error) {
        return handleError(error);
    }
};
const $bded8ec22c6c6d73$export$a3a27526e073307 = (exec, onError)=>{
    try {
        const unwrapped = typeof exec === "function" ? exec() : exec;
        return $bded8ec22c6c6d73$export$4369c812aac99591(unwrapped) ? unwrapped.catch((error)=>{
            onError?.(error);
        }) : unwrapped;
    } catch (error) {
        onError?.(error);
    }
};


const $e0b67f0486495920$export$357523c63a2253b9 = (object, ...keys)=>{
    // eslint-disable-next-line no-restricted-syntax
    return Object.fromEntries(keys.map((key)=>[
            key,
            object[key]
        ]));
};
const $e0b67f0486495920$export$42fd73f889ee4d63 = (...keys)=>(state)=>$e0b67f0486495920$export$357523c63a2253b9(state, ...keys);


function $c7073c91d133eb65$export$1294308be85b4eca(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    return string.toLowerCase().replace(/(?:^|\s|-)\S/g, (value)=>value.toUpperCase()).replace(/-/g, " ");
}
/**
 * RFC 4648 section 5: base64url (URL- and filename-safe standard)
 * @link https://datatracker.ietf.org/doc/html/rfc4648#section-5
 */ const $c7073c91d133eb65$var$replaceNonUrlSafeCharacters = (base64String)=>base64String.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
const $c7073c91d133eb65$var$restoreNonUrlSafeCharacters = (base64String)=>base64String.replace(/-/g, "+").replace(/_/g, "/");
const $c7073c91d133eb65$export$cf6f352aaefa956f = {
    isSafe: (input)=>/^[\w-]*$/.test(input),
    encode: (rawString)=>{
        const encodedString = btoa(unescape(encodeURIComponent(rawString)));
        return $c7073c91d133eb65$var$replaceNonUrlSafeCharacters(encodedString);
    },
    decode: (encodedString)=>{
        const nonUrlSafeEncodedString = $c7073c91d133eb65$var$restoreNonUrlSafeCharacters(encodedString);
        return decodeURIComponent(escape(atob(nonUrlSafeEncodedString)));
    },
    replaceNonUrlSafeCharacters: $c7073c91d133eb65$var$replaceNonUrlSafeCharacters,
    restoreNonUrlSafeCharacters: $c7073c91d133eb65$var$restoreNonUrlSafeCharacters
};
const $c7073c91d133eb65$export$7a668e70ea2210d9 = (value)=>// eslint-disable-next-line no-implicit-coercion
    !!value && [
        "1",
        "true",
        "y",
        "yes",
        "yep",
        "yeah"
    ].includes(value.toLowerCase());



const $71282565a843cf50$export$3988ae62b71be9a3 = (object, keySerial)=>{
    if (object === null || typeof object !== "object") throw new TypeError("Non-object received in `get()`.");
    let result = object;
    for (const key of keySerial.split("."))// @ts-expect-error for performance
    result = result[key];
    return result;
};
const $71282565a843cf50$export$fedb900c0ea4e699 = (...args)=>(0, $bded8ec22c6c6d73$export$a3a27526e073307)(()=>$71282565a843cf50$export$3988ae62b71be9a3(...args));
/** Same to `get()` but with the strict type definition only to enable IntelliSense. */ const $71282565a843cf50$export$bf7199a9ebcb84a9 = (object, keySerial)=>$71282565a843cf50$export$3988ae62b71be9a3(object, keySerial);


/** Join multiple path segments. This function exists since there's no native implementation in browser. */ const $7ef00c920f1265a3$export$b891921babc70093 = (...segments)=>{
    const result = [];
    for (const segment of segments.join("/").split("/")){
        if (!segment || segment === ".") continue;
        if ([
            ...segment
        ].every((char)=>char === ".")) {
            // eslint-disable-next-line @silverhand/fp/no-mutating-methods
            result.pop();
            continue;
        }
        // eslint-disable-next-line @silverhand/fp/no-mutating-methods
        result.push(segment);
    }
    return "/" + result.join("/");
};
/** Append path segments to the base URL. */ const $7ef00c920f1265a3$export$c3cef1c0537c0eb2 = (baseUrl, ...pathnames)=>new URL($7ef00c920f1265a3$export$b891921babc70093(baseUrl.pathname, ...pathnames), baseUrl);


// eslint-disable-next-line @typescript-eslint/ban-types
const $54034266f9d8fd4f$export$a6cdc56e425d0d0a = (object)=>object !== null && typeof object === "object";
const $54034266f9d8fd4f$export$dd89c3a817f05bc7 = (object, key)=>$54034266f9d8fd4f$export$a6cdc56e425d0d0a(object) && key in object;
/**
 * Remove all keys with `undefined` values from an object. This function only
 * performs a shallow removal, i.e. it does not remove `undefined` values nested
 * in objects.
 *
 * @param object The object to remove `undefined` keys from.
 * @returns A new object with all `undefined` keys removed.
 */ const $54034266f9d8fd4f$export$8e7457d724841712 = (object)=>// eslint-disable-next-line no-restricted-syntax
    Object.fromEntries(Object.entries(object).filter(([, value])=>value !== undefined));


/* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ function $3a44ef4a586d55f3$export$d2de3aaeafa91619(function_) {
    let called = false;
    let result;
    return function(...args) {
        if (!called) {
            called = true;
            result = function_.apply(this, args);
        }
        return result;
    };
}





const $ac06e4ccadf0c108$export$aa016a295c6092c8 = (data)=>typeof data === "object" && data !== null;


const $fd640d02b03b6808$var$logtoErrorCodes = Object.freeze({
    "id_token.invalid_iat": "Invalid issued at time in the ID token",
    "id_token.invalid_token": "Invalid ID token",
    "callback_uri_verification.redirect_uri_mismatched": "The callback URI mismatches the redirect URI.",
    "callback_uri_verification.error_found": "Error found in the callback URI",
    "callback_uri_verification.missing_state": "Missing state in the callback URI",
    "callback_uri_verification.state_mismatched": "State mismatched in the callback URI",
    "callback_uri_verification.missing_code": "Missing code in the callback URI",
    crypto_subtle_unavailable: "Crypto.subtle is unavailable in insecure contexts (non-HTTPS).",
    unexpected_response_error: "Unexpected response error from the server."
});
class $fd640d02b03b6808$export$ba60d77e6748b659 extends Error {
    constructor(code, data){
        super($fd640d02b03b6808$var$logtoErrorCodes[code]);
        this.code = code;
        this.data = data;
    }
}
const $fd640d02b03b6808$export$27f79c8238476d38 = (data)=>{
    if (!(0, $ac06e4ccadf0c108$export$aa016a295c6092c8)(data)) return false;
    return typeof data.code === "string" && typeof data.message === "string";
};
class $fd640d02b03b6808$export$e6e15b8ba42b9b70 extends Error {
    constructor(code, message){
        super(message);
        this.code = code;
    }
}
class $fd640d02b03b6808$export$d4832bcf9ce430e0 {
    constructor(error, errorDescription){
        this.error = error;
        this.errorDescription = errorDescription;
    }
}


const $64c8c47b3f912d4b$export$4851e69315d5b72c = (uri)=>{
    const [, queryString = ""] = uri.split("?");
    return new URLSearchParams(queryString);
};
const $64c8c47b3f912d4b$export$dc3fae3c99763885 = (callbackUri, redirectUri, state)=>{
    if (!callbackUri.startsWith(redirectUri)) throw new (0, $fd640d02b03b6808$export$ba60d77e6748b659)("callback_uri_verification.redirect_uri_mismatched");
    const uriParameters = $64c8c47b3f912d4b$export$4851e69315d5b72c(callbackUri);
    const error = (0, $6feb4dcbcbb1bc92$export$c327da55a124987a)(uriParameters.get((0, $238718982990e066$export$65f63a8bc3cba53d).Error));
    const errorDescription = (0, $6feb4dcbcbb1bc92$export$c327da55a124987a)(uriParameters.get((0, $238718982990e066$export$65f63a8bc3cba53d).ErrorDescription));
    if (error) throw new (0, $fd640d02b03b6808$export$ba60d77e6748b659)("callback_uri_verification.error_found", new (0, $fd640d02b03b6808$export$d4832bcf9ce430e0)(error, errorDescription));
    const stateFromCallbackUri = uriParameters.get((0, $238718982990e066$export$65f63a8bc3cba53d).State);
    if (!stateFromCallbackUri) throw new (0, $fd640d02b03b6808$export$ba60d77e6748b659)("callback_uri_verification.missing_state");
    if (stateFromCallbackUri !== state) throw new (0, $fd640d02b03b6808$export$ba60d77e6748b659)("callback_uri_verification.state_mismatched");
    const code = uriParameters.get((0, $238718982990e066$export$65f63a8bc3cba53d).Code);
    if (!code) throw new (0, $fd640d02b03b6808$export$ba60d77e6748b659)("callback_uri_verification.missing_code");
    return code;
};




var $427b2561bbdc2544$export$2e2bcd8739ae039 = crypto;
const $427b2561bbdc2544$export$600b5603bbac4c6 = (key)=>key instanceof CryptoKey;


const $7b6935233e273a4e$var$digest = async (algorithm, data)=>{
    const subtleDigest = `SHA-${algorithm.slice(-3)}`;
    return new Uint8Array(await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.digest(subtleDigest, data));
};
var $7b6935233e273a4e$export$2e2bcd8739ae039 = $7b6935233e273a4e$var$digest;


const $3250a6ce6c4b6b55$export$5486af06137bf21a = new TextEncoder();
const $3250a6ce6c4b6b55$export$124c96e6ce37090b = new TextDecoder();
const $3250a6ce6c4b6b55$var$MAX_INT32 = 2 ** 32;
function $3250a6ce6c4b6b55$export$ee1b3e54f0441b22(...buffers) {
    const size = buffers.reduce((acc, { length: length })=>acc + length, 0);
    const buf = new Uint8Array(size);
    let i = 0;
    buffers.forEach((buffer)=>{
        buf.set(buffer, i);
        i += buffer.length;
    });
    return buf;
}
function $3250a6ce6c4b6b55$export$256d3ca12372f112(alg, p2sInput) {
    return $3250a6ce6c4b6b55$export$ee1b3e54f0441b22($3250a6ce6c4b6b55$export$5486af06137bf21a.encode(alg), new Uint8Array([
        0
    ]), p2sInput);
}
function $3250a6ce6c4b6b55$var$writeUInt32BE(buf, value, offset) {
    if (value < 0 || value >= $3250a6ce6c4b6b55$var$MAX_INT32) throw new RangeError(`value must be >= 0 and <= ${$3250a6ce6c4b6b55$var$MAX_INT32 - 1}. Received ${value}`);
    buf.set([
        value >>> 24,
        value >>> 16,
        value >>> 8,
        value & 0xff
    ], offset);
}
function $3250a6ce6c4b6b55$export$e7b531e00a18fdd7(value) {
    const high = Math.floor(value / $3250a6ce6c4b6b55$var$MAX_INT32);
    const low = value % $3250a6ce6c4b6b55$var$MAX_INT32;
    const buf = new Uint8Array(8);
    $3250a6ce6c4b6b55$var$writeUInt32BE(buf, high, 0);
    $3250a6ce6c4b6b55$var$writeUInt32BE(buf, low, 4);
    return buf;
}
function $3250a6ce6c4b6b55$export$74c16dba6c885532(value) {
    const buf = new Uint8Array(4);
    $3250a6ce6c4b6b55$var$writeUInt32BE(buf, value);
    return buf;
}
function $3250a6ce6c4b6b55$export$c1498c4a3718d967(input) {
    return $3250a6ce6c4b6b55$export$ee1b3e54f0441b22($3250a6ce6c4b6b55$export$74c16dba6c885532(input.length), input);
}
async function $3250a6ce6c4b6b55$export$67163693c21af44f(secret, bits, value) {
    const iterations = Math.ceil((bits >> 3) / 32);
    const res = new Uint8Array(iterations * 32);
    for(let iter = 0; iter < iterations; iter++){
        const buf = new Uint8Array(4 + secret.length + value.length);
        buf.set($3250a6ce6c4b6b55$export$74c16dba6c885532(iter + 1));
        buf.set(secret, 4);
        buf.set(value, 4 + secret.length);
        res.set(await (0, $7b6935233e273a4e$export$2e2bcd8739ae039)("sha256", buf), iter * 32);
    }
    return res.slice(0, bits >> 3);
}


const $f9909655809b2554$export$8fb536984ec8b4d7 = (input)=>{
    let unencoded = input;
    if (typeof unencoded === "string") unencoded = (0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode(unencoded);
    const CHUNK_SIZE = 0x8000;
    const arr = [];
    for(let i = 0; i < unencoded.length; i += CHUNK_SIZE)arr.push(String.fromCharCode.apply(null, unencoded.subarray(i, i + CHUNK_SIZE)));
    return btoa(arr.join(""));
};
const $f9909655809b2554$export$c564cdbbe6da493 = (input)=>{
    return $f9909655809b2554$export$8fb536984ec8b4d7(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
const $f9909655809b2554$export$94fdf11bafc8de6b = (encoded)=>{
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
};
const $f9909655809b2554$export$2f872c0f2117be69 = (input)=>{
    let encoded = input;
    if (encoded instanceof Uint8Array) encoded = (0, $3250a6ce6c4b6b55$export$124c96e6ce37090b).decode(encoded);
    encoded = encoded.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
    try {
        return $f9909655809b2554$export$94fdf11bafc8de6b(encoded);
    } catch  {
        throw new TypeError("The input to be decoded is not correctly encoded.");
    }
};



class $1f4c9ae257e4ef19$export$f754d6850d76bf87 extends Error {
    static get code() {
        return "ERR_JOSE_GENERIC";
    }
    constructor(message){
        super(message);
        this.code = "ERR_JOSE_GENERIC";
        this.name = this.constructor.name;
        Error.captureStackTrace?.(this, this.constructor);
    }
}
class $1f4c9ae257e4ef19$export$f1e14efb908196e9 extends $1f4c9ae257e4ef19$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_CLAIM_VALIDATION_FAILED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_CLAIM_VALIDATION_FAILED";
        this.claim = claim;
        this.reason = reason;
    }
}
class $1f4c9ae257e4ef19$export$4b386bf852b7863d extends $1f4c9ae257e4ef19$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_EXPIRED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_EXPIRED";
        this.claim = claim;
        this.reason = reason;
    }
}
class $1f4c9ae257e4ef19$export$d51fd7fedeccc338 extends $1f4c9ae257e4ef19$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_ALG_NOT_ALLOWED";
    }
    static get code() {
        return "ERR_JOSE_ALG_NOT_ALLOWED";
    }
}
class $1f4c9ae257e4ef19$export$19ddbcbf2016ab28 extends $1f4c9ae257e4ef19$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_NOT_SUPPORTED";
    }
    static get code() {
        return "ERR_JOSE_NOT_SUPPORTED";
    }
}
class $1f4c9ae257e4ef19$export$1a57512ad9773b2a extends $1f4c9ae257e4ef19$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_DECRYPTION_FAILED";
        this.message = "decryption operation failed";
    }
    static get code() {
        return "ERR_JWE_DECRYPTION_FAILED";
    }
}
class $1f4c9ae257e4ef19$export$19f281f2275f6a15 extends $1f4c9ae257e4ef19$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_INVALID";
    }
    static get code() {
        return "ERR_JWE_INVALID";
    }
}
class $1f4c9ae257e4ef19$export$e838de724af3d116 extends $1f4c9ae257e4ef19$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_INVALID";
    }
    static get code() {
        return "ERR_JWS_INVALID";
    }
}
class $1f4c9ae257e4ef19$export$936b39ada0bbfceb extends $1f4c9ae257e4ef19$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWT_INVALID";
    }
    static get code() {
        return "ERR_JWT_INVALID";
    }
}
class $1f4c9ae257e4ef19$export$b3992e0f88fb07e3 extends $1f4c9ae257e4ef19$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWK_INVALID";
    }
    static get code() {
        return "ERR_JWK_INVALID";
    }
}
class $1f4c9ae257e4ef19$export$9b22c2a1e2403b8e extends $1f4c9ae257e4ef19$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_INVALID";
    }
    static get code() {
        return "ERR_JWKS_INVALID";
    }
}
class $1f4c9ae257e4ef19$export$3d5ed1a538bed04e extends $1f4c9ae257e4ef19$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_NO_MATCHING_KEY";
        this.message = "no applicable key found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_NO_MATCHING_KEY";
    }
}
class $1f4c9ae257e4ef19$export$dc036de401a5c284 extends $1f4c9ae257e4ef19$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
        this.message = "multiple matching keys found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
    }
}
Symbol.asyncIterator;
class $1f4c9ae257e4ef19$export$3f30acebf25c04e6 extends $1f4c9ae257e4ef19$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_TIMEOUT";
        this.message = "request timed out";
    }
    static get code() {
        return "ERR_JWKS_TIMEOUT";
    }
}
class $1f4c9ae257e4ef19$export$c67a0218e7c50378 extends $1f4c9ae257e4ef19$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
        this.message = "signature verification failed";
    }
    static get code() {
        return "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
    }
}




var $520f3d77678442a8$export$2e2bcd8739ae039 = (0, $427b2561bbdc2544$export$2e2bcd8739ae039).getRandomValues.bind((0, $427b2561bbdc2544$export$2e2bcd8739ae039));


function $2ed13555acb7734d$export$db433e85ac514a95(alg) {
    switch(alg){
        case "A128GCM":
        case "A128GCMKW":
        case "A192GCM":
        case "A192GCMKW":
        case "A256GCM":
        case "A256GCMKW":
            return 96;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            return 128;
        default:
            throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $2ed13555acb7734d$export$2e2bcd8739ae039 = (alg)=>(0, $520f3d77678442a8$export$2e2bcd8739ae039)(new Uint8Array($2ed13555acb7734d$export$db433e85ac514a95(alg) >> 3));


const $54975f4e821337ae$var$checkIvLength = (enc, iv)=>{
    if (iv.length << 3 !== (0, $2ed13555acb7734d$export$db433e85ac514a95)(enc)) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("Invalid Initialization Vector length");
};
var $54975f4e821337ae$export$2e2bcd8739ae039 = $54975f4e821337ae$var$checkIvLength;



const $e7cfcba43e33823e$var$checkCekLength = (cek, expected)=>{
    const actual = cek.byteLength << 3;
    if (actual !== expected) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)(`Invalid Content Encryption Key length. Expected ${expected} bits, got ${actual} bits`);
};
var $e7cfcba43e33823e$export$2e2bcd8739ae039 = $e7cfcba43e33823e$var$checkCekLength;


const $df90c86caa2de4ad$var$timingSafeEqual = (a, b)=>{
    if (!(a instanceof Uint8Array)) throw new TypeError("First argument must be a buffer");
    if (!(b instanceof Uint8Array)) throw new TypeError("Second argument must be a buffer");
    if (a.length !== b.length) throw new TypeError("Input buffers must have the same length");
    const len = a.length;
    let out = 0;
    let i = -1;
    while(++i < len)out |= a[i] ^ b[i];
    return out === 0;
};
var $df90c86caa2de4ad$export$2e2bcd8739ae039 = $df90c86caa2de4ad$var$timingSafeEqual;




function $1691d89c838a5b9e$var$unusable(name, prop = "algorithm.name") {
    return new TypeError(`CryptoKey does not support this operation, its ${prop} must be ${name}`);
}
function $1691d89c838a5b9e$var$isAlgorithm(algorithm, name) {
    return algorithm.name === name;
}
function $1691d89c838a5b9e$var$getHashLength(hash) {
    return parseInt(hash.name.slice(4), 10);
}
function $1691d89c838a5b9e$var$getNamedCurve(alg) {
    switch(alg){
        case "ES256":
            return "P-256";
        case "ES384":
            return "P-384";
        case "ES512":
            return "P-521";
        default:
            throw new Error("unreachable");
    }
}
function $1691d89c838a5b9e$var$checkUsage(key, usages) {
    if (usages.length && !usages.some((expected)=>key.usages.includes(expected))) {
        let msg = "CryptoKey does not support this operation, its usages must include ";
        if (usages.length > 2) {
            const last = usages.pop();
            msg += `one of ${usages.join(", ")}, or ${last}.`;
        } else if (usages.length === 2) msg += `one of ${usages[0]} or ${usages[1]}.`;
        else msg += `${usages[0]}.`;
        throw new TypeError(msg);
    }
}
function $1691d89c838a5b9e$export$39a36029eee6729(key, alg, ...usages) {
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            {
                if (!$1691d89c838a5b9e$var$isAlgorithm(key.algorithm, "HMAC")) throw $1691d89c838a5b9e$var$unusable("HMAC");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $1691d89c838a5b9e$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $1691d89c838a5b9e$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "RS256":
        case "RS384":
        case "RS512":
            {
                if (!$1691d89c838a5b9e$var$isAlgorithm(key.algorithm, "RSASSA-PKCS1-v1_5")) throw $1691d89c838a5b9e$var$unusable("RSASSA-PKCS1-v1_5");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $1691d89c838a5b9e$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $1691d89c838a5b9e$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "PS256":
        case "PS384":
        case "PS512":
            {
                if (!$1691d89c838a5b9e$var$isAlgorithm(key.algorithm, "RSA-PSS")) throw $1691d89c838a5b9e$var$unusable("RSA-PSS");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $1691d89c838a5b9e$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $1691d89c838a5b9e$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "EdDSA":
            if (key.algorithm.name !== "Ed25519" && key.algorithm.name !== "Ed448") throw $1691d89c838a5b9e$var$unusable("Ed25519 or Ed448");
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            {
                if (!$1691d89c838a5b9e$var$isAlgorithm(key.algorithm, "ECDSA")) throw $1691d89c838a5b9e$var$unusable("ECDSA");
                const expected = $1691d89c838a5b9e$var$getNamedCurve(alg);
                const actual = key.algorithm.namedCurve;
                if (actual !== expected) throw $1691d89c838a5b9e$var$unusable(expected, "algorithm.namedCurve");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $1691d89c838a5b9e$var$checkUsage(key, usages);
}
function $1691d89c838a5b9e$export$41a67f89f6678b35(key, alg, ...usages) {
    switch(alg){
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            {
                if (!$1691d89c838a5b9e$var$isAlgorithm(key.algorithm, "AES-GCM")) throw $1691d89c838a5b9e$var$unusable("AES-GCM");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $1691d89c838a5b9e$var$unusable(expected, "algorithm.length");
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            {
                if (!$1691d89c838a5b9e$var$isAlgorithm(key.algorithm, "AES-KW")) throw $1691d89c838a5b9e$var$unusable("AES-KW");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $1691d89c838a5b9e$var$unusable(expected, "algorithm.length");
                break;
            }
        case "ECDH":
            switch(key.algorithm.name){
                case "ECDH":
                case "X25519":
                case "X448":
                    break;
                default:
                    throw $1691d89c838a5b9e$var$unusable("ECDH, X25519, or X448");
            }
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            if (!$1691d89c838a5b9e$var$isAlgorithm(key.algorithm, "PBKDF2")) throw $1691d89c838a5b9e$var$unusable("PBKDF2");
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            {
                if (!$1691d89c838a5b9e$var$isAlgorithm(key.algorithm, "RSA-OAEP")) throw $1691d89c838a5b9e$var$unusable("RSA-OAEP");
                const expected = parseInt(alg.slice(9), 10) || 1;
                const actual = $1691d89c838a5b9e$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $1691d89c838a5b9e$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $1691d89c838a5b9e$var$checkUsage(key, usages);
}


function $ba15dec115725d2a$var$message(msg, actual, ...types) {
    if (types.length > 2) {
        const last = types.pop();
        msg += `one of type ${types.join(", ")}, or ${last}.`;
    } else if (types.length === 2) msg += `one of type ${types[0]} or ${types[1]}.`;
    else msg += `of type ${types[0]}.`;
    if (actual == null) msg += ` Received ${actual}`;
    else if (typeof actual === "function" && actual.name) msg += ` Received function ${actual.name}`;
    else if (typeof actual === "object" && actual != null) {
        if (actual.constructor && actual.constructor.name) msg += ` Received an instance of ${actual.constructor.name}`;
    }
    return msg;
}
var $ba15dec115725d2a$export$2e2bcd8739ae039 = (actual, ...types)=>{
    return $ba15dec115725d2a$var$message("Key must be ", actual, ...types);
};
function $ba15dec115725d2a$export$e94f758d09bc1828(alg, actual, ...types) {
    return $ba15dec115725d2a$var$message(`Key for the ${alg} algorithm must be `, actual, ...types);
}



var $318059e36031b903$export$2e2bcd8739ae039 = (key)=>{
    return (0, $427b2561bbdc2544$export$600b5603bbac4c6)(key);
};
const $318059e36031b903$export$b14ad400b1d09e0f = [
    "CryptoKey"
];


async function $4d71421a543e55c6$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $ba15dec115725d2a$export$2e2bcd8739ae039)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "decrypt"
    ]);
    const macKey = await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const macData = (0, $3250a6ce6c4b6b55$export$ee1b3e54f0441b22)(aad, iv, ciphertext, (0, $3250a6ce6c4b6b55$export$e7b531e00a18fdd7)(aad.length << 3));
    const expectedTag = new Uint8Array((await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    let macCheckPassed;
    try {
        macCheckPassed = (0, $df90c86caa2de4ad$export$2e2bcd8739ae039)(tag, expectedTag);
    } catch  {}
    if (!macCheckPassed) throw new (0, $1f4c9ae257e4ef19$export$1a57512ad9773b2a)();
    let plaintext;
    try {
        plaintext = new Uint8Array(await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.decrypt({
            iv: iv,
            name: "AES-CBC"
        }, encKey, ciphertext));
    } catch  {}
    if (!plaintext) throw new (0, $1f4c9ae257e4ef19$export$1a57512ad9773b2a)();
    return plaintext;
}
async function $4d71421a543e55c6$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.importKey("raw", cek, "AES-GCM", false, [
        "decrypt"
    ]);
    else {
        (0, $1691d89c838a5b9e$export$41a67f89f6678b35)(cek, enc, "decrypt");
        encKey = cek;
    }
    try {
        return new Uint8Array(await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.decrypt({
            additionalData: aad,
            iv: iv,
            name: "AES-GCM",
            tagLength: 128
        }, encKey, (0, $3250a6ce6c4b6b55$export$ee1b3e54f0441b22)(ciphertext, tag)));
    } catch  {
        throw new (0, $1f4c9ae257e4ef19$export$1a57512ad9773b2a)();
    }
}
const $4d71421a543e55c6$var$decrypt = async (enc, cek, ciphertext, iv, tag, aad)=>{
    if (!(0, $427b2561bbdc2544$export$600b5603bbac4c6)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $ba15dec115725d2a$export$2e2bcd8739ae039)(cek, ...(0, $318059e36031b903$export$b14ad400b1d09e0f), "Uint8Array"));
    (0, $54975f4e821337ae$export$2e2bcd8739ae039)(enc, iv);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, $e7cfcba43e33823e$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(-3), 10));
            return $4d71421a543e55c6$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, $e7cfcba43e33823e$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(1, 4), 10));
            return $4d71421a543e55c6$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad);
        default:
            throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)("Unsupported JWE Content Encryption Algorithm");
    }
};
var $4d71421a543e55c6$export$2e2bcd8739ae039 = $4d71421a543e55c6$var$decrypt;



const $51d4dc598fbcc307$var$isDisjoint = (...headers)=>{
    const sources = headers.filter(Boolean);
    if (sources.length === 0 || sources.length === 1) return true;
    let acc;
    for (const header of sources){
        const parameters = Object.keys(header);
        if (!acc || acc.size === 0) {
            acc = new Set(parameters);
            continue;
        }
        for (const parameter of parameters){
            if (acc.has(parameter)) return false;
            acc.add(parameter);
        }
    }
    return true;
};
var $51d4dc598fbcc307$export$2e2bcd8739ae039 = $51d4dc598fbcc307$var$isDisjoint;


function $52fc695f0f066c93$var$isObjectLike(value) {
    return typeof value === "object" && value !== null;
}
function $52fc695f0f066c93$export$2e2bcd8739ae039(input) {
    if (!$52fc695f0f066c93$var$isObjectLike(input) || Object.prototype.toString.call(input) !== "[object Object]") return false;
    if (Object.getPrototypeOf(input) === null) return true;
    let proto = input;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(input) === proto;
}


const $19480bc193f2944e$var$bogusWebCrypto = [
    {
        hash: "SHA-256",
        name: "HMAC"
    },
    true,
    [
        "sign"
    ]
];
var $19480bc193f2944e$export$2e2bcd8739ae039 = $19480bc193f2944e$var$bogusWebCrypto;






function $60307547ae22ee04$var$checkKeySize(key, alg) {
    if (key.algorithm.length !== parseInt(alg.slice(1, 4), 10)) throw new TypeError(`Invalid key size for alg: ${alg}`);
}
function $60307547ae22ee04$var$getCryptoKey(key, alg, usage) {
    if ((0, $427b2561bbdc2544$export$600b5603bbac4c6)(key)) {
        (0, $1691d89c838a5b9e$export$41a67f89f6678b35)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) return (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.importKey("raw", key, "AES-KW", true, [
        usage
    ]);
    throw new TypeError((0, $ba15dec115725d2a$export$2e2bcd8739ae039)(key, ...(0, $318059e36031b903$export$b14ad400b1d09e0f), "Uint8Array"));
}
const $60307547ae22ee04$export$4997ffc0176396a6 = async (alg, key, cek)=>{
    const cryptoKey = await $60307547ae22ee04$var$getCryptoKey(key, alg, "wrapKey");
    $60307547ae22ee04$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.importKey("raw", cek, ...(0, $19480bc193f2944e$export$2e2bcd8739ae039));
    return new Uint8Array(await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.wrapKey("raw", cryptoKeyCek, cryptoKey, "AES-KW"));
};
const $60307547ae22ee04$export$debb760848ca95a = async (alg, key, encryptedKey)=>{
    const cryptoKey = await $60307547ae22ee04$var$getCryptoKey(key, alg, "unwrapKey");
    $60307547ae22ee04$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.unwrapKey("raw", encryptedKey, cryptoKey, "AES-KW", ...(0, $19480bc193f2944e$export$2e2bcd8739ae039));
    return new Uint8Array(await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.exportKey("raw", cryptoKeyCek));
};







async function $3406b9a12be17f13$export$87770b6b245073b5(publicKey, privateKey, algorithm, keyLength, apu = new Uint8Array(0), apv = new Uint8Array(0)) {
    if (!(0, $427b2561bbdc2544$export$600b5603bbac4c6)(publicKey)) throw new TypeError((0, $ba15dec115725d2a$export$2e2bcd8739ae039)(publicKey, ...(0, $318059e36031b903$export$b14ad400b1d09e0f)));
    (0, $1691d89c838a5b9e$export$41a67f89f6678b35)(publicKey, "ECDH");
    if (!(0, $427b2561bbdc2544$export$600b5603bbac4c6)(privateKey)) throw new TypeError((0, $ba15dec115725d2a$export$2e2bcd8739ae039)(privateKey, ...(0, $318059e36031b903$export$b14ad400b1d09e0f)));
    (0, $1691d89c838a5b9e$export$41a67f89f6678b35)(privateKey, "ECDH", "deriveBits");
    const value = (0, $3250a6ce6c4b6b55$export$ee1b3e54f0441b22)((0, $3250a6ce6c4b6b55$export$c1498c4a3718d967)((0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode(algorithm)), (0, $3250a6ce6c4b6b55$export$c1498c4a3718d967)(apu), (0, $3250a6ce6c4b6b55$export$c1498c4a3718d967)(apv), (0, $3250a6ce6c4b6b55$export$74c16dba6c885532)(keyLength));
    let length;
    if (publicKey.algorithm.name === "X25519") length = 256;
    else if (publicKey.algorithm.name === "X448") length = 448;
    else length = Math.ceil(parseInt(publicKey.algorithm.namedCurve.substr(-3), 10) / 8) << 3;
    const sharedSecret = new Uint8Array(await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.deriveBits({
        name: publicKey.algorithm.name,
        public: publicKey
    }, privateKey, length));
    return (0, $3250a6ce6c4b6b55$export$67163693c21af44f)(sharedSecret, keyLength, value);
}
async function $3406b9a12be17f13$export$1338dee8c889e310(key) {
    if (!(0, $427b2561bbdc2544$export$600b5603bbac4c6)(key)) throw new TypeError((0, $ba15dec115725d2a$export$2e2bcd8739ae039)(key, ...(0, $318059e36031b903$export$b14ad400b1d09e0f)));
    return (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.generateKey(key.algorithm, true, [
        "deriveBits"
    ]);
}
function $3406b9a12be17f13$export$f28ab77d793719b2(key) {
    if (!(0, $427b2561bbdc2544$export$600b5603bbac4c6)(key)) throw new TypeError((0, $ba15dec115725d2a$export$2e2bcd8739ae039)(key, ...(0, $318059e36031b903$export$b14ad400b1d09e0f)));
    return [
        "P-256",
        "P-384",
        "P-521"
    ].includes(key.algorithm.namedCurve) || key.algorithm.name === "X25519" || key.algorithm.name === "X448";
}







function $921a155038aa2073$export$2e2bcd8739ae039(p2s) {
    if (!(p2s instanceof Uint8Array) || p2s.length < 8) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("PBES2 Salt Input must be 8 or more octets");
}






function $9de515988a0bd61d$var$getCryptoKey(key, alg) {
    if (key instanceof Uint8Array) return (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.importKey("raw", key, "PBKDF2", false, [
        "deriveBits"
    ]);
    if ((0, $427b2561bbdc2544$export$600b5603bbac4c6)(key)) {
        (0, $1691d89c838a5b9e$export$41a67f89f6678b35)(key, alg, "deriveBits", "deriveKey");
        return key;
    }
    throw new TypeError((0, $ba15dec115725d2a$export$2e2bcd8739ae039)(key, ...(0, $318059e36031b903$export$b14ad400b1d09e0f), "Uint8Array"));
}
async function $9de515988a0bd61d$var$deriveKey(p2s, alg, p2c, key) {
    (0, $921a155038aa2073$export$2e2bcd8739ae039)(p2s);
    const salt = (0, $3250a6ce6c4b6b55$export$256d3ca12372f112)(alg, p2s);
    const keylen = parseInt(alg.slice(13, 16), 10);
    const subtleAlg = {
        hash: `SHA-${alg.slice(8, 11)}`,
        iterations: p2c,
        name: "PBKDF2",
        salt: salt
    };
    const wrapAlg = {
        length: keylen,
        name: "AES-KW"
    };
    const cryptoKey = await $9de515988a0bd61d$var$getCryptoKey(key, alg);
    if (cryptoKey.usages.includes("deriveBits")) return new Uint8Array(await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.deriveBits(subtleAlg, cryptoKey, keylen));
    if (cryptoKey.usages.includes("deriveKey")) return (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.deriveKey(subtleAlg, cryptoKey, wrapAlg, false, [
        "wrapKey",
        "unwrapKey"
    ]);
    throw new TypeError('PBKDF2 key "usages" must include "deriveBits" or "deriveKey"');
}
const $9de515988a0bd61d$export$5b0f6292f11d1d18 = async (alg, key, cek, p2c = 2048, p2s = (0, $520f3d77678442a8$export$2e2bcd8739ae039)(new Uint8Array(16)))=>{
    const derived = await $9de515988a0bd61d$var$deriveKey(p2s, alg, p2c, key);
    const encryptedKey = await (0, $60307547ae22ee04$export$4997ffc0176396a6)(alg.slice(-6), derived, cek);
    return {
        encryptedKey: encryptedKey,
        p2c: p2c,
        p2s: (0, $f9909655809b2554$export$c564cdbbe6da493)(p2s)
    };
};
const $9de515988a0bd61d$export$e85a0c9a1067c5d3 = async (alg, key, encryptedKey, p2c, p2s)=>{
    const derived = await $9de515988a0bd61d$var$deriveKey(p2s, alg, p2c, key);
    return (0, $60307547ae22ee04$export$debb760848ca95a)(alg.slice(-6), derived, encryptedKey);
};



function $e799a07fdb1137c5$export$2e2bcd8739ae039(alg) {
    switch(alg){
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            return "RSA-OAEP";
        default:
            throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}





var $aa3bbf98edc278b4$export$2e2bcd8739ae039 = (alg, key)=>{
    if (alg.startsWith("RS") || alg.startsWith("PS")) {
        const { modulusLength: modulusLength } = key.algorithm;
        if (typeof modulusLength !== "number" || modulusLength < 2048) throw new TypeError(`${alg} requires key modulusLength to be 2048 bits or larger`);
    }
};




const $45a7dffc4a832420$export$5b0f6292f11d1d18 = async (alg, key, cek)=>{
    if (!(0, $427b2561bbdc2544$export$600b5603bbac4c6)(key)) throw new TypeError((0, $ba15dec115725d2a$export$2e2bcd8739ae039)(key, ...(0, $318059e36031b903$export$b14ad400b1d09e0f)));
    (0, $1691d89c838a5b9e$export$41a67f89f6678b35)(key, alg, "encrypt", "wrapKey");
    (0, $aa3bbf98edc278b4$export$2e2bcd8739ae039)(alg, key);
    if (key.usages.includes("encrypt")) return new Uint8Array(await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.encrypt((0, $e799a07fdb1137c5$export$2e2bcd8739ae039)(alg), key, cek));
    if (key.usages.includes("wrapKey")) {
        const cryptoKeyCek = await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.importKey("raw", cek, ...(0, $19480bc193f2944e$export$2e2bcd8739ae039));
        return new Uint8Array(await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.wrapKey("raw", cryptoKeyCek, key, (0, $e799a07fdb1137c5$export$2e2bcd8739ae039)(alg)));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "encrypt" or "wrapKey" for this operation');
};
const $45a7dffc4a832420$export$e85a0c9a1067c5d3 = async (alg, key, encryptedKey)=>{
    if (!(0, $427b2561bbdc2544$export$600b5603bbac4c6)(key)) throw new TypeError((0, $ba15dec115725d2a$export$2e2bcd8739ae039)(key, ...(0, $318059e36031b903$export$b14ad400b1d09e0f)));
    (0, $1691d89c838a5b9e$export$41a67f89f6678b35)(key, alg, "decrypt", "unwrapKey");
    (0, $aa3bbf98edc278b4$export$2e2bcd8739ae039)(alg, key);
    if (key.usages.includes("decrypt")) return new Uint8Array(await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.decrypt((0, $e799a07fdb1137c5$export$2e2bcd8739ae039)(alg), key, encryptedKey));
    if (key.usages.includes("unwrapKey")) {
        const cryptoKeyCek = await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.unwrapKey("raw", encryptedKey, key, (0, $e799a07fdb1137c5$export$2e2bcd8739ae039)(alg), ...(0, $19480bc193f2944e$export$2e2bcd8739ae039));
        return new Uint8Array(await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.exportKey("raw", cryptoKeyCek));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "decrypt" or "unwrapKey" for this operation');
};






function $dc4ce5ff09990e7e$export$db433e85ac514a95(alg) {
    switch(alg){
        case "A128GCM":
            return 128;
        case "A192GCM":
            return 192;
        case "A256GCM":
        case "A128CBC-HS256":
            return 256;
        case "A192CBC-HS384":
            return 384;
        case "A256CBC-HS512":
            return 512;
        default:
            throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $dc4ce5ff09990e7e$export$2e2bcd8739ae039 = (alg)=>(0, $520f3d77678442a8$export$2e2bcd8739ae039)(new Uint8Array($dc4ce5ff09990e7e$export$db433e85ac514a95(alg) >> 3));






var $c2833afa2948da5c$export$2e2bcd8739ae039 = (b64, descriptor)=>{
    const newlined = (b64.match(/.{1,64}/g) || []).join("\n");
    return `-----BEGIN ${descriptor}-----\n${newlined}\n-----END ${descriptor}-----`;
};




const $55bfcdaa9fd2ca39$var$genericExport = async (keyType, keyFormat, key)=>{
    if (!(0, $427b2561bbdc2544$export$600b5603bbac4c6)(key)) throw new TypeError((0, $ba15dec115725d2a$export$2e2bcd8739ae039)(key, ...(0, $318059e36031b903$export$b14ad400b1d09e0f)));
    if (!key.extractable) throw new TypeError("CryptoKey is not extractable");
    if (key.type !== keyType) throw new TypeError(`key is not a ${keyType} key`);
    return (0, $c2833afa2948da5c$export$2e2bcd8739ae039)((0, $f9909655809b2554$export$8fb536984ec8b4d7)(new Uint8Array(await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.exportKey(keyFormat, key))), `${keyType.toUpperCase()} KEY`);
};
const $55bfcdaa9fd2ca39$export$cfba7e924fe414ca = (key)=>{
    return $55bfcdaa9fd2ca39$var$genericExport("public", "spki", key);
};
const $55bfcdaa9fd2ca39$export$cac76a78a90b914d = (key)=>{
    return $55bfcdaa9fd2ca39$var$genericExport("private", "pkcs8", key);
};
const $55bfcdaa9fd2ca39$var$findOid = (keyData, oid, from = 0)=>{
    if (from === 0) {
        oid.unshift(oid.length);
        oid.unshift(0x06);
    }
    let i = keyData.indexOf(oid[0], from);
    if (i === -1) return false;
    const sub = keyData.subarray(i, i + oid.length);
    if (sub.length !== oid.length) return false;
    return sub.every((value, index)=>value === oid[index]) || $55bfcdaa9fd2ca39$var$findOid(keyData, oid, i + 1);
};
const $55bfcdaa9fd2ca39$var$getNamedCurve = (keyData)=>{
    switch(true){
        case $55bfcdaa9fd2ca39$var$findOid(keyData, [
            0x2a,
            0x86,
            0x48,
            0xce,
            0x3d,
            0x03,
            0x01,
            0x07
        ]):
            return "P-256";
        case $55bfcdaa9fd2ca39$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x22
        ]):
            return "P-384";
        case $55bfcdaa9fd2ca39$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x23
        ]):
            return "P-521";
        case $55bfcdaa9fd2ca39$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6e
        ]):
            return "X25519";
        case $55bfcdaa9fd2ca39$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6f
        ]):
            return "X448";
        case $55bfcdaa9fd2ca39$var$findOid(keyData, [
            0x2b,
            0x65,
            0x70
        ]):
            return "Ed25519";
        case $55bfcdaa9fd2ca39$var$findOid(keyData, [
            0x2b,
            0x65,
            0x71
        ]):
            return "Ed448";
        default:
            throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)("Invalid or unsupported EC Key Curve or OKP Key Sub Type");
    }
};
const $55bfcdaa9fd2ca39$var$genericImport = async (replace, keyFormat, pem, alg, options)=>{
    let algorithm;
    let keyUsages;
    const keyData = new Uint8Array(atob(pem.replace(replace, "")).split("").map((c)=>c.charCodeAt(0)));
    const isPublic = keyFormat === "spki";
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`
            };
            keyUsages = isPublic ? [
                "encrypt",
                "wrapKey"
            ] : [
                "decrypt",
                "unwrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                const namedCurve = $55bfcdaa9fd2ca39$var$getNamedCurve(keyData);
                algorithm = namedCurve.startsWith("P-") ? {
                    name: "ECDH",
                    namedCurve: namedCurve
                } : {
                    name: namedCurve
                };
                keyUsages = isPublic ? [] : [
                    "deriveBits"
                ];
                break;
            }
        case "EdDSA":
            algorithm = {
                name: $55bfcdaa9fd2ca39$var$getNamedCurve(keyData)
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        default:
            throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (Algorithm) value');
    }
    return (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.importKey(keyFormat, keyData, algorithm, options?.extractable ?? false, keyUsages);
};
const $55bfcdaa9fd2ca39$export$224b0a6339c7267f = (pem, alg, options)=>{
    return $55bfcdaa9fd2ca39$var$genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, "pkcs8", pem, alg, options);
};
const $55bfcdaa9fd2ca39$export$f9a3505cdaa1fb3e = (pem, alg, options)=>{
    return $55bfcdaa9fd2ca39$var$genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, "spki", pem, alg, options);
};
function $55bfcdaa9fd2ca39$var$getElement(seq) {
    let result = [];
    let next = 0;
    while(next < seq.length){
        let nextPart = $55bfcdaa9fd2ca39$var$parseElement(seq.subarray(next));
        result.push(nextPart);
        next += nextPart.byteLength;
    }
    return result;
}
function $55bfcdaa9fd2ca39$var$parseElement(bytes) {
    let position = 0;
    let tag = bytes[0] & 0x1f;
    position++;
    if (tag === 0x1f) {
        tag = 0;
        while(bytes[position] >= 0x80){
            tag = tag * 128 + bytes[position] - 0x80;
            position++;
        }
        tag = tag * 128 + bytes[position] - 0x80;
        position++;
    }
    let length = 0;
    if (bytes[position] < 0x80) {
        length = bytes[position];
        position++;
    } else if (length === 0x80) {
        length = 0;
        while(bytes[position + length] !== 0 || bytes[position + length + 1] !== 0){
            if (length > bytes.byteLength) throw new TypeError("invalid indefinite form length");
            length++;
        }
        const byteLength = position + length + 2;
        return {
            byteLength: byteLength,
            contents: bytes.subarray(position, position + length),
            raw: bytes.subarray(0, byteLength)
        };
    } else {
        let numberOfDigits = bytes[position] & 0x7f;
        position++;
        length = 0;
        for(let i = 0; i < numberOfDigits; i++){
            length = length * 256 + bytes[position];
            position++;
        }
    }
    const byteLength = position + length;
    return {
        byteLength: byteLength,
        contents: bytes.subarray(position, byteLength),
        raw: bytes.subarray(0, byteLength)
    };
}
function $55bfcdaa9fd2ca39$var$spkiFromX509(buf) {
    const tbsCertificate = $55bfcdaa9fd2ca39$var$getElement($55bfcdaa9fd2ca39$var$getElement($55bfcdaa9fd2ca39$var$parseElement(buf).contents)[0].contents);
    return (0, $f9909655809b2554$export$8fb536984ec8b4d7)(tbsCertificate[tbsCertificate[0].raw[0] === 0xa0 ? 6 : 5].raw);
}
function $55bfcdaa9fd2ca39$var$getSPKI(x509) {
    const pem = x509.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, "");
    const raw = (0, $f9909655809b2554$export$94fdf11bafc8de6b)(pem);
    return (0, $c2833afa2948da5c$export$2e2bcd8739ae039)($55bfcdaa9fd2ca39$var$spkiFromX509(raw), "PUBLIC KEY");
}
const $55bfcdaa9fd2ca39$export$ed788b6a8533858f = (pem, alg, options)=>{
    let spki;
    try {
        spki = $55bfcdaa9fd2ca39$var$getSPKI(pem);
    } catch (cause) {
        throw new TypeError("Failed to parse the X.509 certificate", {
            cause: cause
        });
    }
    return $55bfcdaa9fd2ca39$export$f9a3505cdaa1fb3e(spki, alg, options);
};




function $e7d1639e9831331f$var$subtleMapping(jwk) {
    let algorithm;
    let keyUsages;
    switch(jwk.kty){
        case "RSA":
            switch(jwk.alg){
                case "PS256":
                case "PS384":
                case "PS512":
                    algorithm = {
                        name: "RSA-PSS",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RS256":
                case "RS384":
                case "RS512":
                    algorithm = {
                        name: "RSASSA-PKCS1-v1_5",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RSA-OAEP":
                case "RSA-OAEP-256":
                case "RSA-OAEP-384":
                case "RSA-OAEP-512":
                    algorithm = {
                        name: "RSA-OAEP",
                        hash: `SHA-${parseInt(jwk.alg.slice(-3), 10) || 1}`
                    };
                    keyUsages = jwk.d ? [
                        "decrypt",
                        "unwrapKey"
                    ] : [
                        "encrypt",
                        "wrapKey"
                    ];
                    break;
                default:
                    throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "EC":
            switch(jwk.alg){
                case "ES256":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-256"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES384":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-384"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES512":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-521"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: "ECDH",
                        namedCurve: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "OKP":
            switch(jwk.alg){
                case "EdDSA":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        default:
            throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
    }
    return {
        algorithm: algorithm,
        keyUsages: keyUsages
    };
}
const $e7d1639e9831331f$var$parse = async (jwk)=>{
    if (!jwk.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const { algorithm: algorithm, keyUsages: keyUsages } = $e7d1639e9831331f$var$subtleMapping(jwk);
    const rest = [
        algorithm,
        jwk.ext ?? false,
        jwk.key_ops ?? keyUsages
    ];
    const keyData = {
        ...jwk
    };
    delete keyData.alg;
    delete keyData.use;
    return (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.importKey("jwk", keyData, ...rest);
};
var $e7d1639e9831331f$export$2e2bcd8739ae039 = $e7d1639e9831331f$var$parse;




async function $16f8df83cb053d45$export$7cdfc961c11d0266(spki, alg, options) {
    if (typeof spki !== "string" || spki.indexOf("-----BEGIN PUBLIC KEY-----") !== 0) throw new TypeError('"spki" must be SPKI formatted string');
    return (0, $55bfcdaa9fd2ca39$export$f9a3505cdaa1fb3e)(spki, alg, options);
}
async function $16f8df83cb053d45$export$948757ecbbf4a918(x509, alg, options) {
    if (typeof x509 !== "string" || x509.indexOf("-----BEGIN CERTIFICATE-----") !== 0) throw new TypeError('"x509" must be X.509 formatted string');
    return (0, $55bfcdaa9fd2ca39$export$ed788b6a8533858f)(x509, alg, options);
}
async function $16f8df83cb053d45$export$17f5e7f6d2848df5(pkcs8, alg, options) {
    if (typeof pkcs8 !== "string" || pkcs8.indexOf("-----BEGIN PRIVATE KEY-----") !== 0) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return (0, $55bfcdaa9fd2ca39$export$224b0a6339c7267f)(pkcs8, alg, options);
}
async function $16f8df83cb053d45$export$2b70d37b4d0b888b(jwk, alg) {
    if (!(0, $52fc695f0f066c93$export$2e2bcd8739ae039)(jwk)) throw new TypeError("JWK must be an object");
    alg || (alg = jwk.alg);
    switch(jwk.kty){
        case "oct":
            if (typeof jwk.k !== "string" || !jwk.k) throw new TypeError('missing "k" (Key Value) Parameter value');
            return (0, $f9909655809b2554$export$2f872c0f2117be69)(jwk.k);
        case "RSA":
            if (jwk.oth !== undefined) throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
        case "EC":
        case "OKP":
            return (0, $e7d1639e9831331f$export$2e2bcd8739ae039)({
                ...jwk,
                alg: alg
            });
        default:
            throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)('Unsupported "kty" (Key Type) Parameter value');
    }
}




const $6055433aeedfa300$var$symmetricTypeCheck = (alg, key)=>{
    if (key instanceof Uint8Array) return;
    if (!(0, $318059e36031b903$export$2e2bcd8739ae039)(key)) throw new TypeError((0, $ba15dec115725d2a$export$e94f758d09bc1828)(alg, key, ...(0, $318059e36031b903$export$b14ad400b1d09e0f), "Uint8Array"));
    if (key.type !== "secret") throw new TypeError(`${(0, $318059e36031b903$export$b14ad400b1d09e0f).join(" or ")} instances for symmetric algorithms must be of type "secret"`);
};
const $6055433aeedfa300$var$asymmetricTypeCheck = (alg, key, usage)=>{
    if (!(0, $318059e36031b903$export$2e2bcd8739ae039)(key)) throw new TypeError((0, $ba15dec115725d2a$export$e94f758d09bc1828)(alg, key, ...(0, $318059e36031b903$export$b14ad400b1d09e0f)));
    if (key.type === "secret") throw new TypeError(`${(0, $318059e36031b903$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithms must not be of type "secret"`);
    if (usage === "sign" && key.type === "public") throw new TypeError(`${(0, $318059e36031b903$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm signing must be of type "private"`);
    if (usage === "decrypt" && key.type === "public") throw new TypeError(`${(0, $318059e36031b903$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm decryption must be of type "private"`);
    if (key.algorithm && usage === "verify" && key.type === "private") throw new TypeError(`${(0, $318059e36031b903$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm verifying must be of type "public"`);
    if (key.algorithm && usage === "encrypt" && key.type === "private") throw new TypeError(`${(0, $318059e36031b903$export$b14ad400b1d09e0f).join(" or ")} instances for asymmetric algorithm encryption must be of type "public"`);
};
const $6055433aeedfa300$var$checkKeyType = (alg, key, usage)=>{
    const symmetric = alg.startsWith("HS") || alg === "dir" || alg.startsWith("PBES2") || /^A\d{3}(?:GCM)?KW$/.test(alg);
    if (symmetric) $6055433aeedfa300$var$symmetricTypeCheck(alg, key);
    else $6055433aeedfa300$var$asymmetricTypeCheck(alg, key, usage);
};
var $6055433aeedfa300$export$2e2bcd8739ae039 = $6055433aeedfa300$var$checkKeyType;











async function $108806d8262e60df$var$cbcEncrypt(enc, plaintext, cek, iv, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $ba15dec115725d2a$export$2e2bcd8739ae039)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "encrypt"
    ]);
    const macKey = await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const ciphertext = new Uint8Array(await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.encrypt({
        iv: iv,
        name: "AES-CBC"
    }, encKey, plaintext));
    const macData = (0, $3250a6ce6c4b6b55$export$ee1b3e54f0441b22)(aad, iv, ciphertext, (0, $3250a6ce6c4b6b55$export$e7b531e00a18fdd7)(aad.length << 3));
    const tag = new Uint8Array((await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    return {
        ciphertext: ciphertext,
        tag: tag
    };
}
async function $108806d8262e60df$var$gcmEncrypt(enc, plaintext, cek, iv, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.importKey("raw", cek, "AES-GCM", false, [
        "encrypt"
    ]);
    else {
        (0, $1691d89c838a5b9e$export$41a67f89f6678b35)(cek, enc, "encrypt");
        encKey = cek;
    }
    const encrypted = new Uint8Array(await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.encrypt({
        additionalData: aad,
        iv: iv,
        name: "AES-GCM",
        tagLength: 128
    }, encKey, plaintext));
    const tag = encrypted.slice(-16);
    const ciphertext = encrypted.slice(0, -16);
    return {
        ciphertext: ciphertext,
        tag: tag
    };
}
const $108806d8262e60df$var$encrypt = async (enc, plaintext, cek, iv, aad)=>{
    if (!(0, $427b2561bbdc2544$export$600b5603bbac4c6)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $ba15dec115725d2a$export$2e2bcd8739ae039)(cek, ...(0, $318059e36031b903$export$b14ad400b1d09e0f), "Uint8Array"));
    (0, $54975f4e821337ae$export$2e2bcd8739ae039)(enc, iv);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, $e7cfcba43e33823e$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(-3), 10));
            return $108806d8262e60df$var$cbcEncrypt(enc, plaintext, cek, iv, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, $e7cfcba43e33823e$export$2e2bcd8739ae039)(cek, parseInt(enc.slice(1, 4), 10));
            return $108806d8262e60df$var$gcmEncrypt(enc, plaintext, cek, iv, aad);
        default:
            throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)("Unsupported JWE Content Encryption Algorithm");
    }
};
var $108806d8262e60df$export$2e2bcd8739ae039 = $108806d8262e60df$var$encrypt;





async function $d3475f7fb9529d3f$export$4997ffc0176396a6(alg, key, cek, iv) {
    const jweAlgorithm = alg.slice(0, 7);
    iv || (iv = (0, $2ed13555acb7734d$export$2e2bcd8739ae039)(jweAlgorithm));
    const { ciphertext: encryptedKey, tag: tag } = await (0, $108806d8262e60df$export$2e2bcd8739ae039)(jweAlgorithm, cek, key, iv, new Uint8Array(0));
    return {
        encryptedKey: encryptedKey,
        iv: (0, $f9909655809b2554$export$c564cdbbe6da493)(iv),
        tag: (0, $f9909655809b2554$export$c564cdbbe6da493)(tag)
    };
}
async function $d3475f7fb9529d3f$export$debb760848ca95a(alg, key, encryptedKey, iv, tag) {
    const jweAlgorithm = alg.slice(0, 7);
    return (0, $4d71421a543e55c6$export$2e2bcd8739ae039)(jweAlgorithm, key, encryptedKey, iv, tag, new Uint8Array(0));
}


async function $d0cd6038b498bd4b$var$decryptKeyManagement(alg, key, encryptedKey, joseHeader, options) {
    (0, $6055433aeedfa300$export$2e2bcd8739ae039)(alg, key, "decrypt");
    switch(alg){
        case "dir":
            if (encryptedKey !== undefined) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("Encountered unexpected JWE Encrypted Key");
            return key;
        case "ECDH-ES":
            if (encryptedKey !== undefined) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("Encountered unexpected JWE Encrypted Key");
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!(0, $52fc695f0f066c93$export$2e2bcd8739ae039)(joseHeader.epk)) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)(`JOSE Header "epk" (Ephemeral Public Key) missing or invalid`);
                if (!$3406b9a12be17f13$export$f28ab77d793719b2(key)) throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const epk = await (0, $16f8df83cb053d45$export$2b70d37b4d0b888b)(joseHeader.epk, alg);
                let partyUInfo;
                let partyVInfo;
                if (joseHeader.apu !== undefined) {
                    if (typeof joseHeader.apu !== "string") throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)(`JOSE Header "apu" (Agreement PartyUInfo) invalid`);
                    try {
                        partyUInfo = (0, $f9909655809b2554$export$2f872c0f2117be69)(joseHeader.apu);
                    } catch  {
                        throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("Failed to base64url decode the apu");
                    }
                }
                if (joseHeader.apv !== undefined) {
                    if (typeof joseHeader.apv !== "string") throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)(`JOSE Header "apv" (Agreement PartyVInfo) invalid`);
                    try {
                        partyVInfo = (0, $f9909655809b2554$export$2f872c0f2117be69)(joseHeader.apv);
                    } catch  {
                        throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("Failed to base64url decode the apv");
                    }
                }
                const sharedSecret = await $3406b9a12be17f13$export$87770b6b245073b5(epk, key, alg === "ECDH-ES" ? joseHeader.enc : alg, alg === "ECDH-ES" ? (0, $dc4ce5ff09990e7e$export$db433e85ac514a95)(joseHeader.enc) : parseInt(alg.slice(-5, -2), 10), partyUInfo, partyVInfo);
                if (alg === "ECDH-ES") return sharedSecret;
                if (encryptedKey === undefined) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Encrypted Key missing");
                return (0, $60307547ae22ee04$export$debb760848ca95a)(alg.slice(-6), sharedSecret, encryptedKey);
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            if (encryptedKey === undefined) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Encrypted Key missing");
            return (0, $45a7dffc4a832420$export$e85a0c9a1067c5d3)(alg, key, encryptedKey);
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                if (encryptedKey === undefined) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Encrypted Key missing");
                if (typeof joseHeader.p2c !== "number") throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)(`JOSE Header "p2c" (PBES2 Count) missing or invalid`);
                const p2cLimit = options?.maxPBES2Count || 10000;
                if (joseHeader.p2c > p2cLimit) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)(`JOSE Header "p2c" (PBES2 Count) out is of acceptable bounds`);
                if (typeof joseHeader.p2s !== "string") throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)(`JOSE Header "p2s" (PBES2 Salt) missing or invalid`);
                let p2s;
                try {
                    p2s = (0, $f9909655809b2554$export$2f872c0f2117be69)(joseHeader.p2s);
                } catch  {
                    throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("Failed to base64url decode the p2s");
                }
                return (0, $9de515988a0bd61d$export$e85a0c9a1067c5d3)(alg, key, encryptedKey, joseHeader.p2c, p2s);
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            if (encryptedKey === undefined) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Encrypted Key missing");
            return (0, $60307547ae22ee04$export$debb760848ca95a)(alg, key, encryptedKey);
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                if (encryptedKey === undefined) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Encrypted Key missing");
                if (typeof joseHeader.iv !== "string") throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)(`JOSE Header "iv" (Initialization Vector) missing or invalid`);
                if (typeof joseHeader.tag !== "string") throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)(`JOSE Header "tag" (Authentication Tag) missing or invalid`);
                let iv;
                try {
                    iv = (0, $f9909655809b2554$export$2f872c0f2117be69)(joseHeader.iv);
                } catch  {
                    throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("Failed to base64url decode the iv");
                }
                let tag;
                try {
                    tag = (0, $f9909655809b2554$export$2f872c0f2117be69)(joseHeader.tag);
                } catch  {
                    throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("Failed to base64url decode the tag");
                }
                return (0, $d3475f7fb9529d3f$export$debb760848ca95a)(alg, key, encryptedKey, iv, tag);
            }
        default:
            throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
}
var $d0cd6038b498bd4b$export$2e2bcd8739ae039 = $d0cd6038b498bd4b$var$decryptKeyManagement;





function $64df821a76e2365c$var$validateCrit(Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader) {
    if (joseHeader.crit !== undefined && protectedHeader.crit === undefined) throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!protectedHeader || protectedHeader.crit === undefined) return new Set();
    if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some((input)=>typeof input !== "string" || input.length === 0)) throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let recognized;
    if (recognizedOption !== undefined) recognized = new Map([
        ...Object.entries(recognizedOption),
        ...recognizedDefault.entries()
    ]);
    else recognized = recognizedDefault;
    for (const parameter of protectedHeader.crit){
        if (!recognized.has(parameter)) throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)(`Extension Header Parameter "${parameter}" is not recognized`);
        if (joseHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" is missing`);
        else if (recognized.get(parameter) && protectedHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" MUST be integrity protected`);
    }
    return new Set(protectedHeader.crit);
}
var $64df821a76e2365c$export$2e2bcd8739ae039 = $64df821a76e2365c$var$validateCrit;


const $680b41bfec6e0cc1$var$validateAlgorithms = (option, algorithms)=>{
    if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some((s)=>typeof s !== "string"))) throw new TypeError(`"${option}" option must be an array of strings`);
    if (!algorithms) return undefined;
    return new Set(algorithms);
};
var $680b41bfec6e0cc1$export$2e2bcd8739ae039 = $680b41bfec6e0cc1$var$validateAlgorithms;


async function $4f476a334a4ed97e$export$b75cd12892ae94d2(jwe, key, options) {
    if (!(0, $52fc695f0f066c93$export$2e2bcd8739ae039)(jwe)) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("Flattened JWE must be an object");
    if (jwe.protected === undefined && jwe.header === undefined && jwe.unprotected === undefined) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JOSE Header missing");
    if (typeof jwe.iv !== "string") throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Initialization Vector missing or incorrect type");
    if (typeof jwe.ciphertext !== "string") throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Ciphertext missing or incorrect type");
    if (typeof jwe.tag !== "string") throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Authentication Tag missing or incorrect type");
    if (jwe.protected !== undefined && typeof jwe.protected !== "string") throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Protected Header incorrect type");
    if (jwe.encrypted_key !== undefined && typeof jwe.encrypted_key !== "string") throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Encrypted Key incorrect type");
    if (jwe.aad !== undefined && typeof jwe.aad !== "string") throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE AAD incorrect type");
    if (jwe.header !== undefined && !(0, $52fc695f0f066c93$export$2e2bcd8739ae039)(jwe.header)) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Shared Unprotected Header incorrect type");
    if (jwe.unprotected !== undefined && !(0, $52fc695f0f066c93$export$2e2bcd8739ae039)(jwe.unprotected)) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Per-Recipient Unprotected Header incorrect type");
    let parsedProt;
    if (jwe.protected) try {
        const protectedHeader = (0, $f9909655809b2554$export$2f872c0f2117be69)(jwe.protected);
        parsedProt = JSON.parse((0, $3250a6ce6c4b6b55$export$124c96e6ce37090b).decode(protectedHeader));
    } catch  {
        throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Protected Header is invalid");
    }
    if (!(0, $51d4dc598fbcc307$export$2e2bcd8739ae039)(parsedProt, jwe.header, jwe.unprotected)) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Protected, JWE Unprotected Header, and JWE Per-Recipient Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jwe.header,
        ...jwe.unprotected
    };
    (0, $64df821a76e2365c$export$2e2bcd8739ae039)((0, $1f4c9ae257e4ef19$export$19f281f2275f6a15), new Map(), options?.crit, parsedProt, joseHeader);
    if (joseHeader.zip !== undefined) throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
    const { alg: alg, enc: enc } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("missing JWE Algorithm (alg) in JWE Header");
    if (typeof enc !== "string" || !enc) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("missing JWE Encryption Algorithm (enc) in JWE Header");
    const keyManagementAlgorithms = options && (0, $680b41bfec6e0cc1$export$2e2bcd8739ae039)("keyManagementAlgorithms", options.keyManagementAlgorithms);
    const contentEncryptionAlgorithms = options && (0, $680b41bfec6e0cc1$export$2e2bcd8739ae039)("contentEncryptionAlgorithms", options.contentEncryptionAlgorithms);
    if (keyManagementAlgorithms && !keyManagementAlgorithms.has(alg) || !keyManagementAlgorithms && alg.startsWith("PBES2")) throw new (0, $1f4c9ae257e4ef19$export$d51fd7fedeccc338)('"alg" (Algorithm) Header Parameter value not allowed');
    if (contentEncryptionAlgorithms && !contentEncryptionAlgorithms.has(enc)) throw new (0, $1f4c9ae257e4ef19$export$d51fd7fedeccc338)('"enc" (Encryption Algorithm) Header Parameter value not allowed');
    let encryptedKey;
    if (jwe.encrypted_key !== undefined) try {
        encryptedKey = (0, $f9909655809b2554$export$2f872c0f2117be69)(jwe.encrypted_key);
    } catch  {
        throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("Failed to base64url decode the encrypted_key");
    }
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jwe);
        resolvedKey = true;
    }
    let cek;
    try {
        cek = await (0, $d0cd6038b498bd4b$export$2e2bcd8739ae039)(alg, key, encryptedKey, joseHeader, options);
    } catch (err) {
        if (err instanceof TypeError || err instanceof (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15) || err instanceof (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)) throw err;
        cek = (0, $dc4ce5ff09990e7e$export$2e2bcd8739ae039)(enc);
    }
    let iv;
    let tag;
    try {
        iv = (0, $f9909655809b2554$export$2f872c0f2117be69)(jwe.iv);
    } catch  {
        throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("Failed to base64url decode the iv");
    }
    try {
        tag = (0, $f9909655809b2554$export$2f872c0f2117be69)(jwe.tag);
    } catch  {
        throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("Failed to base64url decode the tag");
    }
    const protectedHeader = (0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode(jwe.protected ?? "");
    let additionalData;
    if (jwe.aad !== undefined) additionalData = (0, $3250a6ce6c4b6b55$export$ee1b3e54f0441b22)(protectedHeader, (0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode("."), (0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode(jwe.aad));
    else additionalData = protectedHeader;
    let ciphertext;
    try {
        ciphertext = (0, $f9909655809b2554$export$2f872c0f2117be69)(jwe.ciphertext);
    } catch  {
        throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("Failed to base64url decode the ciphertext");
    }
    let plaintext = await (0, $4d71421a543e55c6$export$2e2bcd8739ae039)(enc, cek, ciphertext, iv, tag, additionalData);
    const result = {
        plaintext: plaintext
    };
    if (jwe.protected !== undefined) result.protectedHeader = parsedProt;
    if (jwe.aad !== undefined) try {
        result.additionalAuthenticatedData = (0, $f9909655809b2554$export$2f872c0f2117be69)(jwe.aad);
    } catch  {
        throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("Failed to base64url decode the aad");
    }
    if (jwe.unprotected !== undefined) result.sharedUnprotectedHeader = jwe.unprotected;
    if (jwe.header !== undefined) result.unprotectedHeader = jwe.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}




async function $b4aea0622112a070$export$c9a8efe6bfd872ce(jwe, key, options) {
    if (jwe instanceof Uint8Array) jwe = (0, $3250a6ce6c4b6b55$export$124c96e6ce37090b).decode(jwe);
    if (typeof jwe !== "string") throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("Compact JWE must be a string or Uint8Array");
    const { 0: protectedHeader, 1: encryptedKey, 2: iv, 3: ciphertext, 4: tag, length: length } = jwe.split(".");
    if (length !== 5) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("Invalid Compact JWE");
    const decrypted = await (0, $4f476a334a4ed97e$export$b75cd12892ae94d2)({
        ciphertext: ciphertext,
        iv: iv || undefined,
        protected: protectedHeader || undefined,
        tag: tag || undefined,
        encrypted_key: encryptedKey || undefined
    }, key, options);
    const result = {
        plaintext: decrypted.plaintext,
        protectedHeader: decrypted.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}






async function $3481ce624311d6d3$export$56bc728c88264430(jwe, key, options) {
    if (!(0, $52fc695f0f066c93$export$2e2bcd8739ae039)(jwe)) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("General JWE must be an object");
    if (!Array.isArray(jwe.recipients) || !jwe.recipients.every((0, $52fc695f0f066c93$export$2e2bcd8739ae039))) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Recipients missing or incorrect type");
    if (!jwe.recipients.length) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Recipients has no members");
    for (const recipient of jwe.recipients)try {
        return await (0, $4f476a334a4ed97e$export$b75cd12892ae94d2)({
            aad: jwe.aad,
            ciphertext: jwe.ciphertext,
            encrypted_key: recipient.encrypted_key,
            header: recipient.header,
            iv: jwe.iv,
            protected: jwe.protected,
            tag: jwe.tag,
            unprotected: jwe.unprotected
        }, key, options);
    } catch  {}
    throw new (0, $1f4c9ae257e4ef19$export$1a57512ad9773b2a)();
}

















const $0b5045a47d203326$var$keyToJWK = async (key)=>{
    if (key instanceof Uint8Array) return {
        kty: "oct",
        k: (0, $f9909655809b2554$export$c564cdbbe6da493)(key)
    };
    if (!(0, $427b2561bbdc2544$export$600b5603bbac4c6)(key)) throw new TypeError((0, $ba15dec115725d2a$export$2e2bcd8739ae039)(key, ...(0, $318059e36031b903$export$b14ad400b1d09e0f), "Uint8Array"));
    if (!key.extractable) throw new TypeError("non-extractable CryptoKey cannot be exported as a JWK");
    const { ext: ext, key_ops: key_ops, alg: alg, use: use, ...jwk } = await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.exportKey("jwk", key);
    return jwk;
};
var $0b5045a47d203326$export$2e2bcd8739ae039 = $0b5045a47d203326$var$keyToJWK;


async function $6f7b242a093644cd$export$7f687badbeed246d(key) {
    return (0, $55bfcdaa9fd2ca39$export$cfba7e924fe414ca)(key);
}
async function $6f7b242a093644cd$export$ba4a7192ac1a47fe(key) {
    return (0, $55bfcdaa9fd2ca39$export$cac76a78a90b914d)(key);
}
async function $6f7b242a093644cd$export$ffb510cfd482ce82(key) {
    return (0, $0b5045a47d203326$export$2e2bcd8739ae039)(key);
}




async function $768b744c6538b3c9$var$encryptKeyManagement(alg, enc, key, providedCek, providedParameters = {}) {
    let encryptedKey;
    let parameters;
    let cek;
    (0, $6055433aeedfa300$export$2e2bcd8739ae039)(alg, key, "encrypt");
    switch(alg){
        case "dir":
            cek = key;
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!$3406b9a12be17f13$export$f28ab77d793719b2(key)) throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const { apu: apu, apv: apv } = providedParameters;
                let { epk: ephemeralKey } = providedParameters;
                ephemeralKey || (ephemeralKey = (await $3406b9a12be17f13$export$1338dee8c889e310(key)).privateKey);
                const { x: x, y: y, crv: crv, kty: kty } = await (0, $6f7b242a093644cd$export$ffb510cfd482ce82)(ephemeralKey);
                const sharedSecret = await $3406b9a12be17f13$export$87770b6b245073b5(key, ephemeralKey, alg === "ECDH-ES" ? enc : alg, alg === "ECDH-ES" ? (0, $dc4ce5ff09990e7e$export$db433e85ac514a95)(enc) : parseInt(alg.slice(-5, -2), 10), apu, apv);
                parameters = {
                    epk: {
                        x: x,
                        crv: crv,
                        kty: kty
                    }
                };
                if (kty === "EC") parameters.epk.y = y;
                if (apu) parameters.apu = (0, $f9909655809b2554$export$c564cdbbe6da493)(apu);
                if (apv) parameters.apv = (0, $f9909655809b2554$export$c564cdbbe6da493)(apv);
                if (alg === "ECDH-ES") {
                    cek = sharedSecret;
                    break;
                }
                cek = providedCek || (0, $dc4ce5ff09990e7e$export$2e2bcd8739ae039)(enc);
                const kwAlg = alg.slice(-6);
                encryptedKey = await (0, $60307547ae22ee04$export$4997ffc0176396a6)(kwAlg, sharedSecret, cek);
                break;
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            cek = providedCek || (0, $dc4ce5ff09990e7e$export$2e2bcd8739ae039)(enc);
            encryptedKey = await (0, $45a7dffc4a832420$export$5b0f6292f11d1d18)(alg, key, cek);
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                cek = providedCek || (0, $dc4ce5ff09990e7e$export$2e2bcd8739ae039)(enc);
                const { p2c: p2c, p2s: p2s } = providedParameters;
                ({ encryptedKey: encryptedKey, ...parameters } = await (0, $9de515988a0bd61d$export$5b0f6292f11d1d18)(alg, key, cek, p2c, p2s));
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            cek = providedCek || (0, $dc4ce5ff09990e7e$export$2e2bcd8739ae039)(enc);
            encryptedKey = await (0, $60307547ae22ee04$export$4997ffc0176396a6)(alg, key, cek);
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                cek = providedCek || (0, $dc4ce5ff09990e7e$export$2e2bcd8739ae039)(enc);
                const { iv: iv } = providedParameters;
                ({ encryptedKey: encryptedKey, ...parameters } = await (0, $d3475f7fb9529d3f$export$4997ffc0176396a6)(alg, key, cek, iv));
                break;
            }
        default:
            throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
    return {
        cek: cek,
        encryptedKey: encryptedKey,
        parameters: parameters
    };
}
var $768b744c6538b3c9$export$2e2bcd8739ae039 = $768b744c6538b3c9$var$encryptKeyManagement;






const $f8625f7d073e655d$export$39c45cb77eaf132 = Symbol();
class $f8625f7d073e655d$export$eec23736d3c24809 {
    constructor(plaintext){
        if (!(plaintext instanceof Uint8Array)) throw new TypeError("plaintext must be an instance of Uint8Array");
        this._plaintext = plaintext;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._sharedUnprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._sharedUnprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    async encrypt(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader && !this._sharedUnprotectedHeader) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("either setProtectedHeader, setUnprotectedHeader, or sharedUnprotectedHeader must be called before #encrypt()");
        if (!(0, $51d4dc598fbcc307$export$2e2bcd8739ae039)(this._protectedHeader, this._unprotectedHeader, this._sharedUnprotectedHeader)) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader,
            ...this._sharedUnprotectedHeader
        };
        (0, $64df821a76e2365c$export$2e2bcd8739ae039)((0, $1f4c9ae257e4ef19$export$19f281f2275f6a15), new Map(), options?.crit, this._protectedHeader, joseHeader);
        if (joseHeader.zip !== undefined) throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
        const { alg: alg, enc: enc } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
        if (typeof enc !== "string" || !enc) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
        let encryptedKey;
        if (alg === "dir") {
            if (this._cek) throw new TypeError("setContentEncryptionKey cannot be called when using Direct Encryption");
        } else if (alg === "ECDH-ES") {
            if (this._cek) throw new TypeError("setContentEncryptionKey cannot be called when using Direct Key Agreement");
        }
        let cek;
        {
            let parameters;
            ({ cek: cek, encryptedKey: encryptedKey, parameters: parameters } = await (0, $768b744c6538b3c9$export$2e2bcd8739ae039)(alg, enc, key, this._cek, this._keyManagementParameters));
            if (parameters) {
                if (options && $f8625f7d073e655d$export$39c45cb77eaf132 in options) {
                    if (!this._unprotectedHeader) this.setUnprotectedHeader(parameters);
                    else this._unprotectedHeader = {
                        ...this._unprotectedHeader,
                        ...parameters
                    };
                } else if (!this._protectedHeader) this.setProtectedHeader(parameters);
                else this._protectedHeader = {
                    ...this._protectedHeader,
                    ...parameters
                };
            }
        }
        this._iv || (this._iv = (0, $2ed13555acb7734d$export$2e2bcd8739ae039)(enc));
        let additionalData;
        let protectedHeader;
        let aadMember;
        if (this._protectedHeader) protectedHeader = (0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode((0, $f9909655809b2554$export$c564cdbbe6da493)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode("");
        if (this._aad) {
            aadMember = (0, $f9909655809b2554$export$c564cdbbe6da493)(this._aad);
            additionalData = (0, $3250a6ce6c4b6b55$export$ee1b3e54f0441b22)(protectedHeader, (0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode("."), (0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode(aadMember));
        } else additionalData = protectedHeader;
        const { ciphertext: ciphertext, tag: tag } = await (0, $108806d8262e60df$export$2e2bcd8739ae039)(enc, this._plaintext, cek, this._iv, additionalData);
        const jwe = {
            ciphertext: (0, $f9909655809b2554$export$c564cdbbe6da493)(ciphertext),
            iv: (0, $f9909655809b2554$export$c564cdbbe6da493)(this._iv),
            tag: (0, $f9909655809b2554$export$c564cdbbe6da493)(tag)
        };
        if (encryptedKey) jwe.encrypted_key = (0, $f9909655809b2554$export$c564cdbbe6da493)(encryptedKey);
        if (aadMember) jwe.aad = aadMember;
        if (this._protectedHeader) jwe.protected = (0, $3250a6ce6c4b6b55$export$124c96e6ce37090b).decode(protectedHeader);
        if (this._sharedUnprotectedHeader) jwe.unprotected = this._sharedUnprotectedHeader;
        if (this._unprotectedHeader) jwe.header = this._unprotectedHeader;
        return jwe;
    }
}








class $4aec3d13855a631d$var$IndividualRecipient {
    constructor(enc, key, options){
        this.parent = enc;
        this.key = key;
        this.options = options;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addRecipient(...args) {
        return this.parent.addRecipient(...args);
    }
    encrypt(...args) {
        return this.parent.encrypt(...args);
    }
    done() {
        return this.parent;
    }
}
class $4aec3d13855a631d$export$44234adffc6b0b92 {
    constructor(plaintext){
        this._recipients = [];
        this._plaintext = plaintext;
    }
    addRecipient(key, options) {
        const recipient = new $4aec3d13855a631d$var$IndividualRecipient(this, key, {
            crit: options?.crit
        });
        this._recipients.push(recipient);
        return recipient;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._unprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    async encrypt() {
        if (!this._recipients.length) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("at least one recipient must be added");
        if (this._recipients.length === 1) {
            const [recipient] = this._recipients;
            const flattened = await new (0, $f8625f7d073e655d$export$eec23736d3c24809)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).encrypt(recipient.key, {
                ...recipient.options
            });
            let jwe = {
                ciphertext: flattened.ciphertext,
                iv: flattened.iv,
                recipients: [
                    {}
                ],
                tag: flattened.tag
            };
            if (flattened.aad) jwe.aad = flattened.aad;
            if (flattened.protected) jwe.protected = flattened.protected;
            if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
            if (flattened.encrypted_key) jwe.recipients[0].encrypted_key = flattened.encrypted_key;
            if (flattened.header) jwe.recipients[0].header = flattened.header;
            return jwe;
        }
        let enc;
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            if (!(0, $51d4dc598fbcc307$export$2e2bcd8739ae039)(this._protectedHeader, this._unprotectedHeader, recipient.unprotectedHeader)) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const { alg: alg } = joseHeader;
            if (typeof alg !== "string" || !alg) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
            if (alg === "dir" || alg === "ECDH-ES") throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)('"dir" and "ECDH-ES" alg may only be used with a single recipient');
            if (typeof joseHeader.enc !== "string" || !joseHeader.enc) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
            if (!enc) enc = joseHeader.enc;
            else if (enc !== joseHeader.enc) throw new (0, $1f4c9ae257e4ef19$export$19f281f2275f6a15)('JWE "enc" (Encryption Algorithm) Header Parameter must be the same for all recipients');
            (0, $64df821a76e2365c$export$2e2bcd8739ae039)((0, $1f4c9ae257e4ef19$export$19f281f2275f6a15), new Map(), recipient.options.crit, this._protectedHeader, joseHeader);
            if (joseHeader.zip !== undefined) throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
        }
        const cek = (0, $dc4ce5ff09990e7e$export$2e2bcd8739ae039)(enc);
        let jwe = {
            ciphertext: "",
            iv: "",
            recipients: [],
            tag: ""
        };
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            const target = {};
            jwe.recipients.push(target);
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const p2c = joseHeader.alg.startsWith("PBES2") ? 2048 + i : undefined;
            if (i === 0) {
                const flattened = await new (0, $f8625f7d073e655d$export$eec23736d3c24809)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setContentEncryptionKey(cek).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).setKeyManagementParameters({
                    p2c: p2c
                }).encrypt(recipient.key, {
                    ...recipient.options,
                    [(0, $f8625f7d073e655d$export$39c45cb77eaf132)]: true
                });
                jwe.ciphertext = flattened.ciphertext;
                jwe.iv = flattened.iv;
                jwe.tag = flattened.tag;
                if (flattened.aad) jwe.aad = flattened.aad;
                if (flattened.protected) jwe.protected = flattened.protected;
                if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
                target.encrypted_key = flattened.encrypted_key;
                if (flattened.header) target.header = flattened.header;
                continue;
            }
            const { encryptedKey: encryptedKey, parameters: parameters } = await (0, $768b744c6538b3c9$export$2e2bcd8739ae039)(recipient.unprotectedHeader?.alg || this._protectedHeader?.alg || this._unprotectedHeader?.alg, enc, recipient.key, cek, {
                p2c: p2c
            });
            target.encrypted_key = (0, $f9909655809b2554$export$c564cdbbe6da493)(encryptedKey);
            if (recipient.unprotectedHeader || parameters) target.header = {
                ...recipient.unprotectedHeader,
                ...parameters
            };
        }
        return jwe;
    }
}




function $d145fdb6248e3f3c$export$2e2bcd8739ae039(alg, algorithm) {
    const hash = `SHA-${alg.slice(-3)}`;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            return {
                hash: hash,
                name: "HMAC"
            };
        case "PS256":
        case "PS384":
        case "PS512":
            return {
                hash: hash,
                name: "RSA-PSS",
                saltLength: alg.slice(-3) >> 3
            };
        case "RS256":
        case "RS384":
        case "RS512":
            return {
                hash: hash,
                name: "RSASSA-PKCS1-v1_5"
            };
        case "ES256":
        case "ES384":
        case "ES512":
            return {
                hash: hash,
                name: "ECDSA",
                namedCurve: algorithm.namedCurve
            };
        case "EdDSA":
            return {
                name: algorithm.name
            };
        default:
            throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}








function $8dc0037723d44f8b$export$2e2bcd8739ae039(alg, key, usage) {
    if ((0, $427b2561bbdc2544$export$600b5603bbac4c6)(key)) {
        (0, $1691d89c838a5b9e$export$39a36029eee6729)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) {
        if (!alg.startsWith("HS")) throw new TypeError((0, $ba15dec115725d2a$export$2e2bcd8739ae039)(key, ...(0, $318059e36031b903$export$b14ad400b1d09e0f)));
        return (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.importKey("raw", key, {
            hash: `SHA-${alg.slice(-3)}`,
            name: "HMAC"
        }, false, [
            usage
        ]);
    }
    throw new TypeError((0, $ba15dec115725d2a$export$2e2bcd8739ae039)(key, ...(0, $318059e36031b903$export$b14ad400b1d09e0f), "Uint8Array"));
}


const $bdc375f38c88a683$var$verify = async (alg, key, signature, data)=>{
    const cryptoKey = await (0, $8dc0037723d44f8b$export$2e2bcd8739ae039)(alg, key, "verify");
    (0, $aa3bbf98edc278b4$export$2e2bcd8739ae039)(alg, cryptoKey);
    const algorithm = (0, $d145fdb6248e3f3c$export$2e2bcd8739ae039)(alg, cryptoKey.algorithm);
    try {
        return await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.verify(algorithm, cryptoKey, signature, data);
    } catch  {
        return false;
    }
};
var $bdc375f38c88a683$export$2e2bcd8739ae039 = $bdc375f38c88a683$var$verify;









async function $6cca379a3be4ad3a$export$b2614975507c40c9(jws, key, options) {
    if (!(0, $52fc695f0f066c93$export$2e2bcd8739ae039)(jws)) throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("Flattened JWS must be an object");
    if (jws.protected === undefined && jws.header === undefined) throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)('Flattened JWS must have either of the "protected" or "header" members');
    if (jws.protected !== undefined && typeof jws.protected !== "string") throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("JWS Protected Header incorrect type");
    if (jws.payload === undefined) throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("JWS Payload missing");
    if (typeof jws.signature !== "string") throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("JWS Signature missing or incorrect type");
    if (jws.header !== undefined && !(0, $52fc695f0f066c93$export$2e2bcd8739ae039)(jws.header)) throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("JWS Unprotected Header incorrect type");
    let parsedProt = {};
    if (jws.protected) try {
        const protectedHeader = (0, $f9909655809b2554$export$2f872c0f2117be69)(jws.protected);
        parsedProt = JSON.parse((0, $3250a6ce6c4b6b55$export$124c96e6ce37090b).decode(protectedHeader));
    } catch  {
        throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("JWS Protected Header is invalid");
    }
    if (!(0, $51d4dc598fbcc307$export$2e2bcd8739ae039)(parsedProt, jws.header)) throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jws.header
    };
    const extensions = (0, $64df821a76e2365c$export$2e2bcd8739ae039)((0, $1f4c9ae257e4ef19$export$e838de724af3d116), new Map([
        [
            "b64",
            true
        ]
    ]), options?.crit, parsedProt, joseHeader);
    let b64 = true;
    if (extensions.has("b64")) {
        b64 = parsedProt.b64;
        if (typeof b64 !== "boolean") throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    }
    const { alg: alg } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    const algorithms = options && (0, $680b41bfec6e0cc1$export$2e2bcd8739ae039)("algorithms", options.algorithms);
    if (algorithms && !algorithms.has(alg)) throw new (0, $1f4c9ae257e4ef19$export$d51fd7fedeccc338)('"alg" (Algorithm) Header Parameter value not allowed');
    if (b64) {
        if (typeof jws.payload !== "string") throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("JWS Payload must be a string");
    } else if (typeof jws.payload !== "string" && !(jws.payload instanceof Uint8Array)) throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("JWS Payload must be a string or an Uint8Array instance");
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jws);
        resolvedKey = true;
    }
    (0, $6055433aeedfa300$export$2e2bcd8739ae039)(alg, key, "verify");
    const data = (0, $3250a6ce6c4b6b55$export$ee1b3e54f0441b22)((0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode(jws.protected ?? ""), (0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode("."), typeof jws.payload === "string" ? (0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode(jws.payload) : jws.payload);
    let signature;
    try {
        signature = (0, $f9909655809b2554$export$2f872c0f2117be69)(jws.signature);
    } catch  {
        throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("Failed to base64url decode the signature");
    }
    const verified = await (0, $bdc375f38c88a683$export$2e2bcd8739ae039)(alg, key, signature, data);
    if (!verified) throw new (0, $1f4c9ae257e4ef19$export$c67a0218e7c50378)();
    let payload;
    if (b64) try {
        payload = (0, $f9909655809b2554$export$2f872c0f2117be69)(jws.payload);
    } catch  {
        throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("Failed to base64url decode the payload");
    }
    else if (typeof jws.payload === "string") payload = (0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode(jws.payload);
    else payload = jws.payload;
    const result = {
        payload: payload
    };
    if (jws.protected !== undefined) result.protectedHeader = parsedProt;
    if (jws.header !== undefined) result.unprotectedHeader = jws.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}




async function $305400225aedad5b$export$996150e72a8992e(jws, key, options) {
    if (jws instanceof Uint8Array) jws = (0, $3250a6ce6c4b6b55$export$124c96e6ce37090b).decode(jws);
    if (typeof jws !== "string") throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("Compact JWS must be a string or Uint8Array");
    const { 0: protectedHeader, 1: payload, 2: signature, length: length } = jws.split(".");
    if (length !== 3) throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("Invalid Compact JWS");
    const verified = await (0, $6cca379a3be4ad3a$export$b2614975507c40c9)({
        payload: payload,
        protected: protectedHeader,
        signature: signature
    }, key, options);
    const result = {
        payload: verified.payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}






async function $83fabae7579e5f85$export$45b643129436bc63(jws, key, options) {
    if (!(0, $52fc695f0f066c93$export$2e2bcd8739ae039)(jws)) throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("General JWS must be an object");
    if (!Array.isArray(jws.signatures) || !jws.signatures.every((0, $52fc695f0f066c93$export$2e2bcd8739ae039))) throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("JWS Signatures missing or incorrect type");
    for (const signature of jws.signatures)try {
        return await (0, $6cca379a3be4ad3a$export$b2614975507c40c9)({
            header: signature.header,
            payload: jws.payload,
            protected: signature.protected,
            signature: signature.signature
        }, key, options);
    } catch  {}
    throw new (0, $1f4c9ae257e4ef19$export$c67a0218e7c50378)();
}





var $5570c5f1901e9d95$export$2e2bcd8739ae039 = (date)=>Math.floor(date.getTime() / 1000);


const $b9a1179411b62a58$var$minute = 60;
const $b9a1179411b62a58$var$hour = $b9a1179411b62a58$var$minute * 60;
const $b9a1179411b62a58$var$day = $b9a1179411b62a58$var$hour * 24;
const $b9a1179411b62a58$var$week = $b9a1179411b62a58$var$day * 7;
const $b9a1179411b62a58$var$year = $b9a1179411b62a58$var$day * 365.25;
const $b9a1179411b62a58$var$REGEX = /^(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)$/i;
var $b9a1179411b62a58$export$2e2bcd8739ae039 = (str)=>{
    const matched = $b9a1179411b62a58$var$REGEX.exec(str);
    if (!matched) throw new TypeError("Invalid time period format");
    const value = parseFloat(matched[1]);
    const unit = matched[2].toLowerCase();
    switch(unit){
        case "sec":
        case "secs":
        case "second":
        case "seconds":
        case "s":
            return Math.round(value);
        case "minute":
        case "minutes":
        case "min":
        case "mins":
        case "m":
            return Math.round(value * $b9a1179411b62a58$var$minute);
        case "hour":
        case "hours":
        case "hr":
        case "hrs":
        case "h":
            return Math.round(value * $b9a1179411b62a58$var$hour);
        case "day":
        case "days":
        case "d":
            return Math.round(value * $b9a1179411b62a58$var$day);
        case "week":
        case "weeks":
        case "w":
            return Math.round(value * $b9a1179411b62a58$var$week);
        default:
            return Math.round(value * $b9a1179411b62a58$var$year);
    }
};



const $c6ec2524c9c4c2e6$var$normalizeTyp = (value)=>value.toLowerCase().replace(/^application\//, "");
const $c6ec2524c9c4c2e6$var$checkAudiencePresence = (audPayload, audOption)=>{
    if (typeof audPayload === "string") return audOption.includes(audPayload);
    if (Array.isArray(audPayload)) return audOption.some(Set.prototype.has.bind(new Set(audPayload)));
    return false;
};
var $c6ec2524c9c4c2e6$export$2e2bcd8739ae039 = (protectedHeader, encodedPayload, options = {})=>{
    const { typ: typ } = options;
    if (typ && (typeof protectedHeader.typ !== "string" || $c6ec2524c9c4c2e6$var$normalizeTyp(protectedHeader.typ) !== $c6ec2524c9c4c2e6$var$normalizeTyp(typ))) throw new (0, $1f4c9ae257e4ef19$export$f1e14efb908196e9)('unexpected "typ" JWT header value', "typ", "check_failed");
    let payload;
    try {
        payload = JSON.parse((0, $3250a6ce6c4b6b55$export$124c96e6ce37090b).decode(encodedPayload));
    } catch  {}
    if (!(0, $52fc695f0f066c93$export$2e2bcd8739ae039)(payload)) throw new (0, $1f4c9ae257e4ef19$export$936b39ada0bbfceb)("JWT Claims Set must be a top-level JSON object");
    const { requiredClaims: requiredClaims = [], issuer: issuer, subject: subject, audience: audience, maxTokenAge: maxTokenAge } = options;
    if (maxTokenAge !== undefined) requiredClaims.push("iat");
    if (audience !== undefined) requiredClaims.push("aud");
    if (subject !== undefined) requiredClaims.push("sub");
    if (issuer !== undefined) requiredClaims.push("iss");
    for (const claim of new Set(requiredClaims.reverse())){
        if (!(claim in payload)) throw new (0, $1f4c9ae257e4ef19$export$f1e14efb908196e9)(`missing required "${claim}" claim`, claim, "missing");
    }
    if (issuer && !(Array.isArray(issuer) ? issuer : [
        issuer
    ]).includes(payload.iss)) throw new (0, $1f4c9ae257e4ef19$export$f1e14efb908196e9)('unexpected "iss" claim value', "iss", "check_failed");
    if (subject && payload.sub !== subject) throw new (0, $1f4c9ae257e4ef19$export$f1e14efb908196e9)('unexpected "sub" claim value', "sub", "check_failed");
    if (audience && !$c6ec2524c9c4c2e6$var$checkAudiencePresence(payload.aud, typeof audience === "string" ? [
        audience
    ] : audience)) throw new (0, $1f4c9ae257e4ef19$export$f1e14efb908196e9)('unexpected "aud" claim value', "aud", "check_failed");
    let tolerance;
    switch(typeof options.clockTolerance){
        case "string":
            tolerance = (0, $b9a1179411b62a58$export$2e2bcd8739ae039)(options.clockTolerance);
            break;
        case "number":
            tolerance = options.clockTolerance;
            break;
        case "undefined":
            tolerance = 0;
            break;
        default:
            throw new TypeError("Invalid clockTolerance option type");
    }
    const { currentDate: currentDate } = options;
    const now = (0, $5570c5f1901e9d95$export$2e2bcd8739ae039)(currentDate || new Date());
    if ((payload.iat !== undefined || maxTokenAge) && typeof payload.iat !== "number") throw new (0, $1f4c9ae257e4ef19$export$f1e14efb908196e9)('"iat" claim must be a number', "iat", "invalid");
    if (payload.nbf !== undefined) {
        if (typeof payload.nbf !== "number") throw new (0, $1f4c9ae257e4ef19$export$f1e14efb908196e9)('"nbf" claim must be a number', "nbf", "invalid");
        if (payload.nbf > now + tolerance) throw new (0, $1f4c9ae257e4ef19$export$f1e14efb908196e9)('"nbf" claim timestamp check failed', "nbf", "check_failed");
    }
    if (payload.exp !== undefined) {
        if (typeof payload.exp !== "number") throw new (0, $1f4c9ae257e4ef19$export$f1e14efb908196e9)('"exp" claim must be a number', "exp", "invalid");
        if (payload.exp <= now - tolerance) throw new (0, $1f4c9ae257e4ef19$export$4b386bf852b7863d)('"exp" claim timestamp check failed', "exp", "check_failed");
    }
    if (maxTokenAge) {
        const age = now - payload.iat;
        const max = typeof maxTokenAge === "number" ? maxTokenAge : (0, $b9a1179411b62a58$export$2e2bcd8739ae039)(maxTokenAge);
        if (age - tolerance > max) throw new (0, $1f4c9ae257e4ef19$export$4b386bf852b7863d)('"iat" claim timestamp check failed (too far in the past)', "iat", "check_failed");
        if (age < 0 - tolerance) throw new (0, $1f4c9ae257e4ef19$export$f1e14efb908196e9)('"iat" claim timestamp check failed (it should be in the past)', "iat", "check_failed");
    }
    return payload;
};



async function $8765c16992919069$export$c878fd0f8381da51(jwt, key, options) {
    const verified = await (0, $305400225aedad5b$export$996150e72a8992e)(jwt, key, options);
    if (verified.protectedHeader.crit?.includes("b64") && verified.protectedHeader.b64 === false) throw new (0, $1f4c9ae257e4ef19$export$936b39ada0bbfceb)("JWTs MUST NOT use unencoded payload");
    const payload = (0, $c6ec2524c9c4c2e6$export$2e2bcd8739ae039)(verified.protectedHeader, verified.payload, options);
    const result = {
        payload: payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}





async function $2cccc1ef7e855572$export$6ee899505bc40a19(jwt, key, options) {
    const decrypted = await (0, $b4aea0622112a070$export$c9a8efe6bfd872ce)(jwt, key, options);
    const payload = (0, $c6ec2524c9c4c2e6$export$2e2bcd8739ae039)(decrypted.protectedHeader, decrypted.plaintext, options);
    const { protectedHeader: protectedHeader } = decrypted;
    if (protectedHeader.iss !== undefined && protectedHeader.iss !== payload.iss) throw new (0, $1f4c9ae257e4ef19$export$f1e14efb908196e9)('replicated "iss" claim header parameter mismatch', "iss", "mismatch");
    if (protectedHeader.sub !== undefined && protectedHeader.sub !== payload.sub) throw new (0, $1f4c9ae257e4ef19$export$f1e14efb908196e9)('replicated "sub" claim header parameter mismatch', "sub", "mismatch");
    if (protectedHeader.aud !== undefined && JSON.stringify(protectedHeader.aud) !== JSON.stringify(payload.aud)) throw new (0, $1f4c9ae257e4ef19$export$f1e14efb908196e9)('replicated "aud" claim header parameter mismatch', "aud", "mismatch");
    const result = {
        payload: payload,
        protectedHeader: protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}



class $b7a1c1382cbd24b6$export$965e4de9938e070e {
    constructor(plaintext){
        this._flattened = new (0, $f8625f7d073e655d$export$eec23736d3c24809)(plaintext);
    }
    setContentEncryptionKey(cek) {
        this._flattened.setContentEncryptionKey(cek);
        return this;
    }
    setInitializationVector(iv) {
        this._flattened.setInitializationVector(iv);
        return this;
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    setKeyManagementParameters(parameters) {
        this._flattened.setKeyManagementParameters(parameters);
        return this;
    }
    async encrypt(key, options) {
        const jwe = await this._flattened.encrypt(key, options);
        return [
            jwe.protected,
            jwe.encrypted_key,
            jwe.iv,
            jwe.ciphertext,
            jwe.tag
        ].join(".");
    }
}








const $03c71192319cee21$var$sign = async (alg, key, data)=>{
    const cryptoKey = await (0, $8dc0037723d44f8b$export$2e2bcd8739ae039)(alg, key, "sign");
    (0, $aa3bbf98edc278b4$export$2e2bcd8739ae039)(alg, cryptoKey);
    const signature = await (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.sign((0, $d145fdb6248e3f3c$export$2e2bcd8739ae039)(alg, cryptoKey.algorithm), cryptoKey, data);
    return new Uint8Array(signature);
};
var $03c71192319cee21$export$2e2bcd8739ae039 = $03c71192319cee21$var$sign;







class $b130a48f1bac732d$export$9a8af5200da5ddb1 {
    constructor(payload){
        if (!(payload instanceof Uint8Array)) throw new TypeError("payload must be an instance of Uint8Array");
        this._payload = payload;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    async sign(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader) throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
        if (!(0, $51d4dc598fbcc307$export$2e2bcd8739ae039)(this._protectedHeader, this._unprotectedHeader)) throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader
        };
        const extensions = (0, $64df821a76e2365c$export$2e2bcd8739ae039)((0, $1f4c9ae257e4ef19$export$e838de724af3d116), new Map([
            [
                "b64",
                true
            ]
        ]), options?.crit, this._protectedHeader, joseHeader);
        let b64 = true;
        if (extensions.has("b64")) {
            b64 = this._protectedHeader.b64;
            if (typeof b64 !== "boolean") throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
        }
        const { alg: alg } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
        (0, $6055433aeedfa300$export$2e2bcd8739ae039)(alg, key, "sign");
        let payload = this._payload;
        if (b64) payload = (0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode((0, $f9909655809b2554$export$c564cdbbe6da493)(payload));
        let protectedHeader;
        if (this._protectedHeader) protectedHeader = (0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode((0, $f9909655809b2554$export$c564cdbbe6da493)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode("");
        const data = (0, $3250a6ce6c4b6b55$export$ee1b3e54f0441b22)(protectedHeader, (0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode("."), payload);
        const signature = await (0, $03c71192319cee21$export$2e2bcd8739ae039)(alg, key, data);
        const jws = {
            signature: (0, $f9909655809b2554$export$c564cdbbe6da493)(signature),
            payload: ""
        };
        if (b64) jws.payload = (0, $3250a6ce6c4b6b55$export$124c96e6ce37090b).decode(payload);
        if (this._unprotectedHeader) jws.header = this._unprotectedHeader;
        if (this._protectedHeader) jws.protected = (0, $3250a6ce6c4b6b55$export$124c96e6ce37090b).decode(protectedHeader);
        return jws;
    }
}


class $83f8c96bb84e9e75$export$b6738d8e70498d17 {
    constructor(payload){
        this._flattened = new (0, $b130a48f1bac732d$export$9a8af5200da5ddb1)(payload);
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    async sign(key, options) {
        const jws = await this._flattened.sign(key, options);
        if (jws.payload === undefined) throw new TypeError("use the flattened module for creating JWS with b64: false");
        return `${jws.protected}.${jws.payload}.${jws.signature}`;
    }
}





class $910bca1658a05be6$var$IndividualSignature {
    constructor(sig, key, options){
        this.parent = sig;
        this.key = key;
        this.options = options;
    }
    setProtectedHeader(protectedHeader) {
        if (this.protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this.protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addSignature(...args) {
        return this.parent.addSignature(...args);
    }
    sign(...args) {
        return this.parent.sign(...args);
    }
    done() {
        return this.parent;
    }
}
class $910bca1658a05be6$export$7e2f94727ed1a34b {
    constructor(payload){
        this._signatures = [];
        this._payload = payload;
    }
    addSignature(key, options) {
        const signature = new $910bca1658a05be6$var$IndividualSignature(this, key, options);
        this._signatures.push(signature);
        return signature;
    }
    async sign() {
        if (!this._signatures.length) throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("at least one signature must be added");
        const jws = {
            signatures: [],
            payload: ""
        };
        for(let i = 0; i < this._signatures.length; i++){
            const signature = this._signatures[i];
            const flattened = new (0, $b130a48f1bac732d$export$9a8af5200da5ddb1)(this._payload);
            flattened.setProtectedHeader(signature.protectedHeader);
            flattened.setUnprotectedHeader(signature.unprotectedHeader);
            const { payload: payload, ...rest } = await flattened.sign(signature.key, signature.options);
            if (i === 0) jws.payload = payload;
            else if (jws.payload !== payload) throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)("inconsistent use of JWS Unencoded Payload (RFC7797)");
            jws.signatures.push(rest);
        }
        return jws;
    }
}








function $55035aca5cd3f24c$var$validateInput(label, input) {
    if (!Number.isFinite(input)) throw new TypeError(`Invalid ${label} input`);
    return input;
}
class $55035aca5cd3f24c$export$2ef1b74b7c7e6eb3 {
    constructor(payload = {}){
        if (!(0, $52fc695f0f066c93$export$2e2bcd8739ae039)(payload)) throw new TypeError("JWT Claims Set MUST be an object");
        this._payload = payload;
    }
    setIssuer(issuer) {
        this._payload = {
            ...this._payload,
            iss: issuer
        };
        return this;
    }
    setSubject(subject) {
        this._payload = {
            ...this._payload,
            sub: subject
        };
        return this;
    }
    setAudience(audience) {
        this._payload = {
            ...this._payload,
            aud: audience
        };
        return this;
    }
    setJti(jwtId) {
        this._payload = {
            ...this._payload,
            jti: jwtId
        };
        return this;
    }
    setNotBefore(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            nbf: $55035aca5cd3f24c$var$validateInput("setNotBefore", input)
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            nbf: $55035aca5cd3f24c$var$validateInput("setNotBefore", (0, $5570c5f1901e9d95$export$2e2bcd8739ae039)(input))
        };
        else this._payload = {
            ...this._payload,
            nbf: (0, $5570c5f1901e9d95$export$2e2bcd8739ae039)(new Date()) + (0, $b9a1179411b62a58$export$2e2bcd8739ae039)(input)
        };
        return this;
    }
    setExpirationTime(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            exp: $55035aca5cd3f24c$var$validateInput("setExpirationTime", input)
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            exp: $55035aca5cd3f24c$var$validateInput("setExpirationTime", (0, $5570c5f1901e9d95$export$2e2bcd8739ae039)(input))
        };
        else this._payload = {
            ...this._payload,
            exp: (0, $5570c5f1901e9d95$export$2e2bcd8739ae039)(new Date()) + (0, $b9a1179411b62a58$export$2e2bcd8739ae039)(input)
        };
        return this;
    }
    setIssuedAt(input) {
        if (typeof input === "undefined") this._payload = {
            ...this._payload,
            iat: (0, $5570c5f1901e9d95$export$2e2bcd8739ae039)(new Date())
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            iat: $55035aca5cd3f24c$var$validateInput("setIssuedAt", (0, $5570c5f1901e9d95$export$2e2bcd8739ae039)(input))
        };
        else this._payload = {
            ...this._payload,
            iat: $55035aca5cd3f24c$var$validateInput("setIssuedAt", input)
        };
        return this;
    }
}


class $ac982a9989f5e1c8$export$88d4e5d23fbe6c84 extends (0, $55035aca5cd3f24c$export$2ef1b74b7c7e6eb3) {
    setProtectedHeader(protectedHeader) {
        this._protectedHeader = protectedHeader;
        return this;
    }
    async sign(key, options) {
        const sig = new (0, $83f8c96bb84e9e75$export$b6738d8e70498d17)((0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode(JSON.stringify(this._payload)));
        sig.setProtectedHeader(this._protectedHeader);
        if (Array.isArray(this._protectedHeader?.crit) && this._protectedHeader.crit.includes("b64") && this._protectedHeader.b64 === false) throw new (0, $1f4c9ae257e4ef19$export$936b39ada0bbfceb)("JWTs MUST NOT use unencoded payload");
        return sig.sign(key, options);
    }
}





class $e3879fd9e15b0ebf$export$28c9f8d29aec6f3d extends (0, $55035aca5cd3f24c$export$2ef1b74b7c7e6eb3) {
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    replicateIssuerAsHeader() {
        this._replicateIssuerAsHeader = true;
        return this;
    }
    replicateSubjectAsHeader() {
        this._replicateSubjectAsHeader = true;
        return this;
    }
    replicateAudienceAsHeader() {
        this._replicateAudienceAsHeader = true;
        return this;
    }
    async encrypt(key, options) {
        const enc = new (0, $b7a1c1382cbd24b6$export$965e4de9938e070e)((0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode(JSON.stringify(this._payload)));
        if (this._replicateIssuerAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            iss: this._payload.iss
        };
        if (this._replicateSubjectAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            sub: this._payload.sub
        };
        if (this._replicateAudienceAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            aud: this._payload.aud
        };
        enc.setProtectedHeader(this._protectedHeader);
        if (this._iv) enc.setInitializationVector(this._iv);
        if (this._cek) enc.setContentEncryptionKey(this._cek);
        if (this._keyManagementParameters) enc.setKeyManagementParameters(this._keyManagementParameters);
        return enc.encrypt(key, options);
    }
}







const $3799920f7aae7786$var$check = (value, description)=>{
    if (typeof value !== "string" || !value) throw new (0, $1f4c9ae257e4ef19$export$b3992e0f88fb07e3)(`${description} missing or invalid`);
};
async function $3799920f7aae7786$export$f1ec189735e8660f(jwk, digestAlgorithm) {
    if (!(0, $52fc695f0f066c93$export$2e2bcd8739ae039)(jwk)) throw new TypeError("JWK must be an object");
    digestAlgorithm ?? (digestAlgorithm = "sha256");
    if (digestAlgorithm !== "sha256" && digestAlgorithm !== "sha384" && digestAlgorithm !== "sha512") throw new TypeError('digestAlgorithm must one of "sha256", "sha384", or "sha512"');
    let components;
    switch(jwk.kty){
        case "EC":
            $3799920f7aae7786$var$check(jwk.crv, '"crv" (Curve) Parameter');
            $3799920f7aae7786$var$check(jwk.x, '"x" (X Coordinate) Parameter');
            $3799920f7aae7786$var$check(jwk.y, '"y" (Y Coordinate) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x,
                y: jwk.y
            };
            break;
        case "OKP":
            $3799920f7aae7786$var$check(jwk.crv, '"crv" (Subtype of Key Pair) Parameter');
            $3799920f7aae7786$var$check(jwk.x, '"x" (Public Key) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x
            };
            break;
        case "RSA":
            $3799920f7aae7786$var$check(jwk.e, '"e" (Exponent) Parameter');
            $3799920f7aae7786$var$check(jwk.n, '"n" (Modulus) Parameter');
            components = {
                e: jwk.e,
                kty: jwk.kty,
                n: jwk.n
            };
            break;
        case "oct":
            $3799920f7aae7786$var$check(jwk.k, '"k" (Key Value) Parameter');
            components = {
                k: jwk.k,
                kty: jwk.kty
            };
            break;
        default:
            throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)('"kty" (Key Type) Parameter missing or unsupported');
    }
    const data = (0, $3250a6ce6c4b6b55$export$5486af06137bf21a).encode(JSON.stringify(components));
    return (0, $f9909655809b2554$export$c564cdbbe6da493)(await (0, $7b6935233e273a4e$export$2e2bcd8739ae039)(digestAlgorithm, data));
}
async function $3799920f7aae7786$export$b9879ebc49d4fd7a(jwk, digestAlgorithm) {
    digestAlgorithm ?? (digestAlgorithm = "sha256");
    const thumbprint = await $3799920f7aae7786$export$f1ec189735e8660f(jwk, digestAlgorithm);
    return `urn:ietf:params:oauth:jwk-thumbprint:sha-${digestAlgorithm.slice(-3)}:${thumbprint}`;
}





async function $fb18be75c59bbb85$export$c51e3062a159ef59(protectedHeader, token) {
    const joseHeader = {
        ...protectedHeader,
        ...token?.header
    };
    if (!(0, $52fc695f0f066c93$export$2e2bcd8739ae039)(joseHeader.jwk)) throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)('"jwk" (JSON Web Key) Header Parameter must be a JSON object');
    const key = await (0, $16f8df83cb053d45$export$2b70d37b4d0b888b)({
        ...joseHeader.jwk,
        ext: true
    }, joseHeader.alg);
    if (key instanceof Uint8Array || key.type !== "public") throw new (0, $1f4c9ae257e4ef19$export$e838de724af3d116)('"jwk" (JSON Web Key) Header Parameter must be a public key');
    return key;
}





function $1ec9386fda8f5596$var$getKtyFromAlg(alg) {
    switch(typeof alg === "string" && alg.slice(0, 2)){
        case "RS":
        case "PS":
            return "RSA";
        case "ES":
            return "EC";
        case "Ed":
            return "OKP";
        default:
            throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)('Unsupported "alg" value for a JSON Web Key Set');
    }
}
function $1ec9386fda8f5596$export$d01e0ebadbb4baf(jwks) {
    return jwks && typeof jwks === "object" && Array.isArray(jwks.keys) && jwks.keys.every($1ec9386fda8f5596$var$isJWKLike);
}
function $1ec9386fda8f5596$var$isJWKLike(key) {
    return (0, $52fc695f0f066c93$export$2e2bcd8739ae039)(key);
}
function $1ec9386fda8f5596$var$clone(obj) {
    if (typeof structuredClone === "function") return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
class $1ec9386fda8f5596$export$cfeaec9a672ea12b {
    constructor(jwks){
        this._cached = new WeakMap();
        if (!$1ec9386fda8f5596$export$d01e0ebadbb4baf(jwks)) throw new (0, $1f4c9ae257e4ef19$export$9b22c2a1e2403b8e)("JSON Web Key Set malformed");
        this._jwks = $1ec9386fda8f5596$var$clone(jwks);
    }
    async getKey(protectedHeader, token) {
        const { alg: alg, kid: kid } = {
            ...protectedHeader,
            ...token?.header
        };
        const kty = $1ec9386fda8f5596$var$getKtyFromAlg(alg);
        const candidates = this._jwks.keys.filter((jwk)=>{
            let candidate = kty === jwk.kty;
            if (candidate && typeof kid === "string") candidate = kid === jwk.kid;
            if (candidate && typeof jwk.alg === "string") candidate = alg === jwk.alg;
            if (candidate && typeof jwk.use === "string") candidate = jwk.use === "sig";
            if (candidate && Array.isArray(jwk.key_ops)) candidate = jwk.key_ops.includes("verify");
            if (candidate && alg === "EdDSA") candidate = jwk.crv === "Ed25519" || jwk.crv === "Ed448";
            if (candidate) switch(alg){
                case "ES256":
                    candidate = jwk.crv === "P-256";
                    break;
                case "ES256K":
                    candidate = jwk.crv === "secp256k1";
                    break;
                case "ES384":
                    candidate = jwk.crv === "P-384";
                    break;
                case "ES512":
                    candidate = jwk.crv === "P-521";
                    break;
            }
            return candidate;
        });
        const { 0: jwk, length: length } = candidates;
        if (length === 0) throw new (0, $1f4c9ae257e4ef19$export$3d5ed1a538bed04e)();
        else if (length !== 1) {
            const error = new (0, $1f4c9ae257e4ef19$export$dc036de401a5c284)();
            const { _cached: _cached } = this;
            error[Symbol.asyncIterator] = async function*() {
                for (const jwk of candidates)try {
                    yield await $1ec9386fda8f5596$var$importWithAlgCache(_cached, jwk, alg);
                } catch  {
                    continue;
                }
            };
            throw error;
        }
        return $1ec9386fda8f5596$var$importWithAlgCache(this._cached, jwk, alg);
    }
}
async function $1ec9386fda8f5596$var$importWithAlgCache(cache, jwk, alg) {
    const cached = cache.get(jwk) || cache.set(jwk, {}).get(jwk);
    if (cached[alg] === undefined) {
        const key = await (0, $16f8df83cb053d45$export$2b70d37b4d0b888b)({
            ...jwk,
            ext: true
        }, alg);
        if (key instanceof Uint8Array || key.type !== "public") throw new (0, $1f4c9ae257e4ef19$export$9b22c2a1e2403b8e)("JSON Web Key Set members must be public keys");
        cached[alg] = key;
    }
    return cached[alg];
}
function $1ec9386fda8f5596$export$4892abc640e5f80e(jwks) {
    const set = new $1ec9386fda8f5596$export$cfeaec9a672ea12b(jwks);
    return async function(protectedHeader, token) {
        return set.getKey(protectedHeader, token);
    };
}



const $5cf7c6bf57919e40$var$fetchJwks = async (url, timeout, options)=>{
    let controller;
    let id;
    let timedOut = false;
    if (typeof AbortController === "function") {
        controller = new AbortController();
        id = setTimeout(()=>{
            timedOut = true;
            controller.abort();
        }, timeout);
    }
    const response = await fetch(url.href, {
        signal: controller ? controller.signal : undefined,
        redirect: "manual",
        headers: options.headers
    }).catch((err)=>{
        if (timedOut) throw new (0, $1f4c9ae257e4ef19$export$3f30acebf25c04e6)();
        throw err;
    });
    if (id !== undefined) clearTimeout(id);
    if (response.status !== 200) throw new (0, $1f4c9ae257e4ef19$export$f754d6850d76bf87)("Expected 200 OK from the JSON Web Key Set HTTP response");
    try {
        return await response.json();
    } catch  {
        throw new (0, $1f4c9ae257e4ef19$export$f754d6850d76bf87)("Failed to parse the JSON Web Key Set HTTP response as JSON");
    }
};
var $5cf7c6bf57919e40$export$2e2bcd8739ae039 = $5cf7c6bf57919e40$var$fetchJwks;




function $2a1b2c5057ffefe6$var$isCloudflareWorkers() {
    return typeof WebSocketPair !== "undefined" || typeof navigator !== "undefined" && navigator.userAgent === "Cloudflare-Workers" || typeof EdgeRuntime !== "undefined" && EdgeRuntime === "vercel";
}
class $2a1b2c5057ffefe6$var$RemoteJWKSet extends (0, $1ec9386fda8f5596$export$cfeaec9a672ea12b) {
    constructor(url, options){
        super({
            keys: []
        });
        this._jwks = undefined;
        if (!(url instanceof URL)) throw new TypeError("url must be an instance of URL");
        this._url = new URL(url.href);
        this._options = {
            agent: options?.agent,
            headers: options?.headers
        };
        this._timeoutDuration = typeof options?.timeoutDuration === "number" ? options?.timeoutDuration : 5000;
        this._cooldownDuration = typeof options?.cooldownDuration === "number" ? options?.cooldownDuration : 30000;
        this._cacheMaxAge = typeof options?.cacheMaxAge === "number" ? options?.cacheMaxAge : 600000;
    }
    coolingDown() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cooldownDuration : false;
    }
    fresh() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cacheMaxAge : false;
    }
    async getKey(protectedHeader, token) {
        if (!this._jwks || !this.fresh()) await this.reload();
        try {
            return await super.getKey(protectedHeader, token);
        } catch (err) {
            if (err instanceof (0, $1f4c9ae257e4ef19$export$3d5ed1a538bed04e)) {
                if (this.coolingDown() === false) {
                    await this.reload();
                    return super.getKey(protectedHeader, token);
                }
            }
            throw err;
        }
    }
    async reload() {
        if (this._pendingFetch && $2a1b2c5057ffefe6$var$isCloudflareWorkers()) this._pendingFetch = undefined;
        this._pendingFetch || (this._pendingFetch = (0, $5cf7c6bf57919e40$export$2e2bcd8739ae039)(this._url, this._timeoutDuration, this._options).then((json)=>{
            if (!(0, $1ec9386fda8f5596$export$d01e0ebadbb4baf)(json)) throw new (0, $1f4c9ae257e4ef19$export$9b22c2a1e2403b8e)("JSON Web Key Set malformed");
            this._jwks = {
                keys: json.keys
            };
            this._jwksTimestamp = Date.now();
            this._pendingFetch = undefined;
        }).catch((err)=>{
            this._pendingFetch = undefined;
            throw err;
        }));
        await this._pendingFetch;
    }
}
function $2a1b2c5057ffefe6$export$78ce35c2df51c333(url, options) {
    const set = new $2a1b2c5057ffefe6$var$RemoteJWKSet(url, options);
    return async function(protectedHeader, token) {
        return set.getKey(protectedHeader, token);
    };
}







class $203c52522d4ca176$export$6404fb90f16d8733 extends (0, $55035aca5cd3f24c$export$2ef1b74b7c7e6eb3) {
    encode() {
        const header = $f9909655809b2554$export$c564cdbbe6da493(JSON.stringify({
            alg: "none"
        }));
        const payload = $f9909655809b2554$export$c564cdbbe6da493(JSON.stringify(this._payload));
        return `${header}.${payload}.`;
    }
    static decode(jwt, options) {
        if (typeof jwt !== "string") throw new (0, $1f4c9ae257e4ef19$export$936b39ada0bbfceb)("Unsecured JWT must be a string");
        const { 0: encodedHeader, 1: encodedPayload, 2: signature, length: length } = jwt.split(".");
        if (length !== 3 || signature !== "") throw new (0, $1f4c9ae257e4ef19$export$936b39ada0bbfceb)("Invalid Unsecured JWT");
        let header;
        try {
            header = JSON.parse((0, $3250a6ce6c4b6b55$export$124c96e6ce37090b).decode($f9909655809b2554$export$2f872c0f2117be69(encodedHeader)));
            if (header.alg !== "none") throw new Error();
        } catch  {
            throw new (0, $1f4c9ae257e4ef19$export$936b39ada0bbfceb)("Invalid Unsecured JWT");
        }
        const payload = (0, $c6ec2524c9c4c2e6$export$2e2bcd8739ae039)(header, $f9909655809b2554$export$2f872c0f2117be69(encodedPayload), options);
        return {
            payload: payload,
            header: header
        };
    }
}





const $39d1414e008ced8e$export$c564cdbbe6da493 = $f9909655809b2554$export$c564cdbbe6da493;
const $39d1414e008ced8e$export$2f872c0f2117be69 = $f9909655809b2554$export$2f872c0f2117be69;




function $59a521f4986859fe$export$ca23208356ba8d90(token) {
    let protectedB64u;
    if (typeof token === "string") {
        const parts = token.split(".");
        if (parts.length === 3 || parts.length === 5) [protectedB64u] = parts;
    } else if (typeof token === "object" && token) {
        if ("protected" in token) protectedB64u = token.protected;
        else throw new TypeError("Token does not contain a Protected Header");
    }
    try {
        if (typeof protectedB64u !== "string" || !protectedB64u) throw new Error();
        const result = JSON.parse((0, $3250a6ce6c4b6b55$export$124c96e6ce37090b).decode((0, $39d1414e008ced8e$export$2f872c0f2117be69)(protectedB64u)));
        if (!(0, $52fc695f0f066c93$export$2e2bcd8739ae039)(result)) throw new Error();
        return result;
    } catch  {
        throw new TypeError("Invalid Token or Protected Header formatting");
    }
}






function $dc20508c0d0c8b4e$export$dcef71b8fb9a6794(jwt) {
    if (typeof jwt !== "string") throw new (0, $1f4c9ae257e4ef19$export$936b39ada0bbfceb)("JWTs must use Compact JWS serialization, JWT must be a string");
    const { 1: payload, length: length } = jwt.split(".");
    if (length === 5) throw new (0, $1f4c9ae257e4ef19$export$936b39ada0bbfceb)("Only JWTs using Compact JWS serialization can be decoded");
    if (length !== 3) throw new (0, $1f4c9ae257e4ef19$export$936b39ada0bbfceb)("Invalid JWT");
    if (!payload) throw new (0, $1f4c9ae257e4ef19$export$936b39ada0bbfceb)("JWTs must contain a payload");
    let decoded;
    try {
        decoded = (0, $39d1414e008ced8e$export$2f872c0f2117be69)(payload);
    } catch  {
        throw new (0, $1f4c9ae257e4ef19$export$936b39ada0bbfceb)("Failed to base64url decode the payload");
    }
    let result;
    try {
        result = JSON.parse((0, $3250a6ce6c4b6b55$export$124c96e6ce37090b).decode(decoded));
    } catch  {
        throw new (0, $1f4c9ae257e4ef19$export$936b39ada0bbfceb)("Failed to parse the decoded payload as JSON");
    }
    if (!(0, $52fc695f0f066c93$export$2e2bcd8739ae039)(result)) throw new (0, $1f4c9ae257e4ef19$export$936b39ada0bbfceb)("Invalid JWT Claims Set");
    return result;
}






async function $f123f4d0025a8805$export$25395fe8d170ad7(alg, options) {
    let length;
    let algorithm;
    let keyUsages;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            length = parseInt(alg.slice(-3), 10);
            algorithm = {
                name: "HMAC",
                hash: `SHA-${length}`,
                length: length
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            length = parseInt(alg.slice(-3), 10);
            return (0, $520f3d77678442a8$export$2e2bcd8739ae039)(new Uint8Array(length >> 3));
        case "A128KW":
        case "A192KW":
        case "A256KW":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-KW",
                length: length
            };
            keyUsages = [
                "wrapKey",
                "unwrapKey"
            ];
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-GCM",
                length: length
            };
            keyUsages = [
                "encrypt",
                "decrypt"
            ];
            break;
        default:
            throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.generateKey(algorithm, options?.extractable ?? false, keyUsages);
}
function $f123f4d0025a8805$var$getModulusLengthOption(options) {
    const modulusLength = options?.modulusLength ?? 2048;
    if (typeof modulusLength !== "number" || modulusLength < 2048) throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)("Invalid or unsupported modulusLength option provided, 2048 bits or larger keys must be used");
    return modulusLength;
}
async function $f123f4d0025a8805$export$a949d36eab55b41f(alg, options) {
    let algorithm;
    let keyUsages;
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $f123f4d0025a8805$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $f123f4d0025a8805$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $f123f4d0025a8805$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "decrypt",
                "unwrapKey",
                "encrypt",
                "wrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "EdDSA":
            keyUsages = [
                "sign",
                "verify"
            ];
            const crv = options?.crv ?? "Ed25519";
            switch(crv){
                case "Ed25519":
                case "Ed448":
                    algorithm = {
                        name: crv
                    };
                    break;
                default:
                    throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)("Invalid or unsupported crv option provided");
            }
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                keyUsages = [
                    "deriveKey",
                    "deriveBits"
                ];
                const crv = options?.crv ?? "P-256";
                switch(crv){
                    case "P-256":
                    case "P-384":
                    case "P-521":
                        algorithm = {
                            name: "ECDH",
                            namedCurve: crv
                        };
                        break;
                    case "X25519":
                    case "X448":
                        algorithm = {
                            name: crv
                        };
                        break;
                    default:
                        throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)("Invalid or unsupported crv option provided, supported values are P-256, P-384, P-521, X25519, and X448");
                }
                break;
            }
        default:
            throw new (0, $1f4c9ae257e4ef19$export$19ddbcbf2016ab28)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $427b2561bbdc2544$export$2e2bcd8739ae039).subtle.generateKey(algorithm, options?.extractable ?? false, keyUsages);
}


async function $dd549f1c045b2900$export$a949d36eab55b41f(alg, options) {
    return (0, $f123f4d0025a8805$export$a949d36eab55b41f)(alg, options);
}



async function $ebbc93e8b90a34eb$export$25395fe8d170ad7(alg, options) {
    return (0, $f123f4d0025a8805$export$25395fe8d170ad7)(alg, options);
}



var $a9cf97024c595e44$export$2e2bcd8739ae039 = "WebCryptoAPI";


var $394c91b59ee62389$export$2e2bcd8739ae039 = (0, $a9cf97024c595e44$export$2e2bcd8739ae039);






const $80e3eb1f1651da25$var$issuedAtTimeTolerance = 300; // 5 minutes
/* eslint-disable complexity */ /**
 * @link [ID Token](https://openid.net/specs/openid-connect-core-1_0.html#IDToken)
 */ function $80e3eb1f1651da25$var$assertIdTokenClaims(data) {
    if (!(0, $ac06e4ccadf0c108$export$aa016a295c6092c8)(data)) throw new TypeError("IdToken is expected to be an object");
    for (const key of [
        "iss",
        "sub",
        "aud"
    ]){
        if (typeof data[key] !== "string") throw new TypeError(`At path: IdToken.${key}: expected a string`);
    }
    for (const key of [
        "exp",
        "iat"
    ]){
        if (typeof data[key] !== "number") throw new TypeError(`At path: IdToken.${key}: expected a number`);
    }
    for (const key of [
        "at_hash",
        "name",
        "username",
        "picture",
        "email",
        "phone_number"
    ]){
        if (data[key] === undefined) continue;
        if (typeof data[key] !== "string" && data[key] !== null) throw new TypeError(`At path: IdToken.${key}: expected null or a string`);
    }
    for (const key of [
        "email_verified",
        "phone_number_verified"
    ]){
        if (data[key] === undefined) continue;
        if (typeof data[key] !== "boolean") throw new TypeError(`At path: IdToken.${key}: expected a boolean`);
    }
}
const $80e3eb1f1651da25$export$b5b3317c8aecbcd5 = async (idToken, clientId, issuer, jwks)=>{
    const result = await (0, $8765c16992919069$export$c878fd0f8381da51)(idToken, jwks, {
        audience: clientId,
        issuer: issuer
    });
    if (Math.abs((result.payload.iat ?? 0) - Date.now() / 1000) > $80e3eb1f1651da25$var$issuedAtTimeTolerance) throw new (0, $fd640d02b03b6808$export$ba60d77e6748b659)("id_token.invalid_iat");
};
const $80e3eb1f1651da25$export$aac2d5b7f5cd16d5 = (token)=>{
    const { 1: encodedPayload } = token.split(".");
    if (!encodedPayload) throw new (0, $fd640d02b03b6808$export$ba60d77e6748b659)("id_token.invalid_token");
    const json = (0, $c7073c91d133eb65$export$cf6f352aaefa956f).decode(encodedPayload);
    const idTokenClaims = JSON.parse(json);
    $80e3eb1f1651da25$var$assertIdTokenClaims(idTokenClaims);
    return idTokenClaims;
};


// https://docs.logto.io/docs/recipes/protect-your-api/


function $5a793170da887c78$var$assertAccessTokenClaims(data) {
    if (!(0, $ac06e4ccadf0c108$export$aa016a295c6092c8)(data)) throw new TypeError("AccessToken is expected to be an object");
    for (const key of [
        "jti",
        "iss",
        "sub",
        "aud",
        "client_id",
        "scope"
    ]){
        if (data[key] === undefined) continue;
        if (typeof data[key] !== "string" && data[key] !== null) throw new TypeError(`At path: AccessToken.${key}: expected null or a string`);
    }
    for (const key of [
        "exp",
        "iat"
    ]){
        if (data[key] === undefined) continue;
        if (typeof data[key] !== "number" && data[key] !== null) throw new TypeError(`At path: AccessToken.${key}: expected null or a number`);
    }
}
const $5a793170da887c78$export$1b57a6e65b75f5b3 = (accessToken)=>{
    const { 1: encodedPayload } = accessToken.split(".");
    if (!encodedPayload) // Non-JWT format token string
    return {};
    const json = (0, $c7073c91d133eb65$export$cf6f352aaefa956f).decode(encodedPayload);
    const accessTokenClaims = JSON.parse(json);
    $5a793170da887c78$var$assertAccessTokenClaims(accessTokenClaims);
    return accessTokenClaims;
};



const $6e02a1e92d309d63$export$3cf0748e30b766d7 = (originalScopes)=>{
    const reservedScopes = Object.values((0, $42336f286a2da162$export$1d2e82cebfd4b08));
    const uniqueScopes = new Set([
        ...reservedScopes,
        (0, $42336f286a2da162$export$4b02c5b431f6eb78).Profile,
        ...originalScopes ?? []
    ]);
    return Array.from(uniqueScopes).join(" ");
};





const $010f1c088aafdf62$var$codeChallengeMethod = "S256";
const $010f1c088aafdf62$var$responseType = "code";
const $010f1c088aafdf62$export$b01a187f12b774c6 = ({ authorizationEndpoint: authorizationEndpoint, clientId: clientId, redirectUri: redirectUri, codeChallenge: codeChallenge, state: state, scopes: scopes, resources: resources, prompt: prompt, interactionMode: interactionMode })=>{
    const urlSearchParameters = new URLSearchParams({
        [(0, $238718982990e066$export$65f63a8bc3cba53d).ClientId]: clientId,
        [(0, $238718982990e066$export$65f63a8bc3cba53d).RedirectUri]: redirectUri,
        [(0, $238718982990e066$export$65f63a8bc3cba53d).CodeChallenge]: codeChallenge,
        [(0, $238718982990e066$export$65f63a8bc3cba53d).CodeChallengeMethod]: $010f1c088aafdf62$var$codeChallengeMethod,
        [(0, $238718982990e066$export$65f63a8bc3cba53d).State]: state,
        [(0, $238718982990e066$export$65f63a8bc3cba53d).ResponseType]: $010f1c088aafdf62$var$responseType,
        [(0, $238718982990e066$export$65f63a8bc3cba53d).Prompt]: prompt ?? (0, $238718982990e066$export$83716a4aa1642908).Consent,
        [(0, $238718982990e066$export$65f63a8bc3cba53d).Scope]: (0, $6e02a1e92d309d63$export$3cf0748e30b766d7)(scopes)
    });
    for (const resource of resources ?? [])urlSearchParameters.append((0, $238718982990e066$export$65f63a8bc3cba53d).Resource, resource);
    // Set interactionMode to signUp for a create account user experience
    if (interactionMode) urlSearchParameters.append((0, $238718982990e066$export$65f63a8bc3cba53d).InteractionMode, interactionMode);
    return `${authorizationEndpoint}?${urlSearchParameters.toString()}`;
};



const $88a567ff2664cb17$export$b3c9a2bd2330de28 = ({ endSessionEndpoint: endSessionEndpoint, clientId: clientId, postLogoutRedirectUri: postLogoutRedirectUri })=>{
    const urlSearchParameters = new URLSearchParams({
        [(0, $238718982990e066$export$65f63a8bc3cba53d).ClientId]: clientId
    });
    if (postLogoutRedirectUri) urlSearchParameters.append((0, $238718982990e066$export$65f63a8bc3cba53d).PostLogoutRedirectUri, postLogoutRedirectUri);
    return `${endSessionEndpoint}?${urlSearchParameters.toString()}`;
};


const $8f0467e0ba7edd6b$export$eee09f98e5b044aa = async (userInfoEndpoint, accessToken, requester)=>requester(userInfoEndpoint, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });











const $e4fda73b9a11a820$export$670d48958e84d448 = (value)=>{
    if (value) return Array.isArray(value) ? value : [
        value
    ];
    return [];
};
// Disable FP rules here to use the performant approach while keep the function itself "FP"
/* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ const $e4fda73b9a11a820$export$76d90c956114f2c2 = (times, initial, iterate)=>{
    let result = initial;
    while(times--)result = iterate(result);
    return result;
};
/* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ const $e4fda73b9a11a820$export$6b75200e58bc97d0 = (array)=>[
        ...new Set(array)
    ];


// https://github.com/facebook/jest/issues/7547
const $d5fe648b7697ca73$export$a7a9523472993e97 = (value, error)=>{
    if (!value) // https://github.com/typescript-eslint/typescript-eslint/issues/3814
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw error;
};


// eslint-disable-next-line id-length
const $61e8f602a063eaca$var$compareFunction = (a, b)=>{
    if (typeof a === "string" && typeof b === "string") return a.localeCompare(b);
    if (typeof a === "number" && typeof b === "number") return a - b;
    if (typeof a === "boolean" && typeof b === "boolean") return Number(a) - Number(b);
    throw new Error("Unsupported compare type");
};
const $61e8f602a063eaca$export$12dc7a11e2f7584e = (array1, array2)=>{
    if (array1.length !== array2.length) return false;
    const sortedA = array1.slice().sort($61e8f602a063eaca$var$compareFunction);
    const sortedB = array2.slice().sort($61e8f602a063eaca$var$compareFunction);
    return sortedA.every((value, index)=>value === sortedB[index]);
};
// eslint-disable-next-line unicorn/prefer-native-coercion-functions
const $61e8f602a063eaca$export$ccb441c9c5feb3fc = (value)=>Boolean(value);
const $61e8f602a063eaca$export$b29ea735dcfba3c1 = (value)=>value !== null && value !== undefined;
const $61e8f602a063eaca$export$a4f4bb6b1453fff5 = (data, property)=>Object.prototype.hasOwnProperty.call(data, property);
const $61e8f602a063eaca$export$fb789885f1f64dd7 = (string)=>Boolean(/[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/.test(string));



const $323c277b5fb2675b$export$133fc36489ac9add = (exp)=>(0, $61e8f602a063eaca$export$ccb441c9c5feb3fc)(exp) ? exp : null;
const $323c277b5fb2675b$export$c327da55a124987a = (exp)=>(0, $61e8f602a063eaca$export$ccb441c9c5feb3fc)(exp) ? exp : undefined;
const $323c277b5fb2675b$export$78aa88a01782ee9d = (exp)=>(0, $61e8f602a063eaca$export$ccb441c9c5feb3fc)(exp) ? String(exp) : "";
const $323c277b5fb2675b$export$c96eff0e57d59a5e = (...exp)=>exp.filter((value)=>(0, $61e8f602a063eaca$export$ccb441c9c5feb3fc)(value)).flat();




// Browsers don't have `process`
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const $a5171176f3bcf04f$export$4bd44a2aa29d3d6e = (key, fallback = "")=>$cfae44f0dfdf62c0$exports?.env[key] ?? fallback;
const $a5171176f3bcf04f$export$912b126b3b8a9cf1 = (envKey, fallback = [])=>{
    const rawValue = $a5171176f3bcf04f$export$4bd44a2aa29d3d6e(envKey);
    if (!rawValue) return fallback;
    return rawValue.split(",").map((value)=>value.trim()).filter(Boolean);
};
const $a5171176f3bcf04f$export$9f11f28d727ba39d = (key)=>{
    // Browsers don't have `process`
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const value = $cfae44f0dfdf62c0$exports?.env[key];
    (0, $d5fe648b7697ca73$export$a7a9523472993e97)(value, new Error(`env variable ${key} not found`));
    return value;
};
const $a5171176f3bcf04f$export$8ee0fc9ee280b4ee = ()=>typeof window === "undefined";


// Intended
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $8b17e6f42de80032$export$8793edee2d425525 = ()=>{};
const $8b17e6f42de80032$export$4369c812aac99591 = (value)=>value !== null && (typeof value === "object" || typeof value === "function") && "then" in value && typeof value.then === "function";
const $8b17e6f42de80032$export$2cb2cb98cc670b59 = (exec, onError)=>{
    const handleError = (error)=>{
        if (onError instanceof Error) throw onError;
        return onError(error);
    };
    try {
        const unwrapped = typeof exec === "function" ? exec() : exec;
        return $8b17e6f42de80032$export$4369c812aac99591(unwrapped) ? unwrapped.catch(handleError) : unwrapped;
    } catch (error) {
        return handleError(error);
    }
};
const $8b17e6f42de80032$export$a3a27526e073307 = (exec, onError)=>{
    try {
        const unwrapped = typeof exec === "function" ? exec() : exec;
        return $8b17e6f42de80032$export$4369c812aac99591(unwrapped) ? unwrapped.catch((error)=>{
            onError?.(error);
        }) : unwrapped;
    } catch (error) {
        onError?.(error);
    }
};


const $178417b7af11b2b5$export$357523c63a2253b9 = (object, ...keys)=>{
    // eslint-disable-next-line no-restricted-syntax
    return Object.fromEntries(keys.map((key)=>[
            key,
            object[key]
        ]));
};
const $178417b7af11b2b5$export$42fd73f889ee4d63 = (...keys)=>(state)=>$178417b7af11b2b5$export$357523c63a2253b9(state, ...keys);



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $e735dd01980e6a97$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
function $e735dd01980e6a97$export$1294308be85b4eca(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    return string.toLowerCase().replace(/(?:^|\s|-)\S/g, (value)=>value.toUpperCase()).replace(/-/g, " ");
}
/**
 * RFC 4648 section 5: base64url (URL- and filename-safe standard)
 * @link https://datatracker.ietf.org/doc/html/rfc4648#section-5
 */ const $e735dd01980e6a97$var$replaceNonUrlSafeCharacters = (base64String)=>base64String.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
const $e735dd01980e6a97$var$restoreNonUrlSafeCharacters = (base64String)=>base64String.replace(/-/g, "+").replace(/_/g, "/");
const $e735dd01980e6a97$export$cf6f352aaefa956f = {
    isSafe: (input)=>/^[\w-]*$/.test(input),
    encode: (rawString)=>{
        const encodedString = (0, $a5171176f3bcf04f$export$8ee0fc9ee280b4ee)() ? $e735dd01980e6a97$require$Buffer.from(rawString, "utf8").toString("base64") : window.btoa(unescape(encodeURIComponent(rawString)));
        return $e735dd01980e6a97$var$replaceNonUrlSafeCharacters(encodedString);
    },
    decode: (encodedString)=>{
        const nonUrlSafeEncodedString = $e735dd01980e6a97$var$restoreNonUrlSafeCharacters(encodedString);
        return (0, $a5171176f3bcf04f$export$8ee0fc9ee280b4ee)() ? $e735dd01980e6a97$require$Buffer.from(nonUrlSafeEncodedString, "base64").toString("utf8") : decodeURIComponent(escape(window.atob(nonUrlSafeEncodedString)));
    },
    replaceNonUrlSafeCharacters: $e735dd01980e6a97$var$replaceNonUrlSafeCharacters,
    restoreNonUrlSafeCharacters: $e735dd01980e6a97$var$restoreNonUrlSafeCharacters
};
const $e735dd01980e6a97$export$7a668e70ea2210d9 = (value)=>// eslint-disable-next-line no-implicit-coercion
    !!value && [
        "1",
        "true",
        "y",
        "yes",
        "yep",
        "yeah"
    ].includes(value.toLowerCase());



const $0996c0e07f5b0971$export$3988ae62b71be9a3 = (object, keySerial)=>{
    if (object === null || typeof object !== "object") throw new TypeError("Non-object received in `get()`.");
    let result = object;
    for (const key of keySerial.split("."))// @ts-expect-error for performance
    result = result[key];
    return result;
};
const $0996c0e07f5b0971$export$fedb900c0ea4e699 = (...args)=>(0, $8b17e6f42de80032$export$a3a27526e073307)(()=>$0996c0e07f5b0971$export$3988ae62b71be9a3(...args));
/** Same to `get()` but with the strict type definition only to enable IntelliSense. */ const $0996c0e07f5b0971$export$bf7199a9ebcb84a9 = (object, keySerial)=>$0996c0e07f5b0971$export$3988ae62b71be9a3(object, keySerial);


/** Join multiple path segments. This function exists since there's no native implementation in browser. */ const $07402c01b41fb8cc$export$b891921babc70093 = (...segments)=>{
    const result = [];
    for (const segment of segments.join("/").split("/")){
        if (!segment || segment === ".") continue;
        if ([
            ...segment
        ].every((char)=>char === ".")) {
            // eslint-disable-next-line @silverhand/fp/no-mutating-methods
            result.pop();
            continue;
        }
        // eslint-disable-next-line @silverhand/fp/no-mutating-methods
        result.push(segment);
    }
    return "/" + result.join("/");
};
/** Append path segments to the base URL. */ const $07402c01b41fb8cc$export$c3cef1c0537c0eb2 = (baseUrl, ...pathnames)=>new URL($07402c01b41fb8cc$export$b891921babc70093(baseUrl.pathname, ...pathnames), baseUrl);


// eslint-disable-next-line @typescript-eslint/ban-types
const $24542960d269c891$export$a6cdc56e425d0d0a = (object)=>object !== null && typeof object === "object";
const $24542960d269c891$export$dd89c3a817f05bc7 = (object, key)=>$24542960d269c891$export$a6cdc56e425d0d0a(object) && key in object;




var $8807e1df92666ec7$export$ae0fd1fd1ad1c3f8;
(function(PersistKey) {
    PersistKey["IdToken"] = "idToken";
    PersistKey["RefreshToken"] = "refreshToken";
    PersistKey["AccessToken"] = "accessToken";
    PersistKey["SignInSession"] = "signInSession";
})($8807e1df92666ec7$export$ae0fd1fd1ad1c3f8 || ($8807e1df92666ec7$export$ae0fd1fd1ad1c3f8 = {}));
var $8807e1df92666ec7$export$2cb47d384c8dd787;
(function(CacheKey) {
    /**
   * OpenID Configuration endpoint response.
   *
   * @see {@link https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderConfigurationResponse | OpenID Connect Discovery 1.0}
   */ CacheKey["OpenidConfig"] = "openidConfiguration";
    /**
   * The content of OpenID Provider's `jwks_uri` (JSON Web Key Set).
   *
   * @see {@link https://openid.net/specs/openid-connect-discovery-1_0-21.html#ProviderMetadata | OpenID Connect Discovery 1.0}
   */ CacheKey["Jwks"] = "jwks";
})($8807e1df92666ec7$export$2cb47d384c8dd787 || ($8807e1df92666ec7$export$2cb47d384c8dd787 = {}));


class $ff23524311a972e4$export$63ca545e0fd86684 {
    /* END OF IMPLEMENTATION */ constructor(adapter){
        // eslint-disable-next-line @silverhand/fp/no-mutating-assign
        Object.assign(this, adapter);
    }
    async setStorageItem(key, value) {
        if (!value) {
            await this.storage.removeItem(key);
            return;
        }
        await this.storage.setItem(key, value);
    }
    /**
   * Try to get the string value from the cache and parse as JSON.
   * Return the parsed value if it is an object, return `undefined` otherwise.
   *
   * @param key The cache key to get value from.
   */ async getCachedObject(key) {
        const cached = await (0, $8b17e6f42de80032$export$a3a27526e073307)(async ()=>{
            const data = await this.unstable_cache?.getItem(key);
            // It's actually `unknown`
            // eslint-disable-next-line no-restricted-syntax
            return (0, $323c277b5fb2675b$export$c327da55a124987a)(data && JSON.parse(data));
        });
        if (cached && typeof cached === "object") // Trust cache for now
        // eslint-disable-next-line no-restricted-syntax
        return cached;
    }
    /**
   * Try to get the value from the cache first, if it doesn't exist in cache,
   * run the getter function and store the result into cache.
   *
   * @param key The cache key to get value from.
   */ async getWithCache(key, getter) {
        const cached = await this.getCachedObject(key);
        if (cached) return cached;
        const result = await getter();
        await this.unstable_cache?.setItem(key, JSON.stringify(result));
        return result;
    }
}



const $18f9e2a60b44480b$var$logtoClientErrorCodes = Object.freeze({
    "sign_in_session.invalid": "Invalid sign-in session.",
    "sign_in_session.not_found": "Sign-in session not found.",
    not_authenticated: "Not authenticated.",
    fetch_user_info_failed: "Unable to fetch user info. The access token may be invalid.",
    user_cancelled: "The user cancelled the action.",
    missing_scope_organizations: `The \`${(0, $42336f286a2da162$export$4b02c5b431f6eb78).Organizations}\` scope is required`
});
class $18f9e2a60b44480b$export$877962ca249b8fc8 extends Error {
    constructor(code, data){
        super($18f9e2a60b44480b$var$logtoClientErrorCodes[code]);
        this.name = "LogtoClientError";
        this.code = code;
        this.data = data;
    }
}





// Edited from jose's internal util `isJWKSLike`
function $b1192970f68ab408$var$isJwkSetLike(jwkSet) {
    return Boolean(jwkSet && typeof jwkSet === "object" && "keys" in jwkSet && Array.isArray(jwkSet.keys) && jwkSet.keys.every((element)=>(0, $24542960d269c891$export$a6cdc56e425d0d0a)(element)));
}
class $b1192970f68ab408$export$da08ef74d5a8d180 {
    constructor(url, adapter){
        this.url = url;
        this.adapter = adapter;
        if (!adapter.unstable_cache) throw new Error("No cache found in the client adapter. Use `createRemoteJWKSet()` from 'jose' instead.");
    }
    async getKey(...args) {
        if (!this.jwkSet) this.jwkSet = await this.#load();
        try {
            return await this.#getLocalKey(...args);
        } catch (error) {
            // Jose does not export the error definition
            // Found in https://github.com/panva/jose/blob/d5b3cb672736112b1e1e31ac4d5e9cd641675206/src/util/errors.ts#L347
            if (error instanceof Error && "code" in error && error.code === "ERR_JWKS_NO_MATCHING_KEY") {
                this.jwkSet = await this.#load();
                return this.#getLocalKey(...args);
            }
            throw error;
        }
    }
    async #load() {
        return this.adapter.getWithCache((0, $8807e1df92666ec7$export$2cb47d384c8dd787).Jwks, async ()=>{
            const controller = new AbortController();
            const response = await fetch(this.url, {
                signal: controller.signal,
                redirect: "manual"
            });
            if (!response.ok) throw new Error("Expected OK from the JSON Web Key Set HTTP response");
            const json = await response.json();
            if (!$b1192970f68ab408$var$isJwkSetLike(json)) throw new Error("JSON Web Key Set malformed");
            return json;
        });
    }
    async #getLocalKey(...args) {
        if (!this.jwkSet) throw new Error("No local JWK Set found.");
        return (0, $1ec9386fda8f5596$export$4892abc640e5f80e)(this.jwkSet)(...args);
    }
}




const $8a89cea90d4bd0b8$export$36dfb28a0f06fe9c = (config)=>{
    const { prompt: prompt = (0, $238718982990e066$export$83716a4aa1642908).Consent, scopes: scopes = [], resources: resources, ...rest } = config;
    return {
        ...rest,
        prompt: prompt,
        scopes: (0, $6e02a1e92d309d63$export$3cf0748e30b766d7)(scopes).split(" "),
        resources: scopes.includes((0, $42336f286a2da162$export$4b02c5b431f6eb78).Organizations) ? (0, $e4fda73b9a11a820$export$6b75200e58bc97d0)([
            ...resources ?? [],
            (0, $42336f286a2da162$export$36ba08a8e14b2df6).Organization
        ]) : resources
    };
};
const $8a89cea90d4bd0b8$export$5d8adf6e063019de = (data)=>{
    if (!(0, $ac06e4ccadf0c108$export$aa016a295c6092c8)(data)) return false;
    return [
        "redirectUri",
        "codeVerifier",
        "state"
    ].every((key)=>typeof data[key] === "string");
};
const $8a89cea90d4bd0b8$export$c12fab42a9a3e2a6 = (data)=>{
    if (!(0, $ac06e4ccadf0c108$export$aa016a295c6092c8)(data)) return false;
    return Object.values(data).every((value)=>{
        if (!(0, $ac06e4ccadf0c108$export$aa016a295c6092c8)(value)) return false;
        return typeof value.token === "string" && typeof value.scope === "string" && typeof value.expiresAt === "number";
    });
};





const $702016477b4aaa7f$export$8d54726fdbf08e0a = (fetchFunction)=>{
    return async (...args)=>{
        const response = await fetchFunction(...args);
        if (!response.ok) {
            const responseJson = await response.json();
            if (!(0, $fd640d02b03b6808$export$27f79c8238476d38)(responseJson)) throw new (0, $fd640d02b03b6808$export$ba60d77e6748b659)("unexpected_response_error", responseJson);
            // Expected request error from server
            const { code: code, message: message } = responseJson;
            throw new (0, $fd640d02b03b6808$export$e6e15b8ba42b9b70)(code, message);
        }
        return response.json();
    };
};


const $0dee27de543b74ef$export$8f595bd2a47bcea6 = (resource = "", organizationId, scopes = [])=>`${scopes.slice().sort().join(" ")}@${resource}${(0, $323c277b5fb2675b$export$78aa88a01782ee9d)(organizationId && `#${organizationId}`)}`;
const $0dee27de543b74ef$export$5d9c34f69c80822b = (endpoint)=>new URL((0, $ca3b2e038507e68c$export$815bda5ead26b243), endpoint).toString();


function $e7e27269353dc7fc$export$fc10aeed3a532e2a(run) {
    const promiseCache = new Map();
    const memoized = async function(...args) {
        const promiseKey = args[0];
        const cachedPromise = promiseCache.get(promiseKey);
        if (cachedPromise) return cachedPromise;
        const promise = (async ()=>{
            try {
                return await run.apply(this, args);
            } finally{
                promiseCache.delete(promiseKey);
            }
        })();
        promiseCache.set(promiseKey, promise);
        return promise;
    };
    return memoized;
}


function $a43ea61ce94ba3f7$export$d2de3aaeafa91619(function_) {
    let called = false;
    let result;
    return function(...args) {
        if (!called) {
            called = true;
            result = function_.apply(this, args);
        }
        return result;
    };
} /* eslint-enable @silverhand/fp/no-mutation */  /* eslint-enable @silverhand/fp/no-let */ 


class $f0726e0b21433b3a$export$2e2bcd8739ae039 {
    constructor(logtoConfig, adapter){
        /**
   * Get the OIDC configuration from the discovery endpoint. This method will
   * only fetch the configuration once and cache the result.
   */ this.getOidcConfig = (0, $a43ea61ce94ba3f7$export$d2de3aaeafa91619)(this.#getOidcConfig);
        /**
   * Get the access token from the storage with refresh strategy.
   *
   * - If the access token has expired, it will try to fetch a new one using the Refresh Token.
   * - If there's an ongoing Promise to fetch the access token, it will return the Promise.
   *
   * If you want to get the access token claims, use {@link getAccessTokenClaims} instead.
   *
   * @param resource The resource that the access token is granted for. If not
   * specified, the access token will be used for OpenID Connect or the default
   * resource, as specified in the Logto Console.
   * @returns The access token string.
   * @throws LogtoClientError if the user is not authenticated.
   */ this.getAccessToken = (0, $e7e27269353dc7fc$export$fc10aeed3a532e2a)(this.#getAccessToken);
        /**
   * Get the access token for the specified organization from the storage with refresh strategy.
   *
   * Scope {@link UserScope.Organizations} is required in the config to use organization-related
   * methods.
   *
   * @param organizationId The ID of the organization that the access token is granted for.
   * @returns The access token string.
   * @throws LogtoClientError if the user is not authenticated.
   * @remarks
   * It uses the same refresh strategy as {@link getAccessToken}.
   */ this.getOrganizationToken = (0, $e7e27269353dc7fc$export$fc10aeed3a532e2a)(this.#getOrganizationToken);
        /**
   * Handle the sign-in callback by parsing the authorization code from the
   * callback URI and exchanging it for the tokens.
   *
   * @param callbackUri The callback URI, including the search params, that the user is redirected to after the sign-in flow is completed.
   * The origin and pathname of this URI must match the origin and pathname of the redirect URI specified in {@link signIn}.
   * In many cases you'll probably end up passing `window.location.href` as the argument to this function.
   * @throws LogtoClientError if the sign-in session is not found.
   */ this.handleSignInCallback = (0, $e7e27269353dc7fc$export$fc10aeed3a532e2a)(this.#handleSignInCallback);
        this.getJwtVerifyGetKey = (0, $a43ea61ce94ba3f7$export$d2de3aaeafa91619)(this.#getJwtVerifyGetKey);
        this.accessTokenMap = new Map();
        this.logtoConfig = (0, $8a89cea90d4bd0b8$export$36dfb28a0f06fe9c)(logtoConfig);
        this.adapter = new (0, $ff23524311a972e4$export$63ca545e0fd86684)(adapter);
        this.loadAccessTokenMap();
    }
    /**
   * Check if the user is authenticated by checking if the ID token exists.
   */ async isAuthenticated() {
        return Boolean(await this.getIdToken());
    }
    /**
   * Get the Refresh Token from the storage.
   */ async getRefreshToken() {
        return this.adapter.storage.getItem("refreshToken");
    }
    /**
   * Get the ID Token from the storage. If you want to get the ID Token claims,
   * use {@link getIdTokenClaims} instead.
   */ async getIdToken() {
        return this.adapter.storage.getItem("idToken");
    }
    /**
   * Get the ID Token claims.
   */ async getIdTokenClaims() {
        const idToken = await this.getIdToken();
        if (!idToken) throw new (0, $18f9e2a60b44480b$export$877962ca249b8fc8)("not_authenticated");
        return (0, $80e3eb1f1651da25$export$aac2d5b7f5cd16d5)(idToken);
    }
    /**
   * Get the access token claims for the specified resource.
   *
   * @param resource The resource that the access token is granted for. If not
   * specified, the access token will be used for OpenID Connect or the default
   * resource, as specified in the Logto Console.
   */ async getAccessTokenClaims(resource) {
        const accessToken = await this.getAccessToken(resource);
        return (0, $5a793170da887c78$export$1b57a6e65b75f5b3)(accessToken);
    }
    /**
   * Get the organization token claims for the specified organization.
   *
   * @param organizationId The ID of the organization that the access token is granted for.
   */ async getOrganizationTokenClaims(organizationId) {
        const accessToken = await this.getOrganizationToken(organizationId);
        return (0, $5a793170da887c78$export$1b57a6e65b75f5b3)(accessToken);
    }
    /**
   * Get the user information from the Userinfo Endpoint.
   *
   * Note the Userinfo Endpoint will return more claims than the ID Token. See
   * {@link https://docs.logto.io/docs/recipes/integrate-logto/vanilla-js/#fetch-user-information | Fetch user information}
   * for more information.
   *
   * @returns The user information.
   * @throws LogtoClientError if the user is not authenticated.
   */ async fetchUserInfo() {
        const { userinfoEndpoint: userinfoEndpoint } = await this.getOidcConfig();
        const accessToken = await this.getAccessToken();
        if (!accessToken) throw new (0, $18f9e2a60b44480b$export$877962ca249b8fc8)("fetch_user_info_failed");
        return (0, $8f0467e0ba7edd6b$export$eee09f98e5b044aa)(userinfoEndpoint, accessToken, this.adapter.requester);
    }
    /**
   * Start the sign-in flow with the specified redirect URI. The URI must be
   * registered in the Logto Console.
   *
   * The user will be redirected to that URI after the sign-in flow is completed,
   * and the client will be able to get the authorization code from the URI.
   * To fetch the tokens from the authorization code, use {@link handleSignInCallback}
   * after the user is redirected in the callback URI.
   *
   * @param redirectUri The redirect URI that the user will be redirected to after the sign-in flow is completed.
   * @param interactionMode The interaction mode to be used for the authorization request. Note it's not
   * a part of the OIDC standard, but a Logto-specific extension. Defaults to `signIn`.
   *
   * @see {@link https://docs.logto.io/docs/recipes/integrate-logto/vanilla-js/#sign-in | Sign in} for more information.
   * @see {@link InteractionMode}
   */ async signIn(redirectUri, interactionMode) {
        const { appId: clientId, prompt: prompt, resources: resources, scopes: scopes } = this.logtoConfig;
        const { authorizationEndpoint: authorizationEndpoint } = await this.getOidcConfig();
        const codeVerifier = this.adapter.generateCodeVerifier();
        const codeChallenge = await this.adapter.generateCodeChallenge(codeVerifier);
        const state = this.adapter.generateState();
        const signInUri = (0, $010f1c088aafdf62$export$b01a187f12b774c6)({
            authorizationEndpoint: authorizationEndpoint,
            clientId: clientId,
            redirectUri: redirectUri,
            codeChallenge: codeChallenge,
            state: state,
            scopes: scopes,
            resources: resources,
            prompt: prompt,
            interactionMode: interactionMode
        });
        await Promise.all([
            this.setSignInSession({
                redirectUri: redirectUri,
                codeVerifier: codeVerifier,
                state: state
            }),
            this.setRefreshToken(null),
            this.setIdToken(null)
        ]);
        await this.adapter.navigate(signInUri);
    }
    /**
   * Check if the user is redirected from the sign-in page by checking if the
   * current URL matches the redirect URI in the sign-in session.
   *
   * If there's no sign-in session, it will return `false`.
   *
   * @param url The current URL.
   */ async isSignInRedirected(url) {
        const signInSession = await this.getSignInSession();
        if (!signInSession) return false;
        const { redirectUri: redirectUri } = signInSession;
        const { origin: origin, pathname: pathname } = new URL(url);
        return `${origin}${pathname}` === redirectUri;
    }
    /**
   * Start the sign-out flow with the specified redirect URI. The URI must be
   * registered in the Logto Console.
   *
   * It will also revoke all the tokens and clean up the storage.
   *
   * The user will be redirected that URI after the sign-out flow is completed.
   * If the `postLogoutRedirectUri` is not specified, the user will be redirected
   * to a default page.
   */ async signOut(postLogoutRedirectUri) {
        const { appId: clientId } = this.logtoConfig;
        const { endSessionEndpoint: endSessionEndpoint, revocationEndpoint: revocationEndpoint } = await this.getOidcConfig();
        const refreshToken = await this.getRefreshToken();
        if (refreshToken) try {
            await (0, $1e317dee172ec983$export$573f8dbbf6fbef75)(revocationEndpoint, clientId, refreshToken, this.adapter.requester);
        } catch  {
        // Do nothing at this point, as we don't want to break the sign-out flow even if the revocation is failed
        }
        const url = (0, $88a567ff2664cb17$export$b3c9a2bd2330de28)({
            endSessionEndpoint: endSessionEndpoint,
            postLogoutRedirectUri: postLogoutRedirectUri,
            clientId: clientId
        });
        this.accessTokenMap.clear();
        await Promise.all([
            this.setRefreshToken(null),
            this.setIdToken(null),
            this.adapter.storage.removeItem("accessToken")
        ]);
        await this.adapter.navigate(url);
    }
    async getSignInSession() {
        const jsonItem = await this.adapter.storage.getItem("signInSession");
        if (!jsonItem) return null;
        const item = JSON.parse(jsonItem);
        if (!(0, $8a89cea90d4bd0b8$export$5d8adf6e063019de)(item)) throw new (0, $18f9e2a60b44480b$export$877962ca249b8fc8)("sign_in_session.invalid");
        return item;
    }
    async setSignInSession(value) {
        return this.adapter.setStorageItem((0, $8807e1df92666ec7$export$ae0fd1fd1ad1c3f8).SignInSession, value && JSON.stringify(value));
    }
    async setIdToken(value) {
        return this.adapter.setStorageItem((0, $8807e1df92666ec7$export$ae0fd1fd1ad1c3f8).IdToken, value);
    }
    async setRefreshToken(value) {
        return this.adapter.setStorageItem((0, $8807e1df92666ec7$export$ae0fd1fd1ad1c3f8).RefreshToken, value);
    }
    async getAccessTokenByRefreshToken(resource, organizationId) {
        const currentRefreshToken = await this.getRefreshToken();
        if (!currentRefreshToken) throw new (0, $18f9e2a60b44480b$export$877962ca249b8fc8)("not_authenticated");
        const accessTokenKey = (0, $0dee27de543b74ef$export$8f595bd2a47bcea6)(resource, organizationId);
        const { appId: clientId } = this.logtoConfig;
        const { tokenEndpoint: tokenEndpoint } = await this.getOidcConfig();
        const requestedAt = Math.round(Date.now() / 1000);
        const { accessToken: accessToken, refreshToken: refreshToken, idToken: idToken, scope: scope, expiresIn: expiresIn } = await (0, $a915d9bd754b9637$export$9909137b467efb8b)({
            clientId: clientId,
            tokenEndpoint: tokenEndpoint,
            refreshToken: currentRefreshToken,
            resource: resource,
            organizationId: organizationId
        }, this.adapter.requester);
        this.accessTokenMap.set(accessTokenKey, {
            token: accessToken,
            scope: scope,
            /** The `expiresAt` variable provides an approximate estimation of the actual `exp` property
       * in the token claims. It is utilized by the client to determine if the cached access token
       * has expired and when a new access token should be requested.
       */ expiresAt: requestedAt + expiresIn
        });
        await this.saveAccessTokenMap();
        if (refreshToken) await this.setRefreshToken(refreshToken);
        if (idToken) {
            await this.verifyIdToken(idToken);
            await this.setIdToken(idToken);
        }
        return accessToken;
    }
    async verifyIdToken(idToken) {
        const { appId: appId } = this.logtoConfig;
        const { issuer: issuer } = await this.getOidcConfig();
        const jwtVerifyGetKey = await this.getJwtVerifyGetKey();
        await (0, $80e3eb1f1651da25$export$b5b3317c8aecbcd5)(idToken, appId, issuer, jwtVerifyGetKey);
    }
    async saveAccessTokenMap() {
        const data = {};
        for (const [key, accessToken] of this.accessTokenMap.entries())// eslint-disable-next-line @silverhand/fp/no-mutation
        data[key] = accessToken;
        await this.adapter.storage.setItem("accessToken", JSON.stringify(data));
    }
    async loadAccessTokenMap() {
        const raw = await this.adapter.storage.getItem("accessToken");
        if (!raw) return;
        try {
            const json = JSON.parse(raw);
            if (!(0, $8a89cea90d4bd0b8$export$c12fab42a9a3e2a6)(json)) return;
            this.accessTokenMap.clear();
            for (const [key, accessToken] of Object.entries(json))this.accessTokenMap.set(key, accessToken);
        } catch (error) {
            console.warn(error);
        }
    }
    async #getOidcConfig() {
        return this.adapter.getWithCache((0, $8807e1df92666ec7$export$2cb47d384c8dd787).OpenidConfig, async ()=>{
            return (0, $ca3b2e038507e68c$export$98242d8e822ad11f)((0, $0dee27de543b74ef$export$5d9c34f69c80822b)(this.logtoConfig.endpoint), this.adapter.requester);
        });
    }
    async #getJwtVerifyGetKey() {
        const { jwksUri: jwksUri } = await this.getOidcConfig();
        if (!this.adapter.unstable_cache) return (0, $2a1b2c5057ffefe6$export$78ce35c2df51c333)(new URL(jwksUri));
        const cachedJwkSet = new (0, $b1192970f68ab408$export$da08ef74d5a8d180)(new URL(jwksUri), this.adapter);
        return async (...args)=>cachedJwkSet.getKey(...args);
    }
    async #getAccessToken(resource, organizationId) {
        if (!await this.isAuthenticated()) throw new (0, $18f9e2a60b44480b$export$877962ca249b8fc8)("not_authenticated");
        const accessTokenKey = (0, $0dee27de543b74ef$export$8f595bd2a47bcea6)(resource, organizationId);
        const accessToken = this.accessTokenMap.get(accessTokenKey);
        if (accessToken && accessToken.expiresAt > Date.now() / 1000) return accessToken.token;
        // Since the access token has expired, delete it from the map.
        if (accessToken) this.accessTokenMap.delete(accessTokenKey);
        /**
     * Need to fetch a new access token using refresh token.
     */ return this.getAccessTokenByRefreshToken(resource, organizationId);
    }
    async #getOrganizationToken(organizationId) {
        if (!this.logtoConfig.scopes?.includes((0, $42336f286a2da162$export$4b02c5b431f6eb78).Organizations)) throw new (0, $18f9e2a60b44480b$export$877962ca249b8fc8)("missing_scope_organizations");
        return this.#getAccessToken(undefined, organizationId);
    }
    async #handleSignInCallback(callbackUri) {
        const { requester: requester } = this.adapter;
        const signInSession = await this.getSignInSession();
        if (!signInSession) throw new (0, $18f9e2a60b44480b$export$877962ca249b8fc8)("sign_in_session.not_found");
        const { redirectUri: redirectUri, state: state, codeVerifier: codeVerifier } = signInSession;
        const code = (0, $64c8c47b3f912d4b$export$dc3fae3c99763885)(callbackUri, redirectUri, state);
        // NOTE: Will add scope to accessTokenKey when needed. (Linear issue LOG-1589)
        const accessTokenKey = (0, $0dee27de543b74ef$export$8f595bd2a47bcea6)();
        const { appId: clientId } = this.logtoConfig;
        const { tokenEndpoint: tokenEndpoint } = await this.getOidcConfig();
        const requestedAt = Math.round(Date.now() / 1000);
        const { idToken: idToken, refreshToken: refreshToken, accessToken: accessToken, scope: scope, expiresIn: expiresIn } = await (0, $a915d9bd754b9637$export$684f740cd70532d4)({
            clientId: clientId,
            tokenEndpoint: tokenEndpoint,
            redirectUri: redirectUri,
            codeVerifier: codeVerifier,
            code: code
        }, requester);
        await this.verifyIdToken(idToken);
        await this.setRefreshToken(refreshToken ?? null);
        await this.setIdToken(idToken);
        this.accessTokenMap.set(accessTokenKey, {
            token: accessToken,
            scope: scope,
            /** The `expiresAt` variable provides an approximate estimation of the actual `exp` property
       * in the token claims. It is utilized by the client to determine if the cached access token
       * has expired and when a new access token should be requested.
       */ expiresAt: requestedAt + expiresIn
        });
        await this.saveAccessTokenMap();
        await this.setSignInSession(null);
    }
} /* eslint-enable max-lines */ 



const $fc41e73cd6ea3d17$var$keyPrefix = `logto_cache`;
class $fc41e73cd6ea3d17$export$2b715f8922748263 {
    constructor(appId){
        this.appId = appId;
    }
    getKey(item) {
        if (item === undefined) return `${$fc41e73cd6ea3d17$var$keyPrefix}:${this.appId}`;
        return `${$fc41e73cd6ea3d17$var$keyPrefix}:${this.appId}:${item}`;
    }
    async getItem(key) {
        return sessionStorage.getItem(this.getKey(key));
    }
    async setItem(key, value) {
        sessionStorage.setItem(this.getKey(key), value);
    }
    async removeItem(key) {
        sessionStorage.removeItem(`${this.getKey(key)}`);
    }
}


const $6260f848271ed60d$var$keyPrefix = `logto`;
class $6260f848271ed60d$export$2baa60fa09b100be {
    constructor(appId){
        this.appId = appId;
    }
    getKey(item) {
        if (item === undefined) return `${$6260f848271ed60d$var$keyPrefix}:${this.appId}`;
        return `${$6260f848271ed60d$var$keyPrefix}:${this.appId}:${item}`;
    }
    async getItem(key) {
        if (key === "signInSession") // The latter `getItem()` is for backward compatibility. Can be removed when major bump.
        return sessionStorage.getItem(this.getKey(key)) ?? sessionStorage.getItem(this.getKey());
        return localStorage.getItem(this.getKey(key));
    }
    async setItem(key, value) {
        if (key === "signInSession") {
            sessionStorage.setItem(this.getKey(key), value);
            return;
        }
        localStorage.setItem(this.getKey(key), value);
    }
    async removeItem(key) {
        if (key === "signInSession") {
            sessionStorage.removeItem(this.getKey(key));
            return;
        }
        localStorage.removeItem(this.getKey(key));
    }
}


/** @link [Proof Key for Code Exchange by OAuth Public Clients](https://datatracker.ietf.org/doc/html/rfc7636) */ 
/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */ 
var $e2d47df0036b0170$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
const $e2d47df0036b0170$export$83d89fbfd8236492 = "3.7.4";
/**
 * @deprecated use lowercase `version`.
 */ const $e2d47df0036b0170$export$a4ad2735b021c132 = $e2d47df0036b0170$export$83d89fbfd8236492;
const $e2d47df0036b0170$var$_hasatob = typeof atob === "function";
const $e2d47df0036b0170$var$_hasbtoa = typeof btoa === "function";
const $e2d47df0036b0170$var$_hasBuffer = typeof $e2d47df0036b0170$require$Buffer === "function";
const $e2d47df0036b0170$var$_TD = typeof TextDecoder === "function" ? new TextDecoder() : undefined;
const $e2d47df0036b0170$var$_TE = typeof TextEncoder === "function" ? new TextEncoder() : undefined;
const $e2d47df0036b0170$var$b64ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
const $e2d47df0036b0170$var$b64chs = Array.prototype.slice.call($e2d47df0036b0170$var$b64ch);
const $e2d47df0036b0170$var$b64tab = ((a)=>{
    let tab = {};
    a.forEach((c, i)=>tab[c] = i);
    return tab;
})($e2d47df0036b0170$var$b64chs);
const $e2d47df0036b0170$var$b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const $e2d47df0036b0170$var$_fromCC = String.fromCharCode.bind(String);
const $e2d47df0036b0170$var$_U8Afrom = typeof Uint8Array.from === "function" ? Uint8Array.from.bind(Uint8Array) : (it, fn = (x)=>x)=>new Uint8Array(Array.prototype.slice.call(it, 0).map(fn));
const $e2d47df0036b0170$var$_mkUriSafe = (src)=>src.replace(/=/g, "").replace(/[+\/]/g, (m0)=>m0 == "+" ? "-" : "_");
const $e2d47df0036b0170$var$_tidyB64 = (s)=>s.replace(/[^A-Za-z0-9\+\/]/g, "");
/**
 * polyfill version of `btoa`
 */ const $e2d47df0036b0170$export$ec0fb543302ee251 = (bin)=>{
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = "";
    const pad = bin.length % 3;
    for(let i = 0; i < bin.length;){
        if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255) throw new TypeError("invalid character found");
        u32 = c0 << 16 | c1 << 8 | c2;
        asc += $e2d47df0036b0170$var$b64chs[u32 >> 18 & 63] + $e2d47df0036b0170$var$b64chs[u32 >> 12 & 63] + $e2d47df0036b0170$var$b64chs[u32 >> 6 & 63] + $e2d47df0036b0170$var$b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */ const $e2d47df0036b0170$export$a32219e24f8d1e2 = $e2d47df0036b0170$var$_hasbtoa ? (bin)=>btoa(bin) : $e2d47df0036b0170$var$_hasBuffer ? (bin)=>$e2d47df0036b0170$require$Buffer.from(bin, "binary").toString("base64") : $e2d47df0036b0170$export$ec0fb543302ee251;
const $e2d47df0036b0170$var$_fromUint8Array = $e2d47df0036b0170$var$_hasBuffer ? (u8a)=>$e2d47df0036b0170$require$Buffer.from(u8a).toString("base64") : (u8a)=>{
    // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
    const maxargs = 0x1000;
    let strs = [];
    for(let i = 0, l = u8a.length; i < l; i += maxargs)strs.push($e2d47df0036b0170$var$_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
    return $e2d47df0036b0170$export$a32219e24f8d1e2(strs.join(""));
};
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */ const $e2d47df0036b0170$export$27bbb4e040978768 = (u8a, urlsafe = false)=>urlsafe ? $e2d47df0036b0170$var$_mkUriSafe($e2d47df0036b0170$var$_fromUint8Array(u8a)) : $e2d47df0036b0170$var$_fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const $e2d47df0036b0170$var$cb_utob = (c)=>{
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c : cc < 0x800 ? $e2d47df0036b0170$var$_fromCC(0xc0 | cc >>> 6) + $e2d47df0036b0170$var$_fromCC(0x80 | cc & 0x3f) : $e2d47df0036b0170$var$_fromCC(0xe0 | cc >>> 12 & 0x0f) + $e2d47df0036b0170$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $e2d47df0036b0170$var$_fromCC(0x80 | cc & 0x3f);
    } else {
        var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
        return $e2d47df0036b0170$var$_fromCC(0xf0 | cc >>> 18 & 0x07) + $e2d47df0036b0170$var$_fromCC(0x80 | cc >>> 12 & 0x3f) + $e2d47df0036b0170$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $e2d47df0036b0170$var$_fromCC(0x80 | cc & 0x3f);
    }
};
const $e2d47df0036b0170$var$re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */ const $e2d47df0036b0170$export$10d4b9bd20a66b0 = (u)=>u.replace($e2d47df0036b0170$var$re_utob, $e2d47df0036b0170$var$cb_utob);
//
const $e2d47df0036b0170$var$_encode = $e2d47df0036b0170$var$_hasBuffer ? (s)=>$e2d47df0036b0170$require$Buffer.from(s, "utf8").toString("base64") : $e2d47df0036b0170$var$_TE ? (s)=>$e2d47df0036b0170$var$_fromUint8Array($e2d47df0036b0170$var$_TE.encode(s)) : (s)=>$e2d47df0036b0170$export$a32219e24f8d1e2($e2d47df0036b0170$export$10d4b9bd20a66b0(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */ const $e2d47df0036b0170$export$37cc283d8fbd3462 = (src, urlsafe = false)=>urlsafe ? $e2d47df0036b0170$var$_mkUriSafe($e2d47df0036b0170$var$_encode(src)) : $e2d47df0036b0170$var$_encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */ const $e2d47df0036b0170$export$90c31d5baa78df44 = (src)=>$e2d47df0036b0170$export$37cc283d8fbd3462(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const $e2d47df0036b0170$var$re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const $e2d47df0036b0170$var$cb_btou = (cccc)=>{
    switch(cccc.length){
        case 4:
            var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
            return $e2d47df0036b0170$var$_fromCC((offset >>> 10) + 0xD800) + $e2d47df0036b0170$var$_fromCC((offset & 0x3FF) + 0xDC00);
        case 3:
            return $e2d47df0036b0170$var$_fromCC((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
        default:
            return $e2d47df0036b0170$var$_fromCC((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */ const $e2d47df0036b0170$export$67e9defdeac3dd95 = (b)=>b.replace($e2d47df0036b0170$var$re_btou, $e2d47df0036b0170$var$cb_btou);
/**
 * polyfill version of `atob`
 */ const $e2d47df0036b0170$export$7f16d8e674ddec24 = (asc)=>{
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, "");
    if (!$e2d47df0036b0170$var$b64re.test(asc)) throw new TypeError("malformed base64.");
    asc += "==".slice(2 - (asc.length & 3));
    let u24, bin = "", r1, r2;
    for(let i = 0; i < asc.length;){
        u24 = $e2d47df0036b0170$var$b64tab[asc.charAt(i++)] << 18 | $e2d47df0036b0170$var$b64tab[asc.charAt(i++)] << 12 | (r1 = $e2d47df0036b0170$var$b64tab[asc.charAt(i++)]) << 6 | (r2 = $e2d47df0036b0170$var$b64tab[asc.charAt(i++)]);
        bin += r1 === 64 ? $e2d47df0036b0170$var$_fromCC(u24 >> 16 & 255) : r2 === 64 ? $e2d47df0036b0170$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255) : $e2d47df0036b0170$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
    }
    return bin;
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */ const $e2d47df0036b0170$export$1406ac7a6dfd7b7a = $e2d47df0036b0170$var$_hasatob ? (asc)=>atob($e2d47df0036b0170$var$_tidyB64(asc)) : $e2d47df0036b0170$var$_hasBuffer ? (asc)=>$e2d47df0036b0170$require$Buffer.from(asc, "base64").toString("binary") : $e2d47df0036b0170$export$7f16d8e674ddec24;
//
const $e2d47df0036b0170$var$_toUint8Array = $e2d47df0036b0170$var$_hasBuffer ? (a)=>$e2d47df0036b0170$var$_U8Afrom($e2d47df0036b0170$require$Buffer.from(a, "base64")) : (a)=>$e2d47df0036b0170$var$_U8Afrom($e2d47df0036b0170$export$1406ac7a6dfd7b7a(a), (c)=>c.charCodeAt(0));
/**
 * converts a Base64 string to a Uint8Array.
 */ const $e2d47df0036b0170$export$73470fd2221e6aef = (a)=>$e2d47df0036b0170$var$_toUint8Array($e2d47df0036b0170$var$_unURI(a));
//
const $e2d47df0036b0170$var$_decode = $e2d47df0036b0170$var$_hasBuffer ? (a)=>$e2d47df0036b0170$require$Buffer.from(a, "base64").toString("utf8") : $e2d47df0036b0170$var$_TD ? (a)=>$e2d47df0036b0170$var$_TD.decode($e2d47df0036b0170$var$_toUint8Array(a)) : (a)=>$e2d47df0036b0170$export$67e9defdeac3dd95($e2d47df0036b0170$export$1406ac7a6dfd7b7a(a));
const $e2d47df0036b0170$var$_unURI = (a)=>$e2d47df0036b0170$var$_tidyB64(a.replace(/[-_]/g, (m0)=>m0 == "-" ? "+" : "/"));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */ const $e2d47df0036b0170$export$c537b38001c583b7 = (src)=>$e2d47df0036b0170$var$_decode($e2d47df0036b0170$var$_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */ const $e2d47df0036b0170$export$1ea939691cdc45b8 = (src)=>{
    if (typeof src !== "string") return false;
    const s = src.replace(/\s+/g, "").replace(/={0,2}$/, "");
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const $e2d47df0036b0170$var$_noEnum = (v)=>{
    return {
        value: v,
        enumerable: false,
        writable: true,
        configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */ const $e2d47df0036b0170$export$4678ebf2295c49b = function() {
    const _add = (name, body)=>Object.defineProperty(String.prototype, name, $e2d47df0036b0170$var$_noEnum(body));
    _add("fromBase64", function() {
        return $e2d47df0036b0170$export$c537b38001c583b7(this);
    });
    _add("toBase64", function(urlsafe) {
        return $e2d47df0036b0170$export$37cc283d8fbd3462(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $e2d47df0036b0170$export$37cc283d8fbd3462(this, true);
    });
    _add("toBase64URL", function() {
        return $e2d47df0036b0170$export$37cc283d8fbd3462(this, true);
    });
    _add("toUint8Array", function() {
        return $e2d47df0036b0170$export$73470fd2221e6aef(this);
    });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */ const $e2d47df0036b0170$export$a105d6a15258bd2 = function() {
    const _add = (name, body)=>Object.defineProperty(Uint8Array.prototype, name, $e2d47df0036b0170$var$_noEnum(body));
    _add("toBase64", function(urlsafe) {
        return $e2d47df0036b0170$export$27bbb4e040978768(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $e2d47df0036b0170$export$27bbb4e040978768(this, true);
    });
    _add("toBase64URL", function() {
        return $e2d47df0036b0170$export$27bbb4e040978768(this, true);
    });
};
/**
 * extend Builtin prototypes with relevant methods
 */ const $e2d47df0036b0170$export$1abf1fe5ebfd5245 = ()=>{
    $e2d47df0036b0170$export$4678ebf2295c49b();
    $e2d47df0036b0170$export$a105d6a15258bd2();
};
const $e2d47df0036b0170$export$f436b0c2107cbd35 = {
    version: $e2d47df0036b0170$export$83d89fbfd8236492,
    VERSION: $e2d47df0036b0170$export$a4ad2735b021c132,
    atob: $e2d47df0036b0170$export$1406ac7a6dfd7b7a,
    atobPolyfill: $e2d47df0036b0170$export$7f16d8e674ddec24,
    btoa: $e2d47df0036b0170$export$a32219e24f8d1e2,
    btoaPolyfill: $e2d47df0036b0170$export$ec0fb543302ee251,
    fromBase64: $e2d47df0036b0170$export$c537b38001c583b7,
    toBase64: $e2d47df0036b0170$export$37cc283d8fbd3462,
    encode: $e2d47df0036b0170$export$37cc283d8fbd3462,
    encodeURI: $e2d47df0036b0170$export$90c31d5baa78df44,
    encodeURL: $e2d47df0036b0170$export$90c31d5baa78df44,
    utob: $e2d47df0036b0170$export$10d4b9bd20a66b0,
    btou: $e2d47df0036b0170$export$67e9defdeac3dd95,
    decode: $e2d47df0036b0170$export$c537b38001c583b7,
    isValid: $e2d47df0036b0170$export$1ea939691cdc45b8,
    fromUint8Array: $e2d47df0036b0170$export$27bbb4e040978768,
    toUint8Array: $e2d47df0036b0170$export$73470fd2221e6aef,
    extendString: $e2d47df0036b0170$export$4678ebf2295c49b,
    extendUint8Array: $e2d47df0036b0170$export$a105d6a15258bd2,
    extendBuiltins: $e2d47df0036b0170$export$1abf1fe5ebfd5245
};


/**
 * @param length The length of the raw random data.
 */ const $4cda3d6ed7b1b903$var$generateRandomString = (length = 64)=>(0, $e2d47df0036b0170$export$27bbb4e040978768)(crypto.getRandomValues(new Uint8Array(length)), true);
const $4cda3d6ed7b1b903$export$9ccd2716e53a229b = ()=>$4cda3d6ed7b1b903$var$generateRandomString();
const $4cda3d6ed7b1b903$export$cf1891f923f5943a = ()=>$4cda3d6ed7b1b903$var$generateRandomString();
const $4cda3d6ed7b1b903$export$414b01b1f867308a = async (codeVerifier)=>{
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (crypto.subtle === undefined) /**
     * `crypto.subtle` is available only in secure contexts (HTTPS) in some or all supporting browsers,
     * https://developer.mozilla.org/en-US/docs/Web/API/Crypto/subtle
     * https://www.chromium.org/blink/webcrypto/#accessing-it
     */ throw new (0, $fd640d02b03b6808$export$ba60d77e6748b659)("crypto_subtle_unavailable");
    const encodedCodeVerifier = new TextEncoder().encode(codeVerifier);
    const codeChallenge = new Uint8Array(await crypto.subtle.digest("SHA-256", encodedCodeVerifier));
    return (0, $e2d47df0036b0170$export$27bbb4e040978768)(codeChallenge, true);
};


const $c2a11d0f23cf31ea$var$navigate = (url)=>{
    window.location.assign(url);
};
class $c2a11d0f23cf31ea$export$2e2bcd8739ae039 extends (0, $f0726e0b21433b3a$export$2e2bcd8739ae039) {
    /**
   * @param config The configuration object for the client.
   * @param [unstable_enableCache=false] Whether to enable cache for well-known data.
   * Use sessionStorage by default.
   */ constructor(config, unstable_enableCache = false){
        const requester = (0, $702016477b4aaa7f$export$8d54726fdbf08e0a)(fetch);
        super(config, {
            requester: requester,
            navigate: $c2a11d0f23cf31ea$var$navigate,
            storage: new (0, $6260f848271ed60d$export$2baa60fa09b100be)(config.appId),
            unstable_cache: (0, $323c277b5fb2675b$export$c327da55a124987a)(unstable_enableCache && new (0, $fc41e73cd6ea3d17$export$2b715f8922748263)(config.appId)),
            generateCodeChallenge: $4cda3d6ed7b1b903$export$414b01b1f867308a,
            generateCodeVerifier: $4cda3d6ed7b1b903$export$cf1891f923f5943a,
            generateState: $4cda3d6ed7b1b903$export$9ccd2716e53a229b
        });
    }
}





var $lx97N = parcelRequire("lx97N");

var $lx97N = parcelRequire("lx97N");
const $5b81d9afe4b60291$export$838ead842aa548e7 = ()=>{
    throw new Error("Must be used inside <LogtoProvider> context.");
};
const $5b81d9afe4b60291$export$e5bf247804b97da7 = /*#__PURE__*/ (0, $lx97N.createContext)({
    logtoClient: undefined,
    isAuthenticated: false,
    loadingCount: 0,
    error: undefined,
    setIsAuthenticated: $5b81d9afe4b60291$export$838ead842aa548e7,
    setLoadingCount: $5b81d9afe4b60291$export$838ead842aa548e7,
    setError: $5b81d9afe4b60291$export$838ead842aa548e7
});


const $5f0f3d3fc023d078$export$bfa587c2c3245948 = ({ config: config, children: children, unstable_enableCache: unstable_enableCache = false })=>{
    const [loadingCount, setLoadingCount] = (0, $lx97N.useState)(1);
    const memorizedLogtoClient = (0, $lx97N.useMemo)(()=>({
            logtoClient: new (0, $c2a11d0f23cf31ea$export$2e2bcd8739ae039)(config, unstable_enableCache)
        }), [
        config,
        unstable_enableCache
    ]);
    const [isAuthenticated, setIsAuthenticated] = (0, $lx97N.useState)(false);
    const [error, setError] = (0, $lx97N.useState)();
    (0, $lx97N.useEffect)(()=>{
        (async ()=>{
            const isAuthenticated = await memorizedLogtoClient.logtoClient.isAuthenticated();
            setIsAuthenticated(isAuthenticated);
            setLoadingCount((count)=>Math.max(0, count - 1));
        })();
    }, [
        memorizedLogtoClient
    ]);
    const memorizedContextValue = (0, $lx97N.useMemo)(()=>({
            ...memorizedLogtoClient,
            isAuthenticated: isAuthenticated,
            setIsAuthenticated: setIsAuthenticated,
            loadingCount: loadingCount,
            setLoadingCount: setLoadingCount,
            error: error,
            setError: setError
        }), [
        memorizedLogtoClient,
        isAuthenticated,
        loadingCount,
        error
    ]);
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $5b81d9afe4b60291$export$e5bf247804b97da7).Provider, {
        value: memorizedContextValue,
        children: children
    });
};




var $lx97N = parcelRequire("lx97N");

const $98efe4d430c47d44$var$useLoadingState = ()=>{
    const { loadingCount: loadingCount, setLoadingCount: setLoadingCount } = (0, $lx97N.useContext)((0, $5b81d9afe4b60291$export$e5bf247804b97da7));
    const isLoading = loadingCount > 0;
    const setLoadingState = (0, $lx97N.useCallback)((state)=>{
        if (state) setLoadingCount((count)=>count + 1);
        else setLoadingCount((count)=>Math.max(0, count - 1));
    }, [
        setLoadingCount
    ]);
    return {
        isLoading: isLoading,
        setLoadingState: setLoadingState
    };
};
const $98efe4d430c47d44$var$useErrorHandler = ()=>{
    const { setError: setError } = (0, $lx97N.useContext)((0, $5b81d9afe4b60291$export$e5bf247804b97da7));
    const handleError = (0, $lx97N.useCallback)((error, fallbackErrorMessage)=>{
        if (error instanceof Error) setError(error);
        else if (fallbackErrorMessage) setError(new Error(fallbackErrorMessage));
        console.error(error);
    }, [
        setError
    ]);
    return {
        handleError: handleError
    };
};
const $98efe4d430c47d44$export$84e88c4b3c082374 = (callback)=>{
    const { logtoClient: logtoClient, isAuthenticated: isAuthenticated, error: error, setIsAuthenticated: setIsAuthenticated } = (0, $lx97N.useContext)((0, $5b81d9afe4b60291$export$e5bf247804b97da7));
    const { isLoading: isLoading, setLoadingState: setLoadingState } = $98efe4d430c47d44$var$useLoadingState();
    const { handleError: handleError } = $98efe4d430c47d44$var$useErrorHandler();
    const callbackRef = (0, $lx97N.useRef)();
    (0, $lx97N.useEffect)(()=>{
        // eslint-disable-next-line @silverhand/fp/no-mutation
        callbackRef.current = callback; // Update ref to the latest callback.
    }, [
        callback
    ]);
    (0, $lx97N.useEffect)(()=>{
        if (!logtoClient || isLoading || error) return;
        (async ()=>{
            const currentPageUrl = window.location.href;
            const isRedirected = await logtoClient.isSignInRedirected(currentPageUrl);
            if (!isAuthenticated && isRedirected) {
                setLoadingState(true);
                await (0, $8b17e6f42de80032$export$a3a27526e073307)(async ()=>{
                    await logtoClient.handleSignInCallback(currentPageUrl);
                    setIsAuthenticated(true);
                    callbackRef.current?.();
                }, (error)=>{
                    handleError(error, "Unexpected error occurred while handling sign in callback.");
                });
                setLoadingState(false);
            }
        })();
    }, [
        error,
        handleError,
        isAuthenticated,
        isLoading,
        logtoClient,
        setIsAuthenticated,
        setLoadingState
    ]);
    return {
        isLoading: isLoading,
        isAuthenticated: isAuthenticated,
        error: error
    };
};
const $98efe4d430c47d44$export$44fc9df4d2a1789a = ()=>{
    const { logtoClient: logtoClient, loadingCount: loadingCount, isAuthenticated: isAuthenticated, error: error } = (0, $lx97N.useContext)((0, $5b81d9afe4b60291$export$e5bf247804b97da7));
    const { setLoadingState: setLoadingState } = $98efe4d430c47d44$var$useLoadingState();
    const { handleError: handleError } = $98efe4d430c47d44$var$useErrorHandler();
    const isLoading = loadingCount > 0;
    const client = logtoClient ?? (0, $5b81d9afe4b60291$export$838ead842aa548e7)();
    const proxy = (0, $lx97N.useCallback)((run, resetLoadingState = true)=>{
        return async (...args)=>{
            try {
                setLoadingState(true);
                return await run(...args);
            } catch (error) {
                handleError(error, `Unexpected error occurred while calling ${run.name}.`);
            } finally{
                if (resetLoadingState) setLoadingState(false);
            }
        };
    }, [
        setLoadingState,
        handleError
    ]);
    const methods = (0, $lx97N.useMemo)(()=>({
            getRefreshToken: proxy(client.getRefreshToken.bind(client)),
            getAccessToken: proxy(client.getAccessToken.bind(client)),
            getAccessTokenClaims: proxy(client.getAccessTokenClaims.bind(client)),
            getOrganizationToken: proxy(client.getOrganizationToken.bind(client)),
            getOrganizationTokenClaims: proxy(client.getOrganizationTokenClaims.bind(client)),
            getIdToken: proxy(client.getIdToken.bind(client)),
            getIdTokenClaims: proxy(client.getIdTokenClaims.bind(client)),
            signIn: proxy(client.signIn.bind(client), false),
            // We deliberately do NOT set isAuthenticated to false in the function below, because the app state
            // may change immediately even before navigating to the oidc end session endpoint, which might cause
            // rendering problems.
            // Moreover, since the location will be redirected, the isAuthenticated state will not matter any more.
            signOut: proxy(client.signOut.bind(client)),
            fetchUserInfo: proxy(client.fetchUserInfo.bind(client))
        }), [
        client,
        proxy
    ]);
    return {
        isAuthenticated: isAuthenticated,
        isLoading: isLoading,
        error: error,
        ...methods
    };
};




/**
 * React Router DOM v6.2.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lx97N = parcelRequire("lx97N");
function $e133885d0b1e9831$export$2e2bcd8739ae039() {
    $e133885d0b1e9831$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e133885d0b1e9831$export$2e2bcd8739ae039.apply(this, arguments);
}


/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $be565bd757fdf8fd$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($be565bd757fdf8fd$export$e19cd5f9376f8cee || ($be565bd757fdf8fd$export$e19cd5f9376f8cee = {}));
var $be565bd757fdf8fd$var$readOnly = function(obj) {
    return obj;
};
function $be565bd757fdf8fd$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $be565bd757fdf8fd$var$BeforeUnloadEventType = "beforeunload";
var $be565bd757fdf8fd$var$HashChangeEventType = "hashchange";
var $be565bd757fdf8fd$var$PopStateEventType = "popstate";
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $be565bd757fdf8fd$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $be565bd757fdf8fd$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($be565bd757fdf8fd$var$PopStateEventType, handlePop);
    var action = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $be565bd757fdf8fd$var$createEvents();
    var blockers = $be565bd757fdf8fd$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $e133885d0b1e9831$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function createHref(to) {
        return typeof to === "string" ? to : $be565bd757fdf8fd$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $be565bd757fdf8fd$var$readOnly((0, $e133885d0b1e9831$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $be565bd757fdf8fd$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $be565bd757fdf8fd$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($be565bd757fdf8fd$var$BeforeUnloadEventType, $be565bd757fdf8fd$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($be565bd757fdf8fd$var$BeforeUnloadEventType, $be565bd757fdf8fd$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $be565bd757fdf8fd$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $be565bd757fdf8fd$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? "/" : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? "" : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? "" : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $be565bd757fdf8fd$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($be565bd757fdf8fd$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($be565bd757fdf8fd$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($be565bd757fdf8fd$export$fe53371bee54353d(nextLocation) !== $be565bd757fdf8fd$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $be565bd757fdf8fd$var$createEvents();
    var blockers = $be565bd757fdf8fd$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $e133885d0b1e9831$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getBaseHref() {
        var base = document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + "#" + (typeof to === "string" ? to : $be565bd757fdf8fd$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $be565bd757fdf8fd$var$readOnly((0, $e133885d0b1e9831$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $be565bd757fdf8fd$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $be565bd757fdf8fd$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($be565bd757fdf8fd$var$BeforeUnloadEventType, $be565bd757fdf8fd$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($be565bd757fdf8fd$var$BeforeUnloadEventType, $be565bd757fdf8fd$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $be565bd757fdf8fd$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        "/"
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $be565bd757fdf8fd$var$readOnly((0, $e133885d0b1e9831$export$2e2bcd8739ae039)({
            pathname: "/",
            search: "",
            hash: "",
            state: null,
            key: $be565bd757fdf8fd$var$createKey()
        }, typeof entry === "string" ? $be565bd757fdf8fd$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $be565bd757fdf8fd$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $be565bd757fdf8fd$var$createEvents();
    var blockers = $be565bd757fdf8fd$var$createEvents();
    function createHref(to) {
        return typeof to === "string" ? to : $be565bd757fdf8fd$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $be565bd757fdf8fd$var$readOnly((0, $e133885d0b1e9831$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            search: "",
            hash: ""
        }, typeof to === "string" ? $be565bd757fdf8fd$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $be565bd757fdf8fd$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $be565bd757fdf8fd$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $be565bd757fdf8fd$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $be565bd757fdf8fd$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $be565bd757fdf8fd$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = "";
}
function $be565bd757fdf8fd$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $be565bd757fdf8fd$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $be565bd757fdf8fd$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? "/" : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? "" : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? "" : _ref$hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $be565bd757fdf8fd$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}


/**
 * React Router v6.2.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lx97N = parcelRequire("lx97N");

function $946ebc92e8ce61a6$var$invariant(cond, message) {
    if (!cond) throw new Error(message);
}
function $946ebc92e8ce61a6$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
const $946ebc92e8ce61a6$var$alreadyWarned = {};
function $946ebc92e8ce61a6$var$warningOnce(key, cond, message) {
    if (!cond && !$946ebc92e8ce61a6$var$alreadyWarned[key]) $946ebc92e8ce61a6$var$alreadyWarned[key] = true;
} ///////////////////////////////////////////////////////////////////////////////
// CONTEXT
///////////////////////////////////////////////////////////////////////////////
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $946ebc92e8ce61a6$export$26749e8557646306 = /*#__PURE__*/ (0, $lx97N.createContext)(null);
const $946ebc92e8ce61a6$export$c7914228fb69b0f5 = /*#__PURE__*/ (0, $lx97N.createContext)(null);
const $946ebc92e8ce61a6$export$9072aa6dd1f93057 = /*#__PURE__*/ (0, $lx97N.createContext)({
    outlet: null,
    matches: []
});
// COMPONENTS
///////////////////////////////////////////////////////////////////////////////
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/docs/en/v6/api#memoryrouter
 */ function $946ebc92e8ce61a6$export$ae46f04cfaffe093(_ref) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref;
    let historyRef = (0, $lx97N.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $be565bd757fdf8fd$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex
    });
    let history = historyRef.current;
    let [state, setState] = (0, $lx97N.useState)({
        action: history.action,
        location: history.location
    });
    (0, $lx97N.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $lx97N.createElement)($946ebc92e8ce61a6$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/docs/en/v6/api#navigate
 */ function $946ebc92e8ce61a6$export$444b3ab0cb9aec40(_ref2) {
    let { to: to, replace: replace, state: state } = _ref2;
    !$946ebc92e8ce61a6$export$9c954a9d03d32f4a() && $946ebc92e8ce61a6$var$invariant(false);
    let navigate = $946ebc92e8ce61a6$export$9770f232ac06a008();
    (0, $lx97N.useEffect)(()=>{
        navigate(to, {
            replace: replace,
            state: state
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/docs/en/v6/api#outlet
 */ function $946ebc92e8ce61a6$export$910ae8079b2c2852(props) {
    return $946ebc92e8ce61a6$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/docs/en/v6/api#route
 */ function $946ebc92e8ce61a6$export$e7b0ac011bb776c6(_props) {
    $946ebc92e8ce61a6$var$invariant(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/docs/en/v6/api#router
 */ function $946ebc92e8ce61a6$export$55185c17a0fcbe46(_ref3) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $be565bd757fdf8fd$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref3;
    !!$946ebc92e8ce61a6$export$9c954a9d03d32f4a() && $946ebc92e8ce61a6$var$invariant(false);
    let basename = $946ebc92e8ce61a6$var$normalizePathname(basenameProp);
    let navigationContext = (0, $lx97N.useMemo)(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $be565bd757fdf8fd$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let location = (0, $lx97N.useMemo)(()=>{
        let trailingPathname = $946ebc92e8ce61a6$var$stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            pathname: trailingPathname,
            search: search,
            hash: hash,
            state: state,
            key: key
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key
    ]);
    if (location == null) return null;
    return /*#__PURE__*/ (0, $lx97N.createElement)($946ebc92e8ce61a6$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ (0, $lx97N.createElement)($946ebc92e8ce61a6$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: {
            location: location,
            navigationType: navigationType
        }
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#routes
 */ function $946ebc92e8ce61a6$export$3565eb3d00ca5a74(_ref4) {
    let { children: children, location: location } = _ref4;
    return $946ebc92e8ce61a6$export$5d3fca4a98652595($946ebc92e8ce61a6$export$16da398f5434bdec(children), location);
} ///////////////////////////////////////////////////////////////////////////////
// HOOKS
///////////////////////////////////////////////////////////////////////////////
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usehref
 */ function $946ebc92e8ce61a6$export$b66bb29c5006f12f(to) {
    !$946ebc92e8ce61a6$export$9c954a9d03d32f4a() && $946ebc92e8ce61a6$var$invariant(false);
    let { basename: basename, navigator: navigator } = (0, $lx97N.useContext)($946ebc92e8ce61a6$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $946ebc92e8ce61a6$export$e75d2a2d1b3c245b(to);
    let joinedPathname = pathname;
    if (basename !== "/") {
        let toPathname = $946ebc92e8ce61a6$var$getToPathname(to);
        let endsWithSlash = toPathname != null && toPathname.endsWith("/");
        joinedPathname = pathname === "/" ? basename + (endsWithSlash ? "/" : "") : $946ebc92e8ce61a6$var$joinPaths([
            basename,
            pathname
        ]);
    }
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useinroutercontext
 */ function $946ebc92e8ce61a6$export$9c954a9d03d32f4a() {
    return (0, $lx97N.useContext)($946ebc92e8ce61a6$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/docs/en/v6/api#uselocation
 */ function $946ebc92e8ce61a6$export$45d76561a5302f2b() {
    !$946ebc92e8ce61a6$export$9c954a9d03d32f4a() && $946ebc92e8ce61a6$var$invariant(false);
    return (0, $lx97N.useContext)($946ebc92e8ce61a6$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usenavigationtype
 */ function $946ebc92e8ce61a6$export$1b3f31771c5d07c() {
    return (0, $lx97N.useContext)($946ebc92e8ce61a6$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns true if the URL for the given "to" value matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usematch
 */ function $946ebc92e8ce61a6$export$6c330e8992e8a295(pattern) {
    !$946ebc92e8ce61a6$export$9c954a9d03d32f4a() && $946ebc92e8ce61a6$var$invariant(false);
    let { pathname: pathname } = $946ebc92e8ce61a6$export$45d76561a5302f2b();
    return (0, $lx97N.useMemo)(()=>$946ebc92e8ce61a6$export$81336c211d5ff295(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usenavigate
 */ function $946ebc92e8ce61a6$export$9770f232ac06a008() {
    !$946ebc92e8ce61a6$export$9c954a9d03d32f4a() && $946ebc92e8ce61a6$var$invariant(false);
    let { basename: basename, navigator: navigator } = (0, $lx97N.useContext)($946ebc92e8ce61a6$export$26749e8557646306);
    let { matches: matches } = (0, $lx97N.useContext)($946ebc92e8ce61a6$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $946ebc92e8ce61a6$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify(matches.map((match)=>match.pathnameBase));
    let activeRef = (0, $lx97N.useRef)(false);
    (0, $lx97N.useEffect)(()=>{
        activeRef.current = true;
    });
    let navigate = (0, $lx97N.useCallback)(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $946ebc92e8ce61a6$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname);
        if (basename !== "/") path.pathname = $946ebc92e8ce61a6$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $946ebc92e8ce61a6$var$OutletContext = /*#__PURE__*/ (0, $lx97N.createContext)(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/docs/en/v6/api#useoutletcontext
 */ function $946ebc92e8ce61a6$export$4138103a3ae699cc() {
    return (0, $lx97N.useContext)($946ebc92e8ce61a6$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useoutlet
 */ function $946ebc92e8ce61a6$export$a3be3530d8e40d0b(context) {
    let outlet = (0, $lx97N.useContext)($946ebc92e8ce61a6$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ (0, $lx97N.createElement)($946ebc92e8ce61a6$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useparams
 */ function $946ebc92e8ce61a6$export$99eaa27ddbbb95ef() {
    let { matches: matches } = (0, $lx97N.useContext)($946ebc92e8ce61a6$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useresolvedpath
 */ function $946ebc92e8ce61a6$export$e75d2a2d1b3c245b(to) {
    let { matches: matches } = (0, $lx97N.useContext)($946ebc92e8ce61a6$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $946ebc92e8ce61a6$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify(matches.map((match)=>match.pathnameBase));
    return (0, $lx97N.useMemo)(()=>$946ebc92e8ce61a6$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname), [
        to,
        routePathnamesJson,
        locationPathname
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useroutes
 */ function $946ebc92e8ce61a6$export$5d3fca4a98652595(routes, locationArg) {
    !$946ebc92e8ce61a6$export$9c954a9d03d32f4a() && $946ebc92e8ce61a6$var$invariant(false);
    let { matches: parentMatches } = (0, $lx97N.useContext)($946ebc92e8ce61a6$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $946ebc92e8ce61a6$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $be565bd757fdf8fd$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && $946ebc92e8ce61a6$var$invariant(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = $946ebc92e8ce61a6$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    return $946ebc92e8ce61a6$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $946ebc92e8ce61a6$var$joinPaths([
                parentPathnameBase,
                match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $946ebc92e8ce61a6$var$joinPaths([
                parentPathnameBase,
                match.pathnameBase
            ])
        })), parentMatches);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/docs/en/v6/api#createroutesfromchildren
 */ function $946ebc92e8ce61a6$export$16da398f5434bdec(children) {
    let routes = [];
    (0, $lx97N.Children).forEach(children, (element)=>{
        if (!/*#__PURE__*/ (0, $lx97N.isValidElement)(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        if (element.type === (0, $lx97N.Fragment)) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $946ebc92e8ce61a6$export$16da398f5434bdec(element.props.children));
            return;
        }
        !(element.type === $946ebc92e8ce61a6$export$e7b0ac011bb776c6) && $946ebc92e8ce61a6$var$invariant(false);
        let route = {
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            index: element.props.index,
            path: element.props.path
        };
        if (element.props.children) route.children = $946ebc92e8ce61a6$export$16da398f5434bdec(element.props.children);
        routes.push(route);
    });
    return routes;
}
/**
 * The parameters that were parsed from the URL path.
 */ /**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/docs/en/v6/api#generatepath
 */ function $946ebc92e8ce61a6$export$82476f982757e71e(path, params) {
    if (params === void 0) params = {};
    return path.replace(/:(\w+)/g, (_, key)=>{
        !(params[key] != null) && $946ebc92e8ce61a6$var$invariant(false);
        return params[key];
    }).replace(/\/*\*$/, (_)=>params["*"] == null ? "" : params["*"].replace(/^\/*/, "/"));
}
/**
 * A RouteMatch contains info about how a route matched a URL.
 */ /**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/docs/en/v6/api#matchroutes
 */ function $946ebc92e8ce61a6$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? (0, $be565bd757fdf8fd$export$8ccf933b0513f8d0)(locationArg) : locationArg;
    let pathname = $946ebc92e8ce61a6$var$stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $946ebc92e8ce61a6$var$flattenRoutes(routes);
    $946ebc92e8ce61a6$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $946ebc92e8ce61a6$var$matchRouteBranch(branches[i], pathname);
    return matches;
}
function $946ebc92e8ce61a6$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    routes.forEach((route, index)=>{
        let meta = {
            relativePath: route.path || "",
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            !meta.relativePath.startsWith(parentPath) && $946ebc92e8ce61a6$var$invariant(false);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $946ebc92e8ce61a6$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            !(route.index !== true) && $946ebc92e8ce61a6$var$invariant(false);
            $946ebc92e8ce61a6$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $946ebc92e8ce61a6$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    });
    return branches;
}
function $946ebc92e8ce61a6$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $946ebc92e8ce61a6$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $946ebc92e8ce61a6$var$paramRe = /^:\w+$/;
const $946ebc92e8ce61a6$var$dynamicSegmentValue = 3;
const $946ebc92e8ce61a6$var$indexRouteValue = 2;
const $946ebc92e8ce61a6$var$emptySegmentValue = 1;
const $946ebc92e8ce61a6$var$staticSegmentValue = 10;
const $946ebc92e8ce61a6$var$splatPenalty = -2;
const $946ebc92e8ce61a6$var$isSplat = (s)=>s === "*";
function $946ebc92e8ce61a6$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($946ebc92e8ce61a6$var$isSplat)) initialScore += $946ebc92e8ce61a6$var$splatPenalty;
    if (index) initialScore += $946ebc92e8ce61a6$var$indexRouteValue;
    return segments.filter((s)=>!$946ebc92e8ce61a6$var$isSplat(s)).reduce((score, segment)=>score + ($946ebc92e8ce61a6$var$paramRe.test(segment) ? $946ebc92e8ce61a6$var$dynamicSegmentValue : segment === "" ? $946ebc92e8ce61a6$var$emptySegmentValue : $946ebc92e8ce61a6$var$staticSegmentValue), initialScore);
}
function $946ebc92e8ce61a6$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $946ebc92e8ce61a6$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $946ebc92e8ce61a6$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            params: matchedParams,
            pathname: $946ebc92e8ce61a6$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $946ebc92e8ce61a6$var$normalizePathname($946ebc92e8ce61a6$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $946ebc92e8ce61a6$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $946ebc92e8ce61a6$export$daf73786167a7f72(matches) {
    return $946ebc92e8ce61a6$var$_renderMatches(matches);
}
function $946ebc92e8ce61a6$var$_renderMatches(matches, parentMatches) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) return null;
    return matches.reduceRight((outlet, match, index)=>{
        return /*#__PURE__*/ (0, $lx97N.createElement)($946ebc92e8ce61a6$export$9072aa6dd1f93057.Provider, {
            children: match.route.element !== undefined ? match.route.element : outlet,
            value: {
                outlet: outlet,
                matches: parentMatches.concat(matches.slice(0, index + 1))
            }
        });
    }, null);
}
/**
 * A PathPattern is used to match on some portion of a URL pathname.
 */ /**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/docs/en/v6/api#matchpath
 */ function $946ebc92e8ce61a6$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $946ebc92e8ce61a6$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $946ebc92e8ce61a6$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $946ebc92e8ce61a6$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else regexpSource += end ? "\\/*$" // When matching to the end, ignore trailing slashes
     : // parent routes to matching only their own words and nothing more, e.g. parent
    // route "/home" should not match "/home2".
    // Additionally, allow paths starting with `.`, `-`, `~`, and url-encoded entities,
    // but do not consume the character in the matched path so they can match against
    // nested paths.
    "(?:(?=[.~-]|%[0-9A-F]{2})|\\b|\\/|$)";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $946ebc92e8ce61a6$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/docs/en/v6/api#resolvepath
 */ function $946ebc92e8ce61a6$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $be565bd757fdf8fd$export$8ccf933b0513f8d0)(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $946ebc92e8ce61a6$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $946ebc92e8ce61a6$var$normalizeSearch(search),
        hash: $946ebc92e8ce61a6$var$normalizeHash(hash)
    };
}
function $946ebc92e8ce61a6$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $946ebc92e8ce61a6$var$resolveTo(toArg, routePathnames, locationPathname) {
    let to = typeof toArg === "string" ? (0, $be565bd757fdf8fd$export$8ccf933b0513f8d0)(toArg) : toArg;
    let toPathname = toArg === "" || to.pathname === "" ? "/" : to.pathname; // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $946ebc92e8ce61a6$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original to value had one.
    if (toPathname && toPathname !== "/" && toPathname.endsWith("/") && !path.pathname.endsWith("/")) path.pathname += "/";
    return path;
}
function $946ebc92e8ce61a6$var$getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? (0, $be565bd757fdf8fd$export$8ccf933b0513f8d0)(to).pathname : to.pathname;
}
function $946ebc92e8ce61a6$var$stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let nextChar = pathname.charAt(basename.length);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(basename.length) || "/";
}
const $946ebc92e8ce61a6$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
const $946ebc92e8ce61a6$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
const $946ebc92e8ce61a6$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $946ebc92e8ce61a6$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash; ///////////////////////////////////////////////////////////////////////////////


function $09f8f45067289bca$var$_extends() {
    $09f8f45067289bca$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $09f8f45067289bca$var$_extends.apply(this, arguments);
}
function $09f8f45067289bca$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $09f8f45067289bca$var$_excluded = [
    "onClick",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to"
], $09f8f45067289bca$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
];
function $09f8f45067289bca$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
} ////////////////////////////////////////////////////////////////////////////////
// COMPONENTS
////////////////////////////////////////////////////////////////////////////////
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $09f8f45067289bca$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window } = _ref;
    let historyRef = (0, $lx97N.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $be565bd757fdf8fd$export$719fc203c4e16dee)({
        window: window
    });
    let history = historyRef.current;
    let [state, setState] = (0, $lx97N.useState)({
        action: history.action,
        location: history.location
    });
    (0, $lx97N.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $lx97N.createElement)((0, $946ebc92e8ce61a6$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $09f8f45067289bca$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window } = _ref2;
    let historyRef = (0, $lx97N.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $be565bd757fdf8fd$export$b71fdd3798280242)({
        window: window
    });
    let history = historyRef.current;
    let [state, setState] = (0, $lx97N.useState)({
        action: history.action,
        location: history.location
    });
    (0, $lx97N.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $lx97N.createElement)((0, $946ebc92e8ce61a6$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $09f8f45067289bca$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = (0, $lx97N.useState)({
        action: history.action,
        location: history.location
    });
    (0, $lx97N.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $lx97N.createElement)((0, $946ebc92e8ce61a6$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $09f8f45067289bca$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */ const $09f8f45067289bca$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $lx97N.forwardRef)(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, reloadDocument: reloadDocument, replace: replace = false, state: state, target: target, to: to } = _ref4, rest = $09f8f45067289bca$var$_objectWithoutPropertiesLoose(_ref4, $09f8f45067289bca$var$_excluded);
    let href = (0, $946ebc92e8ce61a6$export$b66bb29c5006f12f)(to);
    let internalOnClick = $09f8f45067289bca$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented && !reloadDocument) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    (0, $lx97N.createElement)("a", $09f8f45067289bca$var$_extends({}, rest, {
        href: href,
        onClick: handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $09f8f45067289bca$export$b0d92dbee9b5b60d = /*#__PURE__*/ (0, $lx97N.forwardRef)(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $09f8f45067289bca$var$_objectWithoutPropertiesLoose(_ref5, $09f8f45067289bca$var$_excluded2);
    let location = (0, $946ebc92e8ce61a6$export$45d76561a5302f2b)();
    let path = (0, $946ebc92e8ce61a6$export$e75d2a2d1b3c245b)(to);
    let locationPathname = location.pathname;
    let toPathname = path.pathname;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive
    }) : styleProp;
    return /*#__PURE__*/ (0, $lx97N.createElement)($09f8f45067289bca$export$a6c7ac8248d6e38a, $09f8f45067289bca$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive
    }) : children);
});
// HOOKS
////////////////////////////////////////////////////////////////////////////////
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $09f8f45067289bca$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $946ebc92e8ce61a6$export$9770f232ac06a008)();
    let location = (0, $946ebc92e8ce61a6$export$45d76561a5302f2b)();
    let path = (0, $946ebc92e8ce61a6$export$e75d2a2d1b3c245b)(to);
    return (0, $lx97N.useCallback)((event)=>{
        if (event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
        !$09f8f45067289bca$var$isModifiedEvent(event) // Ignore clicks with modifier keys
        ) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here.
            let replace = !!replaceProp || (0, $be565bd757fdf8fd$export$fe53371bee54353d)(location) === (0, $be565bd757fdf8fd$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $09f8f45067289bca$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = (0, $lx97N.useRef)($09f8f45067289bca$export$a2e4e2dcc7b1f22f(defaultInit));
    let location = (0, $946ebc92e8ce61a6$export$45d76561a5302f2b)();
    let searchParams = (0, $lx97N.useMemo)(()=>{
        let searchParams = $09f8f45067289bca$export$a2e4e2dcc7b1f22f(location.search);
        for (let key of defaultSearchParamsRef.current.keys())if (!searchParams.has(key)) defaultSearchParamsRef.current.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
        return searchParams;
    }, [
        location.search
    ]);
    let navigate = (0, $946ebc92e8ce61a6$export$9770f232ac06a008)();
    let setSearchParams = (0, $lx97N.useCallback)((nextInit, navigateOptions)=>{
        navigate("?" + $09f8f45067289bca$export$a2e4e2dcc7b1f22f(nextInit), navigateOptions);
    }, [
        navigate
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $09f8f45067289bca$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}





var $lx97N = parcelRequire("lx97N");

const $d14a0f9d339bbbaf$export$a135e81e9a047f61 = window.location.origin;
const $d14a0f9d339bbbaf$export$8bd32f43e6170583 = `${$d14a0f9d339bbbaf$export$a135e81e9a047f61}/callback`;
const $d14a0f9d339bbbaf$export$e0cbbd86f88a6ea5 = "4va65wlazq2rpe4dg42lk"; // Register the sample app in Logto dashboard
const $d14a0f9d339bbbaf$export$125e2b775860041f = "https://vt9dp4.logto.app/"; // Replace with your own Logto endpoint


const $e0620eb245dda77e$var$RequireAuth = ()=>{
    const { isAuthenticated: isAuthenticated, isLoading: isLoading, signIn: signIn } = (0, $98efe4d430c47d44$export$44fc9df4d2a1789a)();
    (0, $lx97N.useEffect)(()=>{
        if (!isAuthenticated && !isLoading) signIn((0, $d14a0f9d339bbbaf$export$8bd32f43e6170583));
    }, [
        isAuthenticated,
        isLoading,
        signIn
    ]);
    return isAuthenticated ? /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $946ebc92e8ce61a6$export$910ae8079b2c2852), {}) : /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
        children: "Not authenticated"
    });
};
var $e0620eb245dda77e$export$2e2bcd8739ae039 = $e0620eb245dda77e$var$RequireAuth;






const $8b52a37a2af3b9f8$var$Callback = ()=>{
    const navigate = (0, $946ebc92e8ce61a6$export$9770f232ac06a008)();
    const { isLoading: isLoading } = (0, $98efe4d430c47d44$export$84e88c4b3c082374)(()=>{
        navigate("/");
    });
    return isLoading ? /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
        children: "Redirecting..."
    }) : null;
};
var $8b52a37a2af3b9f8$export$2e2bcd8739ae039 = $8b52a37a2af3b9f8$var$Callback;





var $lx97N = parcelRequire("lx97N");


var $0817af759030d67d$export$2ba01fb71ed41cb6;
var $0817af759030d67d$export$34e0f9847d4c02dd;
var $0817af759030d67d$export$9852986a3ec5f6a0;
$0817af759030d67d$export$2ba01fb71ed41cb6 = `c_pAGa_button`;
$0817af759030d67d$export$34e0f9847d4c02dd = `c_pAGa_container`;
$0817af759030d67d$export$9852986a3ec5f6a0 = `c_pAGa_table`;


const $239c2f742b0923a5$var$Home = ()=>{
    const { isAuthenticated: isAuthenticated, signIn: signIn, signOut: signOut, fetchUserInfo: fetchUserInfo } = (0, $98efe4d430c47d44$export$44fc9df4d2a1789a)();
    const [user, setUser] = (0, $lx97N.useState)();
    (0, $lx97N.useEffect)(()=>{
        (async ()=>{
            if (isAuthenticated) {
                const userInfo = await fetchUserInfo();
                setUser(userInfo);
            }
        })();
    }, [
        fetchUserInfo,
        isAuthenticated
    ]);
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
        className: $0817af759030d67d$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("h3", {
                children: "Logto React sample"
            }),
            !isAuthenticated && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            signIn((0, $d14a0f9d339bbbaf$export$8bd32f43e6170583));
                        },
                        children: "Sign in"
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            signIn((0, $d14a0f9d339bbbaf$export$8bd32f43e6170583), "signUp");
                        },
                        children: "Sign up"
                    })
                ]
            }),
            isAuthenticated && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
                type: "button",
                onClick: ()=>{
                    signOut(`${(0, $d14a0f9d339bbbaf$export$a135e81e9a047f61)}/protected`);
                },
                children: "Sign out"
            }),
            isAuthenticated && user && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $b8c53ef43392f031$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("table", {
                        className: $0817af759030d67d$export$9852986a3ec5f6a0,
                        children: [
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("th", {
                                            children: "Name"
                                        }),
                                        /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("th", {
                                            children: "Value"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("tbody", {
                                children: Object.entries(user).map(([key, value])=>/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("td", {
                                                children: key
                                            }),
                                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("td", {
                                                children: typeof value === "string" ? value : JSON.stringify(value)
                                            })
                                        ]
                                    }, key))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $09f8f45067289bca$export$a6c7ac8248d6e38a), {
                                    to: "/protected",
                                    children: "View protected resource"
                                })
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $09f8f45067289bca$export$a6c7ac8248d6e38a), {
                                    to: "/protected/react-query",
                                    children: "View user info via react-query"
                                })
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("li", {
                                children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $09f8f45067289bca$export$a6c7ac8248d6e38a), {
                                    to: "/protected/organizations",
                                    children: "View organizations"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $239c2f742b0923a5$export$2e2bcd8739ae039 = $239c2f742b0923a5$var$Home;





var $lx97N = parcelRequire("lx97N");
const $aa0416e9003c9929$var$Organizations = ()=>{
    const { getOrganizationToken: getOrganizationToken, getOrganizationTokenClaims: getOrganizationTokenClaims, getIdTokenClaims: getIdTokenClaims } = (0, $98efe4d430c47d44$export$44fc9df4d2a1789a)();
    const [organizationIds, setOrganizationIds] = (0, $lx97N.useState)();
    (0, $lx97N.useEffect)(()=>{
        (async ()=>{
            const claims = await getIdTokenClaims();
            console.log("ID token claims", claims);
            setOrganizationIds(claims?.organizations);
        })();
    }, [
        getIdTokenClaims
    ]);
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("h2", {
                children: "Organizations"
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("a", {
                href: "/",
                children: "Go back"
            }),
            organizationIds?.length === 0 && /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
                children: "No organization memberships found."
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("ul", {
                children: organizationIds?.map((organizationId)=>{
                    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("li", {
                        style: {
                            display: "flex",
                            alignItems: "center",
                            gap: 8
                        },
                        children: [
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("span", {
                                children: organizationId
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("button", {
                                type: "button",
                                onClick: async ()=>{
                                    console.log("raw token", await getOrganizationToken(organizationId));
                                    console.log("claims", await getOrganizationTokenClaims(organizationId));
                                },
                                children: "fetch token (see console)"
                            })
                        ]
                    }, organizationId);
                })
            })
        ]
    });
};
var $aa0416e9003c9929$export$2e2bcd8739ae039 = $aa0416e9003c9929$var$Organizations;



const $84284a4586f8984f$var$ProtectedResource = ()=>{
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("a", {
                href: "/",
                children: "Go back"
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
                children: "Protected resource is only visible after sign-in."
            })
        ]
    });
};
var $84284a4586f8984f$export$2e2bcd8739ae039 = $84284a4586f8984f$var$ProtectedResource;






var $f58bfde3eede9a19$var$__accessCheck = (obj, member, msg)=>{
    if (!member.has(obj)) throw TypeError("Cannot " + msg);
};
var $f58bfde3eede9a19$export$18a094aefa070634 = (obj, member, getter)=>{
    $f58bfde3eede9a19$var$__accessCheck(obj, member, "read from private field");
    return getter ? getter.call(obj) : member.get(obj);
};
var $f58bfde3eede9a19$export$addf369becd23283 = (obj, member, value1)=>{
    if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
    member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
};
var $f58bfde3eede9a19$export$42432efe6614d3b4 = (obj, member, value1, setter)=>{
    $f58bfde3eede9a19$var$__accessCheck(obj, member, "write to private field");
    setter ? setter.call(obj, value1) : member.set(obj, value1);
    return value1;
};
var $f58bfde3eede9a19$export$b1fe7cbb4502036b = (obj, member, setter, getter)=>({
        set _ (value){
            $f58bfde3eede9a19$export$42432efe6614d3b4(obj, member, value, setter);
        },
        get _ () {
            return $f58bfde3eede9a19$export$18a094aefa070634(obj, member, getter);
        }
    });
var $f58bfde3eede9a19$export$fa92d15b718fce20 = (obj, member, method)=>{
    $f58bfde3eede9a19$var$__accessCheck(obj, member, "access private method");
    return method;
};



// src/utils.ts
var $e09d41c159fd9abe$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in window;
function $e09d41c159fd9abe$export$8793edee2d425525() {
    return void 0;
}
function $e09d41c159fd9abe$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $e09d41c159fd9abe$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $e09d41c159fd9abe$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $e09d41c159fd9abe$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $e09d41c159fd9abe$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$e09d41c159fd9abe$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $e09d41c159fd9abe$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($e09d41c159fd9abe$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $e09d41c159fd9abe$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$e09d41c159fd9abe$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $e09d41c159fd9abe$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $e09d41c159fd9abe$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $e09d41c159fd9abe$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$e09d41c159fd9abe$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $e09d41c159fd9abe$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$e09d41c159fd9abe$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $e09d41c159fd9abe$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $e09d41c159fd9abe$export$7a8558113332b71e(a) && $e09d41c159fd9abe$export$7a8558113332b71e(b);
    if (array || $e09d41c159fd9abe$export$53b83ca8eaab0383(a) && $e09d41c159fd9abe$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $e09d41c159fd9abe$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $e09d41c159fd9abe$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $e09d41c159fd9abe$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $e09d41c159fd9abe$export$53b83ca8eaab0383(o) {
    if (!$e09d41c159fd9abe$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
    const prot = ctor.prototype;
    if (!$e09d41c159fd9abe$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    return true;
}
function $e09d41c159fd9abe$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $e09d41c159fd9abe$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $e09d41c159fd9abe$export$4304cb76768ca134(callback) {
    $e09d41c159fd9abe$export$e772c8ff12451969(0).then(callback);
}
function $e09d41c159fd9abe$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) return $e09d41c159fd9abe$export$77a71fc411098696(prevData, data);
    return data;
}
function $e09d41c159fd9abe$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $e09d41c159fd9abe$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $e09d41c159fd9abe$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}








function $2f656cc2322d9680$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $e09d41c159fd9abe$export$4304cb76768ca134)(()=>{
            notifyFn(callback);
        });
    };
    const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $e09d41c159fd9abe$export$4304cb76768ca134)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
}
var $2f656cc2322d9680$export$520687f44db6e1ab = $2f656cc2322d9680$export$316a8efd03cd1458();





// src/subscribable.ts
var $d4341f808ffac513$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $9de16649720f5d2a$var$_focused, $9de16649720f5d2a$var$_cleanup, $9de16649720f5d2a$var$_setup;
var $9de16649720f5d2a$export$86f1af424b2ca4de = class extends (0, $d4341f808ffac513$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $9de16649720f5d2a$var$_focused, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $9de16649720f5d2a$var$_cleanup, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $9de16649720f5d2a$var$_setup, void 0);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $9de16649720f5d2a$var$_setup, (onFocus)=>{
            if (!(0, $e09d41c159fd9abe$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $9de16649720f5d2a$var$_cleanup)) this.setEventListener((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $9de16649720f5d2a$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $9de16649720f5d2a$var$_cleanup)) == null || _a.call(this);
            (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $9de16649720f5d2a$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $9de16649720f5d2a$var$_setup, setup);
        (_a = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $9de16649720f5d2a$var$_cleanup)) == null || _a.call(this);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $9de16649720f5d2a$var$_cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $9de16649720f5d2a$var$_focused) !== focused;
        if (changed) {
            (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $9de16649720f5d2a$var$_focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach((listener)=>{
            listener();
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $9de16649720f5d2a$var$_focused) === "boolean") return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $9de16649720f5d2a$var$_focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
$9de16649720f5d2a$var$_focused = new WeakMap();
$9de16649720f5d2a$var$_cleanup = new WeakMap();
$9de16649720f5d2a$var$_setup = new WeakMap();
var $9de16649720f5d2a$export$6bf54661be5b02cf = new $9de16649720f5d2a$export$86f1af424b2ca4de();





var $faa65a22bce83a61$var$_online, $faa65a22bce83a61$var$_cleanup, $faa65a22bce83a61$var$_setup;
var $faa65a22bce83a61$export$58774fb55d5ff7fc = class extends (0, $d4341f808ffac513$export$d26086b469ecdbcc) {
    constructor(){
        super();
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $faa65a22bce83a61$var$_online, true);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $faa65a22bce83a61$var$_cleanup, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $faa65a22bce83a61$var$_setup, void 0);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $faa65a22bce83a61$var$_setup, (onOnline)=>{
            if (!(0, $e09d41c159fd9abe$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $faa65a22bce83a61$var$_cleanup)) this.setEventListener((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $faa65a22bce83a61$var$_setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $faa65a22bce83a61$var$_cleanup)) == null || _a.call(this);
            (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $faa65a22bce83a61$var$_cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $faa65a22bce83a61$var$_setup, setup);
        (_a = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $faa65a22bce83a61$var$_cleanup)) == null || _a.call(this);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $faa65a22bce83a61$var$_cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $faa65a22bce83a61$var$_online) !== online;
        if (changed) {
            (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $faa65a22bce83a61$var$_online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $faa65a22bce83a61$var$_online);
    }
};
$faa65a22bce83a61$var$_online = new WeakMap();
$faa65a22bce83a61$var$_cleanup = new WeakMap();
$faa65a22bce83a61$var$_setup = new WeakMap();
var $faa65a22bce83a61$export$b113e788b2dd3fdc = new $faa65a22bce83a61$export$58774fb55d5ff7fc();



function $784dc3a91673eb1e$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $784dc3a91673eb1e$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $faa65a22bce83a61$export$b113e788b2dd3fdc).isOnline() : true;
}
var $784dc3a91673eb1e$export$a8430ed4188f35a9 = class {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function $784dc3a91673eb1e$export$986cc6445c1d323(value) {
    return value instanceof $784dc3a91673eb1e$export$a8430ed4188f35a9;
}
function $784dc3a91673eb1e$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved) {
            reject(new $784dc3a91673eb1e$export$a8430ed4188f35a9(cancelOptions));
            (_a = config.abort) == null || _a.call(config);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $9de16649720f5d2a$export$6bf54661be5b02cf).isFocused() || config.networkMode !== "always" && !(0, $faa65a22bce83a61$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onSuccess) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        var _a;
        if (!isResolved) {
            isResolved = true;
            (_a = config.onError) == null || _a.call(config, value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved) return;
            const retry = config.retry ?? ((0, $e09d41c159fd9abe$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $784dc3a91673eb1e$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, $e09d41c159fd9abe$export$e772c8ff12451969)(delay).then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    if ($784dc3a91673eb1e$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}




var $0ea81eec4104b98a$var$_gcTimeout;
var $0ea81eec4104b98a$export$e09608847fcc8c59 = class {
    constructor(){
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $0ea81eec4104b98a$var$_gcTimeout, void 0);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $e09d41c159fd9abe$export$e539f754e934e270)(this.gcTime)) (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $0ea81eec4104b98a$var$_gcTimeout, setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $e09d41c159fd9abe$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $0ea81eec4104b98a$var$_gcTimeout)) {
            clearTimeout((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $0ea81eec4104b98a$var$_gcTimeout));
            (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $0ea81eec4104b98a$var$_gcTimeout, void 0);
        }
    }
};
$0ea81eec4104b98a$var$_gcTimeout = new WeakMap();


var $db7e1507d4892c68$var$_initialState, $db7e1507d4892c68$var$_revertState, $db7e1507d4892c68$var$_cache, $db7e1507d4892c68$var$_promise, $db7e1507d4892c68$var$_retryer, $db7e1507d4892c68$var$_observers, $db7e1507d4892c68$var$_defaultOptions, $db7e1507d4892c68$var$_abortSignalConsumed, $db7e1507d4892c68$var$_setOptions, $db7e1507d4892c68$var$setOptions_fn, $db7e1507d4892c68$var$_dispatch, $db7e1507d4892c68$var$dispatch_fn;
var $db7e1507d4892c68$export$62297b13309008b2 = class extends (0, $0ea81eec4104b98a$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $db7e1507d4892c68$var$_setOptions);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $db7e1507d4892c68$var$_dispatch);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $db7e1507d4892c68$var$_initialState, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $db7e1507d4892c68$var$_revertState, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $db7e1507d4892c68$var$_cache, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $db7e1507d4892c68$var$_promise, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $db7e1507d4892c68$var$_retryer, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $db7e1507d4892c68$var$_observers, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $db7e1507d4892c68$var$_defaultOptions, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $db7e1507d4892c68$var$_abortSignalConsumed, void 0);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $db7e1507d4892c68$var$_abortSignalConsumed, false);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $db7e1507d4892c68$var$_defaultOptions, config.defaultOptions);
        (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $db7e1507d4892c68$var$_setOptions, $db7e1507d4892c68$var$setOptions_fn).call(this, config.options);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $db7e1507d4892c68$var$_observers, []);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $db7e1507d4892c68$var$_cache, config.cache);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $db7e1507d4892c68$var$_initialState, config.state || $db7e1507d4892c68$var$getDefaultState(this.options));
        this.state = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    optionalRemove() {
        if (!(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_observers).length && this.state.fetchStatus === "idle") (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, $e09d41c159fd9abe$export$17619bac5b909b23)(this.state.data, newData, this.options);
        (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $db7e1507d4892c68$var$_dispatch, $db7e1507d4892c68$var$dispatch_fn).call(this, {
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $db7e1507d4892c68$var$_dispatch, $db7e1507d4892c68$var$dispatch_fn).call(this, {
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _a;
        const promise = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_promise);
        (_a = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_retryer)) == null || _a.cancel(options);
        return promise ? promise.then((0, $e09d41c159fd9abe$export$8793edee2d425525)).catch((0, $e09d41c159fd9abe$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_initialState));
    }
    isActive() {
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_observers).some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_observers).some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $e09d41c159fd9abe$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_observers).find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_observers).find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_observers).includes(observer)) {
            (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_cache).notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if ((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_observers).includes(observer)) {
            (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $db7e1507d4892c68$var$_observers, (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_observers).filter((x)=>x !== observer));
            if (!(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_observers).length) {
                if ((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_retryer)) {
                    if ((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_abortSignalConsumed)) (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_retryer).cancel({
                        revert: true
                    });
                    else (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_cache).notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_observers).length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $db7e1507d4892c68$var$_dispatch, $db7e1507d4892c68$var$dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _a, _b, _c, _d;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_promise)) {
                (_a = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_retryer)) == null || _a.continueRetry();
                return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_promise);
            }
        }
        if (options) (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $db7e1507d4892c68$var$_setOptions, $db7e1507d4892c68$var$setOptions_fn).call(this, options);
        if (!this.options.queryFn) {
            const observer = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_observers).find((x)=>x.options.queryFn);
            if (observer) (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $db7e1507d4892c68$var$_setOptions, $db7e1507d4892c68$var$setOptions_fn).call(this, observer.options);
        }
        const abortController = new AbortController();
        const queryFnContext = {
            queryKey: this.queryKey,
            meta: this.meta
        };
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $db7e1507d4892c68$var$_abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        addSignalProperty(queryFnContext);
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject(new Error(`Missing queryFn: '${this.options.queryHash}'`));
            (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $db7e1507d4892c68$var$_abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(this.options.queryFn, queryFnContext, this);
            return this.options.queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_b = this.options.behavior) == null || _b.onFetch(context, this);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $db7e1507d4892c68$var$_revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_c = context.fetchOptions) == null ? void 0 : _c.meta)) (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $db7e1507d4892c68$var$_dispatch, $db7e1507d4892c68$var$dispatch_fn).call(this, {
            type: "fetch",
            meta: (_d = context.fetchOptions) == null ? void 0 : _d.meta
        });
        const onError = (error)=>{
            var _a2, _b2, _c2, _d2;
            if (!((0, $784dc3a91673eb1e$export$986cc6445c1d323)(error) && error.silent)) (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $db7e1507d4892c68$var$_dispatch, $db7e1507d4892c68$var$dispatch_fn).call(this, {
                type: "error",
                error: error
            });
            if (!(0, $784dc3a91673eb1e$export$986cc6445c1d323)(error)) {
                (_b2 = (_a2 = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_cache).config).onError) == null || _b2.call(_a2, error, this);
                (_d2 = (_c2 = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_cache).config).onSettled) == null || _d2.call(_c2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) this.scheduleGc();
            this.isFetchingOptimistic = false;
        };
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $db7e1507d4892c68$var$_retryer, (0, $784dc3a91673eb1e$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _a2, _b2, _c2, _d2;
                if (typeof data === "undefined") {
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                this.setData(data);
                (_b2 = (_a2 = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_cache).config).onSuccess) == null || _b2.call(_a2, data, this);
                (_d2 = (_c2 = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_cache).config).onSettled) == null || _d2.call(_c2, data, this.state.error, this);
                if (!this.isFetchingOptimistic) this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $db7e1507d4892c68$var$_dispatch, $db7e1507d4892c68$var$dispatch_fn).call(this, {
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $db7e1507d4892c68$var$_dispatch, $db7e1507d4892c68$var$dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $db7e1507d4892c68$var$_dispatch, $db7e1507d4892c68$var$dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        }));
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $db7e1507d4892c68$var$_promise, (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_retryer).promise);
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_promise);
    }
};
$db7e1507d4892c68$var$_initialState = new WeakMap();
$db7e1507d4892c68$var$_revertState = new WeakMap();
$db7e1507d4892c68$var$_cache = new WeakMap();
$db7e1507d4892c68$var$_promise = new WeakMap();
$db7e1507d4892c68$var$_retryer = new WeakMap();
$db7e1507d4892c68$var$_observers = new WeakMap();
$db7e1507d4892c68$var$_defaultOptions = new WeakMap();
$db7e1507d4892c68$var$_abortSignalConsumed = new WeakMap();
$db7e1507d4892c68$var$_setOptions = new WeakSet();
$db7e1507d4892c68$var$setOptions_fn = function(options) {
    this.options = {
        ...(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_defaultOptions),
        ...options
    };
    this.updateGcTime(this.options.gcTime);
};
$db7e1507d4892c68$var$_dispatch = new WeakSet();
$db7e1507d4892c68$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    fetchFailureCount: 0,
                    fetchFailureReason: null,
                    fetchMeta: action.meta ?? null,
                    fetchStatus: (0, $784dc3a91673eb1e$export$61b92f63f30245cf)(this.options.networkMode) ? "fetching" : "paused",
                    ...!state.dataUpdatedAt && {
                        error: null,
                        status: "pending"
                    }
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    dataUpdateCount: state.dataUpdateCount + 1,
                    dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                    error: null,
                    isInvalidated: false,
                    status: "success",
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
            case "error":
                const error = action.error;
                if ((0, $784dc3a91673eb1e$export$986cc6445c1d323)(error) && error.revert && (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_revertState)) return {
                    ...(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_revertState),
                    fetchStatus: "idle"
                };
                return {
                    ...state,
                    error: error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, $2f656cc2322d9680$export$520687f44db6e1ab).batch(()=>{
        (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_observers).forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $db7e1507d4892c68$var$_cache).notify({
            query: this,
            type: "updated",
            action: action
        });
    });
};
function $db7e1507d4892c68$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $aef7cbe7da32a022$var$_queries;
var $aef7cbe7da32a022$export$5dde0cd941da8468 = class extends (0, $d4341f808ffac513$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $aef7cbe7da32a022$var$_queries, void 0);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $aef7cbe7da32a022$var$_queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $e09d41c159fd9abe$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $db7e1507d4892c68$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $aef7cbe7da32a022$var$_queries).has(query.queryHash)) {
            (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $aef7cbe7da32a022$var$_queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $aef7cbe7da32a022$var$_queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $aef7cbe7da32a022$var$_queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $2f656cc2322d9680$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $aef7cbe7da32a022$var$_queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $aef7cbe7da32a022$var$_queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $e09d41c159fd9abe$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $e09d41c159fd9abe$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $2f656cc2322d9680$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $2f656cc2322d9680$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $2f656cc2322d9680$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
$aef7cbe7da32a022$var$_queries = new WeakMap();








var $d6c4912715f3fde4$var$_observers, $d6c4912715f3fde4$var$_defaultOptions, $d6c4912715f3fde4$var$_mutationCache, $d6c4912715f3fde4$var$_retryer, $d6c4912715f3fde4$var$_dispatch, $d6c4912715f3fde4$var$dispatch_fn;
var $d6c4912715f3fde4$export$17b8b19c814bcf56 = class extends (0, $0ea81eec4104b98a$export$e09608847fcc8c59) {
    constructor(config){
        super();
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $d6c4912715f3fde4$var$_dispatch);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $d6c4912715f3fde4$var$_observers, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $d6c4912715f3fde4$var$_defaultOptions, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $d6c4912715f3fde4$var$_mutationCache, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $d6c4912715f3fde4$var$_retryer, void 0);
        this.mutationId = config.mutationId;
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $d6c4912715f3fde4$var$_defaultOptions, config.defaultOptions);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $d6c4912715f3fde4$var$_mutationCache, config.mutationCache);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $d6c4912715f3fde4$var$_observers, []);
        this.state = config.state || $d6c4912715f3fde4$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_observers).includes(observer)) {
            (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_observers).push(observer);
            this.clearGcTimeout();
            (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $d6c4912715f3fde4$var$_observers, (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        const executeMutation = ()=>{
            (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $d6c4912715f3fde4$var$_retryer, (0, $784dc3a91673eb1e$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                    return this.options.mutationFn(variables);
                },
                onFail: (failureCount, error)=>{
                    (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $d6c4912715f3fde4$var$_dispatch, $d6c4912715f3fde4$var$dispatch_fn).call(this, {
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $d6c4912715f3fde4$var$_dispatch, $d6c4912715f3fde4$var$dispatch_fn).call(this, {
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $d6c4912715f3fde4$var$_dispatch, $d6c4912715f3fde4$var$dispatch_fn).call(this, {
                        type: "continue"
                    });
                },
                retry: this.options.retry ?? 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            }));
            return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_retryer).promise;
        };
        const restored = this.state.status === "pending";
        try {
            if (!restored) {
                (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $d6c4912715f3fde4$var$_dispatch, $d6c4912715f3fde4$var$dispatch_fn).call(this, {
                    type: "pending",
                    variables: variables
                });
                await ((_b = (_a = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables));
                if (context !== this.state.context) (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $d6c4912715f3fde4$var$_dispatch, $d6c4912715f3fde4$var$dispatch_fn).call(this, {
                    type: "pending",
                    context: context,
                    variables: variables
                });
            }
            const data = await executeMutation();
            await ((_f = (_e = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context));
            await ((_j = (_i = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context));
            (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $d6c4912715f3fde4$var$_dispatch, $d6c4912715f3fde4$var$dispatch_fn).call(this, {
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context));
                await ((_r = (_q = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context));
                throw error;
            } finally{
                (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $d6c4912715f3fde4$var$_dispatch, $d6c4912715f3fde4$var$dispatch_fn).call(this, {
                    type: "error",
                    error: error
                });
            }
        }
    }
};
$d6c4912715f3fde4$var$_observers = new WeakMap();
$d6c4912715f3fde4$var$_defaultOptions = new WeakMap();
$d6c4912715f3fde4$var$_mutationCache = new WeakMap();
$d6c4912715f3fde4$var$_retryer = new WeakMap();
$d6c4912715f3fde4$var$_dispatch = new WeakSet();
$d6c4912715f3fde4$var$dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: !(0, $784dc3a91673eb1e$export$61b92f63f30245cf)(this.options.networkMode),
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, $2f656cc2322d9680$export$520687f44db6e1ab).batch(()=>{
        (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $d6c4912715f3fde4$var$_mutationCache).notify({
            mutation: this,
            type: "updated",
            action: action
        });
    });
};
function $d6c4912715f3fde4$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $cfe88c93ae9d890f$var$_mutations, $cfe88c93ae9d890f$var$_mutationId, $cfe88c93ae9d890f$var$_resuming;
var $cfe88c93ae9d890f$export$1fcfd9a244434844 = class extends (0, $d4341f808ffac513$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $cfe88c93ae9d890f$var$_mutations, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $cfe88c93ae9d890f$var$_mutationId, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $cfe88c93ae9d890f$var$_resuming, void 0);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $cfe88c93ae9d890f$var$_mutations, []);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $cfe88c93ae9d890f$var$_mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, $d6c4912715f3fde4$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++(0, $f58bfde3eede9a19$export$b1fe7cbb4502036b)(this, $cfe88c93ae9d890f$var$_mutationId)._,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $cfe88c93ae9d890f$var$_mutations).push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $cfe88c93ae9d890f$var$_mutations, (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $cfe88c93ae9d890f$var$_mutations).filter((x)=>x !== mutation));
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $2f656cc2322d9680$export$520687f44db6e1ab).batch(()=>{
            (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $cfe88c93ae9d890f$var$_mutations).forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $cfe88c93ae9d890f$var$_mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $cfe88c93ae9d890f$var$_mutations).find((mutation)=>(0, $e09d41c159fd9abe$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $cfe88c93ae9d890f$var$_mutations).filter((mutation)=>(0, $e09d41c159fd9abe$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $2f656cc2322d9680$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $cfe88c93ae9d890f$var$_resuming, ((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $cfe88c93ae9d890f$var$_resuming) ?? Promise.resolve()).then(()=>{
            const pausedMutations = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $cfe88c93ae9d890f$var$_mutations).filter((x)=>x.state.isPaused);
            return (0, $2f656cc2322d9680$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $e09d41c159fd9abe$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $cfe88c93ae9d890f$var$_resuming, void 0);
        }));
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $cfe88c93ae9d890f$var$_resuming);
    }
};
$cfe88c93ae9d890f$var$_mutations = new WeakMap();
$cfe88c93ae9d890f$var$_mutationId = new WeakMap();
$cfe88c93ae9d890f$var$_resuming = new WeakMap();







function $392a302c0b36b02d$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const fetchFn = async ()=>{
                var _a, _b, _c, _d, _e;
                const options = context.options;
                const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
                const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
                const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
                const empty = {
                    pages: [],
                    pageParams: []
                };
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = context.options.queryFn || (()=>Promise.reject(new Error(`Missing queryFn: '${context.options.queryHash}'`)));
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $e09d41c159fd9abe$export$8c6246b73dd61f4a) : (0, $e09d41c159fd9abe$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                let result;
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $392a302c0b36b02d$var$getPreviousPageParam : $392a302c0b36b02d$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    result = await fetchPage(empty, oldPageParams[0] ?? options.initialPageParam);
                    const remainingPages = pages ?? oldPages.length;
                    for(let i = 1; i < remainingPages; i++){
                        const param = $392a302c0b36b02d$var$getNextPageParam(options, result);
                        result = await fetchPage(result, param);
                    }
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a, _b;
                return (_b = (_a = context.options).persister) == null ? void 0 : _b.call(_a, fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $392a302c0b36b02d$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams);
}
function $392a302c0b36b02d$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    var _a;
    return (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams);
}
function $392a302c0b36b02d$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $392a302c0b36b02d$var$getNextPageParam(options, data) != null;
}
function $392a302c0b36b02d$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $392a302c0b36b02d$var$getPreviousPageParam(options, data) != null;
}


var $67b8adb984bd1673$var$_queryCache, $67b8adb984bd1673$var$_mutationCache, $67b8adb984bd1673$var$_defaultOptions, $67b8adb984bd1673$var$_queryDefaults, $67b8adb984bd1673$var$_mutationDefaults, $67b8adb984bd1673$var$_mountCount, $67b8adb984bd1673$var$_unsubscribeFocus, $67b8adb984bd1673$var$_unsubscribeOnline;
var $67b8adb984bd1673$export$405d0624ed55a03f = class {
    constructor(config = {}){
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $67b8adb984bd1673$var$_queryCache, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $67b8adb984bd1673$var$_mutationCache, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $67b8adb984bd1673$var$_defaultOptions, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $67b8adb984bd1673$var$_queryDefaults, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $67b8adb984bd1673$var$_mutationDefaults, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $67b8adb984bd1673$var$_mountCount, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $67b8adb984bd1673$var$_unsubscribeFocus, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $67b8adb984bd1673$var$_unsubscribeOnline, void 0);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $67b8adb984bd1673$var$_queryCache, config.queryCache || new (0, $aef7cbe7da32a022$export$5dde0cd941da8468)());
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $67b8adb984bd1673$var$_mutationCache, config.mutationCache || new (0, $cfe88c93ae9d890f$export$1fcfd9a244434844)());
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $67b8adb984bd1673$var$_defaultOptions, config.defaultOptions || {});
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $67b8adb984bd1673$var$_queryDefaults, /* @__PURE__ */ new Map());
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $67b8adb984bd1673$var$_mutationDefaults, /* @__PURE__ */ new Map());
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $67b8adb984bd1673$var$_mountCount, 0);
    }
    mount() {
        (0, $f58bfde3eede9a19$export$b1fe7cbb4502036b)(this, $67b8adb984bd1673$var$_mountCount)._++;
        if ((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_mountCount) !== 1) return;
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $67b8adb984bd1673$var$_unsubscribeFocus, (0, $9de16649720f5d2a$export$6bf54661be5b02cf).subscribe(()=>{
            if ((0, $9de16649720f5d2a$export$6bf54661be5b02cf).isFocused()) {
                this.resumePausedMutations();
                (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryCache).onFocus();
            }
        }));
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $67b8adb984bd1673$var$_unsubscribeOnline, (0, $faa65a22bce83a61$export$b113e788b2dd3fdc).subscribe(()=>{
            if ((0, $faa65a22bce83a61$export$b113e788b2dd3fdc).isOnline()) {
                this.resumePausedMutations();
                (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, $f58bfde3eede9a19$export$b1fe7cbb4502036b)(this, $67b8adb984bd1673$var$_mountCount)._--;
        if ((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_mountCount) !== 0) return;
        (_a = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_unsubscribeFocus)) == null || _a.call(this);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $67b8adb984bd1673$var$_unsubscribeFocus, void 0);
        (_b = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_unsubscribeOnline)) == null || _b.call(this);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $67b8adb984bd1673$var$_unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        var _a;
        return (_a = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryCache).find({
            queryKey: queryKey
        })) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const cachedData = this.getQueryData(options.queryKey);
        return cachedData !== void 0 ? Promise.resolve(cachedData) : this.fetchQuery(options);
    }
    getQueriesData(filters) {
        return this.getQueryCache().findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryCache).find({
            queryKey: queryKey
        });
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $e09d41c159fd9abe$export$7f095f455ad5af3f)(updater, prevData);
        if (typeof data === "undefined") return void 0;
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $2f656cc2322d9680$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        return (_a = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryCache).find({
            queryKey: queryKey
        })) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryCache);
        (0, $2f656cc2322d9680$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryCache);
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $2f656cc2322d9680$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters = {}, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $2f656cc2322d9680$export$520687f44db6e1ab).batch(()=>(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $e09d41c159fd9abe$export$8793edee2d425525)).catch((0, $e09d41c159fd9abe$export$8793edee2d425525));
    }
    invalidateQueries(filters = {}, options = {}) {
        return (0, $2f656cc2322d9680$export$520687f44db6e1ab).batch(()=>{
            (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: filters.refetchType ?? filters.type ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters = {}, options) {
        const fetchOptions = {
            ...options,
            cancelRefetch: (options == null ? void 0 : options.cancelRefetch) ?? true
        };
        const promises = (0, $2f656cc2322d9680$export$520687f44db6e1ab).batch(()=>(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryCache).findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $e09d41c159fd9abe$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $e09d41c159fd9abe$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryCache).build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $e09d41c159fd9abe$export$8793edee2d425525)).catch((0, $e09d41c159fd9abe$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $392a302c0b36b02d$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $e09d41c159fd9abe$export$8793edee2d425525)).catch((0, $e09d41c159fd9abe$export$8793edee2d425525));
    }
    resumePausedMutations() {
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_mutationCache).resumePausedMutations();
    }
    getQueryCache() {
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryCache);
    }
    getMutationCache() {
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_mutationCache);
    }
    getDefaultOptions() {
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_defaultOptions);
    }
    setDefaultOptions(options) {
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $67b8adb984bd1673$var$_defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryDefaults).set((0, $e09d41c159fd9abe$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $e09d41c159fd9abe$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_mutationDefaults).set((0, $e09d41c159fd9abe$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_mutationDefaults).values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $e09d41c159fd9abe$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        const defaultedOptions = {
            ...(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_defaultOptions).queries,
            ...(options == null ? void 0 : options.queryKey) && this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $e09d41c159fd9abe$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.throwOnError === "undefined") defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (typeof defaultedOptions.networkMode === "undefined" && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_queryCache).clear();
        (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $67b8adb984bd1673$var$_mutationCache).clear();
    }
};
$67b8adb984bd1673$var$_queryCache = new WeakMap();
$67b8adb984bd1673$var$_mutationCache = new WeakMap();
$67b8adb984bd1673$var$_defaultOptions = new WeakMap();
$67b8adb984bd1673$var$_queryDefaults = new WeakMap();
$67b8adb984bd1673$var$_mutationDefaults = new WeakMap();
$67b8adb984bd1673$var$_mountCount = new WeakMap();
$67b8adb984bd1673$var$_unsubscribeFocus = new WeakMap();
$67b8adb984bd1673$var$_unsubscribeOnline = new WeakMap();


var $lx97N = parcelRequire("lx97N");
"use client";
var $a3b781903edd9716$export$da112d31b0149f31 = $lx97N.createContext(void 0);
var $a3b781903edd9716$export$22e77b9572c4fded = (queryClient)=>{
    const client = $lx97N.useContext($a3b781903edd9716$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $a3b781903edd9716$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $lx97N.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ $lx97N.createElement($a3b781903edd9716$export$da112d31b0149f31.Provider, {
        value: client
    }, children);
};







var $6417df6052633d3e$var$_client, $6417df6052633d3e$var$_currentQuery, $6417df6052633d3e$var$_currentQueryInitialState, $6417df6052633d3e$var$_currentResult, $6417df6052633d3e$var$_currentResultState, $6417df6052633d3e$var$_currentResultOptions, $6417df6052633d3e$var$_selectError, $6417df6052633d3e$var$_selectFn, $6417df6052633d3e$var$_selectResult, $6417df6052633d3e$var$_lastQueryWithDefinedData, $6417df6052633d3e$var$_staleTimeoutId, $6417df6052633d3e$var$_refetchIntervalId, $6417df6052633d3e$var$_currentRefetchInterval, $6417df6052633d3e$var$_trackedProps, $6417df6052633d3e$var$_executeFetch, $6417df6052633d3e$var$executeFetch_fn, $6417df6052633d3e$var$_updateStaleTimeout, $6417df6052633d3e$var$updateStaleTimeout_fn, $6417df6052633d3e$var$_computeRefetchInterval, $6417df6052633d3e$var$computeRefetchInterval_fn, $6417df6052633d3e$var$_updateRefetchInterval, $6417df6052633d3e$var$updateRefetchInterval_fn, $6417df6052633d3e$var$_updateTimers, $6417df6052633d3e$var$updateTimers_fn, $6417df6052633d3e$var$_clearStaleTimeout, $6417df6052633d3e$var$clearStaleTimeout_fn, $6417df6052633d3e$var$_clearRefetchInterval, $6417df6052633d3e$var$clearRefetchInterval_fn, $6417df6052633d3e$var$_updateQuery, $6417df6052633d3e$var$updateQuery_fn, $6417df6052633d3e$var$_notify, $6417df6052633d3e$var$notify_fn;
var $6417df6052633d3e$export$a06cf8c0066f0d4c = class extends (0, $d4341f808ffac513$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_executeFetch);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_updateStaleTimeout);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_computeRefetchInterval);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_updateRefetchInterval);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_updateTimers);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_clearStaleTimeout);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_clearRefetchInterval);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_updateQuery);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_notify);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_client, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_currentQuery, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_currentQueryInitialState, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_currentResult, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_currentResultState, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_currentResultOptions, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_selectError, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_selectFn, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_selectResult, void 0);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_lastQueryWithDefinedData, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_staleTimeoutId, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_refetchIntervalId, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_currentRefetchInterval, void 0);
        (0, $f58bfde3eede9a19$export$addf369becd23283)(this, $6417df6052633d3e$var$_trackedProps, /* @__PURE__ */ new Set());
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_client, client);
        this.options = options;
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_selectError, null);
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery).addObserver(this);
            if ($6417df6052633d3e$var$shouldFetchOnMount((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery), this.options)) (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_executeFetch, $6417df6052633d3e$var$executeFetch_fn).call(this);
            else this.updateResult();
            (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_updateTimers, $6417df6052633d3e$var$updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $6417df6052633d3e$var$shouldFetchOn((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $6417df6052633d3e$var$shouldFetchOn((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_clearStaleTimeout, $6417df6052633d3e$var$clearStaleTimeout_fn).call(this);
        (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_clearRefetchInterval, $6417df6052633d3e$var$clearRefetchInterval_fn).call(this);
        (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery).removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery);
        this.options = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_client).defaultQueryOptions(options);
        if (!(0, $e09d41c159fd9abe$export$3e67810a3f0e9f1c)(prevOptions, this.options)) (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery),
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_updateQuery, $6417df6052633d3e$var$updateQuery_fn).call(this);
        const mounted = this.hasListeners();
        if (mounted && $6417df6052633d3e$var$shouldFetchOptionally((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery), prevQuery, this.options, prevOptions)) (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_executeFetch, $6417df6052633d3e$var$executeFetch_fn).call(this);
        this.updateResult(notifyOptions);
        if (mounted && ((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_updateStaleTimeout, $6417df6052633d3e$var$updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_computeRefetchInterval, $6417df6052633d3e$var$computeRefetchInterval_fn).call(this);
        if (mounted && ((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery) !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentRefetchInterval))) (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_updateRefetchInterval, $6417df6052633d3e$var$updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_client).getQueryCache().build((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_client), options);
        const result = this.createResult(query, options);
        if ($6417df6052633d3e$var$shouldAssignObserverCurrentProperties(this, result)) {
            (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_currentResult, result);
            (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_currentResultOptions, this.options);
            (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_currentResultState, (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentResult);
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_trackedProps).add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_client).defaultQueryOptions(options);
        const query = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_client).getQueryCache().build((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_client), defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_executeFetch, $6417df6052633d3e$var$executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentResult);
        const prevResultState = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentResultState);
        const prevResultOptions = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQueryInitialState);
        const { state: state } = query;
        let { error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $6417df6052633d3e$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $6417df6052633d3e$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $784dc3a91673eb1e$export$61b92f63f30245cf)(query.options.networkMode) ? "fetching" : "paused";
                if (!state.dataUpdatedAt) status = "pending";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        }
        if (options.select && typeof state.data !== "undefined") {
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_selectFn)) data = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_selectResult);
            else try {
                (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_selectFn, options.select);
                data = options.select(state.data);
                data = (0, $e09d41c159fd9abe$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_selectResult, data);
                (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_selectError, null);
            } catch (selectError) {
                (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_selectError, selectError);
            }
        } else data = state.data;
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_lastQueryWithDefinedData)) : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_selectError, null);
                } catch (selectError) {
                    (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_selectError, selectError);
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $e09d41c159fd9abe$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if ((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_selectError)) {
            error = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_selectError);
            data = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: state.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $6417df6052633d3e$var$isStale(query, options),
            refetch: this.refetch
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentResult);
        const nextResult = this.createResult((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery), this.options);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_currentResultState, (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery).state);
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_currentResultOptions, this.options);
        if ((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentResultState).data !== void 0) (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_lastQueryWithDefinedData, (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery));
        if ((0, $e09d41c159fd9abe$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_currentResult, nextResult);
        const defaultNotifyOptions = {};
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_notify, $6417df6052633d3e$var$notify_fn).call(this, {
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_updateTimers, $6417df6052633d3e$var$updateTimers_fn).call(this);
    }
};
$6417df6052633d3e$var$_client = new WeakMap();
$6417df6052633d3e$var$_currentQuery = new WeakMap();
$6417df6052633d3e$var$_currentQueryInitialState = new WeakMap();
$6417df6052633d3e$var$_currentResult = new WeakMap();
$6417df6052633d3e$var$_currentResultState = new WeakMap();
$6417df6052633d3e$var$_currentResultOptions = new WeakMap();
$6417df6052633d3e$var$_selectError = new WeakMap();
$6417df6052633d3e$var$_selectFn = new WeakMap();
$6417df6052633d3e$var$_selectResult = new WeakMap();
$6417df6052633d3e$var$_lastQueryWithDefinedData = new WeakMap();
$6417df6052633d3e$var$_staleTimeoutId = new WeakMap();
$6417df6052633d3e$var$_refetchIntervalId = new WeakMap();
$6417df6052633d3e$var$_currentRefetchInterval = new WeakMap();
$6417df6052633d3e$var$_trackedProps = new WeakMap();
$6417df6052633d3e$var$_executeFetch = new WeakSet();
$6417df6052633d3e$var$executeFetch_fn = function(fetchOptions) {
    (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_updateQuery, $6417df6052633d3e$var$updateQuery_fn).call(this);
    let promise = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, $e09d41c159fd9abe$export$8793edee2d425525));
    return promise;
};
$6417df6052633d3e$var$_updateStaleTimeout = new WeakSet();
$6417df6052633d3e$var$updateStaleTimeout_fn = function() {
    (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_clearStaleTimeout, $6417df6052633d3e$var$clearStaleTimeout_fn).call(this);
    if ((0, $e09d41c159fd9abe$export$6acf61af03e62db) || (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentResult).isStale || !(0, $e09d41c159fd9abe$export$e539f754e934e270)(this.options.staleTime)) return;
    const time = (0, $e09d41c159fd9abe$export$811b83d62bcf47f0)((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentResult).dataUpdatedAt, this.options.staleTime);
    const timeout = time + 1;
    (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_staleTimeoutId, setTimeout(()=>{
        if (!(0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentResult).isStale) this.updateResult();
    }, timeout));
};
$6417df6052633d3e$var$_computeRefetchInterval = new WeakSet();
$6417df6052633d3e$var$computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery)) : this.options.refetchInterval) ?? false;
};
$6417df6052633d3e$var$_updateRefetchInterval = new WeakSet();
$6417df6052633d3e$var$updateRefetchInterval_fn = function(nextInterval) {
    (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_clearRefetchInterval, $6417df6052633d3e$var$clearRefetchInterval_fn).call(this);
    (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_currentRefetchInterval, nextInterval);
    if ((0, $e09d41c159fd9abe$export$6acf61af03e62db) || this.options.enabled === false || !(0, $e09d41c159fd9abe$export$e539f754e934e270)((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentRefetchInterval)) || (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentRefetchInterval) === 0) return;
    (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_refetchIntervalId, setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, $9de16649720f5d2a$export$6bf54661be5b02cf).isFocused()) (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_executeFetch, $6417df6052633d3e$var$executeFetch_fn).call(this);
    }, (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentRefetchInterval)));
};
$6417df6052633d3e$var$_updateTimers = new WeakSet();
$6417df6052633d3e$var$updateTimers_fn = function() {
    (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_updateStaleTimeout, $6417df6052633d3e$var$updateStaleTimeout_fn).call(this);
    (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_updateRefetchInterval, $6417df6052633d3e$var$updateRefetchInterval_fn).call(this, (0, $f58bfde3eede9a19$export$fa92d15b718fce20)(this, $6417df6052633d3e$var$_computeRefetchInterval, $6417df6052633d3e$var$computeRefetchInterval_fn).call(this));
};
$6417df6052633d3e$var$_clearStaleTimeout = new WeakSet();
$6417df6052633d3e$var$clearStaleTimeout_fn = function() {
    if ((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_staleTimeoutId)) {
        clearTimeout((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_staleTimeoutId));
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_staleTimeoutId, void 0);
    }
};
$6417df6052633d3e$var$_clearRefetchInterval = new WeakSet();
$6417df6052633d3e$var$clearRefetchInterval_fn = function() {
    if ((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_refetchIntervalId)) {
        clearInterval((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_refetchIntervalId));
        (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_refetchIntervalId, void 0);
    }
};
$6417df6052633d3e$var$_updateQuery = new WeakSet();
$6417df6052633d3e$var$updateQuery_fn = function() {
    const query = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_client).getQueryCache().build((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_client), this.options);
    if (query === (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery)) return;
    const prevQuery = (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery);
    (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_currentQuery, query);
    (0, $f58bfde3eede9a19$export$42432efe6614d3b4)(this, $6417df6052633d3e$var$_currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
$6417df6052633d3e$var$_notify = new WeakSet();
$6417df6052633d3e$var$notify_fn = function(notifyOptions) {
    (0, $2f656cc2322d9680$export$520687f44db6e1ab).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentResult));
        });
        (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_client).getQueryCache().notify({
            query: (0, $f58bfde3eede9a19$export$18a094aefa070634)(this, $6417df6052633d3e$var$_currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function $6417df6052633d3e$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $6417df6052633d3e$var$shouldFetchOnMount(query, options) {
    return $6417df6052633d3e$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $6417df6052633d3e$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $6417df6052633d3e$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $6417df6052633d3e$var$isStale(query, options);
    }
    return false;
}
function $6417df6052633d3e$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $6417df6052633d3e$var$isStale(query, options);
}
function $6417df6052633d3e$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
}
function $6417df6052633d3e$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $e09d41c159fd9abe$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $lx97N = parcelRequire("lx97N");


var $lx97N = parcelRequire("lx97N");
"use client";
function $a73c2c0203084350$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $a73c2c0203084350$var$QueryErrorResetBoundaryContext = $lx97N.createContext($a73c2c0203084350$var$createValue());
var $a73c2c0203084350$export$50dfac555130cafd = ()=>$lx97N.useContext($a73c2c0203084350$var$QueryErrorResetBoundaryContext);
var $a73c2c0203084350$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $lx97N.useState(()=>$a73c2c0203084350$var$createValue());
    return /* @__PURE__ */ $lx97N.createElement($a73c2c0203084350$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};




var $lx97N = parcelRequire("lx97N");
"use client";
var $82253f960436b383$var$IsRestoringContext = $lx97N.createContext(false);
var $82253f960436b383$export$4da0178d6b5f553 = ()=>$lx97N.useContext($82253f960436b383$var$IsRestoringContext);
var $82253f960436b383$export$593807d4e94f9621 = $82253f960436b383$var$IsRestoringContext.Provider;



var $lx97N = parcelRequire("lx97N");
// src/utils.ts
function $a21b47912e09fde6$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}


"use client";
var $8fcfe5890e60b3cc$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $8fcfe5890e60b3cc$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $lx97N.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $8fcfe5890e60b3cc$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $a21b47912e09fde6$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]);
};


// src/suspense.ts
var $4ac8896fe09c86af$export$8bed2f8d02206063 = (_error, query)=>typeof query.state.data === "undefined";
var $4ac8896fe09c86af$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1e3;
    }
};
var $4ac8896fe09c86af$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $4ac8896fe09c86af$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $4ac8896fe09c86af$export$e0a3f29513afe430(result, isRestoring);
var $4ac8896fe09c86af$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $d837824bb100a4dc$export$fff0865807e996c5(options, Observer, queryClient) {
    const client = (0, $a3b781903edd9716$export$22e77b9572c4fded)(queryClient);
    const isRestoring = (0, $82253f960436b383$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $a73c2c0203084350$export$50dfac555130cafd)();
    const defaultedOptions = client.defaultQueryOptions(options);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $4ac8896fe09c86af$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $8fcfe5890e60b3cc$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $8fcfe5890e60b3cc$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $lx97N.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    $lx97N.useSyncExternalStore($lx97N.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>void 0 : observer.subscribe((0, $2f656cc2322d9680$export$520687f44db6e1ab).batchCalls(onStoreChange));
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $lx97N.useEffect(()=>{
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $4ac8896fe09c86af$export$88d3586dfed64df9)(defaultedOptions, result, isRestoring)) throw (0, $4ac8896fe09c86af$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $8fcfe5890e60b3cc$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: observer.getCurrentQuery()
    })) throw result.error;
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $f1f5f4bd27803bac$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $d837824bb100a4dc$export$fff0865807e996c5)(options, (0, $6417df6052633d3e$export$a06cf8c0066f0d4c), queryClient);
}



/**
 * A custom hook that returns a fetcher function that automatically adds the access token to the
 * request. It uses `fetch` under the hood, and has the same signature.
 */ const $2d7850d42577ce1b$var$useApi = ()=>{
    const { getAccessToken: getAccessToken } = (0, $98efe4d430c47d44$export$44fc9df4d2a1789a)();
    const fetcher = async (input, init)=>{
        const accessToken = await getAccessToken();
        if (!accessToken) throw new Error("No access token available.");
        const response = await fetch(input, {
            ...init,
            headers: {
                ...init?.headers,
                Authorization: `Bearer ${accessToken}`
            }
        });
        return response;
    };
    return fetcher;
};
const $2d7850d42577ce1b$var$queryClient = new (0, $67b8adb984bd1673$export$405d0624ed55a03f)();
const $2d7850d42577ce1b$var$ReactQuery = ()=>{
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $a3b781903edd9716$export$45604f0cc8ae667b), {
        client: $2d7850d42577ce1b$var$queryClient,
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)($2d7850d42577ce1b$var$Content, {})
    });
};
const $2d7850d42577ce1b$var$Content = ()=>{
    const api = $2d7850d42577ce1b$var$useApi();
    const query = (0, $f1f5f4bd27803bac$export$dd0a697e1782aedd)({
        queryKey: [
            "userinfo"
        ],
        queryFn: async ()=>{
            const response = await api(new URL("/oidc/me", (0, $d14a0f9d339bbbaf$export$125e2b775860041f)));
            return response.json();
        }
    });
    if (query.isLoading) return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("div", {
        children: "Loading..."
    });
    if (query.isError) return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("h1", {
                children: "Error"
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
                children: JSON.stringify(query.error)
            })
        ]
    });
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("h2", {
                children: "Success"
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
                children: "You are seeing this page because react-query successfully fetched the user info."
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("a", {
                href: "/",
                children: "Go back"
            }),
            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)("p", {
                children: JSON.stringify(query.data)
            })
        ]
    });
};
var $2d7850d42577ce1b$export$2e2bcd8739ae039 = $2d7850d42577ce1b$var$ReactQuery;


const $e360bf797a4a50f1$export$86fbec116b87613f = ()=>{
    const config = {
        appId: $d14a0f9d339bbbaf$export$e0cbbd86f88a6ea5,
        endpoint: $d14a0f9d339bbbaf$export$125e2b775860041f,
        scopes: [
            (0, $42336f286a2da162$export$4b02c5b431f6eb78).Email,
            (0, $42336f286a2da162$export$4b02c5b431f6eb78).Phone,
            (0, $42336f286a2da162$export$4b02c5b431f6eb78).CustomData,
            (0, $42336f286a2da162$export$4b02c5b431f6eb78).Identities,
            (0, $42336f286a2da162$export$4b02c5b431f6eb78).Organizations
        ]
    };
    return /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $09f8f45067289bca$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $5f0f3d3fc023d078$export$bfa587c2c3245948), {
            config: config,
            children: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $946ebc92e8ce61a6$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $946ebc92e8ce61a6$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $239c2f742b0923a5$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $946ebc92e8ce61a6$export$e7b0ac011bb776c6), {
                        path: "/callback",
                        element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $8b52a37a2af3b9f8$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsxs)((0, $946ebc92e8ce61a6$export$e7b0ac011bb776c6), {
                        path: "/protected",
                        element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $e0620eb245dda77e$export$2e2bcd8739ae039), {}),
                        children: [
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $946ebc92e8ce61a6$export$e7b0ac011bb776c6), {
                                index: true,
                                element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $84284a4586f8984f$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $946ebc92e8ce61a6$export$e7b0ac011bb776c6), {
                                path: "react-query",
                                element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $2d7850d42577ce1b$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $946ebc92e8ce61a6$export$e7b0ac011bb776c6), {
                                path: "organizations",
                                element: /*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $aa0416e9003c9929$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                ]
            })
        })
    });
};


const $d53ebeefff1dd964$var$app = document.querySelector("#app");
const $d53ebeefff1dd964$var$root = $d53ebeefff1dd964$var$app && (0, $e08bedd2d92855da$export$882461b6382ed46c)($d53ebeefff1dd964$var$app);
$d53ebeefff1dd964$var$root?.render(/*#__PURE__*/ (0, $b8c53ef43392f031$exports.jsx)((0, $e360bf797a4a50f1$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.d61209ba.js.map
